webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(621);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StartNewProjectButton = exports.COLORS_SET = exports.ColorPicker = exports.EditableTextArea = exports.ActionIcon = exports.TopBar = exports.CheckBox = exports.Menu = exports.Tooltip = exports.Markup = exports.Spinner = exports.Icons = exports.Tab = exports.Button = exports.OuterLink = exports.PseudoLink = exports.Link = undefined;
	
	var _Link = __webpack_require__(212);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__(545);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icons = __webpack_require__(17);
	
	var Icons = _interopRequireWildcard(_Icons);
	
	var _Spinner = __webpack_require__(137);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _Markup = __webpack_require__(82);
	
	var Markup = _interopRequireWildcard(_Markup);
	
	var _Tab = __webpack_require__(560);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Tooltip = __webpack_require__(561);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _index = __webpack_require__(557);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _TopBar = __webpack_require__(213);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	var _ActionIcon = __webpack_require__(210);
	
	var _ActionIcon2 = _interopRequireDefault(_ActionIcon);
	
	var _EditableTextArea = __webpack_require__(552);
	
	var _EditableTextArea2 = _interopRequireDefault(_EditableTextArea);
	
	var _ColorPicker = __webpack_require__(551);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _ColorsSet = __webpack_require__(211);
	
	var _ColorsSet2 = _interopRequireDefault(_ColorsSet);
	
	var _index3 = __webpack_require__(550);
	
	var CheckBox = _interopRequireWildcard(_index3);
	
	var _StartNewProjectButton = __webpack_require__(559);
	
	var _StartNewProjectButton2 = _interopRequireDefault(_StartNewProjectButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Link = _Link2.default;
	exports.PseudoLink = _Link.PseudoLink;
	exports.OuterLink = _Link.OuterLink;
	exports.Button = _Button2.default;
	exports.Tab = _Tab2.default;
	exports.Icons = Icons;
	exports.Spinner = _Spinner2.default;
	exports.Markup = Markup;
	exports.Tooltip = _Tooltip2.default;
	exports.Menu = _index2.default;
	exports.CheckBox = CheckBox;
	exports.TopBar = _TopBar2.default;
	exports.ActionIcon = _ActionIcon2.default;
	exports.EditableTextArea = _EditableTextArea2.default;
	exports.ColorPicker = _ColorPicker2.default;
	exports.COLORS_SET = _ColorsSet2.default;
	exports.StartNewProjectButton = _StartNewProjectButton2.default;
	/* injects from baggage-loader */

/***/ },
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditorDelete = exports.EditorEdit = exports.PermissionUnlisted = exports.PermissionPrivate = exports.Scissors = exports.ClipCrossed = exports.Clip = exports.EditorLink = exports.EditorNumberedList = exports.EditorList = exports.EditorBold = exports.Visibility = exports.Share = exports.Hamburger = exports.ArrowBack = exports.Exit = exports.Plus = exports.Twitter = exports.Facebook = exports.Logo = undefined;
	
	var _Logo = __webpack_require__(529);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Facebook = __webpack_require__(527);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Twitter = __webpack_require__(535);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _Plus = __webpack_require__(532);
	
	var _Plus2 = _interopRequireDefault(_Plus);
	
	var _Exit = __webpack_require__(526);
	
	var _Exit2 = _interopRequireDefault(_Exit);
	
	var _ArrowBack = __webpack_require__(517);
	
	var _ArrowBack2 = _interopRequireDefault(_ArrowBack);
	
	var _Hamburger = __webpack_require__(528);
	
	var _Hamburger2 = _interopRequireDefault(_Hamburger);
	
	var _EditorBold = __webpack_require__(520);
	
	var _EditorBold2 = _interopRequireDefault(_EditorBold);
	
	var _EditorList = __webpack_require__(524);
	
	var _EditorList2 = _interopRequireDefault(_EditorList);
	
	var _EditorNumberedList = __webpack_require__(525);
	
	var _EditorNumberedList2 = _interopRequireDefault(_EditorNumberedList);
	
	var _EditorLink = __webpack_require__(523);
	
	var _EditorLink2 = _interopRequireDefault(_EditorLink);
	
	var _Clip = __webpack_require__(518);
	
	var _Clip2 = _interopRequireDefault(_Clip);
	
	var _ClipCrossed = __webpack_require__(519);
	
	var _ClipCrossed2 = _interopRequireDefault(_ClipCrossed);
	
	var _Scissors = __webpack_require__(533);
	
	var _Scissors2 = _interopRequireDefault(_Scissors);
	
	var _Share = __webpack_require__(534);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _Visibility = __webpack_require__(536);
	
	var _Visibility2 = _interopRequireDefault(_Visibility);
	
	var _PermissionPrivate = __webpack_require__(530);
	
	var _PermissionPrivate2 = _interopRequireDefault(_PermissionPrivate);
	
	var _PermissionUnlisted = __webpack_require__(531);
	
	var _PermissionUnlisted2 = _interopRequireDefault(_PermissionUnlisted);
	
	var _EditorEdit = __webpack_require__(522);
	
	var _EditorEdit2 = _interopRequireDefault(_EditorEdit);
	
	var _EditorDelete = __webpack_require__(521);
	
	var _EditorDelete2 = _interopRequireDefault(_EditorDelete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	exports.Logo = _Logo2.default;
	exports.Facebook = _Facebook2.default;
	exports.Twitter = _Twitter2.default;
	exports.Plus = _Plus2.default;
	exports.Exit = _Exit2.default;
	exports.ArrowBack = _ArrowBack2.default;
	exports.Hamburger = _Hamburger2.default;
	exports.Share = _Share2.default;
	exports.Visibility = _Visibility2.default;
	exports.EditorBold = _EditorBold2.default;
	exports.EditorList = _EditorList2.default;
	exports.EditorNumberedList = _EditorNumberedList2.default;
	exports.EditorLink = _EditorLink2.default;
	exports.Clip = _Clip2.default;
	exports.ClipCrossed = _ClipCrossed2.default;
	exports.Scissors = _Scissors2.default;
	exports.PermissionPrivate = _PermissionPrivate2.default;
	exports.PermissionUnlisted = _PermissionUnlisted2.default;
	exports.EditorEdit = _EditorEdit2.default;
	exports.EditorDelete = _EditorDelete2.default;

/***/ },
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shareProjectShowFBPopup = exports.shareProjectPopupOpened = exports.shareProjectFailure = exports.shareProjectGotFBLink = exports.shareProjectSuccess = undefined;
	exports.setProjectsList = setProjectsList;
	exports.addProject = addProject;
	exports.addDefaultProject = addDefaultProject;
	exports.updateProjectName = updateProjectName;
	exports.setProject = setProject;
	exports.updateNode = updateNode;
	exports.updateNodes = updateNodes;
	exports.removeEdge = removeEdge;
	exports.detachNode = detachNode;
	exports.confirmRemoveNode = confirmRemoveNode;
	exports.removeNode = removeNode;
	exports.addNode = addNode;
	exports.appendNewNode = appendNewNode;
	exports.appendRightConnectedNode = appendRightConnectedNode;
	exports.appendBottomConnectedNode = appendBottomConnectedNode;
	exports.appendRightNode = appendRightNode;
	exports.addEdge = addEdge;
	exports.setPermission = setPermission;
	exports.projectDelete = projectDelete;
	exports.shareProject = shareProject;
	
	var _actionTypes = __webpack_require__(23);
	
	var _popupTypes = __webpack_require__(102);
	
	var _popupActions = __webpack_require__(101);
	
	var _projectActions = __webpack_require__(230);
	
	var _projectSimpleStubbedData = __webpack_require__(627);
	
	var _projectSimpleStubbedData2 = _interopRequireDefault(_projectSimpleStubbedData);
	
	var _defaultProjectData = __webpack_require__(623);
	
	var _defaultProjectData2 = _interopRequireDefault(_defaultProjectData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODO move!
	
	/* injects from baggage-loader */
	
	function setProjectsList(value) {
	  return {
	    type: _actionTypes.SET_PROJECTS_LIST,
	    value: value
	  };
	}
	
	function addProject() {
	  var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var transition = params.transition;
	
	
	  return function (dispatch, getState) {
	    var user = getState().user.authorizedUser;
	    if (user) {
	      dispatch({
	        type: _actionTypes.ADD_PROJECT,
	        userId: user.id,
	        transition: transition,
	        project: (0, _projectSimpleStubbedData2.default)()
	      });
	    }
	  };
	}
	
	function addDefaultProject() {
	  return function (dispatch, getState) {
	    var user = getState().user.authorizedUser;
	    dispatch({
	      type: _actionTypes.ADD_PROJECT,
	      userId: user.id,
	      transition: false,
	      project: (0, _defaultProjectData2.default)()
	    });
	  };
	}
	
	function updateProjectName(projectId, value) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.UPDATE_PROJECT_NAME,
	      projectId: projectId,
	      value: value
	    });
	  };
	}
	
	function setProject(value) {
	  return {
	    type: _actionTypes.SET_PROJECT,
	    value: value
	  };
	}
	
	function updateNode(nodeId, data) {
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.UPDATE_NODE,
	      projectId: projectId,
	      nodeId: nodeId,
	      data: data
	    });
	  };
	}
	
	function updateNodes(nodesIds, nodesData) {
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	
	    dispatch({
	      type: _actionTypes.UPDATE_NODES,
	      projectId: projectId,
	      nodesIds: nodesIds,
	      nodesData: nodesData
	    });
	  };
	}
	
	function removeEdge(edgeId) {
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.REMOVE_EDGE,
	      projectId: projectId,
	      edgeId: edgeId
	    });
	  };
	}
	
	function detachNode(nodeId) {
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.DETACH_NODE,
	      projectId: projectId,
	      nodeId: nodeId
	    });
	  };
	}
	
	function confirmRemoveNode(nodeId) {
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch((0, _popupActions.popupShow)(_popupTypes.PROJECT_CONFIRM_REMOVE_NODE, { nodeId: nodeId, projectId: projectId }));
	  };
	}
	
	function removeNode(nodeId) {
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.REMOVE_NODE,
	      projectId: projectId,
	      nodeId: nodeId
	    });
	  };
	}
	
	function addNode(_ref) {
	  var _ref$x = _ref.x;
	  var x = _ref$x === undefined ? 0 : _ref$x;
	  var _ref$y = _ref.y;
	  var y = _ref$y === undefined ? 0 : _ref$y;
	  var _ref$caption = _ref.caption;
	  var caption = _ref$caption === undefined ? 'caption' : _ref$caption;
	  var _ref$color = _ref.color;
	  var color = _ref$color === undefined ? '#555' : _ref$color;
	
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.ADD_NODE,
	      projectId: projectId,
	      nodeData: { caption: caption, color: color, x: x, y: y }
	    });
	  };
	}
	
	function appendNewNode(_ref2) {
	  var id = _ref2.id;
	  var _ref2$x = _ref2.x;
	  var x = _ref2$x === undefined ? 0 : _ref2$x;
	  var _ref2$y = _ref2.y;
	  var y = _ref2$y === undefined ? 0 : _ref2$y;
	  var _ref2$caption = _ref2.caption;
	  var caption = _ref2$caption === undefined ? 'caption' : _ref2$caption;
	  var _ref2$color = _ref2.color;
	  var color = _ref2$color === undefined ? '#555' : _ref2$color;
	
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.APPEND_NEW_NODE,
	      projectId: projectId,
	      newNodeData: { caption: caption, color: color, x: x, y: y },
	      id: id
	    });
	  };
	}
	
	function appendRightConnectedNode(_ref3) {
	  var id = _ref3.id;
	  var _ref3$x = _ref3.x;
	  var x = _ref3$x === undefined ? 0 : _ref3$x;
	  var _ref3$y = _ref3.y;
	  var y = _ref3$y === undefined ? 0 : _ref3$y;
	  var _ref3$caption = _ref3.caption;
	  var caption = _ref3$caption === undefined ? 'caption' : _ref3$caption;
	  var _ref3$color = _ref3.color;
	  var color = _ref3$color === undefined ? '#555' : _ref3$color;
	
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.APPEND_RIGHT_CONNECTED_NODE,
	      projectId: projectId,
	      newNodeData: { caption: caption, color: color, x: x, y: y },
	      id: id
	    });
	  };
	}
	
	function appendBottomConnectedNode(_ref4) {
	  var id = _ref4.id;
	  var _ref4$x = _ref4.x;
	  var x = _ref4$x === undefined ? 0 : _ref4$x;
	  var _ref4$y = _ref4.y;
	  var y = _ref4$y === undefined ? 0 : _ref4$y;
	  var _ref4$caption = _ref4.caption;
	  var caption = _ref4$caption === undefined ? 'caption' : _ref4$caption;
	  var _ref4$color = _ref4.color;
	  var color = _ref4$color === undefined ? '#555' : _ref4$color;
	
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.APPEND_BOTTOM_CONNECTED_NODE,
	      projectId: projectId,
	      newNodeData: { caption: caption, color: color, x: x, y: y },
	      id: id
	    });
	  };
	}
	
	function appendRightNode(_ref5) {
	  var id = _ref5.id;
	  var _ref5$x = _ref5.x;
	  var x = _ref5$x === undefined ? 0 : _ref5$x;
	  var _ref5$y = _ref5.y;
	  var y = _ref5$y === undefined ? 0 : _ref5$y;
	  var _ref5$caption = _ref5.caption;
	  var caption = _ref5$caption === undefined ? 'caption' : _ref5$caption;
	  var _ref5$color = _ref5.color;
	  var color = _ref5$color === undefined ? '#555' : _ref5$color;
	
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.APPEND_RIGHT_NODE,
	      projectId: projectId,
	      newNodeData: { caption: caption, color: color, x: x, y: y },
	      id: id
	    });
	  };
	}
	
	function addEdge(from, to) {
	  return function (dispatch, getState) {
	    var projectId = getState().routing.params.projectId;
	
	    dispatch({
	      type: _actionTypes.ADD_EDGE,
	      projectId: projectId,
	      from: from,
	      to: to
	    });
	  };
	}
	
	function setPermission(userId, projectId, isPublic, isListed) {
	  return {
	    type: _actionTypes.SET_PERMISSION,
	    userId: userId,
	    projectId: projectId,
	    isPublic: isPublic,
	    isListed: isListed
	  };
	}
	
	function projectDelete(project) {
	  return {
	    type: _actionTypes.DELETE_PROJECT,
	    project: project
	  };
	}
	
	function shareProject(project) {
	  return function (dispatch, getState) {
	    var user = getState().user.authorizedUser;
	
	    var userId = user.id;
	    var userName = user.displayName;
	
	    dispatch({
	      type: _actionTypes.SHARE_PROJECT,
	      project: project, userId: userId, userName: userName
	    });
	  };
	}
	
	var shareProjectSuccess = exports.shareProjectSuccess = function shareProjectSuccess() {
	  return { type: _actionTypes.SHARE_PROJECT_SUCCESS };
	};
	var shareProjectGotFBLink = exports.shareProjectGotFBLink = function shareProjectGotFBLink(link) {
	  return {
	    type: _actionTypes.SHARE_PROJECT_GOT_FB_LINK,
	    link: link
	  };
	};
	var shareProjectFailure = exports.shareProjectFailure = function shareProjectFailure() {
	  return { type: _actionTypes.SHARE_PROJECT_FAILURE };
	};
	var shareProjectPopupOpened = exports.shareProjectPopupOpened = function shareProjectPopupOpened() {
	  return { type: _actionTypes.SHARE_PROJECT_POPUP_OPENED };
	};
	var shareProjectShowFBPopup = exports.shareProjectShowFBPopup = function shareProjectShowFBPopup(link) {
	  (0, _projectActions.showProjectShareFBPopup)(link);
	
	  return function (dispatch) {
	    dispatch(shareProjectPopupOpened());
	    dispatch(shareProjectSuccess());
	    dispatch((0, _popupActions.popupCloseLast)());
	  };
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ROUTE_TRANSITION_FINISHED = exports.SET_PERMISSION = exports.APPEND_BOTTOM_CONNECTED_NODE = exports.APPEND_RIGHT_CONNECTED_NODE = exports.APPEND_RIGHT_NODE = exports.APPEND_NEW_NODE = exports.DETACH_NODE = exports.REMOVE_EDGE = exports.ADD_EDGE = exports.REMOVE_NODE = exports.UPDATE_NODES = exports.UPDATE_NODE = exports.ADD_NODE = exports.SHARE_PROJECT_POPUP_OPENED = exports.SHARE_PROJECT_FAILURE = exports.SHARE_PROJECT_SUCCESS = exports.SHARE_PROJECT_GOT_FB_LINK = exports.SHARE_PROJECT = exports.DELETE_PROJECT = exports.SET_PROJECT = exports.UPDATE_PROJECT_NAME = exports.ADD_PROJECT = exports.POPUP_CLOSE_LAST = exports.POPUP_CLOSE = exports.POPUP_SHOW = exports.USER_SET_WELCOME_POPUP_SHOWN = exports.USER_SET_FIRST_LOGIN = exports.SET_EDITOR_NODE = exports.SET_PROJECTS_LIST = exports.SET_SHOWN_USER = exports.LOG_IN_AND_TO_INDEX = exports.SET_AUTHORIZED_USER = exports.SET_AUTHORIZING = exports.LOGGED_IN = exports.LOG_OUT = exports.LOG_IN = exports.NOTIFICATION_RESUME = exports.NOTIFICATION_PAUSE = exports.NOTIFICATION_REMOVE = exports.NOTIFICATION_ADD = exports.API_ERRORS = exports.API_FAILURE = exports.POPUP_ERRORS_SET = exports.ROUTING_ACTIONS_KEYS = undefined;
	
	var _routing = __webpack_require__(27);
	
	var ROUTING_ACTIONS = _interopRequireWildcard(_routing);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ROUTING_ACTIONS_KEYS = exports.ROUTING_ACTIONS_KEYS = Object.keys(ROUTING_ACTIONS);
	/* injects from baggage-loader */
	
	var POPUP_ERRORS_SET = exports.POPUP_ERRORS_SET = 'POPUP_ERRORS_SET';
	
	var API_FAILURE = exports.API_FAILURE = 'API_FAILURE';
	var API_ERRORS = exports.API_ERRORS = 'API_ERRORS';
	
	var NOTIFICATION_ADD = exports.NOTIFICATION_ADD = 'NOTIFICATION_ADD';
	var NOTIFICATION_REMOVE = exports.NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';
	
	var NOTIFICATION_PAUSE = exports.NOTIFICATION_PAUSE = 'NOTIFICATION_PAUSE';
	var NOTIFICATION_RESUME = exports.NOTIFICATION_RESUME = 'NOTIFICATION_RESUME';
	
	var LOG_IN = exports.LOG_IN = 'LOG_IN';
	var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
	var LOGGED_IN = exports.LOGGED_IN = 'LOGGED_IN';
	var SET_AUTHORIZING = exports.SET_AUTHORIZING = 'SET_AUTHORIZING';
	var SET_AUTHORIZED_USER = exports.SET_AUTHORIZED_USER = 'SET_AUTHORIZED_USER';
	var LOG_IN_AND_TO_INDEX = exports.LOG_IN_AND_TO_INDEX = 'LOG_IN_AND_TO_INDEX';
	
	var SET_SHOWN_USER = exports.SET_SHOWN_USER = 'SET_SHOWN_USER';
	var SET_PROJECTS_LIST = exports.SET_PROJECTS_LIST = 'SET_PROJECTS_LIST';
	
	var SET_EDITOR_NODE = exports.SET_EDITOR_NODE = 'SET_EDITOR_NODE';
	
	var USER_SET_FIRST_LOGIN = exports.USER_SET_FIRST_LOGIN = 'USER_SET_FIRST_LOGIN';
	var USER_SET_WELCOME_POPUP_SHOWN = exports.USER_SET_WELCOME_POPUP_SHOWN = 'USER_SET_WELCOME_POPUP_SHOWN';
	
	var POPUP_SHOW = exports.POPUP_SHOW = 'POPUP_SHOW';
	var POPUP_CLOSE = exports.POPUP_CLOSE = 'POPUP_CLOSE';
	var POPUP_CLOSE_LAST = exports.POPUP_CLOSE_LAST = 'POPUP_CLOSE_LAST';
	
	var ADD_PROJECT = exports.ADD_PROJECT = 'ADD_PROJECT';
	var UPDATE_PROJECT_NAME = exports.UPDATE_PROJECT_NAME = 'UPDATE_PROJECT_NAME';
	var SET_PROJECT = exports.SET_PROJECT = 'SET_PROJECT';
	var DELETE_PROJECT = exports.DELETE_PROJECT = 'DELETE_PROJECT';
	var SHARE_PROJECT = exports.SHARE_PROJECT = 'SHARE_PROJECT';
	var SHARE_PROJECT_GOT_FB_LINK = exports.SHARE_PROJECT_GOT_FB_LINK = 'SHARE_PROJECT_GOT_FB_LINK';
	var SHARE_PROJECT_SUCCESS = exports.SHARE_PROJECT_SUCCESS = 'SHARE_PROJECT_SUCCESS';
	var SHARE_PROJECT_FAILURE = exports.SHARE_PROJECT_FAILURE = 'SHARE_PROJECT_FAILURE';
	var SHARE_PROJECT_POPUP_OPENED = exports.SHARE_PROJECT_POPUP_OPENED = 'SHARE_PROJECT_POPUP_OPENED';
	
	var ADD_NODE = exports.ADD_NODE = 'ADD_NODE';
	var UPDATE_NODE = exports.UPDATE_NODE = 'UPDATE_NODE';
	var UPDATE_NODES = exports.UPDATE_NODES = 'UPDATE_NODES';
	var REMOVE_NODE = exports.REMOVE_NODE = 'REMOVE_NODE';
	var ADD_EDGE = exports.ADD_EDGE = 'ADD_EDGE';
	var REMOVE_EDGE = exports.REMOVE_EDGE = 'REMOVE_EDGE';
	var DETACH_NODE = exports.DETACH_NODE = 'DETACH_NODE';
	var APPEND_NEW_NODE = exports.APPEND_NEW_NODE = 'APPEND_NEW_NODE';
	var APPEND_RIGHT_NODE = exports.APPEND_RIGHT_NODE = 'APPEND_RIGHT_NODE';
	var APPEND_RIGHT_CONNECTED_NODE = exports.APPEND_RIGHT_CONNECTED_NODE = 'APPEND_RIGHT_CONNECTED_NODE';
	var APPEND_BOTTOM_CONNECTED_NODE = exports.APPEND_BOTTOM_CONNECTED_NODE = 'APPEND_BOTTOM_CONNECTED_NODE';
	
	var SET_PERMISSION = exports.SET_PERMISSION = 'SET_PERMISSION';
	
	var ROUTE_TRANSITION_FINISHED = exports.ROUTE_TRANSITION_FINISHED = 'ROUTE_TRANSITION_FINISHED';

/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	var JALAN_USER_LIST = exports.JALAN_USER_LIST = 'JALAN_USER_LIST';
	
	var JALAN_INDEX = exports.JALAN_INDEX = 'JALAN_INDEX';
	var JALAN_INDEX_PROJECT = exports.JALAN_INDEX_PROJECT = 'JALAN_INDEX_PROJECT';
	var JALAN_PROJECT = exports.JALAN_PROJECT = 'JALAN_PROJECT';
	var JALAN_PROJECT_NODE = exports.JALAN_PROJECT_NODE = 'JALAN_PROJECT_NODE';
	var JALAN_NODE = exports.JALAN_NODE = 'JALAN_NODE';
	
	var JALAN_TEST = exports.JALAN_TEST = 'JALAN_TEST';

/***/ },
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	/* injects from baggage-loader */
	
	exports.stupidRouteType = stupidRouteType;
	exports.stupidRoute = stupidRoute;
	exports.right = right;
	exports.left = left;
	exports.goRight = goRight;
	exports.goLeft = goLeft;
	exports.openIndex = openIndex;
	exports.previewProject = previewProject;
	exports.viewProject = viewProject;
	
	var _invariant = __webpack_require__(4);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _routing = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = __webpack_require__(40)('metapro:actions:routing');
	
	function stupidRouteType(_ref) {
	  var userId = _ref.userId;
	  var projectId = _ref.projectId;
	  var nodeId = _ref.nodeId;
	  var preview = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  if (projectId) {
	    if (nodeId) {
	      return [preview ? _routing.JALAN_PROJECT_NODE : _routing.JALAN_NODE, { projectId: projectId, nodeId: nodeId }];
	    }
	    return [preview ? _routing.JALAN_INDEX_PROJECT : _routing.JALAN_PROJECT, { userId: userId, projectId: projectId }];
	  }
	
	  return [_routing.JALAN_INDEX, {}];
	}
	
	function stupidRoute() {
	  var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var preview = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  var _stupidRouteType = stupidRouteType(params, preview);
	
	  var _stupidRouteType2 = _slicedToArray(_stupidRouteType, 2);
	
	  var type = _stupidRouteType2[0];
	  var cleanParams = _stupidRouteType2[1];
	
	  return { type: type, params: cleanParams };
	}
	
	function right(_ref2) {
	  var routing = _ref2.routing;
	  var type = routing.type;
	
	
	  switch (type) {
	    case _routing.JALAN_USER_LIST:
	      return { type: _routing.JALAN_USER_LIST, params: routing.params };
	
	    case _routing.JALAN_INDEX_PROJECT:
	      return { type: _routing.JALAN_PROJECT, params: routing.params };
	
	    case _routing.JALAN_PROJECT_NODE:
	      return { type: _routing.JALAN_NODE, params: routing.params };
	
	    case _routing.JALAN_INDEX:
	      // fixes https://trello.com/c/QQdDWWO8/81-2-3
	      return { type: _routing.JALAN_INDEX, params: {} };
	
	    default:
	      (0, _invariant2.default)(false, 'no right route for ' + type);
	  }
	}
	
	function left(_ref3) {
	  var project = _ref3.project;
	  var routing = _ref3.routing;
	  var type = routing.type;
	
	
	  switch (type) {
	    case _routing.JALAN_USER_LIST:
	      return { type: _routing.JALAN_USER_LIST, params: { userId: routing.params.userId } };
	
	    case _routing.JALAN_INDEX_PROJECT:
	      return { type: _routing.JALAN_USER_LIST, params: { userId: routing.params.userId } };
	
	    case _routing.JALAN_PROJECT:
	      return {
	        type: _routing.JALAN_INDEX_PROJECT,
	        params: {
	          projectId: routing.params.projectId, userId: project.owner
	        }
	      };
	
	    case _routing.JALAN_PROJECT_NODE:
	      return { type: _routing.JALAN_PROJECT, params: { projectId: routing.params.projectId } };
	
	    case _routing.JALAN_NODE:
	      return {
	        type: _routing.JALAN_PROJECT_NODE,
	        params: { projectId: routing.params.projectId, nodeId: routing.params.nodeId }
	      };
	
	    default:
	      (0, _invariant2.default)(false, 'no left route for ' + type);
	  }
	}
	
	function goRight() {
	  return function (dispatch, getState) {
	    var _getState = getState();
	
	    var routing = _getState.routing;
	    var project = _getState.projects.project;
	
	
	    var data = { routing: routing, project: project };
	
	    debug('go right', data);
	    dispatch(right(data));
	  };
	}
	
	function goLeft() {
	  return function (dispatch, getState) {
	    var _getState2 = getState();
	
	    var routing = _getState2.routing;
	    var project = _getState2.projects.project;
	
	
	    var data = { routing: routing, project: project };
	
	    debug('go left', data);
	    dispatch(left(data));
	  };
	}
	
	function openIndex() {
	  return {
	    type: _routing.JALAN_INDEX,
	    params: {}
	  };
	}
	
	function previewProject(userId, projectId) {
	  return stupidRoute({ userId: userId, projectId: projectId }, true);
	}
	
	function viewProject(userId, projectId) {
	  return stupidRoute({ userId: userId, projectId: projectId }, false);
	}

/***/ },
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setWelcomePopupShown = exports.logInAndToIndex = exports.setAuthorizedUser = exports.setAuthorizing = exports.setShownUser = exports.logOut = exports.loggedIn = exports.logIn = undefined;
	exports.showWelcomePopup = showWelcomePopup;
	exports.setFirstLogin = setFirstLogin;
	
	var _actionTypes = __webpack_require__(23);
	
	var _routing = __webpack_require__(27);
	
	var _popupTypes = __webpack_require__(102);
	
	var _popupActions = __webpack_require__(101);
	
	/* injects from baggage-loader */
	
	var logIn = exports.logIn = function logIn() {
	  return { type: _actionTypes.LOG_IN };
	};
	var loggedIn = exports.loggedIn = function loggedIn() {
	  return { type: _actionTypes.LOGGED_IN };
	};
	var logOut = exports.logOut = function logOut() {
	  return { type: _actionTypes.LOG_OUT };
	};
	
	var setShownUser = exports.setShownUser = function setShownUser(value) {
	  return { type: _actionTypes.SET_SHOWN_USER, value: value };
	};
	var setAuthorizing = exports.setAuthorizing = function setAuthorizing(value) {
	  return { type: _actionTypes.SET_AUTHORIZING, value: value };
	};
	var setAuthorizedUser = exports.setAuthorizedUser = function setAuthorizedUser(value) {
	  return { type: _actionTypes.SET_AUTHORIZED_USER, value: value };
	};
	var logInAndToIndex = exports.logInAndToIndex = function logInAndToIndex() {
	  return { type: _actionTypes.LOG_IN_AND_TO_INDEX };
	};
	var setWelcomePopupShown = exports.setWelcomePopupShown = function setWelcomePopupShown(value) {
	  return { type: _actionTypes.USER_SET_WELCOME_POPUP_SHOWN, value: value };
	};
	
	function showWelcomePopup() {
	  return function (dispatch) {
	    setTimeout(function () {
	      dispatch(setWelcomePopupShown(true));
	      dispatch((0, _popupActions.popupShow)(_popupTypes.WELCOME));
	    }, 100);
	  };
	}
	
	var mustShowWelcomePopup = function mustShowWelcomePopup(routeType) {
	  return [_routing.JALAN_USER_PROJECT, _routing.JALAN_PROJECT, _routing.JALAN_NODE, _routing.JALAN_USER_NODE].indexOf(routeType) > -1;
	};
	
	function setFirstLogin(value) {
	  return function (dispatch, getState) {
	    var routeType = getState().routing.type;
	
	    dispatch({ type: _actionTypes.USER_SET_FIRST_LOGIN, value: value });
	
	    if (value && mustShowWelcomePopup(routeType)) dispatch(showWelcomePopup());
	  };
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ref;
	
	/* injects from baggage-loader */
	
	var firebase = __webpack_require__(802);
	
	// Initialize Firebase
	var config = {
	  apiKey: 'AIzaSyDyruKX8Qig8p2KIdcnN8MRMQKVvxJumhE',
	  authDomain: 'meta-pro-naissur.firebaseapp.com',
	  databaseURL: 'https://meta-pro-naissur.firebaseio.com',
	  storageBucket: 'meta-pro-naissur.appspot.com',
	  messagingSenderId: '723172402961'
	};
	firebase.initializeApp(config);
	
	var rootRef = firebase.database().ref();
	
	function ref(path, parentRef) {
	
	  if (!path || path.length === 0) {
	    return parentRef || rootRef;
	  }
	
	  if (parentRef) {
	    var parentPath = parentRef.toString().replace(rootRef.toString(), '');
	    return ref(parentPath + '/' + path);
	  }
	
	  return rootRef.child(path);
	}
	
	var auth = exports.auth = firebase.auth();

/***/ },
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Logout = exports.LoginSmall = exports.Login = undefined;
	
	var _Login = __webpack_require__(542);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _LoginSmall = __webpack_require__(543);
	
	var _LoginSmall2 = _interopRequireDefault(_LoginSmall);
	
	var _Logout = __webpack_require__(544);
	
	var _Logout2 = _interopRequireDefault(_Logout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Login = _Login2.default;
	exports.LoginSmall = _LoginSmall2.default;
	exports.Logout = _Logout2.default;
	/* injects from baggage-loader */

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserMenu = exports.UserPic = exports.UserPageWrapper = undefined;
	
	var _UserPage = __webpack_require__(228);
	
	var _UserPage2 = _interopRequireDefault(_UserPage);
	
	var _UserPageWrapper = __webpack_require__(618);
	
	var _UserPageWrapper2 = _interopRequireDefault(_UserPageWrapper);
	
	var _UserPic = __webpack_require__(619);
	
	var _UserPic2 = _interopRequireDefault(_UserPic);
	
	var _UserMenu = __webpack_require__(227);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	exports.default = _UserPage2.default;
	exports.UserPageWrapper = _UserPageWrapper2.default;
	exports.UserPic = _UserPic2.default;
	exports.UserMenu = _UserMenu2.default;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.guid = exports.randomElement = exports.getClosestPair = exports.dist = exports.xprod = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	/* injects from baggage-loader */
	
	exports.toCamelCase = toCamelCase;
	exports.toSnakeCase = toSnakeCase;
	exports.prependZeroes = prependZeroes;
	exports.parsePhone = parsePhone;
	exports.unparsePhone = unparsePhone;
	exports.areDatesEqualUpToPrecision = areDatesEqualUpToPrecision;
	exports.areDatesFullPeriod = areDatesFullPeriod;
	exports.capitalizeWords = capitalizeWords;
	exports.interpolateLinear = interpolateLinear;
	exports.padNumber = padNumber;
	exports.getPairs = getPairs;
	exports.minimum = minimum;
	exports.maximum = maximum;
	exports.numberWithSpaces = numberWithSpaces;
	
	var _lodash = __webpack_require__(28);
	
	var _snakeCase = __webpack_require__(1074);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _camelCase = __webpack_require__(650);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _curry = __webpack_require__(259);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function changeCase(obj, transform) {
	  if ((0, _lodash.isArray)(obj)) {
	    return obj.map(function (x) {
	      return changeCase(x, transform);
	    });
	  } else if ((0, _lodash.isObject)(obj)) {
	    return (0, _lodash.mapValues)((0, _lodash.mapKeys)(obj, function (v, k) {
	      return transform(k);
	    }), function (x) {
	      return changeCase(x, transform);
	    });
	  }
	  return obj;
	}
	
	function toCamelCase(obj) {
	  return changeCase(obj, _camelCase2.default);
	}
	
	function toSnakeCase(obj) {
	  return changeCase(obj, _snakeCase2.default);
	}
	
	function prependZeroes(value, length) {
	  var zeroes = '';
	  for (var i = 0; i < length; i++) {
	    zeroes += '0';
	  }
	  return (zeroes + value).slice(-length);
	}
	
	function parsePhone(phone) {
	  return phone ? phone.replace('+7', '').replace(/\s+/g, '') : '';
	}
	
	function unparsePhone(phone) {
	  return phone ? '+7 ' + phone.slice(0, 3) + ' ' + phone.slice(3, 6) + ' ' + phone.slice(6, 8) + ' ' + phone.slice(8, 10) : '';
	}
	
	function areDatesEqualUpToPrecision(d1, d2) {
	  var precision = arguments.length <= 2 || arguments[2] === undefined ? 'day' : arguments[2];
	
	  var nd1 = (0, _moment2.default)(d1).startOf(precision);
	  var nd2 = (0, _moment2.default)(d2).startOf(precision);
	
	  return nd1.diff(nd2) === 0;
	}
	
	function areDatesFullPeriod(_ref) {
	  var start = _ref.start;
	  var end = _ref.end;
	  var _ref$period = _ref.period;
	  var period = _ref$period === undefined ? 'month' : _ref$period;
	  var _ref$precision = _ref.precision;
	  var precision = _ref$precision === undefined ? 'day' : _ref$precision;
	
	  var mStart = (0, _moment2.default)(start);
	  var mEnd = (0, _moment2.default)(end);
	
	  var mStartOf = (0, _moment2.default)(mStart).startOf(period);
	  var mEndOf = (0, _moment2.default)(mEnd).endOf(period);
	
	  var numberOfPeriods = Math.ceil(mEndOf.diff(mStartOf, period, true));
	
	  return numberOfPeriods === 1 && areDatesEqualUpToPrecision(mStart, mStartOf, precision) && areDatesEqualUpToPrecision(mEnd, mEndOf, precision);
	}
	
	function capitalizeWords(s) {
	  return s.replace(/(?:^|\s)\S/g, function (a) {
	    return a.toUpperCase();
	  });
	}
	
	// ==================== //
	// =       MATH       = //
	// ==================== //
	
	function interpolateLinear(_ref2) {
	  var a = _ref2.a;
	  var b = _ref2.b;
	  var c = _ref2.c;
	  var d = _ref2.d;
	  var x = _ref2.x;
	
	  if (b - a < 10e-30) {
	    return c + d / 2;
	  } // a being equal to b leads to undefined results
	
	  var relative = (x - a) / (b - a);
	  return relative * (d - c) + c;
	}
	
	function padNumber(_ref3) {
	  var _ref3$min = _ref3.min;
	  var min = _ref3$min === undefined ? -Infinity : _ref3$min;
	  var _ref3$max = _ref3.max;
	  var max = _ref3$max === undefined ? Infinity : _ref3$max;
	  var x = _ref3.x;
	
	  if (x < min) {
	    return min;
	  }
	  if (x > max) {
	    return max;
	  }
	
	  return x;
	}
	
	// getPairs([1,2,3]) -> [[1, 2], [2, 3]]
	// getPairs([1,2,3], true) -> [[1, 2], [2, 3], [3, undefined]]
	function getPairs(array) {
	  var includeLast = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  var zipped = (0, _lodash.zip)(array, (0, _lodash.drop)(array));
	  return includeLast ? zipped : (0, _lodash.dropRight)(zipped);
	}
	
	function minimum(arr) {
	  return arr.reduce(function (a, b) {
	    return Math.min(a, b);
	  }, Infinity);
	}
	
	function maximum(arr) {
	  return arr.reduce(function (a, b) {
	    return Math.max(a, b);
	  }, -Infinity);
	}
	
	function numberWithSpaces(x) {
	  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}
	
	// cartesian product of two lists
	var xprod = exports.xprod = function xprod(a, b) {
	  var idx = 0;
	  var ilen = a.length;
	  var j = undefined;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	};
	
	// distance between points
	var dist = exports.dist = (0, _curry2.default)(function (a, b) {
	  var dx = Math.abs(a.x - b.x);
	  var dy = Math.abs(a.y - b.y);
	  return Math.sqrt(dx * dx + dy * dy);
	});
	
	var getClosestPair = exports.getClosestPair = function getClosestPair(a, b) {
	  var allPairs = xprod(a, b);
	  var result = allPairs.reduce(function (_ref4, _ref5) {
	    var minP1 = _ref4.minP1;
	    var minP2 = _ref4.minP2;
	    var minDist = _ref4.minDist;
	
	    var _ref6 = _slicedToArray(_ref5, 2);
	
	    var p1 = _ref6[0];
	    var p2 = _ref6[1];
	
	    var currDist = dist(p1, p2);
	    return currDist < minDist ? { minP1: p1, minP2: p2, minDist: currDist } : { minP1: minP1, minP2: minP2, minDist: minDist };
	  }, { minP1: {}, minP2: {}, minDist: Infinity });
	
	  var p1 = result.minP1;
	  var p2 = result.minP2;
	  var minDist = result.minDist;
	
	
	  return { p1: p1, p2: p2, dist: minDist };
	};
	
	var randomElement = exports.randomElement = function randomElement(array) {
	  return array[Math.floor(Math.random() * array.length)];
	};
	
	var guid = exports.guid = function guid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c === 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	};

/***/ },
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Faded = exports.Approve = exports.Paragraph = exports.HeadingSmall = exports.HeadingMedium = exports.HeadingLarge = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(472);
	
	var getStylesFromProps = function getStylesFromProps(_ref) {
	  var _ref$customTextAlign = _ref.customTextAlign;
	  var customTextAlign = _ref$customTextAlign === undefined ? null : _ref$customTextAlign;
	  var _ref$customMarginTop = _ref.customMarginTop;
	  var customMarginTop = _ref$customMarginTop === undefined ? null : _ref$customMarginTop;
	  var _ref$noMargins = _ref.noMargins;
	  var noMargins = _ref$noMargins === undefined ? false : _ref$noMargins;
	  var _ref$fontMedium = _ref.fontMedium;
	  var fontMedium = _ref$fontMedium === undefined ? null : _ref$fontMedium;
	  return {
	    marginTop: customMarginTop,
	    textAlign: customTextAlign,
	    fontWeight: fontMedium && 500,
	    margin: noMargins && '0'
	  };
	};
	
	var HeadingLarge = exports.HeadingLarge = function (_Component) {
	  _inherits(HeadingLarge, _Component);
	
	  function HeadingLarge() {
	    _classCallCheck(this, HeadingLarge);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(HeadingLarge).apply(this, arguments));
	  }
	
	  _createClass(HeadingLarge, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'h1',
	        { style: getStylesFromProps(this.props), className: styles.headingLarge },
	        this.props.children
	      );
	    }
	  }]);
	
	  return HeadingLarge;
	}(_react.Component);
	
	var HeadingMedium = exports.HeadingMedium = function (_Component2) {
	  _inherits(HeadingMedium, _Component2);
	
	  function HeadingMedium() {
	    _classCallCheck(this, HeadingMedium);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(HeadingMedium).apply(this, arguments));
	  }
	
	  _createClass(HeadingMedium, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'h2',
	        { style: getStylesFromProps(this.props), className: styles.headingMedium },
	        this.props.children
	      );
	    }
	  }]);
	
	  return HeadingMedium;
	}(_react.Component);
	
	var HeadingSmall = exports.HeadingSmall = function (_Component3) {
	  _inherits(HeadingSmall, _Component3);
	
	  function HeadingSmall() {
	    _classCallCheck(this, HeadingSmall);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(HeadingSmall).apply(this, arguments));
	  }
	
	  _createClass(HeadingSmall, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'h3',
	        { style: getStylesFromProps(this.props), className: styles.headingSmall },
	        this.props.children
	      );
	    }
	  }]);
	
	  return HeadingSmall;
	}(_react.Component);
	
	var Paragraph = exports.Paragraph = function (_Component4) {
	  _inherits(Paragraph, _Component4);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Paragraph).apply(this, arguments));
	  }
	
	  _createClass(Paragraph, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'p',
	        { style: getStylesFromProps(this.props), className: styles.paragraph },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Paragraph;
	}(_react.Component);
	
	var Approve = exports.Approve = function (_Component5) {
	  _inherits(Approve, _Component5);
	
	  function Approve() {
	    _classCallCheck(this, Approve);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Approve).apply(this, arguments));
	  }
	
	  _createClass(Approve, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.approve },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Approve;
	}(_react.Component);
	
	var Faded = exports.Faded = function (_Component6) {
	  _inherits(Faded, _Component6);
	
	  function Faded() {
	    _classCallCheck(this, Faded);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Faded).apply(this, arguments));
	  }
	
	  _createClass(Faded, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: styles.faded },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Faded;
	}(_react.Component);

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keyedLense = exports.inspect = exports.equals = exports.map = exports.getProp = exports.setProp = exports.add = exports.id = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	exports.compose = compose;
	
	var _curry = __webpack_require__(259);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var debug = __webpack_require__(40)('metapro:curry');
	
	var id = exports.id = (0, _curry2.default)(function (x) {
	  return x;
	});
	var add = exports.add = (0, _curry2.default)(function (a, b) {
	  return a + b;
	});
	var setProp = exports.setProp = (0, _curry2.default)(function (key, value, obj) {
	  return _extends({}, obj, _defineProperty({}, key, value));
	});
	var getProp = exports.getProp = (0, _curry2.default)(function (key, obj) {
	  return obj[key];
	});
	var map = exports.map = (0, _curry2.default)(function (fn, array) {
	  return array.map(fn);
	});
	var equals = exports.equals = (0, _curry2.default)(function (a, b) {
	  return a === b;
	});
	
	var inspect = exports.inspect = (0, _curry2.default)(function (name, val) {
	  debug('Inspect: Calling "%s" with', name, val);
	  return val;
	});
	
	var keyedLense = exports.keyedLense = (0, _curry2.default)(function (key, fn, item) {
	  var value = getProp(key, item);
	  var newValue = fn(value);
	  return setProp(key, newValue, item);
	});
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return function apply() {
	    var args = arguments;
	    var length = funcs.length;
	
	    while (length--) {
	      args = [funcs[length].apply(this, args)];
	    }
	    return args[0];
	  };
	}

/***/ },
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.popupShow = popupShow;
	exports.popupCloseLast = popupCloseLast;
	
	var _actionTypes = __webpack_require__(23);
	
	function popupShow(type, data) {
	  return {
	    type: _actionTypes.POPUP_SHOW,
	    popupType: type,
	    popupData: data
	  };
	}
	/* injects from baggage-loader */
	
	function popupCloseLast() {
	  return {
	    type: _actionTypes.POPUP_CLOSE_LAST
	  };
	}

/***/ },
/* 102 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	var WELCOME = exports.WELCOME = 'WELCOME';
	var PROJECT_VISIBILITY = exports.PROJECT_VISIBILITY = 'PROJECT_VISIBILITY';
	var PROJECT_DELETE = exports.PROJECT_DELETE = 'PROJECT_DELETE';
	var PROJECT_SHARE = exports.PROJECT_SHARE = 'PROJECT_SHARE';
	var PROJECT_SHARE_VISIBILITY_CHECK = exports.PROJECT_SHARE_VISIBILITY_CHECK = 'PROJECT_SHARE_VISIBILITY_CHECK';
	
	var PROJECT_CONFIRM_REMOVE_NODE = exports.PROJECT_CONFIRM_REMOVE_NODE = 'PROJECT_CONFIRM_REMOVE_NODE';

/***/ },
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Icons = __webpack_require__(558);
	
	var _loop = function _loop(_key2) {
	  if (_key2 === "default") return 'continue';
	  Object.defineProperty(exports, _key2, {
	    enumerable: true,
	    get: function get() {
	      return _Icons[_key2];
	    }
	  });
	};
	
	for (var _key2 in _Icons) {
	  var _ret = _loop(_key2);
	
	  if (_ret === 'continue') continue;
	}

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(478);
	
	var Spinner = function (_Component) {
	  _inherits(Spinner, _Component);
	
	  function Spinner() {
	    _classCallCheck(this, Spinner);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Spinner).apply(this, arguments));
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)(styles.spinner, this.props.white && styles.white, this.props.wide && styles.wide, this.props.field && styles.field, this.props.fullPage && styles.fullPage, this.props.routeSpinner && styles.routeSpinner, this.props.halfRouteSpinner && styles.halfRouteSpinner);
	
	      return _react2.default.createElement('span', { className: className });
	    }
	  }]);
	
	  return Spinner;
	}(_react.Component);
	
	exports.default = Spinner;
	
	
	Spinner.propTypes = {
	  wide: _react.PropTypes.bool,
	  field: _react.PropTypes.bool,
	  fullPage: _react.PropTypes.bool,
	  routeSpinner: _react.PropTypes.bool,
	  halfRouteSpinner: _react.PropTypes.bool,
	  white: _react.PropTypes.bool
	};

/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	exports.default = {
	  NODE: 'node',
	  SCENE: 'scene',
	  NODE_HANDLE: 'node_handle'
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.icons = exports.PERMISSIONS = undefined;
	
	var _icons;
	
	exports.getPermission = getPermission;
	exports.parsePermission = parsePermission;
	exports.getPermissionIcon = getPermissionIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* injects from baggage-loader */
	
	var PERMISSIONS = exports.PERMISSIONS = {
	  PUBLIC: 'PUBLIC',
	  UNLISTED: 'UNLISTED',
	  PRIVATE: 'PRIVATE'
	};
	
	var icons = exports.icons = (_icons = {}, _defineProperty(_icons, PERMISSIONS.PRIVATE, _react2.default.createElement(_Icons.PermissionPrivate, { width: '14', height: '14' })), _defineProperty(_icons, PERMISSIONS.UNLISTED, _react2.default.createElement(_Icons.PermissionUnlisted, { width: '14', height: '14' })), _defineProperty(_icons, PERMISSIONS.PUBLIC, null), _icons);
	
	function getPermission() {
	  var project = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var userPublicProjects = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  if (project.public) {
	    if (userPublicProjects.hasOwnProperty(project.id)) {
	      return PERMISSIONS.PUBLIC;
	    }
	    return PERMISSIONS.UNLISTED;
	  }
	  return PERMISSIONS.PRIVATE;
	}
	
	function parsePermission(permission) {
	  var isPublic = permission === PERMISSIONS.PUBLIC || permission === PERMISSIONS.UNLISTED;
	  var isListed = permission === PERMISSIONS.PUBLIC;
	  return {
	    isPublic: isPublic,
	    isListed: isListed
	  };
	}
	
	function getPermissionIcon(permission) {
	  return icons[permission];
	}

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FontFace = __webpack_require__(76);
	
	var _FontFace2 = _interopRequireDefault(_FontFace);
	
	var _measureText = __webpack_require__(173);
	
	var _measureText2 = _interopRequireDefault(_measureText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	exports.default = function (_ref) {
	  var text = _ref.text;
	  var _ref$maxWidth = _ref.maxWidth;
	  var maxWidth = _ref$maxWidth === undefined ? +Infinity : _ref$maxWidth;
	  var _ref$fontFamily = _ref.fontFamily;
	  var fontFamily = _ref$fontFamily === undefined ? 'sans-serif' : _ref$fontFamily;
	  var _ref$fontSize = _ref.fontSize;
	  var fontSize = _ref$fontSize === undefined ? 14 : _ref$fontSize;
	  var _ref$lineHeight = _ref.lineHeight;
	  var lineHeight = _ref$lineHeight === undefined ? fontSize * 1.3 : _ref$lineHeight;
	  return (0, _measureText2.default)(text, maxWidth, (0, _FontFace2.default)(fontFamily), fontSize, lineHeight);
	};

/***/ },
/* 141 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	var PROJECTS_DATA = exports.PROJECTS_DATA = 'PROJECTS_DATA';
	var PROJECT_DATA = exports.PROJECT_DATA = 'PROJECT_DATA';
	var NODE_DATA = exports.NODE_DATA = 'NODE_DATA';

/***/ },
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ROUTES, _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _reactAddonsTransitionGroup = __webpack_require__(898);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDom = __webpack_require__(29);
	
	var _CSSCore = __webpack_require__(154);
	
	var _CSSCore2 = _interopRequireDefault(_CSSCore);
	
	var _App = __webpack_require__(541);
	
	var _routing = __webpack_require__(44);
	
	var _routing2 = __webpack_require__(27);
	
	var _actionTypes = __webpack_require__(23);
	
	var _UserPage = __webpack_require__(228);
	
	var _UserPage2 = _interopRequireDefault(_UserPage);
	
	var _ProjectPage = __webpack_require__(217);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	var _NodePage = __webpack_require__(564);
	
	var _NodePage2 = _interopRequireDefault(_NodePage);
	
	var _TestPage = __webpack_require__(614);
	
	var _TestPage2 = _interopRequireDefault(_TestPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(459);
	
	var animation = {
	  time: 300,
	  rightOut: styles.rightOut,
	  rightIn: styles.rightIn,
	  leftOut: styles.leftOut,
	  pause: styles.pause
	};
	
	var ROUTES = (_ROUTES = {}, _defineProperty(_ROUTES, _routing2.JALAN_USER_LIST, [_UserPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_INDEX, [_UserPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_INDEX_PROJECT, [_UserPage2.default, _ProjectPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_PROJECT, [_ProjectPage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_PROJECT_NODE, [_ProjectPage2.default, _NodePage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_NODE, [_NodePage2.default]), _defineProperty(_ROUTES, _routing2.JALAN_TEST, [_TestPage2.default]), _ROUTES);
	
	var COMPONENT_ORDER = [_UserPage2.default, _ProjectPage2.default, _NodePage2.default];
	
	var getState = function getState(state) {
	  return {
	    routeType: state.routing.type
	  };
	};
	
	var AnimatedRoutes = (_dec = (0, _reduxSimple.connect)(getState, {
	  goLeft: _routing.goLeft,
	  goRight: _routing.goRight,
	  routeTransitionFinished: function routeTransitionFinished() {
	    return {
	      type: _actionTypes.ROUTE_TRANSITION_FINISHED
	    };
	  }
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AnimatedRoutes, _Component);
	
	  function AnimatedRoutes() {
	    _classCallCheck(this, AnimatedRoutes);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(AnimatedRoutes).apply(this, arguments));
	  }
	
	  _createClass(AnimatedRoutes, [{
	    key: 'elementHasParentLink',
	    value: function elementHasParentLink(node) {
	      var element = node;
	      while (element) {
	        if (element.nodeName === 'A') return true;
	        element = element.parentNode;
	      }
	      return false;
	    }
	  }, {
	    key: 'goLeft',
	    value: function goLeft(e) {
	      if (!this.elementHasParentLink(e.target)) {
	        this.props.goLeft();
	      }
	    }
	  }, {
	    key: 'goRight',
	    value: function goRight(e) {
	      e.preventDefault();
	
	      this.props.goRight();
	    }
	  }, {
	    key: 'getLeftRoute',
	    value: function getLeftRoute() {
	      return (0, _reactDom.findDOMNode)(this).childNodes[0];
	    }
	  }, {
	    key: 'transition',
	    value: function transition(isEnter, isLeftRoute, callback) {
	      var _this2 = this;
	
	      if (isEnter) {
	        callback();
	      } else {
	        setTimeout(callback, animation.time);
	      }
	      if (isLeftRoute) {
	        _CSSCore2.default.addClass(this.getLeftRoute(), animation.leftOut);
	        if (isEnter) {
	          _CSSCore2.default.addClass(this.getLeftRoute(), animation.pause);
	          setTimeout(function () {
	            _CSSCore2.default.removeClass(_this2.getLeftRoute(), animation.leftOut);
	            _CSSCore2.default.removeClass(_this2.getLeftRoute(), animation.pause);
	          }, 0);
	        }
	      }
	    }
	  }, {
	    key: 'prepareRoutes',
	    value: function prepareRoutes() {
	      var _this3 = this;
	
	      var routeType = this.props.routeType;
	
	      var routes = ROUTES[routeType];
	
	      return routes.map(function (routeComponent, index) {
	        var isLeftRoute = index === 0;
	        var className = (0, _classnames2.default)(styles.route, isLeftRoute && styles.leftRoute || styles.rightRoute, isLeftRoute && routes.length === 1 && animation.rightOut, isLeftRoute && routes.length === 2 && animation.rightIn);
	        var props = {
	          key: COMPONENT_ORDER.indexOf(routeComponent),
	          className: className,
	          enter: _this3.transition.bind(_this3, true, isLeftRoute),
	          leave: _this3.transition.bind(_this3, false, isLeftRoute),
	          routeTransitionFinished: _this3.props.routeTransitionFinished
	        };
	        if (routes.length === 2) props.onClick = isLeftRoute ? _this3.goLeft.bind(_this3) : _this3.goRight.bind(_this3);
	
	        return _react2.default.createElement(
	          _App.AnimatedRoute,
	          props,
	          _react2.default.createElement(routeComponent)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        {
	          component: 'div',
	          className: styles.routes
	        },
	        this.prepareRoutes()
	      );
	    }
	  }]);
	
	  return AnimatedRoutes;
	}(_react.Component), _class2.propTypes = {
	  routeType: _react.PropTypes.string.isRequired
	}, _temp)) || _class);
	exports.default = AnimatedRoutes;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AnimatedRoutes = __webpack_require__(208);
	
	var _AnimatedRoutes2 = _interopRequireDefault(_AnimatedRoutes);
	
	var _Wrapper = __webpack_require__(540);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _PopupManager = __webpack_require__(215);
	
	var _PopupManager2 = _interopRequireDefault(_PopupManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(460);
	
	_moment2.default.locale('ru');
	
	var App = (_temp = _class = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(App).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Wrapper2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: styles.container },
	          _react2.default.createElement(_PopupManager2.default, null),
	          _react2.default.createElement(_AnimatedRoutes2.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component), _class.propTypes = {
	  authorizedUser: _react.PropTypes.object
	}, _temp);
	exports.default = App;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(463);
	
	var ActionIcon = (_temp = _class = function (_Component) {
	  _inherits(ActionIcon, _Component);
	
	  function ActionIcon() {
	    _classCallCheck(this, ActionIcon);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ActionIcon).apply(this, arguments));
	  }
	
	  _createClass(ActionIcon, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)(styles.actionIcon, this.props.right && styles.right, this.props.noShadow && styles.noShadow, this.props.smallShadow && styles.smallShadow, this.props.margined && styles.margined, this.props.marginedBottom && styles.marginedBottom, this.props.active && styles.active);
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.props.onClick, className: className },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ActionIcon;
	}(_react.Component), _class.propTypes = {
	  onClick: _react.PropTypes.func,
	  children: _react.PropTypes.any,
	  right: _react.PropTypes.bool,
	  noShadow: _react.PropTypes.bool,
	  smallShadow: _react.PropTypes.bool,
	  margined: _react.PropTypes.bool,
	  marginedBottom: _react.PropTypes.bool,
	  active: _react.PropTypes.bool
	}, _temp);
	exports.default = ActionIcon;

/***/ },
/* 211 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	exports.default = ['#de0b73', '#ff3c3b', '#de2a0b', '#ff4a00', '#ff8000', '#de9a0b', '#ffc107', '#fbf60d', '#0dfbd4', '#baf030', '#60db13', '#0ac272', '#0d9ffb', '#0b56de', '#2d11af', '#9e41ff', '#323232', '#727272', '#a6a6a6', '#d0d0d0'];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OuterLink = exports.PseudoLink = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _invariant = __webpack_require__(4);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(989);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(471);
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	var Link = (_dec = (0, _reduxSimple.connect)(function (state) {
	  return {
	    routing: {
	      type: state.routing.type,
	      params: state.routing.params
	    }
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Link, _Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Link).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'simulateReactRouter',
	    value: function simulateReactRouter(event) {
	      var _props = this.props;
	      var onClick = _props.onClick;
	      var dispatch = _props.dispatch;
	      var jalan = _props.jalan;
	
	      var allowTransition = true;
	
	      if (onClick) {
	        onClick(event);
	      }
	
	      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
	        return;
	      }
	
	      if (event.defaultPrevented === true) {
	        allowTransition = false;
	      }
	
	      event.preventDefault();
	
	      if (allowTransition) {
	        dispatch(this.getRoutingAction());
	        var params = undefined;
	        var type = jalan.type;
	
	        if (jalan.params) {
	          params = jalan.params;
	        } else {
	          params = _lodash2.default.omit(jalan, 'type');
	        }
	        dispatch({ type: type, params: params });
	      }
	    }
	  }, {
	    key: 'getRoutingAction',
	    value: function getRoutingAction() {
	      var jalan = this.props.jalan;
	      var type = jalan.type;
	
	      var params = undefined;
	      if (jalan.params) {
	        params = jalan.params;
	      } else {
	        params = _lodash2.default.omit(jalan, 'type');
	      }
	      return { type: type, params: params };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var to = _props2.to;
	      var jalan = _props2.jalan;
	      var routing = _props2.routing;
	
	
	      (0, _invariant2.default)(to || jalan, 'Link requires either `to` or `jalan` prop');
	
	      var classNames = (0, _classnames2.default)(styles.link, this.props.noUnderline && styles.noUnderline, this.props.dotted && styles.dotted, this.props.className);
	
	      var activeClassName = (0, _classnames2.default)(!this.props.ignoreActive && styles.active);
	
	      if (jalan) {
	        if (_lodash2.default.isEqual(this.getRoutingAction(), routing)) {
	          classNames = (0, _classnames2.default)(classNames, activeClassName);
	        }
	        return _react2.default.createElement(
	          'a',
	          { href: '#jalan', className: classNames, onClick: this.simulateReactRouter.bind(this) },
	          this.props.children
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { to: to, onClick: this.props.onClick, className: classNames,
	          activeClassName: activeClassName },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Link;
	}(_react.Component), _class2.propTypes = {
	  children: _react.PropTypes.any,
	  to: _react.PropTypes.string,
	  jalan: _react.PropTypes.shape({
	    type: _react.PropTypes.string.isRequired
	  }),
	  ignoreActive: _react.PropTypes.bool,
	  noUnderline: _react.PropTypes.bool,
	  dotted: _react.PropTypes.bool,
	  onClick: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = Link;
	
	var PseudoLink = exports.PseudoLink = function (_Component2) {
	  _inherits(PseudoLink, _Component2);
	
	  function PseudoLink() {
	    _classCallCheck(this, PseudoLink);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(PseudoLink).apply(this, arguments));
	  }
	
	  _createClass(PseudoLink, [{
	    key: 'render',
	    value: function render() {
	      var classNames = (0, _classnames2.default)(styles.link, this.props.danger && styles.danger, this.props.white && styles.white, this.props.noUnderline && styles.noUnderline, this.props.dotted && styles.dotted);
	      return _react2.default.createElement(
	        'span',
	        _extends({}, this.props, { className: classNames }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return PseudoLink;
	}(_react.Component);
	
	PseudoLink.propTypes = {
	  children: _react.PropTypes.any,
	  white: _react.PropTypes.bool,
	  noUnderline: _react.PropTypes.bool,
	  dotted: _react.PropTypes.bool
	};
	
	var OuterLink = exports.OuterLink = function (_Component3) {
	  _inherits(OuterLink, _Component3);
	
	  function OuterLink() {
	    _classCallCheck(this, OuterLink);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(OuterLink).apply(this, arguments));
	  }
	
	  _createClass(OuterLink, [{
	    key: 'render',
	    value: function render() {
	      var classNames = (0, _classnames2.default)(styles.link, this.props.white && styles.white, this.props.noUnderline && styles.noUnderline, this.props.dotted && styles.dotted);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({}, this.props, { className: classNames }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return OuterLink;
	}(_react.Component);
	
	OuterLink.propTypes = {
	  children: _react.PropTypes.any,
	  white: _react.PropTypes.bool,
	  noUnderline: _react.PropTypes.bool,
	  dotted: _react.PropTypes.bool
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(482);
	
	var TopBar = (_temp = _class = function (_Component) {
	  _inherits(TopBar, _Component);
	
	  function TopBar() {
	    _classCallCheck(this, TopBar);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(TopBar).apply(this, arguments));
	  }
	
	  _createClass(TopBar, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)(styles.bar, this.props.left && styles.left, this.props.right && styles.right, this.props.hidden && styles.hidden);
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        this.props.children
	      );
	    }
	  }]);
	
	  return TopBar;
	}(_react.Component), _class.propTypes = {
	  left: _react.PropTypes.bool,
	  right: _react.PropTypes.bool,
	  hidden: _react.PropTypes.bool
	}, _temp);
	exports.default = TopBar;

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeLinkFromFirebase = makeLinkFromFirebase;
	exports.makeFirebaseFromLink = makeFirebaseFromLink;
	exports.copy = copy;
	exports.cut = cut;
	exports.paste = paste;
	
	/* injects from baggage-loader */
	
	function makeLinkFromFirebase(info) {
	  var link = document.createElement('a');
	  link.setAttribute('href', info.href);
	  link.innerHTML = info.content;
	  if (info.hasOwnProperty('target')) link.setAttribute('target', info.target);
	  return link;
	}
	
	function makeFirebaseFromLink(link) {
	  var info = {};
	  info.href = link.hasAttribute('href') ? link.getAttribute('href') : '';
	  if (link.hasAttribute('href')) info.target = link.getAttribute('target');
	  info.content = link.innerHTML || '';
	  return info;
	}
	
	function copy(firepad, e) {
	  e.preventDefault();
	  var selection = firepad.getHtmlFromSelection();
	
	  if (e.clipboardData) {
	    e.clipboardData.setData('text/plain', selection.replace(/<(?:.|\n)*?>/gm, '').replace('&nbsp;', ''));
	    e.clipboardData.setData('text/html', selection.replace('<div>', '').replace('</div>', ''));
	  } else if (window.clipboardData) {
	    window.clipboardData.setData('Text', selection.replace('<div>', '').replace('</div>', ''));
	  }
	}
	
	function cut(firepad, codeMirror, e) {
	  copy(firepad, e);
	  codeMirror.replaceSelection('');
	}
	
	function paste(firepad, e) {
	  e.preventDefault();
	  var data = e.clipboardData ? e.clipboardData.getData('text/html') : window.clipboardData.getData('Text');
	  firepad.insertHtmlAtCursor(data);
	}

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _routing = __webpack_require__(44);
	
	var _Popups = __webpack_require__(216);
	
	var _popupTypes = __webpack_require__(102);
	
	var _keycodes = __webpack_require__(620);
	
	var _Welcome = __webpack_require__(584);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _ProjectVisibility = __webpack_require__(580);
	
	var _ProjectVisibility2 = _interopRequireDefault(_ProjectVisibility);
	
	var _ProjectShare = __webpack_require__(578);
	
	var _ProjectShare2 = _interopRequireDefault(_ProjectShare);
	
	var _ProjectDelete = __webpack_require__(576);
	
	var _ProjectDelete2 = _interopRequireDefault(_ProjectDelete);
	
	var _ProjectVisibilityCheckBeforeShare = __webpack_require__(582);
	
	var _ProjectVisibilityCheckBeforeShare2 = _interopRequireDefault(_ProjectVisibilityCheckBeforeShare);
	
	var _ProjectConfirmRemoveNode = __webpack_require__(574);
	
	var _ProjectConfirmRemoveNode2 = _interopRequireDefault(_ProjectConfirmRemoveNode);
	
	var _popupActions = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPopupContent = function getPopupContent(_ref) {
	  var type = _ref.type;
	  var key = _ref.key;
	  var onClose = _ref.onClose;
	  var openIndex = _ref.openIndex;
	  var data = _ref.data;
	
	  if (type === _popupTypes.WELCOME) {
	    return _react2.default.createElement(_Welcome2.default, {
	      key: key, onStay: onClose,
	      onGoToProjects: function onGoToProjects() {
	        onClose();
	        openIndex();
	      }
	    });
	  }
	
	  if (type === _popupTypes.PROJECT_SHARE) {
	    return _react2.default.createElement(_ProjectShare2.default, _extends({}, data, { onSubmitted: onClose }));
	  }
	
	  if (type === _popupTypes.PROJECT_DELETE) {
	    return _react2.default.createElement(_ProjectDelete2.default, _extends({}, data, { onSubmitted: onClose }));
	  }
	
	  if (type === _popupTypes.PROJECT_VISIBILITY) {
	    return _react2.default.createElement(_ProjectVisibility2.default, { onSubmitted: onClose });
	  }
	
	  if (type === _popupTypes.PROJECT_CONFIRM_REMOVE_NODE) {
	    return _react2.default.createElement(_ProjectConfirmRemoveNode2.default, _extends({}, data, { onSubmitted: onClose }));
	  }
	
	  if (type === _popupTypes.PROJECT_SHARE_VISIBILITY_CHECK) {
	    return _react2.default.createElement(_ProjectVisibilityCheckBeforeShare2.default, { onSubmitted: onClose, onChecked: data });
	  }
	
	  return null;
	};
	
	var getState = function getState(state) {
	  return {
	    popups: state.popup.popups,
	    hasPopups: state.popup.popups.length > 0
	  };
	};
	
	var PopupManager = (_dec = (0, _reduxSimple.connect)(getState, { popupCloseLast: _popupActions.popupCloseLast, openIndex: _routing.openIndex }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PopupManager, _Component);
	
	  function PopupManager() {
	    _classCallCheck(this, PopupManager);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(PopupManager).apply(this, arguments));
	  }
	
	  _createClass(PopupManager, [{
	    key: 'handleClose',
	    value: function handleClose() {
	      this.props.popupCloseLast();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      document.addEventListener('keydown', function (e) {
	        if (e.keyCode === _keycodes.KEY_ESC) {
	          _this2.handleClose();
	        }
	      });
	    }
	  }, {
	    key: 'getPopups',
	    value: function getPopups() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var popups = _props.popups;
	      var openIndex = _props.openIndex;
	
	
	      return popups.map(function (_ref2, i) {
	        var type = _ref2.type;
	        var data = _ref2.data;
	        return _react2.default.createElement(
	          _Popups.Popup,
	          { key: i, onClose: _this3.handleClose.bind(_this3), autoSize: true },
	          _react2.default.createElement(
	            _Popups.PopupContent,
	            null,
	            getPopupContent({ type: type, data: data, key: i, onClose: _this3.handleClose.bind(_this3), openIndex: openIndex })
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Popups.PopupAnimator,
	        null,
	        this.getPopups()
	      );
	    }
	  }]);
	
	  return PopupManager;
	}(_react.Component), _class2.propTypes = {
	  openIndex: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = PopupManager;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PopupEditorLink = exports.PopupContent = exports.PopupHeaderText = exports.PopupHeader = exports.PopupAnimator = exports.PopupManager = exports.Popup = undefined;
	
	var _Popup = __webpack_require__(568);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _PopupManager = __webpack_require__(215);
	
	var _PopupManager2 = _interopRequireDefault(_PopupManager);
	
	var _PopupAnimator = __webpack_require__(569);
	
	var _PopupAnimator2 = _interopRequireDefault(_PopupAnimator);
	
	var _PopupHeader = __webpack_require__(571);
	
	var _PopupHeader2 = _interopRequireDefault(_PopupHeader);
	
	var _PopupHeaderText = __webpack_require__(572);
	
	var _PopupHeaderText2 = _interopRequireDefault(_PopupHeaderText);
	
	var _PopupContent = __webpack_require__(570);
	
	var _PopupContent2 = _interopRequireDefault(_PopupContent);
	
	var _EditorLink = __webpack_require__(567);
	
	var _EditorLink2 = _interopRequireDefault(_EditorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import PopupErrors from './PopupErrors';
	exports.Popup = _Popup2.default;
	exports.PopupManager = _PopupManager2.default;
	exports.PopupAnimator = _PopupAnimator2.default;
	exports.PopupHeader = _PopupHeader2.default;
	exports.PopupHeaderText = _PopupHeaderText2.default;
	exports.
	// PopupErrors,
	PopupContent = _PopupContent2.default;
	exports.PopupEditorLink = _EditorLink2.default;
	/* injects from baggage-loader */

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(100);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _userActions = __webpack_require__(49);
	
	var _routing = __webpack_require__(44);
	
	var _projectsActions = __webpack_require__(22);
	
	var _routing2 = __webpack_require__(27);
	
	var _Common = __webpack_require__(11);
	
	var _User = __webpack_require__(67);
	
	var _Icons = __webpack_require__(17);
	
	var _ProjectMenu = __webpack_require__(586);
	
	var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);
	
	var _Auth = __webpack_require__(66);
	
	var _ProjectView = __webpack_require__(601);
	
	var _ProjectView2 = _interopRequireDefault(_ProjectView);
	
	var _Projects = __webpack_require__(224);
	
	var _projectPermissions = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(499);
	
	// import COLORS_SET from '../../constants/colors';
	// import { randomElement } from '../../utils/utils';
	
	var DEFAULT_ADDED_NODE_COLOR = '#d0d0d0';
	
	var getState = function getState(state) {
	  return {
	    projectId: state.routing.params.projectId,
	    nodeId: state.routing.params.nodeId,
	    routeType: state.routing.type,
	
	    foreignUser: state.routing.foreignUser,
	    authorizedUser: state.user.authorizedUser,
	    shownUser: state.user.shownUser,
	
	    firstLogin: state.user.firstLogin,
	    welcomePopupShown: state.user.welcomePopupShown,
	    project: state.projects.project
	  };
	};
	
	var getActions = {
	  showWelcomePopup: _userActions.showWelcomePopup,
	  addNode: _projectsActions.addNode,
	  updateNode: _projectsActions.updateNode,
	  updateNodes: _projectsActions.updateNodes,
	  addEdge: _projectsActions.addEdge,
	  removeEdge: _projectsActions.removeEdge,
	  confirmRemoveNode: _projectsActions.confirmRemoveNode,
	  detachNode: _projectsActions.detachNode,
	  appendNewNode: _projectsActions.appendNewNode,
	  appendRightNode: _projectsActions.appendRightNode,
	  appendRightConnectedNode: _projectsActions.appendRightConnectedNode,
	  appendBottomConnectedNode: _projectsActions.appendBottomConnectedNode,
	  goLeft: _routing.goLeft,
	  projectDelete: _projectsActions.projectDelete,
	  openIndex: _routing.openIndex,
	
	  previewNode: function previewNode(projectId, nodeId) {
	    return {
	      type: _routing2.JALAN_PROJECT_NODE,
	      params: { projectId: projectId, nodeId: nodeId }
	    };
	  }
	};
	
	var ProjectPage = (_dec = (0, _reduxSimple.connect)(getState, getActions), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectPage, _Component);
	
	  function ProjectPage(props) {
	    _classCallCheck(this, ProjectPage);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectPage).call(this, props));
	
	    _this.state = {
	      showingMenu: false,
	      viewport: { x: 0, y: 0 },
	      draggingViewport: false,
	
	      projectNameEditing: false,
	      editProjectViewNodesOnMount: false
	    };
	    return _this;
	  }
	
	  _createClass(ProjectPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ showing: true });
	    }
	  }, {
	    key: 'handleProjectViewClick',
	    value: function handleProjectViewClick(e) {
	      var draggingViewport = this.state.draggingViewport;
	
	
	      if (draggingViewport) {
	        e.stopPropagation();
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var currId = this.props.projectId;
	      var nextId = nextProps.projectId;
	
	
	      if (currId !== nextId) {
	        this.setState({ editProjectViewNodesOnMount: false });
	      }
	    }
	  }, {
	    key: 'showMenu',
	    value: function showMenu() {
	      if (this.state.showingMenu) return;
	      this.setState({ showingMenu: true });
	    }
	  }, {
	    key: 'hideMenu',
	    value: function hideMenu() {
	      if (!this.state.showingMenu) return;
	      this.setState({ showingMenu: false });
	    }
	  }, {
	    key: 'isViewingProject',
	    value: function isViewingProject() {
	      var routeType = this.props.routeType;
	
	      return routeType === _routing2.JALAN_PROJECT;
	    }
	  }, {
	    key: 'isPreviewingNode',
	    value: function isPreviewingNode() {
	      var routeType = this.props.routeType;
	
	      return routeType === _routing2.JALAN_PROJECT_NODE;
	    }
	  }, {
	    key: 'isPreviewingProject',
	    value: function isPreviewingProject() {
	      var routeType = this.props.routeType;
	
	      return routeType === _routing2.JALAN_INDEX_PROJECT;
	    }
	  }, {
	    key: 'isViewingUser',
	    value: function isViewingUser() {
	      var routeType = this.props.routeType;
	
	      return routeType === _routing2.JALAN_INDEX || routeType === _routing2.JALAN_USER_LIST;
	    }
	  }, {
	    key: 'isViewingNode',
	    value: function isViewingNode() {
	      var routeType = this.props.routeType;
	
	      return routeType === _routing2.JALAN_NODE;
	    }
	  }, {
	    key: 'getPreviewingNodeId',
	    value: function getPreviewingNodeId() {
	      var nodeId = this.props.nodeId;
	
	      return nodeId;
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.props.goLeft();
	    }
	  }, {
	    key: 'addNode',
	    value: function addNode() {
	      var _state$viewport = this.state.viewport;
	      var x = _state$viewport.x;
	      var y = _state$viewport.y;
	
	      var color = DEFAULT_ADDED_NODE_COLOR;
	      var caption = 'new node';
	
	      this.setState({ editProjectViewNodesOnMount: true });
	      this.props.addNode({ x: x, y: y, color: color, caption: caption });
	    }
	  }, {
	    key: 'appendNewNode',
	    value: function appendNewNode(id) {
	      var _state$viewport2 = this.state.viewport;
	      var x = _state$viewport2.x;
	      var y = _state$viewport2.y;
	
	      var color = DEFAULT_ADDED_NODE_COLOR;
	      var caption = 'child node';
	
	      this.setState({ editProjectViewNodesOnMount: true });
	      this.props.appendNewNode({ id: id, x: x, y: y, color: color, caption: caption });
	    }
	  }, {
	    key: 'appendRightConnectedNode',
	    value: function appendRightConnectedNode(id, _ref) {
	      var x = _ref.x;
	      var y = _ref.y;
	
	      var color = DEFAULT_ADDED_NODE_COLOR;
	      var caption = 'child node';
	
	      this.setState({ editProjectViewNodesOnMount: true });
	      this.props.appendRightConnectedNode({ id: id, x: x, y: y, color: color, caption: caption });
	    }
	  }, {
	    key: 'appendRightNode',
	    value: function appendRightNode(id, _ref2) {
	      var x = _ref2.x;
	      var y = _ref2.y;
	
	      var color = DEFAULT_ADDED_NODE_COLOR;
	      var caption = 'child node';
	
	      this.setState({ editProjectViewNodesOnMount: true });
	      this.props.appendRightNode({ id: id, x: x, y: y, color: color, caption: caption });
	    }
	  }, {
	    key: 'appendBottomConnectedNode',
	    value: function appendBottomConnectedNode(id, _ref3) {
	      var x = _ref3.x;
	      var y = _ref3.y;
	
	      var color = DEFAULT_ADDED_NODE_COLOR;
	      var caption = 'child node';
	
	      this.setState({ editProjectViewNodesOnMount: true });
	      this.props.appendBottomConnectedNode({ id: id, x: x, y: y, color: color, caption: caption });
	    }
	  }, {
	    key: 'updateViewportPosition',
	    value: function updateViewportPosition(_ref4) {
	      var x = _ref4.x;
	      var y = _ref4.y;
	
	      this.setState({ viewport: { x: x, y: y } });
	    }
	  }, {
	    key: 'handleViewportDragStart',
	    value: function handleViewportDragStart() {
	      this.setState({ draggingViewport: true });
	    }
	  }, {
	    key: 'handleViewportDragStop',
	    value: function handleViewportDragStop() {
	      var _this2 = this;
	
	      (0, _raf2.default)(function () {
	        _this2.setState({ draggingViewport: false });
	      });
	    }
	  }, {
	    key: 'previewNode',
	    value: function previewNode(nodeId) {
	      var _props = this.props;
	      var projectId = _props.projectId;
	      var previewNode = _props.previewNode;
	
	      previewNode(projectId, nodeId);
	    }
	  }, {
	    key: 'getMenuContainer',
	    value: function getMenuContainer() {
	      return _react2.default.createElement(
	        _reactOnclickout2.default,
	        { onClickOut: this.hideMenu.bind(this) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.menuContainer },
	          _react2.default.createElement(
	            _Common.ActionIcon,
	            { onClick: this.showMenu.bind(this), smallShadow: true, right: true },
	            _react2.default.createElement(_Icons.Hamburger, { width: '16', height: '12' })
	          ),
	          this.state.showingMenu && _react2.default.createElement(
	            'div',
	            { className: styles.menu },
	            _react2.default.createElement(_ProjectMenu2.default, { onClose: this.hideMenu.bind(this), rename: this.editProjectName.bind(this) })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'editProjectName',
	    value: function editProjectName() {
	      this.setState({ projectNameEditing: true });
	    }
	  }, {
	    key: 'finishEditProjectName',
	    value: function finishEditProjectName() {
	      this.setState({ projectNameEditing: false });
	    }
	  }, {
	    key: 'handleProjectDelete',
	    value: function handleProjectDelete() {
	      this.props.projectDelete(this.props.project);
	      this.props.openIndex();
	    }
	  }, {
	    key: 'isProjectEmpty',
	    value: function isProjectEmpty() {
	      var nodesData = this.props.project.nodesData;
	
	      if ((0, _shallowequal2.default)(nodesData, {})) return true;
	      if (!nodesData) return true;
	      return false;
	    }
	  }, {
	    key: 'isProjectForeign',
	    value: function isProjectForeign() {
	      var _props2 = this.props;
	      var project = _props2.project;
	      var authorizedUser = _props2.authorizedUser;
	
	
	      if (!authorizedUser) return true;
	      if (!project) return false;
	
	      return project.owner !== authorizedUser.id;
	    }
	  }, {
	    key: 'getEmptyForeignProjectView',
	    value: function getEmptyForeignProjectView() {
	      var shownUser = this.props.shownUser;
	
	
	      var userName = shownUser.displayName;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.emptyView },
	        _react2.default.createElement(
	          'div',
	          { className: styles.container },
	          _react2.default.createElement(
	            'div',
	            { className: styles.caption },
	            userName,
	            ' hasn\'t added anything to this project yet.',
	            _react2.default.createElement('br', null),
	            'How about making your own project with Meta?',
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.startNewProject },
	            _react2.default.createElement(_Common.StartNewProjectButton, null)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getProjectViewContent',
	    value: function getProjectViewContent() {
	      var project = this.props.project;
	      var editProjectViewNodesOnMount = this.state.editProjectViewNodesOnMount;
	
	
	      var canEditProject = this.canEditProject();
	
	      if (!canEditProject && this.isProjectEmpty()) {
	        return this.getEmptyForeignProjectView();
	      }
	
	      return _react2.default.createElement(_ProjectView2.default, {
	        ref: 'projectView',
	        data: project,
	        previewingProject: this.isPreviewingProject(),
	        viewingUser: this.isViewingUser(),
	        viewingNode: this.isViewingNode(),
	        canPreviewNode: this.isViewingProject() || this.isPreviewingNode(),
	        viewingProject: this.isViewingProject(),
	        previewingNode: this.isPreviewingNode(),
	        previewingNodeId: this.getPreviewingNodeId(),
	
	        onNodeUpdate: this.props.updateNode,
	        onNodesUpdate: this.props.updateNodes,
	        onNodeRemove: this.props.confirmRemoveNode,
	        onNodeDetach: this.props.detachNode,
	        onNodeAppendNew: this.appendNewNode.bind(this),
	        onNodeAppendRight: this.appendRightNode.bind(this),
	        onNodeAppendRightConnected: this.appendRightConnectedNode.bind(this),
	        onNodeAppendBottomConnected: this.appendBottomConnectedNode.bind(this),
	        onEdgeRemove: this.props.removeEdge,
	
	        onProjectDelete: this.handleProjectDelete.bind(this),
	
	        onNodePreview: this.previewNode.bind(this),
	        initSceneX: 0, initSceneY: 0,
	        onViewportPositionChange: this.updateViewportPosition.bind(this),
	        onEdgeConnectionRequest: this.props.addEdge,
	
	        disableModifications: !canEditProject,
	        editNodesOnMount: editProjectViewNodesOnMount,
	
	        onViewportDragStart: this.handleViewportDragStart.bind(this),
	        onViewportDragStop: this.handleViewportDragStop.bind(this)
	      });
	    }
	  }, {
	    key: 'getProjectView',
	    value: function getProjectView() {
	      var routeType = this.props.routeType;
	
	      var showLogo = this.isProjectForeign();
	      var canEdit = this.canEditProject();
	      var showControls = routeType === _routing2.JALAN_PROJECT || routeType === _routing2.JALAN_PROJECT_NODE;
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.handleProjectViewClick.bind(this), className: styles.project },
	        this.getProjectViewContent(),
	        canEdit && _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(styles.addNode, !showControls && styles.hidden) },
	          _react2.default.createElement(
	            _Common.ActionIcon,
	            { onClick: this.addNode.bind(this) },
	            _react2.default.createElement(_Icons.Plus, { width: '16', height: '16' })
	          )
	        ),
	        showLogo && _react2.default.createElement(_Icons.Logo, { className: styles.logo, width: '55', height: '40' })
	      );
	    }
	
	    //TODO move this logic upper (to get this from reducer)
	
	  }, {
	    key: 'canEditProject',
	    value: function canEditProject() {
	      var _props3 = this.props;
	      var _props3$project = _props3.project;
	      var project = _props3$project === undefined ? {} : _props3$project;
	      var _props3$authorizedUse = _props3.authorizedUser;
	      var authorizedUser = _props3$authorizedUse === undefined ? {} : _props3$authorizedUse;
	
	
	      if (!project || !authorizedUser) return false;
	
	      var owner = project.owner;
	      var userId = authorizedUser.id;
	
	
	      if (!owner || !userId) return false;
	
	      return owner === userId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props;
	      var project = _props4.project;
	      var projectId = _props4.projectId;
	      var authorizedUser = _props4.authorizedUser;
	      var shownUser = _props4.shownUser;
	      var routeType = _props4.routeType; // TODO FIX
	
	      var showControls = routeType === _routing2.JALAN_PROJECT || routeType === _routing2.JALAN_PROJECT_NODE;
	
	      if (!project || project.id && projectId && project.id !== projectId) {
	        return showControls ? _react2.default.createElement(_Common.Spinner, { routeSpinner: true }) : _react2.default.createElement(_Common.Spinner, { halfRouteSpinner: true });
	      }
	
	      var className = (0, _classnames2.default)(styles.projectWrapper, styles.enter, this.state.showing && styles.enterActive);
	
	      var projectNameClassName = (0, _classnames2.default)(styles.projectName, project.id === project.id ? styles.editableName : styles.nonEditableName, this.state.projectNameEditing && styles.projectNameEditing);
	
	      var user = shownUser || authorizedUser;
	      var permission = !!user ? (0, _projectPermissions.getPermission)(project, user.publicProjects) : null;
	      var permissionIcon = (0, _projectPermissions.getPermissionIcon)(permission);
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: styles.bars },
	          _react2.default.createElement(
	            _Common.TopBar,
	            { left: true, hidden: !showControls },
	            _react2.default.createElement(
	              _Common.ActionIcon,
	              { onClick: this.goBack.bind(this) },
	              _react2.default.createElement(_Icons.ArrowBack, { width: '15', height: '14' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: projectNameClassName },
	              !this.state.projectNameEditing && _react2.default.createElement(
	                'span',
	                null,
	                project.name
	              ),
	              !this.state.projectNameEditing && permissionIcon && _react2.default.createElement(
	                'span',
	                { className: styles.permissionIcon },
	                permissionIcon
	              ),
	              this.state.projectNameEditing && _react2.default.createElement(_Projects.ProjectsListItemEdit, { project: project, afterEdit: this.finishEditProjectName.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            _Common.TopBar,
	            { right: true, hidden: !showControls },
	            !this.isProjectForeign() && this.getMenuContainer(),
	            authorizedUser ? _react2.default.createElement(
	              _Common.ActionIcon,
	              { smallShadow: true, margined: true },
	              _react2.default.createElement(_User.UserMenu, { compact: true })
	            ) : _react2.default.createElement(_Auth.LoginSmall, null)
	          )
	        ),
	        this.getProjectView()
	      );
	    }
	  }]);
	
	  return ProjectPage;
	}(_react.Component), _class2.propTypes = {
	  project: _react.PropTypes.object,
	  foreignUser: _react.PropTypes.string,
	  projectId: _react.PropTypes.string,
	  authorizedUser: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ProjectPage;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	/* injects from baggage-loader */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCanvas = __webpack_require__(906);
	
	var _measureText = __webpack_require__(140);
	
	var _measureText2 = _interopRequireDefault(_measureText);
	
	var _getProjectBase64SrcImage = __webpack_require__(590);
	
	var _getProjectBase64SrcImage2 = _interopRequireDefault(_getProjectBase64SrcImage);
	
	var _getProjectDimentions2 = __webpack_require__(226);
	
	var _getProjectDimentions3 = _interopRequireDefault(_getProjectDimentions2);
	
	var _logo = __webpack_require__(592);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BACKGROUND_COLOR = '#F2F2F2';
	var SURFACE_WIDTH = 600;
	var SURFACE_HEIGHT = 400;
	var LOGO_SRC = _logo2.default;
	var PROJECT_ZOOM_FACTOR = 1.7;
	
	// const PROJECT_IMAGE_TOP_FACTOR = 0.6;
	
	var getFontStyles = function getFontStyles(_ref) {
	  var weight = _ref.weight;
	  var size = _ref.size;
	  var _ref$lineHeight = _ref.lineHeight;
	  var lineHeight = _ref$lineHeight === undefined ? size * 1.3 : _ref$lineHeight;
	  return {
	    fontSize: size,
	    lineHeight: lineHeight,
	    fontFace: (0, _reactCanvas.FontFace)('Roboto, sans-serif', null, { weight: weight })
	  };
	};
	
	var ProjectShareRenderer = (_temp = _class = function (_Component) {
	  _inherits(ProjectShareRenderer, _Component);
	
	  function ProjectShareRenderer() {
	    _classCallCheck(this, ProjectShareRenderer);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectShareRenderer).apply(this, arguments));
	  }
	
	  _createClass(ProjectShareRenderer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var authorName = _props.authorName;
	      var projectTitle = _props.projectTitle;
	      var project = _props.project;
	      var width = _props.width;
	      var height = _props.height;
	
	
	      var projectBackgroundSrc = (0, _getProjectBase64SrcImage2.default)(project);
	
	      return _react2.default.createElement(
	        _reactCanvas.Surface,
	        {
	          top: 0, left: 0,
	          width: width, height: height,
	          style: { width: width, height: height }
	        },
	        _react2.default.createElement(
	          _reactCanvas.Group,
	          { style: this.getGroupStyle() },
	          _react2.default.createElement(_reactCanvas.Image, {
	            src: projectBackgroundSrc,
	            style: this.getBackgroundProjectImageStyle()
	          }),
	          _react2.default.createElement(
	            _reactCanvas.Text,
	            { style: this.getProjectTitleStyle() },
	            this.getProjectTitleText(projectTitle)
	          ),
	          _react2.default.createElement(
	            _reactCanvas.Text,
	            { style: this.getProjectAuthorStyle() },
	            'by ' + authorName
	          ),
	          _react2.default.createElement(
	            _reactCanvas.Text,
	            { style: this.getLogoCaptionStyle() },
	            'Meta Projects'
	          ),
	          _react2.default.createElement(_reactCanvas.Image, { style: this.getLogoImageStyle(), src: LOGO_SRC })
	        )
	      );
	    }
	  }, {
	    key: 'getGroupStyle',
	    value: function getGroupStyle() {
	      var _props2 = this.props;
	      var width = _props2.width;
	      var height = _props2.height;
	
	
	      return {
	        top: 0,
	        left: 0,
	        width: width,
	        height: height,
	        backgroundColor: BACKGROUND_COLOR
	      };
	    }
	  }, {
	    key: 'getBackgroundProjectImageStyle',
	    value: function getBackgroundProjectImageStyle() {
	      var _props3 = this.props;
	      var surfaceWidth = _props3.width;
	      var surfaceHeight = _props3.height;
	      var project = _props3.project;
	
	      var _getProjectDimentions = (0, _getProjectDimentions3.default)(project);
	
	      var width = _getProjectDimentions.width;
	      var height = _getProjectDimentions.height;
	
	
	      var projectRenderWidth = width * PROJECT_ZOOM_FACTOR;
	      var projectRenderHeight = height * PROJECT_ZOOM_FACTOR;
	
	      return {
	        top: surfaceHeight * 0.65,
	        left: surfaceWidth / 2 - projectRenderWidth / 2,
	        width: projectRenderWidth,
	        height: projectRenderHeight
	      };
	    }
	  }, {
	    key: 'getProjectTitleStyle',
	    value: function getProjectTitleStyle() {
	      var _props4 = this.props;
	      var width = _props4.width;
	      var height = _props4.height;
	
	
	      var fontSize = 72;
	
	      return _extends({
	        top: height / 2 - 128,
	        left: width * 0.1,
	        width: width * 0.8,
	        maxWidth: width * 0.8,
	
	        height: fontSize
	
	      }, getFontStyles({
	        weight: 400, size: fontSize, lineHeight: 80
	      }), {
	
	        textAlign: 'center',
	        color: '#000'
	      });
	    }
	  }, {
	    key: 'getProjectTitleText',
	    value: function getProjectTitleText(text) {
	      var width = this.props.width;
	
	
	      var fontSize = 72;
	
	      var metrics = (0, _measureText2.default)({
	        text: text, maxWidth: width * 0.8,
	        fontFamily: 'Roboto, sans-serif',
	        fontSize: fontSize,
	        lineHeight: fontSize
	      });
	
	      var lines = metrics.lines;
	
	      var linesCount = lines.length;
	      var firstLineText = lines[0].text;
	
	      if (linesCount === 1) {
	        return firstLineText;
	      }
	
	      return firstLineText + '…';
	    }
	  }, {
	    key: 'getProjectAuthorStyle',
	    value: function getProjectAuthorStyle() {
	      var _props5 = this.props;
	      var width = _props5.width;
	      var height = _props5.height;
	
	
	      return _extends({
	        top: height / 2 - 8,
	        left: 0,
	        width: width,
	        height: 32
	
	      }, getFontStyles({ weight: 500, size: 32 }), {
	
	        textAlign: 'center',
	        lineHeight: 32,
	        color: '#333'
	      });
	    }
	  }, {
	    key: 'getLogoImageStyle',
	    value: function getLogoImageStyle() {
	      return {
	        top: 28,
	        left: 34,
	        width: 60,
	        height: 60
	      };
	    }
	  }, {
	    key: 'getLogoCaptionStyle',
	    value: function getLogoCaptionStyle() {
	      var width = this.props.width;
	
	
	      return _extends({
	        top: 42,
	        left: 110,
	        width: width,
	        height: 32
	
	      }, getFontStyles({ weight: 500, size: 24 }), {
	        textAlign: 'left',
	        color: '#000'
	      });
	    }
	  }]);
	
	  return ProjectShareRenderer;
	}(_react.Component), _class.propTypes = {
	  project: _react.PropTypes.object.isRequired,
	  authorName: _react.PropTypes.string.isRequired,
	  projectTitle: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired
	}, _class.defaultProps = {
	  width: SURFACE_WIDTH,
	  height: SURFACE_HEIGHT
	}, _temp);
	exports.default = ProjectShareRenderer;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectShareRenderer = undefined;
	
	var _ProjectShareRenderer = __webpack_require__(218);
	
	var _ProjectShareRenderer2 = _interopRequireDefault(_ProjectShareRenderer);
	
	var _getProjectShareImage = __webpack_require__(591);
	
	var _getProjectShareImage2 = _interopRequireDefault(_getProjectShareImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	exports.default = _getProjectShareImage2.default;
	exports.ProjectShareRenderer = _ProjectShareRenderer2.default;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(506);
	
	var Viewport = function (_Component) {
	  _inherits(Viewport, _Component);
	
	  function Viewport() {
	    _classCallCheck(this, Viewport);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Viewport).apply(this, arguments));
	  }
	
	  _createClass(Viewport, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var x = _props.x;
	      var y = _props.y;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.viewport, style: { transform: 'translate(' + -x + 'px, ' + -y + 'px)' } },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Viewport;
	}(_react.Component);
	
	exports.default = Viewport;
	
	
	Viewport.propTypes = {
	  x: _react.PropTypes.number.isRequired,
	  y: _react.PropTypes.number.isRequired,
	  children: _react.PropTypes.any.isRequired
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _component = __webpack_require__(123);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _routing = __webpack_require__(44);
	
	var _Link = __webpack_require__(212);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ProjectsListItemEdit = __webpack_require__(222);
	
	var _ProjectsListItemEdit2 = _interopRequireDefault(_ProjectsListItemEdit);
	
	var _projectPermissions = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(508);
	
	var getState = function getState(state) {
	  return {
	    authorizedUser: state.user.authorizedUser,
	    currentProjectId: state.routing.params.projectId
	  };
	};
	
	var ProjectListItem = (_dec = (0, _reduxSimple.connect)(getState), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectListItem, _Component);
	
	  function ProjectListItem() {
	    _classCallCheck(this, ProjectListItem);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectListItem).call(this));
	
	    _this.state = {
	      editing: false
	    };
	    return _this;
	  }
	
	  _createClass(ProjectListItem, [{
	    key: 'isProjectForeign',
	    value: function isProjectForeign() {
	      var _props = this.props;
	      var authorizedUser = _props.authorizedUser;
	      var project = _props.project;
	
	
	      if (!authorizedUser) return true;
	      if (!project) return true;
	
	      return authorizedUser.id !== project.owner;
	    }
	  }, {
	    key: 'openEdit',
	    value: function openEdit(e) {
	      var _props2 = this.props;
	      var currentProjectId = _props2.currentProjectId;
	      var project = _props2.project;
	
	      if (!this.isProjectForeign() && currentProjectId === project.id) {
	        e.preventDefault();
	        if (!this.state.editing) {
	          this.setState({ editing: true });
	        }
	      }
	    }
	  }, {
	    key: 'closeEdit',
	    value: function closeEdit() {
	      this.setState({ editing: false });
	    }
	  }, {
	    key: 'getJalan',
	    value: function getJalan() {
	      var project = this.props.project;
	      var owner = project.owner;
	      var id = project.id;
	
	
	      return (0, _routing.previewProject)(owner, id);
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var _props3 = this.props;
	      var project = _props3.project;
	      var currentProjectId = _props3.currentProjectId;
	      var authorizedUser = _props3.authorizedUser;
	      var editing = this.state.editing;
	
	
	      var className = (0, _classnames2.default)(styles.project, !this.isProjectForeign() && currentProjectId === project.id ? styles.editableName : styles.nonEditableName, editing && styles.editing);
	
	      var permissionIcon = !this.isProjectForeign() ? (0, _projectPermissions.getPermissionIcon)((0, _projectPermissions.getPermission)(project, authorizedUser.publicProjects)) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, onClick: this.openEdit.bind(this) },
	        !editing && _react2.default.createElement(
	          'span',
	          { className: styles.projectName },
	          project.name
	        ),
	        !editing && permissionIcon && _react2.default.createElement(
	          'span',
	          { className: styles.permissionIcon },
	          permissionIcon
	        ),
	        editing && _react2.default.createElement(_ProjectsListItemEdit2.default, { project: project, afterEdit: this.closeEdit.bind(this) }),
	        _react2.default.createElement(
	          'span',
	          { className: styles.nodesAmount },
	          _lodash2.default.size(project.nodes)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.editing) {
	        var linkRoute = this.getJalan();
	
	        return _react2.default.createElement(
	          _Link2.default,
	          { className: styles.root, jalan: linkRoute },
	          this.getContent()
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.root },
	        this.getContent()
	      );
	    }
	  }]);
	
	  return ProjectListItem;
	}(_component2.default), _class2.propTypes = {
	  authorizedUser: _react.PropTypes.object,
	  project: _react.PropTypes.object.isRequired,
	  currentProjectId: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = ProjectListItem;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _reactDom = __webpack_require__(29);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _projectsActions = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(509);
	
	var ProjectListItem = (_dec = (0, _reduxSimple.connect)(null, { updateProjectName: _projectsActions.updateProjectName }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectListItem, _Component);
	
	  function ProjectListItem() {
	    _classCallCheck(this, ProjectListItem);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectListItem).apply(this, arguments));
	  }
	
	  _createClass(ProjectListItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var input = (0, _reactDom.findDOMNode)(this);
	      input.focus();
	      input.value = input.value;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      this.props.updateProjectName(this.props.project.id, (0, _reactDom.findDOMNode)(this).value);
	      this.props.afterEdit();
	    }
	  }, {
	    key: 'keyUp',
	    value: function keyUp(e) {
	      if (e.keyCode === 13) this.save();
	      if (e.keyCode === 27) this.props.afterEdit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactOnclickout2.default,
	        { onClickOut: this.save.bind(this) },
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)('plain', styles.input),
	          defaultValue: this.props.project.name,
	          onKeyUp: this.keyUp.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return ProjectListItem;
	}(_react.Component), _class2.propTypes = {
	  project: _react.PropTypes.object.isRequired,
	  afterEdit: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ProjectListItem;

/***/ },
/* 223 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	var NODE_MAX_WIDTH = exports.NODE_MAX_WIDTH = 300;
	var NODE_BORDER_RADIUS = exports.NODE_BORDER_RADIUS = 16;
	var NODE_PADDING_VERTICAL = exports.NODE_PADDING_VERTICAL = 8;
	var NODE_PADDING_HORIZONTAL = exports.NODE_PADDING_HORIZONTAL = 12;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectsListItemEdit = exports.ProjectsListItem = exports.ProjectsList = exports.ProjectAdd = undefined;
	
	var _ProjectPage = __webpack_require__(217);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	var _ProjectAdd = __webpack_require__(585);
	
	var _ProjectAdd2 = _interopRequireDefault(_ProjectAdd);
	
	var _ProjectsList = __webpack_require__(607);
	
	var _ProjectsList2 = _interopRequireDefault(_ProjectsList);
	
	var _ProjectsListItem = __webpack_require__(221);
	
	var _ProjectsListItem2 = _interopRequireDefault(_ProjectsListItem);
	
	var _ProjectsListItemEdit = __webpack_require__(222);
	
	var _ProjectsListItemEdit2 = _interopRequireDefault(_ProjectsListItemEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectPage2.default;
	/* injects from baggage-loader */
	
	exports.ProjectAdd = _ProjectAdd2.default;
	exports.ProjectsList = _ProjectsList2.default;
	exports.ProjectsListItem = _ProjectsListItem2.default;
	exports.ProjectsListItemEdit = _ProjectsListItemEdit2.default;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	var _pureGraph = __webpack_require__(34);
	
	var _constants = __webpack_require__(223);
	
	var _measureText2 = __webpack_require__(140);
	
	var _measureText3 = _interopRequireDefault(_measureText2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getNodesRects = function getNodesRects(project) {
	  var graph = project.graph;
	  var nodesData = project.nodesData;
	
	
	  var nodes = (0, _pureGraph.getNodes)(graph);
	  var mappedNodesData = nodes.map(function (id) {
	    return { id: id, data: nodesData[id] };
	  });
	
	  var nodesRects = mappedNodesData.map(function (node) {
	    var caption = node.data.caption;
	
	    var _measureText = (0, _measureText3.default)({ text: caption, maxWidth: _constants.NODE_MAX_WIDTH });
	
	    var width = _measureText.width;
	    var height = _measureText.height;
	
	
	    return _extends({}, node, {
	      width: Math.round(width) + 2 * _constants.NODE_PADDING_HORIZONTAL,
	      height: Math.round(height) + 2 * _constants.NODE_PADDING_VERTICAL
	    });
	  }).reduce(function (res, node) {
	    return _extends({}, res, _defineProperty({}, node.id, { width: node.width, height: node.height }));
	  }, {});
	
	  return nodesRects;
	};
	
	exports.default = getNodesRects;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	var _ramda = __webpack_require__(61);
	
	var _getNodesRects = __webpack_require__(225);
	
	var _getNodesRects2 = _interopRequireDefault(_getNodesRects);
	
	var _pureGraph = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getProjectDimentions = function getProjectDimentions(project) {
	  var graph = project.graph;
	  var nodesData = project.nodesData;
	
	
	  var nodes = (0, _pureGraph.getNodes)(graph);
	  var nodesRects = (0, _getNodesRects2.default)(project);
	
	  var mappedNodesData = nodes.map(function (id) {
	    return { id: id, data: nodesData[id] };
	  });
	
	  var mappedNodes = mappedNodesData.map(function (node) {
	    var id = node.id;
	    var _node$data = node.data;
	    var x = _node$data.x;
	    var y = _node$data.y;
	    var _nodesRects$id = nodesRects[id];
	    var width = _nodesRects$id.width;
	    var height = _nodesRects$id.height;
	
	    return _extends({ id: id, x: x, y: y, width: width, height: height });
	  });
	
	  // get the minima and maxima
	  var minByX = mappedNodes.reduce((0, _ramda.minBy)((0, _ramda.prop)('x')), { x: Infinity });
	  var maxByX = mappedNodes.reduce((0, _ramda.maxBy)((0, _ramda.prop)('x')), { x: -Infinity });
	
	  var minByY = mappedNodes.reduce((0, _ramda.minBy)((0, _ramda.prop)('y')), { y: Infinity });
	  var maxByY = mappedNodes.reduce((0, _ramda.maxBy)((0, _ramda.prop)('y')), { y: -Infinity });
	
	  var width = maxByX.x - minByX.x + (maxByX.width + minByX.width) / 2;
	  var height = maxByY.y - minByY.y + (maxByY.height + minByY.height) / 2;
	
	  return { width: width, height: height, minByX: minByX, maxByX: maxByX, minByY: minByY, maxByY: maxByY };
	};
	
	exports.default = getProjectDimentions;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserMenu = __webpack_require__(615);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UserMenu2.default;
	/* injects from baggage-loader */

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _projectsActions = __webpack_require__(22);
	
	var _userActions = __webpack_require__(49);
	
	var _Auth = __webpack_require__(66);
	
	var _Projects = __webpack_require__(224);
	
	var _User = __webpack_require__(67);
	
	var _Icons = __webpack_require__(17);
	
	var _Auth2 = __webpack_require__(66);
	
	var _Common = __webpack_require__(11);
	
	var _routing = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(513);
	
	var getState = function getState(state) {
	  return {
	    routeType: state.routing.type,
	    authorizedUser: state.user.authorizedUser,
	    shownUser: state.user.shownUser,
	    projects: state.projects.list
	  };
	};
	
	var UserPage = (_dec = (0, _reduxSimple.connect)(getState, { addProject: _projectsActions.addProject, logInAndToIndex: _userActions.logInAndToIndex }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(UserPage, _Component);
	
	  function UserPage() {
	    _classCallCheck(this, UserPage);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserPage).apply(this, arguments));
	  }
	
	  _createClass(UserPage, [{
	    key: 'isProjectListEmpty',
	    value: function isProjectListEmpty() {
	      var projects = this.props.projects;
	
	      if (!projects) return false;
	      if (projects.length === 0) return true;
	      return false;
	    }
	  }, {
	    key: 'isUserForeign',
	    value: function isUserForeign() {
	      var _props = this.props;
	      var shownUser = _props.shownUser;
	      var authorizedUser = _props.authorizedUser;
	
	
	      if (!authorizedUser) return true;
	      if (!shownUser) return false;
	
	      return shownUser.id !== authorizedUser.id;
	    }
	  }, {
	    key: 'getEmptyProjectListCaption',
	    value: function getEmptyProjectListCaption() {
	      var shownUser = this.props.shownUser;
	
	
	      if (this.isUserForeign()) {
	        var userName = shownUser.displayName;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          userName,
	          ' has no projects to show yet.',
	          _react2.default.createElement('br', null),
	          'How about making your own project with Meta?',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: styles.startNewProject },
	            _react2.default.createElement(_Common.StartNewProjectButton, null)
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        'You\'ve just deleted your last project. ',
	        _react2.default.createElement('br', null),
	        'Click the button above to create a new one.'
	      );
	    }
	  }, {
	    key: 'getProjectsList',
	    value: function getProjectsList() {
	      var projects = this.props.projects;
	
	
	      if (this.isProjectListEmpty()) {
	        return _react2.default.createElement(
	          'div',
	          { className: styles.emptyProjectsListCaption },
	          this.getEmptyProjectListCaption()
	        );
	      }
	
	      return _react2.default.createElement(_Projects.ProjectsList, { projects: projects });
	    }
	  }, {
	    key: 'isForeignProfile',
	    value: function isForeignProfile() {
	      var _props2 = this.props;
	      var authorizedUser = _props2.authorizedUser;
	      var shownUser = _props2.shownUser;
	      var routeType = _props2.routeType;
	
	
	      if (routeType === _routing.JALAN_INDEX) return false;
	      if (!shownUser) return true;
	      if (!authorizedUser) return true;
	
	      return authorizedUser.id !== shownUser.id;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var authorizedUser = _props3.authorizedUser;
	      var shownUser = _props3.shownUser;
	      var routeType = _props3.routeType;
	
	      /*
	      if (!authorizedUser && !isForeignProfile) {
	        return <Login />;
	      }
	      */
	
	      if (routeType === _routing.JALAN_INDEX && !authorizedUser) {
	        return _react2.default.createElement(_Auth.Login, null);
	      }
	
	      if (!(authorizedUser || shownUser)) {
	        return _react2.default.createElement(_Common.Spinner, { routeSpinner: true });
	      }
	
	      var isForeignProfile = this.isForeignProfile();
	
	      if (isForeignProfile && !shownUser) {
	        return _react2.default.createElement(_Common.Spinner, { routeSpinner: true });
	      }
	
	      return _react2.default.createElement(
	        _User.UserPageWrapper,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: styles.header },
	          _react2.default.createElement(
	            'div',
	            { className: styles.logoWrapper },
	            isForeignProfile ? _react2.default.createElement(
	              _Common.Link,
	              { jalan: { type: _routing.JALAN_INDEX } },
	              _react2.default.createElement(_Icons.Logo, { className: styles.logo, width: '69', height: '50' })
	            ) : _react2.default.createElement(_Icons.Logo, { className: styles.logo, width: '69', height: '50' })
	          ),
	          authorizedUser && !isForeignProfile ? _react2.default.createElement(_Projects.ProjectAdd, null) : _react2.default.createElement(
	            'div',
	            { className: styles.otherUser },
	            _react2.default.createElement(_User.UserPic, { url: shownUser.avatarUrl }),
	            _react2.default.createElement(
	              'div',
	              { className: styles.userName },
	              authorizedUser && authorizedUser.id === isForeignProfile ? shownUser.displayName + ' - public profile' : shownUser.displayName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.right },
	            authorizedUser ? _react2.default.createElement(_User.UserMenu, null) : _react2.default.createElement(_Auth2.LoginSmall, null)
	          )
	        ),
	        this.getProjectsList()
	      );
	    }
	  }]);
	
	  return UserPage;
	}(_react.Component), _class2.propTypes = {
	  authorizedUser: _react.PropTypes.object,
	  shownUser: _react.PropTypes.object,
	  logInAndToIndex: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = UserPage;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.refSet = refSet;
	exports.refUpdate = refUpdate;
	exports.refRemove = refRemove;
	exports.default = watchActions;
	
	var _reduxSaga = __webpack_require__(25);
	
	var _routing = __webpack_require__(44);
	
	var _projectsActions = __webpack_require__(22);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _actionTypes = __webpack_require__(23);
	
	var _projectActions = __webpack_require__(230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [updateProjectName, addProject, shareProject, projectUpdateNode, projectUpdateNodes, projectRemoveNode, projectRemoveEdge, projectDetachNode, projectAddNode, projectAddEdge, appendNewNode, appendRightNode, appendRightConnectedNode, appendBottomConnectedNode, projectSetPermission, watchDeleteProject, watchActions].map(regeneratorRuntime.mark);
	/* injects from baggage-loader */
	
	function refSet(path, value) {
	  (0, _firebase2.default)(path).set(value);
	}
	
	function refUpdate(path, value) {
	  (0, _firebase2.default)(path).update(value);
	}
	
	function refRemove(path) {
	  (0, _firebase2.default)(path).remove();
	}
	
	function updateProjectName() {
	  var _ref, projectId, value;
	
	  return regeneratorRuntime.wrap(function updateProjectName$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.UPDATE_PROJECT_NAME);
	
	        case 3:
	          _ref = _context.sent;
	          projectId = _ref.projectId;
	          value = _ref.value;
	          _context.next = 8;
	          return (0, _reduxSaga.call)(refSet, 'projects/' + projectId + '/name', value);
	
	        case 8:
	          _context.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function addProject() {
	  var _ref2, userId, project, transition, _projectId;
	
	  return regeneratorRuntime.wrap(function addProject$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (false) {
	            _context2.next = 15;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.ADD_PROJECT);
	
	        case 3:
	          _ref2 = _context2.sent;
	          userId = _ref2.userId;
	          project = _ref2.project;
	          transition = _ref2.transition;
	          _context2.next = 9;
	          return (0, _reduxSaga.call)(_projectActions.initAddProject, userId, project);
	
	        case 9:
	          _projectId = _context2.sent;
	
	          if (!transition) {
	            _context2.next = 13;
	            break;
	          }
	
	          _context2.next = 13;
	          return (0, _reduxSaga.put)((0, _routing.previewProject)(userId, _projectId));
	
	        case 13:
	          _context2.next = 0;
	          break;
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function shareProject() {
	  var _ref3, userName, _userId, _project, _projectId2, projectTitle, base64Data, projectImageUrl, facebookShareLink;
	
	  return regeneratorRuntime.wrap(function shareProject$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 22;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.SHARE_PROJECT);
	
	        case 3:
	          _ref3 = _context3.sent;
	          userName = _ref3.userName;
	          _userId = _ref3.userId;
	          _project = _ref3.project;
	          _projectId2 = _project.id;
	          projectTitle = _project.title;
	          _context3.next = 11;
	          return (0, _reduxSaga.call)(_projectActions.initGenerateProjectImage, { userName: userName, userId: _userId, project: _project });
	
	        case 11:
	          base64Data = _context3.sent;
	          _context3.next = 14;
	          return (0, _reduxSaga.call)(_projectActions.initUploadProjectImage, { projectId: _projectId2, base64Data: base64Data });
	
	        case 14:
	          projectImageUrl = _context3.sent;
	          facebookShareLink = (0, _projectActions.getFacebookShareLink)({ projectId: _projectId2, userId: _userId, projectImageUrl: projectImageUrl, projectTitle: projectTitle });
	          _context3.next = 18;
	          return (0, _reduxSaga.put)((0, _projectsActions.shareProjectGotFBLink)(facebookShareLink));
	
	        case 18:
	          _context3.next = 20;
	          return (0, _reduxSaga.put)((0, _projectsActions.shareProjectSuccess)());
	
	        case 20:
	          _context3.next = 0;
	          break;
	
	        case 22:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function projectUpdateNode() {
	  var _ref4, _projectId3, nodeId, data;
	
	  return regeneratorRuntime.wrap(function projectUpdateNode$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (false) {
	            _context4.next = 11;
	            break;
	          }
	
	          _context4.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.UPDATE_NODE);
	
	        case 3:
	          _ref4 = _context4.sent;
	          _projectId3 = _ref4.projectId;
	          nodeId = _ref4.nodeId;
	          data = _ref4.data;
	          _context4.next = 9;
	          return (0, _reduxSaga.call)(refUpdate, 'projects/' + _projectId3 + '/nodesData/' + nodeId, data);
	
	        case 9:
	          _context4.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function projectUpdateNodes() {
	  var _ref5, _projectId4, nodesIds, nodesData;
	
	  return regeneratorRuntime.wrap(function projectUpdateNodes$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (false) {
	            _context5.next = 11;
	            break;
	          }
	
	          _context5.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.UPDATE_NODES);
	
	        case 3:
	          _ref5 = _context5.sent;
	          _projectId4 = _ref5.projectId;
	          nodesIds = _ref5.nodesIds;
	          nodesData = _ref5.nodesData;
	          _context5.next = 9;
	          return (0, _reduxSaga.call)(_projectActions.initUpdateNodes, _projectId4, nodesIds, nodesData);
	
	        case 9:
	          _context5.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function projectRemoveNode() {
	  var _ref6, _projectId5, _nodeId;
	
	  return regeneratorRuntime.wrap(function projectRemoveNode$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          if (false) {
	            _context6.next = 10;
	            break;
	          }
	
	          _context6.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.REMOVE_NODE);
	
	        case 3:
	          _ref6 = _context6.sent;
	          _projectId5 = _ref6.projectId;
	          _nodeId = _ref6.nodeId;
	          _context6.next = 8;
	          return (0, _reduxSaga.call)(_projectActions.initRemoveNode, _projectId5, _nodeId);
	
	        case 8:
	          _context6.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function projectRemoveEdge() {
	  var _ref7, _projectId6, edgeId;
	
	  return regeneratorRuntime.wrap(function projectRemoveEdge$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          if (false) {
	            _context7.next = 10;
	            break;
	          }
	
	          _context7.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.REMOVE_EDGE);
	
	        case 3:
	          _ref7 = _context7.sent;
	          _projectId6 = _ref7.projectId;
	          edgeId = _ref7.edgeId;
	          _context7.next = 8;
	          return (0, _reduxSaga.call)(_projectActions.initRemoveEdge, _projectId6, edgeId);
	
	        case 8:
	          _context7.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}
	
	function projectDetachNode() {
	  var _ref8, _projectId7, _nodeId2;
	
	  return regeneratorRuntime.wrap(function projectDetachNode$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          if (false) {
	            _context8.next = 10;
	            break;
	          }
	
	          _context8.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.DETACH_NODE);
	
	        case 3:
	          _ref8 = _context8.sent;
	          _projectId7 = _ref8.projectId;
	          _nodeId2 = _ref8.nodeId;
	          _context8.next = 8;
	          return (0, _reduxSaga.call)(_projectActions.initDetachNode, _projectId7, _nodeId2);
	
	        case 8:
	          _context8.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function projectAddNode() {
	  var _ref9, _projectId8, nodeData;
	
	  return regeneratorRuntime.wrap(function projectAddNode$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          if (false) {
	            _context9.next = 10;
	            break;
	          }
	
	          _context9.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.ADD_NODE);
	
	        case 3:
	          _ref9 = _context9.sent;
	          _projectId8 = _ref9.projectId;
	          nodeData = _ref9.nodeData;
	          _context9.next = 8;
	          return (0, _reduxSaga.call)(_projectActions.initAddNode, _projectId8, nodeData);
	
	        case 8:
	          _context9.next = 0;
	          break;
	
	        case 10:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}
	
	function projectAddEdge() {
	  var _ref10, _projectId9, from, to;
	
	  return regeneratorRuntime.wrap(function projectAddEdge$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          if (false) {
	            _context10.next = 11;
	            break;
	          }
	
	          _context10.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.ADD_EDGE);
	
	        case 3:
	          _ref10 = _context10.sent;
	          _projectId9 = _ref10.projectId;
	          from = _ref10.from;
	          to = _ref10.to;
	          _context10.next = 9;
	          return (0, _reduxSaga.call)(_projectActions.initAddEdge, _projectId9, from, to);
	
	        case 9:
	          _context10.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[9], this);
	}
	
	function appendNewNode() {
	  var _ref11, _projectId10, newNodeData, id;
	
	  return regeneratorRuntime.wrap(function appendNewNode$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          if (false) {
	            _context11.next = 11;
	            break;
	          }
	
	          _context11.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.APPEND_NEW_NODE);
	
	        case 3:
	          _ref11 = _context11.sent;
	          _projectId10 = _ref11.projectId;
	          newNodeData = _ref11.newNodeData;
	          id = _ref11.id;
	          _context11.next = 9;
	          return (0, _reduxSaga.call)(_projectActions.initAppendNewNode, _projectId10, { newNodeData: newNodeData, id: id });
	
	        case 9:
	          _context11.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked[10], this);
	}
	
	function appendRightNode() {
	  var _ref12, _projectId11, _newNodeData, _id;
	
	  return regeneratorRuntime.wrap(function appendRightNode$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          if (false) {
	            _context12.next = 11;
	            break;
	          }
	
	          _context12.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.APPEND_RIGHT_NODE);
	
	        case 3:
	          _ref12 = _context12.sent;
	          _projectId11 = _ref12.projectId;
	          _newNodeData = _ref12.newNodeData;
	          _id = _ref12.id;
	          _context12.next = 9;
	          return (0, _reduxSaga.call)(_projectActions.initAppendRightNode, _projectId11, { newNodeData: _newNodeData, id: _id });
	
	        case 9:
	          _context12.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked[11], this);
	}
	
	function appendRightConnectedNode() {
	  var _ref13, _projectId12, _newNodeData2, _id2;
	
	  return regeneratorRuntime.wrap(function appendRightConnectedNode$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          if (false) {
	            _context13.next = 11;
	            break;
	          }
	
	          _context13.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.APPEND_RIGHT_CONNECTED_NODE);
	
	        case 3:
	          _ref13 = _context13.sent;
	          _projectId12 = _ref13.projectId;
	          _newNodeData2 = _ref13.newNodeData;
	          _id2 = _ref13.id;
	          _context13.next = 9;
	          return (0, _reduxSaga.call)(_projectActions.initAppendRightConnectedNode, _projectId12, { newNodeData: _newNodeData2, id: _id2 });
	
	        case 9:
	          _context13.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked[12], this);
	}
	
	function appendBottomConnectedNode() {
	  var _ref14, _projectId13, _newNodeData3, _id3;
	
	  return regeneratorRuntime.wrap(function appendBottomConnectedNode$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          if (false) {
	            _context14.next = 11;
	            break;
	          }
	
	          _context14.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.APPEND_BOTTOM_CONNECTED_NODE);
	
	        case 3:
	          _ref14 = _context14.sent;
	          _projectId13 = _ref14.projectId;
	          _newNodeData3 = _ref14.newNodeData;
	          _id3 = _ref14.id;
	          _context14.next = 9;
	          return (0, _reduxSaga.call)(_projectActions.initAppendBottomConnectedNode, _projectId13, { newNodeData: _newNodeData3, id: _id3 });
	
	        case 9:
	          _context14.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked[13], this);
	}
	
	function projectSetPermission() {
	  var _ref15, _userId2, _projectId14, isPublic, isListed;
	
	  return regeneratorRuntime.wrap(function projectSetPermission$(_context15) {
	    while (1) {
	      switch (_context15.prev = _context15.next) {
	        case 0:
	          if (false) {
	            _context15.next = 12;
	            break;
	          }
	
	          _context15.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.SET_PERMISSION);
	
	        case 3:
	          _ref15 = _context15.sent;
	          _userId2 = _ref15.userId;
	          _projectId14 = _ref15.projectId;
	          isPublic = _ref15.isPublic;
	          isListed = _ref15.isListed;
	          _context15.next = 10;
	          return (0, _reduxSaga.fork)(_projectActions.initProjectSetPermission, _userId2, _projectId14, isPublic, isListed);
	
	        case 10:
	          _context15.next = 0;
	          break;
	
	        case 12:
	        case 'end':
	          return _context15.stop();
	      }
	    }
	  }, _marked[14], this);
	}
	
	function watchDeleteProject() {
	  var _ref16, _project2;
	
	  return regeneratorRuntime.wrap(function watchDeleteProject$(_context16) {
	    while (1) {
	      switch (_context16.prev = _context16.next) {
	        case 0:
	          if (false) {
	            _context16.next = 9;
	            break;
	          }
	
	          _context16.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.DELETE_PROJECT);
	
	        case 3:
	          _ref16 = _context16.sent;
	          _project2 = _ref16.project;
	          _context16.next = 7;
	          return (0, _reduxSaga.fork)(_projectActions.initDeleteProject, _project2);
	
	        case 7:
	          _context16.next = 0;
	          break;
	
	        case 9:
	        case 'end':
	          return _context16.stop();
	      }
	    }
	  }, _marked[15], this);
	}
	
	function watchActions() {
	  return regeneratorRuntime.wrap(function watchActions$(_context17) {
	    while (1) {
	      switch (_context17.prev = _context17.next) {
	        case 0:
	          _context17.next = 2;
	          return (0, _reduxSaga.fork)(addProject);
	
	        case 2:
	          _context17.next = 4;
	          return (0, _reduxSaga.fork)(updateProjectName);
	
	        case 4:
	          _context17.next = 6;
	          return (0, _reduxSaga.fork)(projectUpdateNode);
	
	        case 6:
	          _context17.next = 8;
	          return (0, _reduxSaga.fork)(projectUpdateNodes);
	
	        case 8:
	          _context17.next = 10;
	          return (0, _reduxSaga.fork)(shareProject);
	
	        case 10:
	          _context17.next = 12;
	          return (0, _reduxSaga.fork)(projectRemoveEdge);
	
	        case 12:
	          _context17.next = 14;
	          return (0, _reduxSaga.fork)(projectDetachNode);
	
	        case 14:
	          _context17.next = 16;
	          return (0, _reduxSaga.fork)(projectRemoveNode);
	
	        case 16:
	          _context17.next = 18;
	          return (0, _reduxSaga.fork)(projectAddNode);
	
	        case 18:
	          _context17.next = 20;
	          return (0, _reduxSaga.fork)(projectAddEdge);
	
	        case 20:
	          _context17.next = 22;
	          return (0, _reduxSaga.fork)(appendNewNode);
	
	        case 22:
	          _context17.next = 24;
	          return (0, _reduxSaga.fork)(appendRightNode);
	
	        case 24:
	          _context17.next = 26;
	          return (0, _reduxSaga.fork)(appendRightConnectedNode);
	
	        case 26:
	          _context17.next = 28;
	          return (0, _reduxSaga.fork)(appendBottomConnectedNode);
	
	        case 28:
	          _context17.next = 30;
	          return (0, _reduxSaga.fork)(projectSetPermission);
	
	        case 30:
	          _context17.next = 32;
	          return (0, _reduxSaga.fork)(watchDeleteProject);
	
	        case 32:
	        case 'end':
	          return _context17.stop();
	      }
	    }
	  }, _marked[16], this);
	}

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFacebookShareLink = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	/* injects from baggage-loader */
	
	exports.initRemoveNode = initRemoveNode;
	exports.initUpdateNodes = initUpdateNodes;
	exports.initAddEdge = initAddEdge;
	exports.initAddNode = initAddNode;
	exports.initDetachNode = initDetachNode;
	exports.initRemoveEdge = initRemoveEdge;
	exports.initAppendNewNode = initAppendNewNode;
	exports.initAppendRightConnectedNode = initAppendRightConnectedNode;
	exports.initAppendRightNode = initAppendRightNode;
	exports.initAppendBottomConnectedNode = initAppendBottomConnectedNode;
	exports.initAddProject = initAddProject;
	exports.initProjectSetPermission = initProjectSetPermission;
	exports.initDeleteProject = initDeleteProject;
	exports.popupWindow = popupWindow;
	exports.showProjectShareFBPopup = showProjectShareFBPopup;
	exports.initUploadProjectImage = initUploadProjectImage;
	exports.initGenerateProjectImage = initGenerateProjectImage;
	
	var _reduxSaga = __webpack_require__(25);
	
	var _actions = __webpack_require__(229);
	
	var _kebakaran = __webpack_require__(90);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ProjectShareRenderer = __webpack_require__(219);
	
	var _ProjectShareRenderer2 = _interopRequireDefault(_ProjectShareRenderer);
	
	var _s2 = __webpack_require__(643);
	
	var _pureGraph = __webpack_require__(34);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _functional = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [initProjectSetPermission, initDeleteProject, initUploadProjectImage, initGenerateProjectImage].map(regeneratorRuntime.mark);
	
	var queryString = __webpack_require__(896);
	
	var METAPRO_DOMAIN = 'https://meta.pro';
	
	function getTransactionFunction(transform) {
	  return function (data) {
	    return (0, _functional.compose)(_pureGraph.convertToIncidentForm, transform, _pureGraph.convertFromIncidentForm)(data || _pureGraph.EMPTY_GRAPH);
	  };
	}
	
	function getProjectRefs(projectId) {
	  var projectRef = (0, _firebase2.default)('projects/' + projectId);
	  var graphRef = projectRef.child('graph');
	  var nodesDataRef = projectRef.child('nodesData');
	
	  return { projectRef: projectRef, graphRef: graphRef, nodesDataRef: nodesDataRef };
	}
	
	function graphTransaction(projectId, transform) {
	  var _getProjectRefs = getProjectRefs(projectId);
	
	  var graphRef = _getProjectRefs.graphRef;
	
	  return graphRef.transaction(getTransactionFunction(transform));
	}
	
	function pushToNodesData(projectId, data) {
	  var _getProjectRefs2 = getProjectRefs(projectId);
	
	  var nodesDataRef = _getProjectRefs2.nodesDataRef;
	
	  return nodesDataRef.push(data).key;
	}
	
	function pushToGraph(projectId, data) {
	  var _getProjectRefs3 = getProjectRefs(projectId);
	
	  var graphRef = _getProjectRefs3.graphRef;
	
	  return graphRef.push(data).key;
	}
	
	function initRemoveNode(projectId, nodeId) {
	  var _getProjectRefs4 = getProjectRefs(projectId);
	
	  var nodesDataRef = _getProjectRefs4.nodesDataRef;
	
	
	  graphTransaction(projectId, (0, _pureGraph.removeNode)(nodeId)).then(function () {
	    return nodesDataRef.child(nodeId).remove();
	  });
	}
	
	function initUpdateNodes(projectId, nodesIds, nodesData) {
	  var _getProjectRefs5 = getProjectRefs(projectId);
	
	  var nodesDataRef = _getProjectRefs5.nodesDataRef;
	
	
	  nodesIds.forEach( //TODO WTF?
	  function (id) {
	    var _nodesData$id = nodesData[id];
	    var caption = _nodesData$id.caption;
	    var color = _nodesData$id.color;
	    var x = _nodesData$id.x;
	    var y = _nodesData$id.y;
	
	    var nodeRef = nodesDataRef.child(id);
	
	    nodeRef.child('caption').set(caption);
	    nodeRef.child('color').set(color);
	    nodeRef.child('x').set(x);
	    nodeRef.child('y').set(y);
	  });
	}
	
	function initAddEdge(projectId, from, to) {
	  var edgeRefKey = pushToGraph(projectId);
	
	  graphTransaction(projectId, (0, _functional.compose)((0, _pureGraph.addEdge)(edgeRefKey, from, to), // second, add the edge
	  (0, _pureGraph.removeEdgesToNode)(to) // first, remove all edges to the node
	  ));
	}
	
	function initAddNode(projectId, nodeData) {
	  var nodeRefKey = pushToNodesData(projectId, nodeData);
	  graphTransaction(projectId, (0, _pureGraph.addNode)(nodeRefKey));
	}
	
	function initDetachNode(projectId, nodeId) {
	  graphTransaction(projectId, (0, _pureGraph.removeEdgesIncidentToNode)(nodeId));
	}
	
	function initRemoveEdge(projectId, edgeId) {
	  graphTransaction(projectId, (0, _pureGraph.removeEdgeWithId)(edgeId));
	}
	
	function initAppendNewNode(projectId, _ref) {
	  var newNodeData = _ref.newNodeData;
	  var id = _ref.id;
	
	  var newNodeId = pushToNodesData(projectId, newNodeData);
	  var newEdgeId = pushToGraph(projectId);
	
	  graphTransaction(projectId, (0, _functional.compose)((0, _pureGraph.addEdge)(newEdgeId, id, newNodeId), (0, _pureGraph.addNode)(newNodeId)));
	}
	
	function initAppendRightConnectedNode(projectId, _ref2) {
	  var newNodeData = _ref2.newNodeData;
	  var id = _ref2.id;
	
	  var newNodeId = pushToNodesData(projectId, newNodeData);
	  var newEdgeId = pushToGraph(projectId);
	
	  graphTransaction(projectId, function (graphData) {
	    var appendedNode = (0, _pureGraph.addNode)(newNodeId, graphData);
	
	    if ((0, _pureGraph.getNodesTo)(id, graphData).length >= 1) {
	      // TODO extract to hasNodesTo in pure-graph
	
	      var _getNodesTo = (0, _pureGraph.getNodesTo)(id, graphData);
	
	      var _getNodesTo2 = _slicedToArray(_getNodesTo, 1);
	
	      var parentNodeId = _getNodesTo2[0];
	
	
	      return (0, _pureGraph.addEdge)(newEdgeId, parentNodeId, newNodeId, appendedNode);
	    }
	
	    return appendedNode;
	  });
	}
	
	function initAppendRightNode(projectId, _ref3) /*, id*/{
	  var newNodeData = _ref3.newNodeData;
	
	  var newNodeId = pushToNodesData(projectId, newNodeData);
	  graphTransaction(projectId, (0, _pureGraph.addNode)(newNodeId));
	}
	
	function initAppendBottomConnectedNode(projectId, _ref4) {
	  var newNodeData = _ref4.newNodeData;
	  var id = _ref4.id;
	
	  return initAppendNewNode(projectId, { newNodeData: newNodeData, id: id });
	}
	
	function initAddProject(userId, project) {
	  return new Promise(function (resolve) {
	    var data = _extends({}, project, {
	      owner: userId,
	      deleted: false,
	      public: false,
	      graph: (0, _pureGraph.convertToIncidentForm)(project.graph)
	    });
	
	    var projectRef = (0, _firebase2.default)('projects').push();
	    var projectId = projectRef.key;
	
	    __webpack_require__(40)('metapro:test')(projectId, projectRef);
	
	    // check for `userPermissions/` existence
	    (0, _firebase2.default)('userPermissions/').once('value', function (permissionsData) {
	      __webpack_require__(40)('metapro:test')(permissionsData);
	
	      if (!permissionsData) {
	        (0, _firebase2.default)('userPermissions/').set(true);
	      }
	
	      var permissionsRef = (0, _firebase2.default)('userPermissions/' + userId + '-' + projectId);
	      permissionsRef.set({
	        user: userId,
	        project: projectId
	      }, function () {
	        return projectRef.set(data);
	      });
	
	      resolve(projectId);
	    });
	  });
	}
	
	function initProjectSetPermission(userId, projectId, isPublic, isListed) {
	  return regeneratorRuntime.wrap(function initProjectSetPermission$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (isListed) {
	            _context.next = 3;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _reduxSaga.call)(_actions.refSet, '/users/' + userId + '/publicProjects/' + projectId, null);
	
	        case 3:
	          _context.next = 5;
	          return (0, _reduxSaga.call)(_actions.refSet, '/projects/' + projectId + '/public', isPublic);
	
	        case 5:
	          if (!isListed) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _reduxSaga.call)(_actions.refSet, '/users/' + userId + '/publicProjects/' + projectId, true);
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function initDeleteProject(project) {
	  var _sagaCbLoose, listener, callback, permissions;
	
	  return regeneratorRuntime.wrap(function initDeleteProject$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _sagaCbLoose = (0, _kebakaran.sagaCbLoose)();
	          listener = _sagaCbLoose.listener;
	          callback = _sagaCbLoose.callback;
	          _context2.next = 5;
	          return (0, _reduxSaga.call)(_actions.refSet, '/projects/' + project.id + '/deleted', true);
	
	        case 5:
	          (0, _firebase2.default)('userPermissions').orderByChild('project').equalTo(project.id).once('value', listener);
	          _context2.next = 8;
	          return (0, _reduxSaga.cps)(callback);
	
	        case 8:
	          permissions = _context2.sent;
	
	          _lodash2.default.each(permissions.val(), function (permission) {
	            var userId = permission.user;
	            var projectId = permission.project;
	            (0, _firebase2.default)('/userPermissions/' + userId + '-' + projectId).remove();
	          });
	          _context2.next = 12;
	          return (0, _reduxSaga.call)(_actions.refRemove, '/users/' + project.owner + '/publicProjects/' + project.id);
	
	        case 12:
	          _context2.next = 14;
	          return (0, _reduxSaga.call)(_actions.refRemove, '/projects/' + project.id);
	
	        case 14:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	// Sharing
	function popupWindow(url, title, w, h) {
	  var _window$screen = window.screen;
	  var width = _window$screen.width;
	  var height = _window$screen.height;
	
	
	  var left = width / 2 - w / 2;
	  var top = height / 2 - h / 2;
	  return window.open(url, title, 'toolbar=no, location=no, directories=no, ' + 'status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, ' + ('width=' + w + ', height=' + h + ', top=' + top + ', left=' + left));
	}
	
	function showProjectShareFBPopup(url) {
	  popupWindow(url, 'Share on Facebook', 600, 600);
	}
	
	/* eslint camelcase:0 */
	var getFacebookShareLink = exports.getFacebookShareLink = function getFacebookShareLink(_ref5) {
	  var projectId = _ref5.projectId;
	  var /*userId,*/projectTitle = _ref5.projectTitle;
	  var projectImageUrl = _ref5.projectImageUrl;
	
	  var projectShareLink = METAPRO_DOMAIN + '/project/' + projectId;
	
	  var shareQuery = queryString.stringify({
	    app_id: '1549614872020223',
	
	    display: 'popup',
	    name: projectTitle,
	    redirect_uri: METAPRO_DOMAIN,
	    link: projectShareLink,
	    picture: projectImageUrl,
	    caption: 'My project at metapro',
	    description: 'I\'ve made a mindmap at meta.pro and I\'m sharing it with you.',
	    ref: 'metapro'
	  });
	
	  var facebookShareLink = 'https://www.facebook.com/dialog/feed?' + shareQuery;
	
	  return facebookShareLink;
	};
	
	function initUploadProjectImage(_ref6) {
	  var projectId = _ref6.projectId;
	  var base64Data = _ref6.base64Data;
	  return regeneratorRuntime.wrap(function initUploadProjectImage$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          return _context3.abrupt('return', (0, _s2.uploadProjectImage)({ projectId: projectId, base64Data: base64Data }));
	
	        case 1:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function initGenerateProjectImage(_ref7) {
	  var userName = _ref7.userName;
	  var /*userId,*/project = _ref7.project;
	  var projectTitle;
	  return regeneratorRuntime.wrap(function initGenerateProjectImage$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          // const projectId = project.id;
	          projectTitle = project.name;
	
	          // generate the image
	
	          return _context4.abrupt('return', (0, _ProjectShareRenderer2.default)({
	            project: project, authorName: userName, projectTitle: projectTitle,
	            width: 1200,
	            height: 630
	          }));
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageView = pageView;
	exports.projectAddEvent = projectAddEvent;
	
	/* injects from baggage-loader */
	
	var ga = __webpack_require__(954);
	
	var GA_TRACKING_ID = 'UA-2325415-14';
	var gaOptions = { debug: ("production") === 'development' };
	
	ga.initialize(GA_TRACKING_ID, gaOptions);
	
	function pageView(path) {
	  ga.pageview(path);
	}
	
	function projectAddEvent(userId) {
	  ga.event({ category: 'User',
	    action: 'Created a Project',
	    userId: userId
	  });
	}

/***/ },
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
458,
/* 458 */,
/* 459 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"routes":"_2eVeKrPue9N2SjIr","route":"ujCwt1aUe6xcVlq7","leftRoute":"HMyN1me-33uNUhXe","rightOut":"_730YLZ9yKGDH60J1","rightIn":"_1ij4X5CWHm_rRZe_","leftOut":"_2Imyecpgn3e2lho8","pause":"_20MJOTpHRAJkaDR5","rightRoute":"_1JSj6bCTNLQjSveU"};

/***/ },
/* 460 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"JsX9wXuTBoQzOc1D","apiError":"_2872iaqzNTx7hrc1"};

/***/ },
/* 461 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_1D-fcmytPtTlJPE6","logo":"_3kqrOgp9svXo7ZdO","project":"_2cSKCsdjWOKSpUyi","description":"_2CeO0f2qXpxogznM"};

/***/ },
/* 462 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spinner":"UsO13C1kTWW3CqFF"};

/***/ },
/* 463 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"actionIcon":"vbrUcP2pxzYzLFip","noShadow":"_1LuXxCQmaHrqFPVC","active":"_5tphBpRL297K6og3","smallShadow":"_2Txp_XW3qLHqqTFD","margined":"_10TwZdfFKmZfZr9c","marginedBottom":"_3XykfRewswEOh7Kl","right":"_2j3gpK-N91Fiejn9"};

/***/ },
/* 464 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_1JxkiVlzkTj09nwo","content":"_1Ib43gT-Pni5_Udd","facebook":"VK4ObjcVnVIW0hFR","facebookSmall":"LSns4l0gCQeWxNvI","twitter":"_1JUQjBlvexeERu0-","small":"tn7rMMPBceOWoire","light":"_3FBT7a4LfTBN8vC0","loading":"_2_r4Qedbc7KxmtrI","spinner":"_29AlFeTD7BtP6jcc"};

/***/ },
/* 465 */
458,
/* 466 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2lWr6Oqw9o1EnvM_","inner":"_3JBtK9vyE5eOpH8P","selected":"_3OXi1J4IgtXWFZ-p","outer":"_65CUzQGocdGlYBb5"};

/***/ },
/* 467 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2RWK_unTFLSqBpDG","selected":"_3y_tR1VqjesnDNl6"};

/***/ },
/* 468 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"label":"_3UBYw8K3uQocy2fY"};

/***/ },
/* 469 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"picker":"_3UuF5ljUtRTUJZHG","itemContainer":"_3-rn4S2EMIFNrXT5","hoverLabel":"_31EQBk5YuFE66vPa","content":"_5RA5xsxNE-Z0ZVts"};

/***/ },
/* 470 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_1JJQbz1btasWrujJ","dark":"_3hQgRhin84WllOiZ","textArea":"_1QKVxkbxQrcKupQ6","content":"_3D7pvDJ4CRyDA5lP","editing":"_3cnh9lDuGSmLERNs"};

/***/ },
/* 471 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"link":"_2Q4oAGSBKi_xcACG","active":"_2JjkK5Qk-RnmnN0u","noUnderline":"_39RYtEpBlt8o_Rkr","dotted":"_2SvxpVE7R0jHRxD7","danger":"_1H9ep2mXbORKYPcs"};

/***/ },
/* 472 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headingLarge":"_2wRVZPFV8yHNOSjn","headingMedium":"_3_gtZKmQC8E5rxzu","headingSmall":"_3Gj5NFDonHBM3s0o","paragraph":"_1NWiUTn1MKBisFvg","approve":"UnyqFPTRnLBWU9Dm","fontMedium":"_2Ej54rTcHtp0ZJpX","faded":"XJwwNN2Tx0Cnnoqm"};

/***/ },
/* 473 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_3mssmpgZWen2UqIY","backdrop":"_3sG_nIF0SFMfynkX","open":"_3llPvDxiohES_r2Z","container":"_3Qm_OLRewzcglhn5","content":"_1cuCSR9ZipYyQR0X"};

/***/ },
/* 474 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menuItem":"_1JAq1NIWI6byele2","thin":"_1yjr8TLlTzo5K5A-"};

/***/ },
/* 475 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menuItemIcon":"unBnXq_xtCctDFQg"};

/***/ },
/* 476 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menuItemLabel":"_1F4y1qO2pI2j_Zoh"};

/***/ },
/* 477 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hamburger":"_1wMKzdDMNaR9G4yW","dragHandle":"_3st6qfesmYBeAiLX","hover":"_31BF45yuEbb_cKxN"};

/***/ },
/* 478 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wide":"_1eG83qDk62t5v_5C","field":"_1HjqInf6zCJGOkvH","fullPage":"_17tvZ0cq80DIqghU","routeSpinner":"_1jC1PjbrjAaVmQbe","halfRouteSpinner":"_36Y1fHGiYyYSYX6F","spinner":"_1RQ2GqCxZ4jX-X3v","white":"_1FcIYiAng0EUUhF9","spinnerWhite":"_18ye7lxPU3clWj_z"};

/***/ },
/* 479 */
458,
/* 480 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tab":"_1T4UdPB7y-xR8m5d","selected":"_24DyGHxObB7Ost4E"};

/***/ },
/* 481 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tooltip":"_2RdzSJLK0qSAHjkP","icon":"_1WVRXk0GTbeLcrHN","iconHover":"_3IMv7qW7J0vVAvsr","content":"_2fPOhDaiQ0WgxZUV"};

/***/ },
/* 482 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bar":"_2xcyMZOqjCcB7Qma","left":"_1HOxMHFfkZWL5Ol5","right":"_1wp6tff21nqGXROn","hidden":"tFqrBGNlBoyakwSe"};

/***/ },
/* 483 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"editor":"_1d8wsAj_ood5jWCx","controls":"_3vuSI6oSGTbao15G","wrapper":"_2be7KzOCgs8OIQr8","firepad":"_1Z16EnlV-4Rf9Kci","firepadLoading":"_3wcfuO3cD_8sPqM0"};

/***/ },
/* 484 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"preview":"_3jBFIwYRxTeH_UkF"};

/***/ },
/* 485 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nodePage":"_28c1kXjoXz3y-6Jy"};

/***/ },
/* 486 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"firepad":"_2-Rm_-IaVNOdNxFI","viewer":"_2pGuelms4bsp-daE","emptyContentCaption":"_1oHeHG6cNeOgO5Mo"};

/***/ },
/* 487 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"link":"_3m7rQUAMZv-mTTJ2","title":"_1lBZ-g-qSvvxvwW0","field":"_2tDvx9D4yQvOh7qh","label":"XKDEaomtFxALrHcb","input":"_1rPU_O5L8p-gqLme","controls":"_3qtEkyN70ZZc75ie","cancel":"_3vob3H8Y8K26NjUY","delete":"_1D-Vh9yN0yreUcUk"};

/***/ },
/* 488 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"popup":"_2U7P6XP3EBlYHFmn","fade":"_1AeDNzS5GEA6LLm8","containerWrapper":"_3Aqe-ephRcxT8HY_","container":"XiLhIsWPNFbZl_GY","autoSize":"_1W-QvqbqTbGocphl"};

/***/ },
/* 489 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"enter":"_2tH8ZsSD7xM74zQa","enterActive":"_1Rhjc-RiZU6EGvhC","leave":"_2G8kGaTzd_NxWRc6","leaveActive":"_2AZ-_HH6NlAfwhE6"};

/***/ },
/* 490 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"_3nYYbQkd9N1EVzdX"};

/***/ },
/* 491 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_2HDozO5Jm4m4GNjh","transparent":"_3C7y73bQ76AoAzTO"};

/***/ },
/* 492 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"text":"_37I4Ijtd3DK4zVNc","delimiter":"_3N4-jAUEVf8aIpR7","faded":"wt5Zf7B9oWXqt4gW"};

/***/ },
/* 493 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectConfirmDeleteNode":"TKmp7Mjk4p1txXHD","title":"_2fpn3jVadJ9ckQ1o","controls":"_1Rn180XqAS8mzsIj","cancel":"_2VywIZlwMYsqC8h6","remove":"_3VHf8GsbpYLroz4H"};

/***/ },
/* 494 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectDelete":"_3oaolBrYdXACD6gy","title":"_1JtvxxhfjAsbb_3s","controls":"_3yQtA76gJH6I9kl0","cancel":"_2h-ofhuWiT1VIlun","delete":"_1Sn3zK81acoQSxbM"};

/***/ },
/* 495 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectShare":"_12fgWb7mQndANPg5","title":"_3YjXC_nhu2mzRq0T","label":"BaAxfOoCPEjSKOgg","link":"iURPAs9jEqSofz9G","input":"_21BJAR1Jb0OPgnKV","social":"_3FED4-eosSEHnyZK","buttons":"_21SUYuOgFCLcY_MP","caption":"n86Qx9i0ZK_azHWi"};

/***/ },
/* 496 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectVisibility":"_2WOVD6ZrNJIWTzh1","title":"_29qVVKipjFPz9gvE","options":"_1j7UbZvsAK60O5DB","accept":"_37pKB2n9pcVgrAQM"};

/***/ },
/* 497 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectVisibility":"_3bFzo94hDbHahFb_","title":"_2orjehLKSfAm8JMM","text":"JhvAKghJeGHAu_1P","controls":"NNo11Nk_oQqqrJvX","cancel":"_18r0zXxoFJpHkKoi","delete":"YThokTdA5x4sMv3H"};

/***/ },
/* 498 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"welcome":"_1WVistuQ4mgkl8iZ","logo":"_3gjwIySt1vWKuLmJ","action":"_3o5sl4MVckdW0ET1"};

/***/ },
/* 499 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectName":"_3JSs7QNEkFQf_AXk","projectWrapper":"_2BQiEWF0mWD8cRyG","bars":"_1axqveKKfCRfiZ75","menuContainer":"_1Yw_PexzRR0StNJ2","menu":"rPhCq00nPCPkQZXK","projectNameEditing":"UstOZpl7ZYUp9QBJ","permissionIcon":"_16MuJeOy-sjJ5BHF","project":"_1-LjHLLFZ2_xDBft","addNode":"_1YBZjtuwhCV_I1YJ","hidden":"_1sKln61mhysc2j5C","enter":"_3SJYuGqADBMt91YB","enterActive":"yhCVkSdLh04kxede","leave":"_2kZajVFKZBX7bOog","leaveActive":"_2J2WchYLIxILGaCs","logo":"_635NClyE0I6xNYa7","emptyView":"_2DD-NHFGJQLObkdT","container":"DQqxVZFko5O8NFcy","caption":"_1aTQJ0Xa0P72H6lo","startNewProject":"x8gyjWtgOE9UmJEB"};

/***/ },
/* 500 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"edgeView":"_1FX1XGt6tE9pmIZz","removeContainer":"cPA_MGx_Il7Ddmz8","remove":"_2y7ikb_Vm0FHmhMT","icon":"QYpQn6cVfGzfZAvm","pathHoverArea":"Wm-9Kdt15JE2Bk_l","svgContainer":"MZ3rrngJus6shJD7","path":"_2Xk6l0Sw2cWbjYl5","highlighted":"Hqe_rnvqlZ5I_Nx3"};

/***/ },
/* 501 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2R25xEYgv9Ry-gNr","dragging":"_1lbrZLlm-MLs4S1C","noPointerEvents":"_2i-hDSCTn8HkGk95","lifted":"_15PYU13iHaN0193r","lowered":"OpK23nKydGJozZ7R","item":"_12Usgs8SASev8UbQ","node":"sEhxcuZBhW2_Cm47","dropdownMenu":"_2KYSpgOY1plgSpdZ","menuContent":"nfBdHiPMfxf96aBd"};

/***/ },
/* 502 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nodeView":"_2Z6HAhJI7dGGQWxa","disableModifications":"_1ldZLDgBz3OVUPsF","highlightColor":"_2UiU_Xa6Nc9S8IF4","expanded":"_1m6VsyyMotXeo-8s","control":"_3en2ZAZGvzPcjSoG","dragging":"ef4mEajO5v9Md0qo","overlay":"_14febF_8sxOfsUav","clipIcon":"_13njHzo05EGGwUse","nodeOver":"_2lfig4IFiXiBYVR4","dragHandle":"_2lXua0HbWrC0OURa","controlIcon":"_2Du4mNBV2gpg-Yuz","dropdownMenu":"_3TLeBJqFdoSfHO7C","caption":"_2--7oP___900Hd0y"};

/***/ },
/* 503 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fixer":"_3hiNqbWsqOwH423C"};

/***/ },
/* 504 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectView":"TAjj8Os76H-4I_WQ","noPointerEvents":"YoUkr5SvzclPQzm3","viewport":"Ady71Qgydfr93NoH","previewingNode":"_24mZaz4UypgD5hqB","dragging":"Te5HBk9jLovTovd7","emptyView":"_3wBVmqT6TMOgNIMh","caption":"lMtLa2cNhqCq8124"};

/***/ },
/* 505 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dragArea":"_33X37vXRPzWNr_2-"};

/***/ },
/* 506 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"viewport":"_3FoowSfsizv6chPs"};

/***/ },
/* 507 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"emptyView":"_2H7eXP2ub13AHqWU"};

/***/ },
/* 508 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"MhDC3yOxH8fBa_v3","project":"_30NCxHSjWjUGG5s0","editing":"_1_wmmybswM0sGLre","nodesAmount":"_2dSX52TYcHh2e3Fl","editableName":"_24UV8SqufoZuwclK","projectName":"Ct1O7JQ2VTTqbAPU","permissionIcon":"_1DczbQ0wAlQTPBDP"};

/***/ },
/* 509 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"_3wp9OH4YAfJAu0mQ"};

/***/ },
/* 510 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"userMenuWrapper":"S2JOOT0gEwEvQiEv","userMenuContainer":"FYh6aMCJqBSiqj__"};

/***/ },
/* 511 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"userMenuCompact":"_2XD8ocqYWjhB5-yv","content":"_1efArY7BALOcJUXO","logout":"_3stOa_WNhYPFYwr6","userContent":"rsAhWYu73YDXst1l","iconContainer":"_3Wqxd3CZv_RbWK1-","name":"_3VtoH1y1Yqa3KVG3","myPageLink":"_2aX8RivBqUv_KmdR","enter":"_9HSRRpqdfJiRNe1t","enterActive":"_1Cb4XA-XG6hPMISL","containerAnim":"_2x-RYqIx4GIbcX2C","userNameAnim":"_2hjJuei7tuAnY-V9","leave":"_135w9dsL6_zYvqiH","leaveActive":"_2BGFprs6pYgGFI2t","containerOutAnim":"_147vxd_7F0jfE3lD"};

/***/ },
/* 512 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"userMenuFull":"_1VkBTXZVMqUryOqO","user":"_1NiMdDDc9of2RcIi","name":"_2mtsp1-LU-VPEC-c","myPageLink":"_24SntJU1leRz9hoX","enter":"jrr3FbSvcb-vqJLh","enterActive":"_2OsnNsmQ4X6p-Z3V","leave":"_105sKpmvrIQeOB4D","leaveActive":"_34GwoOI0zHImy5R1"};

/***/ },
/* 513 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_31GWEaAdAw1axkUK","logoWrapper":"UaYrOieoz4Q7gEFp","logo":"iHcB7xUIkfRhrsaj","otherUser":"_1MFZ6Xdf-VvVYd6_","userName":"_2tsCmeXIS8fULKyi","right":"_2Z2f4PyacXGgF0iE","emptyProjectsListCaption":"FvBQaugjlDYBoMSe","startNewProject":"_31gPEotFaw1Q7Ura"};

/***/ },
/* 514 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"__ssWL8fkmuPLyEN"};

/***/ },
/* 515 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"userPic":"_3fiQHoQZmkpgUZGn","my":"Fu08l5WtaCbs9yl6"};

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 290,
		"./af.js": 290,
		"./ar": 294,
		"./ar-ma": 291,
		"./ar-ma.js": 291,
		"./ar-sa": 292,
		"./ar-sa.js": 292,
		"./ar-tn": 293,
		"./ar-tn.js": 293,
		"./ar.js": 294,
		"./az": 295,
		"./az.js": 295,
		"./be": 296,
		"./be.js": 296,
		"./bg": 297,
		"./bg.js": 297,
		"./bn": 298,
		"./bn.js": 298,
		"./bo": 299,
		"./bo.js": 299,
		"./br": 300,
		"./br.js": 300,
		"./bs": 301,
		"./bs.js": 301,
		"./ca": 302,
		"./ca.js": 302,
		"./cs": 303,
		"./cs.js": 303,
		"./cv": 304,
		"./cv.js": 304,
		"./cy": 305,
		"./cy.js": 305,
		"./da": 306,
		"./da.js": 306,
		"./de": 308,
		"./de-at": 307,
		"./de-at.js": 307,
		"./de.js": 308,
		"./dv": 309,
		"./dv.js": 309,
		"./el": 310,
		"./el.js": 310,
		"./en-au": 311,
		"./en-au.js": 311,
		"./en-ca": 312,
		"./en-ca.js": 312,
		"./en-gb": 313,
		"./en-gb.js": 313,
		"./en-ie": 314,
		"./en-ie.js": 314,
		"./en-nz": 315,
		"./en-nz.js": 315,
		"./eo": 316,
		"./eo.js": 316,
		"./es": 317,
		"./es.js": 317,
		"./et": 318,
		"./et.js": 318,
		"./eu": 319,
		"./eu.js": 319,
		"./fa": 320,
		"./fa.js": 320,
		"./fi": 321,
		"./fi.js": 321,
		"./fo": 322,
		"./fo.js": 322,
		"./fr": 325,
		"./fr-ca": 323,
		"./fr-ca.js": 323,
		"./fr-ch": 324,
		"./fr-ch.js": 324,
		"./fr.js": 325,
		"./fy": 326,
		"./fy.js": 326,
		"./gd": 327,
		"./gd.js": 327,
		"./gl": 328,
		"./gl.js": 328,
		"./he": 329,
		"./he.js": 329,
		"./hi": 330,
		"./hi.js": 330,
		"./hr": 331,
		"./hr.js": 331,
		"./hu": 332,
		"./hu.js": 332,
		"./hy-am": 333,
		"./hy-am.js": 333,
		"./id": 334,
		"./id.js": 334,
		"./is": 335,
		"./is.js": 335,
		"./it": 336,
		"./it.js": 336,
		"./ja": 337,
		"./ja.js": 337,
		"./jv": 338,
		"./jv.js": 338,
		"./ka": 339,
		"./ka.js": 339,
		"./kk": 340,
		"./kk.js": 340,
		"./km": 341,
		"./km.js": 341,
		"./ko": 342,
		"./ko.js": 342,
		"./lb": 343,
		"./lb.js": 343,
		"./lo": 344,
		"./lo.js": 344,
		"./lt": 345,
		"./lt.js": 345,
		"./lv": 346,
		"./lv.js": 346,
		"./me": 347,
		"./me.js": 347,
		"./mk": 348,
		"./mk.js": 348,
		"./ml": 349,
		"./ml.js": 349,
		"./mr": 350,
		"./mr.js": 350,
		"./ms": 352,
		"./ms-my": 351,
		"./ms-my.js": 351,
		"./ms.js": 352,
		"./my": 353,
		"./my.js": 353,
		"./nb": 354,
		"./nb.js": 354,
		"./ne": 355,
		"./ne.js": 355,
		"./nl": 356,
		"./nl.js": 356,
		"./nn": 357,
		"./nn.js": 357,
		"./pl": 358,
		"./pl.js": 358,
		"./pt": 360,
		"./pt-br": 359,
		"./pt-br.js": 359,
		"./pt.js": 360,
		"./ro": 361,
		"./ro.js": 361,
		"./ru": 362,
		"./ru.js": 362,
		"./se": 363,
		"./se.js": 363,
		"./si": 364,
		"./si.js": 364,
		"./sk": 365,
		"./sk.js": 365,
		"./sl": 366,
		"./sl.js": 366,
		"./sq": 367,
		"./sq.js": 367,
		"./sr": 369,
		"./sr-cyrl": 368,
		"./sr-cyrl.js": 368,
		"./sr.js": 369,
		"./sv": 370,
		"./sv.js": 370,
		"./sw": 371,
		"./sw.js": 371,
		"./ta": 372,
		"./ta.js": 372,
		"./te": 373,
		"./te.js": 373,
		"./th": 374,
		"./th.js": 374,
		"./tl-ph": 375,
		"./tl-ph.js": 375,
		"./tlh": 376,
		"./tlh.js": 376,
		"./tr": 377,
		"./tr.js": 377,
		"./tzl": 378,
		"./tzl.js": 378,
		"./tzm": 380,
		"./tzm-latn": 379,
		"./tzm-latn.js": 379,
		"./tzm.js": 380,
		"./uk": 381,
		"./uk.js": 381,
		"./uz": 382,
		"./uz.js": 382,
		"./vi": 383,
		"./vi.js": 383,
		"./zh-cn": 384,
		"./zh-cn.js": 384,
		"./zh-tw": 385,
		"./zh-tw.js": 385
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 516;


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 17 16',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Project-Graph-View',
	        transform: 'translate(-156.000000, -95.000000)',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }, React.createElement('g', {
	        id: 'Back-Button',
	        transform: 'translate(97.000000, 96.000000)'
	    }, React.createElement('g', {
	        id: 'XMLID_2_-+-Path-36',
	        transform: 'translate(61.000000, 0.000000)'
	    }, React.createElement('path', {
	        d: 'M1,7 L15,7',
	        id: 'XMLID_2_'
	    }), React.createElement('path', {
	        d: 'M7,0 L0,7 L7,14',
	        id: 'Path-36'
	    }))))));
	};

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, { viewBox: '0 0 16 16' }, props), React.createElement('path', {
	        d: 'M 2.5,6.458428 6.2900927,2.6683353 c 1.7536248,-1.75362478 4.6103363,-1.75362488 6.3639603,-10e-8 1.760696,1.7606956 1.753625,4.6103359 0,6.3639609 L 8.0720014,13.614349 c -1.1808683,1.180868 -3.0900566,1.180868 -4.2709254,-1e-6 -1.159655,-1.159655 -1.166726,-3.04763 5e-7,-4.2143558 L 8.411413,4.7896557 c 0.5868987,-0.5868987 1.5344219,-0.5868988 2.121321,-1e-7 0.586898,0.5868987 0.586898,1.5344217 0,2.1213204 l -3.7900931,3.790093',
	        fill: 'none',
	        stroke: '#222222',
	        strokeWidth: '2',
	        strokeLinecap: 'butt'
	    }));
	};

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, { viewBox: '0 0 16 16' }, props), React.createElement('path', {
	        d: 'M 2.5,6.458428 6.2900927,2.6683353 c 1.7536248,-1.75362478 4.6103363,-1.75362488 6.3639603,-10e-8 1.760696,1.7606956 1.753625,4.6103359 0,6.3639609 L 8.0720014,13.614349 c -1.1808683,1.180868 -3.0900566,1.180868 -4.2709254,-1e-6 -1.159655,-1.159655 -1.166726,-3.04763 5e-7,-4.2143558 L 8.411413,4.7896557 c 0.5868987,-0.5868987 1.5344219,-0.5868988 2.121321,-1e-7 0.586898,0.5868987 0.586898,1.5344217 0,2.1213204 l -3.7900931,3.790093',
	        fill: 'none',
	        stroke: '#a5a5a5',
	        strokeWidth: '2',
	        strokeOpacity: '1',
	        strokeDasharray: 'none'
	    }), React.createElement('path', {
	        d: 'M 1,1 15,15',
	        fill: 'none',
	        stroke: '#e13208',
	        strokeWidth: '2',
	        strokeLinecap: 'butt',
	        strokeOpacity: '1',
	        strokeDasharray: 'none'
	    }));
	};

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 16 14',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Node-Edit',
	        transform: 'translate(-48.000000, -201.000000)'
	    }, React.createElement('g', {
	        id: 'Header-Button',
	        transform: 'translate(47.000000, 201.000000)'
	    }, React.createElement('rect', {
	        id: 'Rectangle-115',
	        fill: '#323232',
	        x: '1',
	        y: '0',
	        width: '16',
	        height: '4'
	    }), React.createElement('path', {
	        d: 'M1.02209078,8 L16.9999999,8',
	        id: 'Path-262',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }), React.createElement('path', {
	        d: 'M1,13 L17,13',
	        id: 'Path-262-Copy',
	        stroke: '#323232',
	        strokeWidth: '2'
	    })))));
	};

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 14 17',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'URL-Edit',
	        transform: 'translate(-869.000000, -315.000000)',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }, React.createElement('g', {
	        id: 'Delete-Icon',
	        transform: 'translate(864.000000, 312.000000)'
	    }, React.createElement('path', {
	        d: 'M6,7 L18,7 L18,10 L6,10 L6,7 Z',
	        id: 'Path'
	    }), React.createElement('path', {
	        d: 'M7,10 L7,19 L17,19 L17,10 L7,10 Z',
	        id: 'Path'
	    }), React.createElement('path', {
	        d: 'M10,7 L10,4 L14,4 L14,7 L10,7 Z',
	        id: 'Path'
	    }), React.createElement('path', {
	        d: 'M14,12 L14,17 L14,12 Z',
	        id: 'Path'
	    }), React.createElement('path', {
	        d: 'M10,12 L10,17 L10,12 Z',
	        id: 'Path'
	    })))));
	};

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 16 17',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'URL-Edit',
	        transform: 'translate(-836.000000, -314.000000)'
	    }, React.createElement('g', {
	        id: 'Edit-icon',
	        transform: 'translate(832.000000, 312.000000)'
	    }, React.createElement('path', {
	        d: 'M18,18 L5,18',
	        id: 'Path-301',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }), React.createElement('path', {
	        d: 'M6,16 L7,12 L15,4 L18,7 L10,15 L6,16 Z',
	        id: 'Path-302',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }), React.createElement('path', {
	        id: 'Path-303',
	        stroke: '#979797',
	        d: ''
	    })))));
	};

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 16 12',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Node-Edit',
	        transform: 'translate(-48.000000, -370.000000)',
	        stroke: '#000000',
	        strokeWidth: '2'
	    }, React.createElement('g', {
	        id: 'Link-Button',
	        transform: 'translate(49.000000, 371.000000)'
	    }, React.createElement('path', {
	        d: 'M8.057,0 L9.004,0 C11.763,0 14,2.244 14,5 C14,7.761 11.763,10 8.995,10 L8,10',
	        id: 'Path'
	    }), React.createElement('path', {
	        d: 'M0.057,0 L1.004,0 C3.763,0 6,2.244 6,5 C6,7.761 3.763,10 0.995,10 L0,10',
	        id: 'Path-Copy',
	        transform: 'translate(3.000000, 5.000000) scale(-1, 1) translate(-3.000000, -5.000000) '
	    }), React.createElement('path', {
	        d: 'M3,5 L11,5',
	        id: 'Path'
	    })))));
	};

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 16 12',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Node-Edit',
	        transform: 'translate(-48.000000, -258.000000)',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }, React.createElement('g', {
	        id: 'Bul-List-Button',
	        transform: 'translate(48.000000, 258.000000)'
	    }, React.createElement('path', {
	        d: 'M0,6 L2.08922455,6',
	        id: 'XMLID_2_-Copy'
	    }), React.createElement('path', {
	        d: 'M0,1 L2.08922455,1',
	        id: 'XMLID_2_-Copy-2'
	    }), React.createElement('path', {
	        d: 'M0,11 L2.08922455,11',
	        id: 'XMLID_2_-Copy-3'
	    }), React.createElement('path', {
	        d: 'M5,11 L15.982,11 M5,6 L15.982,6 M5,1 L15.982,1',
	        id: 'Stroke-2'
	    })))));
	};

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 16 14',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Node-Edit',
	        transform: 'translate(-48.000000, -313.000000)',
	        stroke: '#323232'
	    }, React.createElement('g', {
	        id: 'Num-List-Button-Press',
	        transform: 'translate(48.000000, 313.000000)'
	    }, React.createElement('path', {
	        d: 'M1.482,0 L1.482,4 M0,5.531 L2.51,5.531 L2.51,7 L0.51,7 L0.51,8.49 L3,8.49 M0,10.52 L2.51,10.52 L2.51,13.48 L0,13.48',
	        id: 'Stroke-1'
	    }), React.createElement('path', {
	        d: 'M1,12 L2,12',
	        id: 'Stroke-3'
	    }), React.createElement('path', {
	        d: 'M5,12 L15.982,12 M5,7 L15.982,7 M5,2 L15.982,2',
	        id: 'Stroke-2-Copy',
	        strokeWidth: '2'
	    })))));
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 17 14',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Account-Popup',
	        transform: 'translate(-1104.000000, -197.000000)',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }, React.createElement('g', {
	        id: 'Account-Menu',
	        transform: 'translate(1091.000000, 80.000000)'
	    }, React.createElement('g', {
	        id: 'Share-Icon-Copy',
	        transform: 'translate(8.000000, 112.000000)'
	    }, React.createElement('path', {
	        d: 'M16.5,8.44125 L20,12.00025 L16.5,15.55875',
	        id: 'Path-Copy-2'
	    }), React.createElement('path', {
	        d: 'M9,12.0003833 L19.2333333,12.0003833',
	        id: 'Path-Copy'
	    }), React.createElement('path', {
	        d: 'M12.5,8.5 L15.5,8.5 L15.5,15.5 L3.5,15.5 L3.5,8.5 L6.5,8.5',
	        id: 'Path-184',
	        transform: 'translate(9.500000, 12.000000) rotate(-270.000000) translate(-9.500000, -12.000000) '
	    }))))));
	};

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 24 24',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Homepage-Login',
	        transform: 'translate(-80.000000, -424.000000)',
	        fill: '#FFFFFF'
	    }, React.createElement('g', {
	        id: 'Facebook-Button',
	        transform: 'translate(64.000000, 408.000000)'
	    }, React.createElement('path', {
	        d: 'M38.5818507,16 L17.3191045,16 C16.5905075,16 16,16.5904179 16,17.3191045 L16,38.5818507 C16,39.3103582 16.5905075,39.9009552 17.3191045,39.9009552 L28.766209,39.9009552 L28.766209,30.6452836 L25.6514925,30.6452836 L25.6514925,27.0381194 L28.766209,27.0381194 L28.766209,24.3779701 C28.766209,21.2908358 30.6517313,19.6098507 33.4056418,19.6098507 C34.7247463,19.6098507 35.8585672,19.7080896 36.1889254,19.7519701 L36.1889254,22.9781791 L34.2789552,22.9790746 C32.781194,22.9790746 32.4912239,23.6907463 32.4912239,24.7351045 L32.4912239,27.0381194 L36.063194,27.0381194 L35.5980597,30.6452836 L32.4912239,30.6452836 L32.4912239,39.9009552 L38.5818507,39.9009552 C39.3103582,39.9009552 39.9009552,39.3103582 39.9009552,38.5818507 L39.9009552,17.3191045 C39.9009552,16.5904179 39.3103582,16 38.5818507,16',
	        id: 'Imported-Layers'
	    })))));
	};

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 16 12',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Project-Graph-View',
	        transform: 'translate(-1168.000000, -50.000000)',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }, React.createElement('g', {
	        id: 'Settings-Dropdown',
	        transform: 'translate(1160.000000, 40.000000)'
	    }, React.createElement('g', {
	        id: 'XMLID_2_-Copy-2-+-XMLID_2_-Copy-5-+-XMLID_2_-Copy-4',
	        transform: 'translate(8.000000, 10.000000)'
	    }, React.createElement('path', {
	        d: 'M0,11 L16,11',
	        id: 'XMLID_2_-Copy-2'
	    }), React.createElement('path', {
	        d: 'M0,6 L16,6',
	        id: 'XMLID_2_-Copy-5'
	    }), React.createElement('path', {
	        d: 'M0,1 L16,1',
	        id: 'XMLID_2_-Copy-4'
	    }))))));
	};

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 68 49',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Homepage-Login',
	        transform: 'translate(-64.000000, -96.000000)'
	    }, React.createElement('g', {
	        id: 'M-Logo',
	        transform: 'translate(64.000000, 96.000000)'
	    }, React.createElement('g', { id: 'Color-Bricks' }, React.createElement('path', {
	        d: 'M1,1 L21,1 L21,10 L1,10 L1,1 Z',
	        id: 'Fill-1',
	        fill: '#DE0B73'
	    }), React.createElement('path', {
	        d: 'M13,10 L30,10 L30,16 L13,16 L13,10 Z',
	        id: 'Fill-2',
	        fill: '#FF4A00'
	    }), React.createElement('path', {
	        d: 'M21,3 L27,3 L27,10 L21,10 L21,3 Z',
	        id: 'Fill-3',
	        fill: '#FF3C3B'
	    }), React.createElement('path', {
	        d: 'M0,10 L13,10 L13,18 L0,18 L0,10 Z',
	        id: 'Fill-4',
	        fill: '#FF8000'
	    }), React.createElement('path', {
	        d: 'M13,16 L30,16 L30,23 L13,23 L13,16 Z',
	        id: 'Fill-5',
	        fill: '#DE9A0B'
	    }), React.createElement('path', {
	        d: 'M30,14 L40,14 L40,21 L30,21 L30,14 Z',
	        id: 'Fill-6',
	        fill: '#FF3C3B'
	    }), React.createElement('path', {
	        d: 'M25,23 L30,23 L30,37 L25,37 L25,23 Z',
	        id: 'Fill-7',
	        fill: '#60DB13'
	    }), React.createElement('path', {
	        d: 'M1,18 L13,18 L13,31 L1,31 L1,18 Z',
	        id: 'Fill-8',
	        fill: '#FFC107'
	    }), React.createElement('path', {
	        d: 'M13,23 L25,23 L25,31 L13,31 L13,23 Z',
	        id: 'Fill-9',
	        fill: '#09C272'
	    }), React.createElement('path', {
	        d: 'M7,31 L20,31 L20,36 L7,36 L7,31 Z',
	        id: 'Fill-10',
	        fill: '#0D9FFB'
	    }), React.createElement('path', {
	        d: 'M0,31 L7,31 L7,42 L0,42 L0,31 Z',
	        id: 'Fill-11',
	        fill: '#60DB13'
	    }), React.createElement('path', {
	        d: 'M1,42 L7,42 L7,49 L1,49 L1,42 Z',
	        id: 'Fill-12',
	        fill: '#0B56DE'
	    }), React.createElement('path', {
	        d: 'M7,43 L20,43 L20,49 L7,49 L7,43 Z',
	        id: 'Fill-13',
	        fill: '#2D11AF'
	    }), React.createElement('path', {
	        d: 'M7,36 L21,36 L21,43 L7,43 L7,36 Z',
	        id: 'Fill-14',
	        fill: '#9E41FF'
	    }), React.createElement('path', {
	        d: 'M30,21 L49,21 L49,31 L30,31 L30,21 Z',
	        id: 'Fill-15',
	        fill: '#FF8000'
	    }), React.createElement('path', {
	        d: 'M36,31 L43,31 L43,39 L36,39 L36,31 Z',
	        id: 'Fill-16',
	        fill: '#09C272'
	    }), React.createElement('path', {
	        d: 'M30,31 L36,31 L36,46 L30,46 L30,31 Z',
	        id: 'Fill-17',
	        fill: '#0D9FFB'
	    }), React.createElement('path', {
	        d: 'M39,6 L45,6 L45,21 L39,21 L39,6 Z',
	        id: 'Fill-18',
	        fill: '#FFC107'
	    }), React.createElement('path', {
	        d: 'M45,0 L52,0 L52,12 L45,12 L45,0 Z',
	        id: 'Fill-19',
	        fill: '#DE2A0B'
	    }), React.createElement('path', {
	        d: 'M52,1 L68,1 L68,12 L52,12 L52,1 Z',
	        id: 'Fill-20',
	        fill: '#FF4A00'
	    }), React.createElement('path', {
	        d: 'M45,12 L66,12 L66,21 L45,21 L45,12 Z',
	        id: 'Fill-21',
	        fill: '#FF3C3B'
	    }), React.createElement('path', {
	        d: 'M49,21 L58,21 L58,37 L49,37 L49,21 Z',
	        id: 'Fill-22',
	        fill: '#09C272'
	    }), React.createElement('path', {
	        d: 'M58,21 L68,21 L68,33 L58,33 L58,21 Z',
	        id: 'Fill-23',
	        fill: '#BBF130'
	    }), React.createElement('path', {
	        d: 'M58,33 L67,33 L67,40 L58,40 L58,33 Z',
	        id: 'Fill-24',
	        fill: '#0B56DE'
	    }), React.createElement('path', {
	        d: 'M48,37 L58,37 L58,49 L48,49 L48,37 Z',
	        id: 'Fill-25',
	        fill: '#2D11AF'
	    }), React.createElement('path', {
	        d: 'M58,40 L68,40 L68,48 L58,48 L58,40 Z',
	        id: 'Fill-26',
	        fill: '#9E41FF'
	    }), React.createElement('path', {
	        d: 'M36,39 L40,39 L40,42 L36,42 L36,39 Z',
	        id: 'Fill-27',
	        fill: '#0B56DE'
	    }))))));
	};

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 14 15',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Account-Popup',
	        transform: 'translate(-289.000000, -281.000000)'
	    }, React.createElement('g', {
	        id: 'Private-Icon-Copy',
	        transform: 'translate(289.000000, 282.000000)'
	    }, React.createElement('rect', {
	        id: 'Rectangle-80',
	        fill: '#D0D0D0',
	        x: '0',
	        y: '7',
	        width: '14',
	        height: '7',
	        rx: '2'
	    }), React.createElement('path', {
	        d: 'M11,7.5 L11,4 C11,1.791 9.209,0 7,0 C4.791,0 3,1.791 3,4 L3,7.5',
	        id: 'Stroke-2',
	        stroke: '#D0D0D0',
	        strokeWidth: '2'
	    })))));
	};

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 14 15',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Account-Popup',
	        transform: 'translate(-297.000000, -377.000000)'
	    }, React.createElement('g', {
	        id: 'Private-Icon',
	        transform: 'translate(297.000000, 378.000000)'
	    }, React.createElement('rect', {
	        id: 'Rectangle-80',
	        fill: '#D0D0D0',
	        x: '0',
	        y: '7',
	        width: '14',
	        height: '7',
	        rx: '2'
	    }), React.createElement('path', {
	        d: 'M11,4 C11,1.791 9.209,0 7,0 C4.791,0 3,1.791 3,4 L3,7.5',
	        id: 'Stroke-2',
	        stroke: '#D0D0D0',
	        strokeWidth: '2'
	    })))));
	};

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 2 16',
	        version: '1.1'
	    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
	        id: 'Projects',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none'
	    }, React.createElement('g', {
	        id: 'Rename',
	        transform: 'translate(-167.000000, -112.000000)',
	        stroke: '#323232',
	        strokeWidth: '2'
	    }, React.createElement('g', {
	        id: 'Add-Button',
	        transform: 'translate(152.000000, 104.000000)'
	    }, React.createElement('path', {
	        d: 'M16,8 L16,24',
	        id: 'XMLID_4_'
	    }), React.createElement('path', {
	        d: 'M8,16 L24,16',
	        id: 'XMLID_2_'
	    })))));
	};

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        viewBox: '0 0 14 15',
	        version: '1.1'
	    }, props), React.createElement('path', {
	        strokeLinecap: 'butt',
	        strokeWidth: '2',
	        stroke: '#323232',
	        fill: 'none',
	        d: 'M 9 12 C 9 10.9 9.89 10 11 10 L 11 10 C 12.1 10 13 10.89 13 12 L 13 12 C 13 13.1 12.11 14 11 14 L 11 14 C 9.9 14 9 13.11 9 12 L 9 12 Z M 9 12',
	        id: 'path4'
	    }), React.createElement('path', {
	        strokeLinecap: 'butt',
	        strokeWidth: '2',
	        stroke: '#323232',
	        fill: 'none',
	        d: 'M 1 12 C 1 10.9 1.89 10 3 10 L 3 10 C 4.1 10 5 10.89 5 12 L 5 12 C 5 13.1 4.11 14 3 14 L 3 14 C 1.9 14 1 13.11 1 12 L 1 12 Z M 1 12',
	        id: 'path6'
	    }), React.createElement('path', {
	        d: 'm 5,11.5 0.5,1 L 11.5,2 11,1 z',
	        id: 'path8',
	        fill: 'none',
	        stroke: '#323232',
	        strokeWidth: '1',
	        strokeOpacity: '1',
	        strokeDasharray: 'none'
	    }), React.createElement('path', {
	        d: 'm 8.9942173,11.5 -0.5,1 -6,-10.5 0.5,-1 z',
	        id: 'path8-9',
	        fill: 'none',
	        stroke: '#323232',
	        strokeWidth: '1',
	        strokeOpacity: '1',
	        strokeDasharray: 'none'
	    }));
	};

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, {
	        version: '1.1',
	        viewBox: '0 0 14 17'
	    }, props), React.createElement('path', {
	        d: 'M 3.44,5.5 7,2 10.56,5.5',
	        fill: 'none',
	        stroke: '#323232',
	        strokeWidth: '2',
	        strokeLinecap: 'butt'
	    }), React.createElement('path', {
	        d: 'm 7.115,2.885 0,10.23',
	        fill: 'none',
	        stroke: '#323232',
	        strokeWidth: '2',
	        strokeLinecap: 'butt'
	    }), React.createElement('path', {
	        d: 'm 10,9 3,0 0,7 -12,0 0,-7 3,0',
	        fill: 'none',
	        stroke: '#323232',
	        strokeWidth: '2',
	        strokeLinecap: 'butt'
	    }));
	};

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, { viewBox: '0 0 20 16' }, props), React.createElement('path', {
	        fill: '#ffffff',
	        d: 'M 19.96 1.88 C 19.22 2.2 18.43 2.41 17.6 2.51 C 18.45 2.01 19.1 1.23 19.4 0.29 C 18.61 0.75 17.74 1.09 16.8 1.27 C 16.06 0.49 14.99 0 13.82 0 C 11.55 0 9.72 1.79 9.72 4.01 C 9.72 4.32 9.76 4.63 9.83 4.92 C 6.43 4.75 3.41 3.16 1.39 0.73 C 1.04 1.32 0.83 2.01 0.83 2.75 C 0.83 4.14 1.56 5.36 2.66 6.08 C 1.99 6.06 1.35 5.88 0.8 5.58 C 0.8 5.6 0.8 5.61 0.8 5.63 C 0.8 7.57 2.21 9.19 4.09 9.56 C 3.74 9.65 3.38 9.7 3.01 9.7 C 2.74 9.7 2.49 9.68 2.24 9.63 C 2.76 11.22 4.27 12.38 6.06 12.41 C 4.66 13.49 2.89 14.13 0.98 14.13 C 0.65 14.13 0.32 14.11 0 14.07 C 1.81 15.21 3.96 15.87 6.28 15.87 C 13.81 15.87 17.92 9.77 17.92 4.47 C 17.92 4.3 17.92 4.12 17.91 3.95 C 18.71 3.39 19.41 2.68 19.96 1.88'
	    }));
	};

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var objectAssign = __webpack_require__(13);
	module.exports = function (props) {
	    return React.createElement('svg', objectAssign({}, { viewBox: '0 0 16 9' }, props), React.createElement('path', {
	        strokeLinecap: 'butt',
	        strokeWidth: '2',
	        stroke: '#323232',
	        fill: 'none',
	        d: 'M 1 1 C 1 1 2.71 5 8 5 C 13.34 5 15 1 15 1 M 2.82 3.26 L 1 6 M 6.17 4.86 L 5.17 8.27 M 13.18 3.28 L 15 6 M 9.84 4.86 L 10.83 8.28'
	    }));
	};

/***/ },
/* 537 */
/***/ function(module, exports) {

	// Rollbar Snippet
	!function(r){function o(e){if(t[e])return t[e].exports;var n=t[e]={exports:{},id:e,loaded:!1};return r[e].call(n.exports,n,n.exports,o),n.loaded=!0,n.exports}var t={};return o.m=r,o.c=t,o.p="",o(0)}([function(r,o,t){"use strict";var e=t(1).Rollbar,n=t(2);_rollbarConfig.rollbarJsUrl=_rollbarConfig.rollbarJsUrl||"https://d37gvrvc0wt4s1.cloudfront.net/js/v1.8/rollbar.min.js";var a=e.init(window,_rollbarConfig),i=n(a,_rollbarConfig);a.loadFull(window,document,!_rollbarConfig.async,_rollbarConfig,i)},function(r,o){"use strict";function t(r){return function(){try{return r.apply(this,arguments)}catch(o){try{console.error("[Rollbar]: Internal error",o)}catch(t){}}}}function e(r,o,t){window._rollbarWrappedError&&(t[4]||(t[4]=window._rollbarWrappedError),t[5]||(t[5]=window._rollbarWrappedError._rollbarContext),window._rollbarWrappedError=null),r.uncaughtError.apply(r,t),o&&o.apply(window,t)}function n(r){var o=function(){var o=Array.prototype.slice.call(arguments,0);e(r,r._rollbarOldOnError,o)};return o.belongsToShim=!0,o}function a(r){this.shimId=++s,this.notifier=null,this.parentShim=r,this._rollbarOldOnError=null}function i(r){var o=a;return t(function(){if(this.notifier)return this.notifier[r].apply(this.notifier,arguments);var t=this,e="scope"===r;e&&(t=new o(this));var n=Array.prototype.slice.call(arguments,0),a={shim:t,method:r,args:n,ts:new Date};return window._rollbarShimQueue.push(a),e?t:void 0})}function l(r,o){if(o.hasOwnProperty&&o.hasOwnProperty("addEventListener")){var t=o.addEventListener;o.addEventListener=function(o,e,n){t.call(this,o,r.wrap(e),n)};var e=o.removeEventListener;o.removeEventListener=function(r,o,t){e.call(this,r,o&&o._wrapped?o._wrapped:o,t)}}}var s=0;a.init=function(r,o){var e=o.globalAlias||"Rollbar";if("object"==typeof r[e])return r[e];r._rollbarShimQueue=[],r._rollbarWrappedError=null,o=o||{};var i=new a;return t(function(){if(i.configure(o),o.captureUncaught){i._rollbarOldOnError=r.onerror,r.onerror=n(i);var t,a,s="EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for(t=0;t<s.length;++t)a=s[t],r[a]&&r[a].prototype&&l(i,r[a].prototype)}return r[e]=i,i})()},a.prototype.loadFull=function(r,o,e,n,a){var i=function(){var o;if(void 0===r._rollbarPayloadQueue){var t,e,n,i;for(o=new Error("rollbar.js did not load");t=r._rollbarShimQueue.shift();)for(n=t.args,i=0;i<n.length;++i)if(e=n[i],"function"==typeof e){e(o);break}}"function"==typeof a&&a(o)},l=!1,s=o.createElement("script"),u=o.getElementsByTagName("script")[0],p=u.parentNode;s.crossOrigin="",s.src=n.rollbarJsUrl,s.async=!e,s.onload=s.onreadystatechange=t(function(){if(!(l||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState)){s.onload=s.onreadystatechange=null;try{p.removeChild(s)}catch(r){}l=!0,i()}}),p.insertBefore(s,u)},a.prototype.wrap=function(r,o){try{var t;if(t="function"==typeof o?o:function(){return o||{}},"function"!=typeof r)return r;if(r._isWrap)return r;if(!r._wrapped){r._wrapped=function(){try{return r.apply(this,arguments)}catch(o){throw o._rollbarContext=t()||{},o._rollbarContext._wrappedSource=r.toString(),window._rollbarWrappedError=o,o}},r._wrapped._isWrap=!0;for(var e in r)r.hasOwnProperty(e)&&(r._wrapped[e]=r[e])}return r._wrapped}catch(n){return r}};for(var u="log,debug,info,warn,warning,error,critical,global,configure,scope,uncaughtError".split(","),p=0;p<u.length;++p)a.prototype[u[p]]=i(u[p]);r.exports={Rollbar:a,_rollbarWindowOnError:e}},function(r,o){"use strict";r.exports=function(r,o){return function(t){if(!t&&!window._rollbarInitialized){var e=window.RollbarNotifier,n=o||{},a=n.globalAlias||"Rollbar",i=window.Rollbar.init(n,r);i._processShimQueue(window._rollbarShimQueue||[]),window[a]=i,window._rollbarInitialized=!0,e.processPayloads()}}}}]);


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setEditorNode = setEditorNode;
	
	var _actionTypes = __webpack_require__(23);
	
	function setEditorNode(value) {
	  return {
	    type: _actionTypes.SET_EDITOR_NODE,
	    value: value
	  };
	}
	/* injects from baggage-loader */

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* injects from baggage-loader */
	
	var Route = function (_Component) {
	  _inherits(Route, _Component);
	
	  function Route() {
	    _classCallCheck(this, Route);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Route).apply(this, arguments));
	  }
	
	  _createClass(Route, [{
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.props.enter(callback);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.props.leave(callback);
	    }
	  }, {
	    key: 'componentDidLeave',
	    value: function componentDidLeave() {
	      this.props.routeTransitionFinished();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        this.props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Route;
	}(_react.Component);
	
	exports.default = Route;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	/* injects from baggage-loader */
	
	/*
	
	    Returns spinner if there are no route params in state
	
	*/
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Common = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getState = function getState(state) {
	  return {
	    routing: state.routing
	  };
	};
	
	var AnimatedRoutes = (_dec = (0, _reduxSimple.connect)(getState, {}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AnimatedRoutes, _Component);
	
	  function AnimatedRoutes() {
	    _classCallCheck(this, AnimatedRoutes);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(AnimatedRoutes).apply(this, arguments));
	  }
	
	  _createClass(AnimatedRoutes, [{
	    key: 'render',
	    value: function render() {
	      var routing = this.props.routing;
	
	
	      if (!routing || !routing.type) {
	        return _react2.default.createElement(_Common.Spinner, { routeSpinner: true });
	      }
	
	      return this.props.children;
	    }
	  }]);
	
	  return AnimatedRoutes;
	}(_react.Component), _class2.propTypes = {
	  routing: _react.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.element.isRequired
	}, _temp)) || _class);
	exports.default = AnimatedRoutes;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnimatedRoute = exports.AnimatedRoutes = undefined;
	
	var _App = __webpack_require__(209);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _AnimatedRoutes = __webpack_require__(208);
	
	var _AnimatedRoutes2 = _interopRequireDefault(_AnimatedRoutes);
	
	var _AnimatedRoute = __webpack_require__(539);
	
	var _AnimatedRoute2 = _interopRequireDefault(_AnimatedRoute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _App2.default;
	/* injects from baggage-loader */
	
	exports.AnimatedRoutes = _AnimatedRoutes2.default;
	exports.AnimatedRoute = _AnimatedRoute2.default;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Common = __webpack_require__(11);
	
	var _userActions = __webpack_require__(49);
	
	var _User = __webpack_require__(67);
	
	var _Icons = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(461);
	
	var getState = function getState(state) {
	  return {
	    loggingIn: state.user.loggingIn
	  };
	};
	
	var Login = (_dec = (0, _reduxSimple.connect)(getState, { logIn: _userActions.logIn }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Login).apply(this, arguments));
	  }
	
	  _createClass(Login, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _User.UserPageWrapper,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: styles.header },
	          _react2.default.createElement(_Icons.Logo, { className: styles.logo, width: '69', height: '50' }),
	          _react2.default.createElement(
	            'div',
	            { className: styles.project },
	            'Meta Projects'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.description },
	          'A tool that helps you collect',
	          _react2.default.createElement('br', null),
	          'abstract things and thoughts into',
	          _react2.default.createElement('br', null),
	          'a tangible project.'
	        ),
	        this.props.loggingIn && _react2.default.createElement(_Common.Spinner, null) || _react2.default.createElement(
	          _Common.Button,
	          { onClick: this.props.logIn },
	          'Log in anonymously'
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component), _class2.propTypes = {
	  logIn: _react.PropTypes.func.isRequired,
	  loggingIn: _react.PropTypes.bool.isRequired
	}, _temp)) || _class);
	exports.default = Login;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Common = __webpack_require__(11);
	
	var _userActions = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(462);
	
	var getState = function getState(state) {
	  return {
	    loggingIn: state.user.loggingIn
	  };
	};
	
	var Login = (_dec = (0, _reduxSimple.connect)(getState, { logIn: _userActions.logIn }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Login).apply(this, arguments));
	  }
	
	  _createClass(Login, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Common.Button,
	        { facebookSmall: true, onClick: this.props.logIn, loading: this.props.loggingIn },
	        'Join with Facebook'
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component), _class2.propTypes = {
	  logIn: _react.PropTypes.func.isRequired,
	  loggingIn: _react.PropTypes.bool.isRequired
	}, _temp)) || _class);
	exports.default = Login;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	/* injects from baggage-loader */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _userActions = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logout = (_dec = (0, _reduxSimple.connect)(null, { logOut: _userActions.logOut }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Logout, _Component);
	
	  function Logout() {
	    _classCallCheck(this, Logout);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Logout).apply(this, arguments));
	  }
	
	  _createClass(Logout, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.props.logOut },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Logout;
	}(_react.Component), _class2.propTypes = {
	  logOut: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.any
	}, _temp)) || _class);
	exports.default = Logout;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactFormal = __webpack_require__(947);
	
	var _reactFormal2 = _interopRequireDefault(_reactFormal);
	
	var _Common = __webpack_require__(11);
	
	var _Icons = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(464);
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Button).apply(this, arguments));
	  }
	
	  _createClass(Button, [{
	    key: 'getFacebookIcon',
	    value: function getFacebookIcon() {
	      return _react2.default.createElement(_Icons.Facebook, { width: '24', height: '24' });
	    }
	  }, {
	    key: 'getFacebookSmallIcon',
	    value: function getFacebookSmallIcon() {
	      return _react2.default.createElement(_Icons.Facebook, { width: '18', height: '18' });
	    }
	  }, {
	    key: 'getTwitterIcon',
	    value: function getTwitterIcon() {
	      var iconWidth = this.props.small ? '18' : '24';
	      return _react2.default.createElement(_Icons.Twitter, { width: iconWidth, height: iconWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)(styles.button, this.props.facebook && styles.facebook, this.props.facebookSmall && styles.facebookSmall, this.props.twitter && styles.twitter, this.props.light && styles.light, this.props.small && styles.small, this.props.loading && styles.loading);
	
	      return this.props.submit ? _react2.default.createElement(
	        _reactFormal2.default.Button,
	        _extends({}, this.props, {
	          type: 'submit',
	          className: className }),
	        this.props.loading && _react2.default.createElement(
	          'div',
	          { className: styles.spinner },
	          _react2.default.createElement(_Common.Spinner, { white: this.props.facebook })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.content },
	          this.props.facebook && this.getFacebookIcon(),
	          this.props.facebookSmall && this.getFacebookSmallIcon(),
	          this.props.twitter && this.getTwitterIcon(),
	          this.props.children
	        )
	      ) : _react2.default.createElement(
	        'button',
	        _extends({}, this.props, {
	          className: className }),
	        this.props.loading && _react2.default.createElement(
	          'div',
	          { className: styles.spinner },
	          _react2.default.createElement(_Common.Spinner, { white: this.props.facebook })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.content },
	          this.props.facebook && this.getFacebookIcon(),
	          this.props.facebookSmall && this.getFacebookSmallIcon(),
	          this.props.twitter && this.getTwitterIcon(),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component);
	
	exports.default = Button;
	
	
	Button.propTypes = {
	  children: _react.PropTypes.any,
	  facebook: _react.PropTypes.bool,
	  facebookSmall: _react.PropTypes.bool,
	  light: _react.PropTypes.bool,
	  small: _react.PropTypes.bool,
	  submit: _react.PropTypes.bool,
	  loading: _react.PropTypes.bool
	};

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Group = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(465);
	
	var Group = exports.Group = function (_Component) {
	  _inherits(Group, _Component);
	
	  function Group(props, ctx) {
	    _classCallCheck(this, Group);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Group).call(this, props, ctx));
	
	    _this.state = {
	      selected: props.defaultSelected || ''
	    };
	    return _this;
	  }
	
	  _createClass(Group, [{
	    key: 'handleSelected',
	    value: function handleSelected(id) {
	      this.setState({ selected: id });
	      this.props.onSelect(id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var children = this.props.children;
	
	
	      var mappedChildren = _react2.default.Children.map(children, function (child) {
	        var id = child.props.id;
	        var selected = _this2.state.selected === id;
	
	        return _react2.default.cloneElement(child, {
	          onSelect: function onSelect() {
	            return _this2.handleSelected(id);
	          },
	          selected: selected
	        });
	      });
	
	      var containerClassname = (0, _classnames2.default)(styles.container);
	
	      return _react2.default.createElement(
	        'div',
	        { className: containerClassname },
	        mappedChildren
	      );
	    }
	  }]);
	
	  return Group;
	}(_react.Component);
	
	Group.propTypes = {
	  onSelect: _react.PropTypes.func
	};

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Icon = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(466);
	
	var Icon = exports.Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Icon).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var selected = this.props.selected;
	
	
	      var containerClassname = (0, _classnames2.default)(styles.container, selected && styles.selected);
	
	      return _react2.default.createElement(
	        'div',
	        { className: containerClassname },
	        _react2.default.createElement(
	          'div',
	          { className: styles.outer },
	          _react2.default.createElement('div', { className: styles.inner })
	        )
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.propTypes = {
	  selected: _react.PropTypes.bool
	};

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Item = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(467);
	
	var Item = exports.Item = function (_Component) {
	  _inherits(Item, _Component);
	
	  function Item() {
	    _classCallCheck(this, Item);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Item).apply(this, arguments));
	  }
	
	  _createClass(Item, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var selected = _props.selected;
	      var _props$onSelect = _props.onSelect;
	      var onSelect = _props$onSelect === undefined ? function () {} : _props$onSelect;
	
	
	      var mappedChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.cloneElement(child, { selected: selected });
	      });
	
	      var containerClassname = (0, _classnames2.default)(styles.container, selected && styles.selected);
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: !selected && function () {
	            return onSelect();
	          }, className: containerClassname },
	        mappedChildren
	      );
	    }
	  }]);
	
	  return Item;
	}(_react.Component);
	
	Item.propTypes = {
	  selected: _react.PropTypes.bool,
	  onSelect: _react.PropTypes.func
	};

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Label = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(468);
	
	var Label = exports.Label = function (_Component) {
	  _inherits(Label, _Component);
	
	  function Label() {
	    _classCallCheck(this, Label);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Label).apply(this, arguments));
	  }
	
	  _createClass(Label, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.label },
	        children
	      );
	    }
	  }]);
	
	  return Label;
	}(_react.Component);

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Icon = __webpack_require__(547);
	
	Object.defineProperty(exports, 'Icon', {
	  enumerable: true,
	  get: function get() {
	    return _Icon.Icon;
	  }
	});
	
	var _Item = __webpack_require__(548);
	
	Object.defineProperty(exports, 'Item', {
	  enumerable: true,
	  get: function get() {
	    return _Item.Item;
	  }
	});
	
	var _Label = __webpack_require__(549);
	
	Object.defineProperty(exports, 'Label', {
	  enumerable: true,
	  get: function get() {
	    return _Label.Label;
	  }
	});
	
	var _Group = __webpack_require__(546);
	
	Object.defineProperty(exports, 'Group', {
	  enumerable: true,
	  get: function get() {
	    return _Group.Group;
	  }
	});

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ColorsSet = __webpack_require__(211);
	
	var _ColorsSet2 = _interopRequireDefault(_ColorsSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(469);
	
	var ColorPickerItem = function ColorPickerItem(props) {
	  var onPick = props.onPick;
	  var color = props.color;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: styles.itemContainer,
	      onClick: function onClick(e) {
	        e.stopPropagation();
	        e.preventDefault();
	        onPick();
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: { backgroundColor: color }, className: styles.content },
	      _react2.default.createElement('div', { className: styles.hoverLabel })
	    )
	  );
	};
	
	var ColorPicker = function (_Component) {
	  _inherits(ColorPicker, _Component);
	
	  function ColorPicker() {
	    _classCallCheck(this, ColorPicker);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ColorPicker).apply(this, arguments));
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.picker },
	        _ColorsSet2.default.map(function (color, index) {
	          return _react2.default.createElement(ColorPickerItem, {
	            key: index, color: color,
	            onPick: function onPick() {
	              return _this2.props.onPick(color);
	            }
	          });
	        })
	      );
	    }
	  }]);
	
	  return ColorPicker;
	}(_react.Component);
	
	exports.default = ColorPicker;
	
	
	ColorPicker.propTypes = {
	  onPick: _react.PropTypes.func.isRequired
	};

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTextareaAutosize = __webpack_require__(1004);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _reactDom = __webpack_require__(29);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _is = __webpack_require__(157);
	
	var _is2 = _interopRequireDefault(_is);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _textWidth = __webpack_require__(1076);
	
	var _textWidth2 = _interopRequireDefault(_textWidth);
	
	var _utils = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(470);
	
	//TODO fix font loading bug
	var measureLine = function measureLine(line) {
	  return Math.ceil((0, _textWidth2.default)(line, { family: 'sans-serif', size: 14 })) + 1;
	};
	
	var measureWidth = function measureWidth(text) {
	  return text.split('\n').map(measureLine).reduce(function (a, b) {
	    return Math.max(a, b);
	  }, 0);
	};
	
	var EditableTextArea = (_temp = _class = function (_Component) {
	  _inherits(EditableTextArea, _Component);
	
	  _createClass(EditableTextArea, [{
	    key: 'startEdit',
	    value: function startEdit() {
	      if (this) {
	        this.handleEditStart();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.textAreaNode = (0, _reactDom.findDOMNode)(this.refs.textArea);
	    }
	  }]);
	
	  function EditableTextArea(props) {
	    _classCallCheck(this, EditableTextArea);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditableTextArea).call(this, props));
	
	    _this.state = { editing: false, editValue: '' };
	    return _this;
	  }
	
	  _createClass(EditableTextArea, [{
	    key: 'handleEditStart',
	    value: function handleEditStart(ev) {
	      var _this2 = this;
	
	      if (ev) ev.stopPropagation();
	
	      var disabled = this.props.disabled;
	
	      if (disabled) return;
	
	      this.setState({ editing: true, editValue: this.props.text });
	      this.props.onEditStart();
	
	      (0, _raf2.default)(function () {
	        _this2.textAreaNode.focus();
	        _this2.textAreaNode.select();
	      });
	    }
	  }, {
	    key: 'handleEditSubmit',
	    value: function handleEditSubmit() {
	      var editValue = this.state.editValue;
	
	      this.props.onEditSubmit(editValue);
	      this.setState({ editing: false });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(ev) {
	      var editValue = ev.target.value;
	      this.setState({ editValue: editValue });
	      this.props.onEditChange(editValue);
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(e) {
	      if (e.keyCode === 27) this.handleEditSubmit();
	    }
	  }, {
	    key: 'handleClickOut',
	    value: function handleClickOut() {
	      if (this.isEditing()) this.handleEditSubmit();
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      var editValue = this.state.editValue;
	      var _props = this.props;
	      var text = _props.text;
	      var maxWidth = _props.maxWidth;
	      var minWidth = _props.minWidth;
	
	
	      var measured = this.isEditing() ? editValue : text;
	      return (0, _utils.padNumber)({ x: measureWidth(measured), min: minWidth, max: maxWidth });
	    }
	  }, {
	    key: 'isEditing',
	    value: function isEditing() {
	      if (_is2.default.defined(this.props.editing)) return this.props.editing;
	
	      return this.state.editing;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var width = this.getWidth();
	
	      var editing = this.isEditing();
	
	      var classname = (0, _classnames2.default)(styles.container, editing && styles.editing, this.props.disabled && styles.disabled, this.props.dark && styles.dark);
	
	      return _react2.default.createElement(
	        _reactOnclickout2.default,
	        { onClickOut: this.handleClickOut.bind(this) },
	        _react2.default.createElement(
	          'div',
	          {
	            style: { width: width },
	            className: classname
	          },
	          _react2.default.createElement(_reactTextareaAutosize2.default, {
	            style: { width: width },
	            ref: 'textArea',
	            onBlur: this.handleEditSubmit.bind(this),
	            onKeyUp: this.handleKeyUp.bind(this),
	            onClick: function onClick(ev) {
	              return ev.stopPropagation();
	            },
	
	            className: styles.textArea,
	            value: this.state.editValue,
	            onChange: this.handleChange.bind(this)
	          }),
	          _react2.default.createElement(
	            'span',
	            {
	              style: { width: width },
	              className: styles.content
	            },
	            this.props.text
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditableTextArea;
	}(_react.Component), _class.defaultProps = {
	  minWidth: 40,
	  onEditStart: _lodash2.default.noop,
	  onEditSubmit: _lodash2.default.noop,
	  onEditCancel: _lodash2.default.noop,
	  onEditChange: _lodash2.default.noop
	}, _temp);
	exports.default = EditableTextArea;
	
	
	EditableTextArea.propTypes = {
	  customWidth: _react.PropTypes.number,
	  text: _react.PropTypes.string.isRequired,
	  dark: _react.PropTypes.bool,
	
	  onEditStart: _react.PropTypes.func,
	  onEditChange: _react.PropTypes.func,
	  onEditSubmit: _react.PropTypes.func,
	  onEditCancel: _react.PropTypes.func,
	
	  editing: _react.PropTypes.bool, // controlled mode
	
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(473);
	
	var Menu = (_temp = _class = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Menu).apply(this, arguments));
	  }
	
	  _createClass(Menu, [{
	    key: 'getBackdrop',
	    value: function getBackdrop() {
	      return _react2.default.createElement('div', { className: styles.backdrop, onClick: this.props.close });
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      var _props = this.props;
	      var openable = _props.openable;
	      var isOpen = _props.isOpen;
	      var close = _props.close;
	
	
	      if (!openable || openable && isOpen) close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var openable = _props2.openable;
	      var isOpen = _props2.isOpen;
	      var backdrop = _props2.backdrop;
	
	
	      var classname = (0, _classnames2.default)(styles.menu, (openable && isOpen || !openable) && styles.open);
	
	      var Content = _react2.default.createElement(
	        'div',
	        { className: classname },
	        backdrop ? this.getBackdrop() : null,
	        _react2.default.createElement(
	          'div',
	          { className: styles.container },
	          _react2.default.createElement(
	            'div',
	            { className: styles.content },
	            this.props.children
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        _reactOnclickout2.default,
	        { onClickOut: this.handleClose.bind(this) },
	        Content
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any.isRequired,
	  close: _react.PropTypes.func,
	  backdrop: _react.PropTypes.bool,
	
	  openable: _react.PropTypes.bool,
	  isOpen: _react.PropTypes.bool
	}, _temp);
	exports.default = Menu;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(474);
	
	var MenuItem = function (_Component) {
	  _inherits(MenuItem, _Component);
	
	  function MenuItem() {
	    _classCallCheck(this, MenuItem);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(MenuItem).apply(this, arguments));
	  }
	
	  _createClass(MenuItem, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (!this.props.onClick) return;
	
	      e.preventDefault();
	      e.stopPropagation();
	
	      this.props.onClick();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var thin = _props.thin;
	      var children = _props.children;
	
	
	      var className = (0, _classnames2.default)(styles.menuItem, thin && styles.thin);
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.handleClick.bind(this), className: className },
	        children
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react.Component);
	
	exports.default = MenuItem;
	
	
	MenuItem.propTypes = {
	  children: _react.PropTypes.any.isRequired,
	  onClick: _react.PropTypes.func,
	
	  thin: _react.PropTypes.bool
	};

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(475);
	
	var MenuItemIcon = (_temp = _class = function (_Component) {
	  _inherits(MenuItemIcon, _Component);
	
	  function MenuItemIcon() {
	    _classCallCheck(this, MenuItemIcon);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(MenuItemIcon).apply(this, arguments));
	  }
	
	  _createClass(MenuItemIcon, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.menuItemIcon },
	        this.props.children
	      );
	    }
	  }]);
	
	  return MenuItemIcon;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any
	}, _temp);
	exports.default = MenuItemIcon;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(476);
	
	var MenuItemLabel = (_temp = _class = function (_Component) {
	  _inherits(MenuItemLabel, _Component);
	
	  function MenuItemLabel() {
	    _classCallCheck(this, MenuItemLabel);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(MenuItemLabel).apply(this, arguments));
	  }
	
	  _createClass(MenuItemLabel, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.menuItemLabel },
	        this.props.children
	      );
	    }
	  }]);
	
	  return MenuItemLabel;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any
	}, _temp);
	exports.default = MenuItemLabel;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Menu = __webpack_require__(553);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(554);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuItemIcon = __webpack_require__(555);
	
	var _MenuItemIcon2 = _interopRequireDefault(_MenuItemIcon);
	
	var _MenuItemLabel = __webpack_require__(556);
	
	var _MenuItemLabel2 = _interopRequireDefault(_MenuItemLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	/*
	<Menu>
	  <MenuItem>
	    <MenuItemIcon><OpenNew /></MenuItemIcon>
	    <MenuItemLabel>Open new</MenuItemLabel>
	  </MenuItem>
	
	  <MenuItem>
	    <MenuItemIcon><Rename /></MenuItemIcon>
	    <MenuItemLabel>Rename</MenuItemLabel>
	  </MenuItem>
	</Menu>
	*/
	
	_Menu2.default.Item = _MenuItem2.default;
	_Menu2.default.ItemIcon = _MenuItemIcon2.default;
	_Menu2.default.ItemLabel = _MenuItemLabel2.default;
	
	exports.default = _Menu2.default;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppendNew = exports.Delete = exports.Detach = exports.SetColor = exports.Rename = exports.Open = exports.DragHandle = exports.Hamburger = undefined;
	
	var _class, _temp;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(477);
	
	var Hamburger = exports.Hamburger = function (_Component) {
	  _inherits(Hamburger, _Component);
	
	  function Hamburger() {
	    _classCallCheck(this, Hamburger);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Hamburger).apply(this, arguments));
	  }
	
	  _createClass(Hamburger, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { className: styles.hamburger, height: '24', width: '24', viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#000000', fill: 'none',
	          d: 'M 5 12 L 19 12' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#000000', fill: 'none',
	          d: 'M 5 7 L 19 7' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#000000', fill: 'none',
	          d: 'M 5 17 L 19 17' })
	      );
	    }
	  }]);
	
	  return Hamburger;
	}(_react.Component);
	
	var DragHandle = exports.DragHandle = (_temp = _class = function (_Component2) {
	  _inherits(DragHandle, _Component2);
	
	  function DragHandle() {
	    _classCallCheck(this, DragHandle);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(DragHandle).apply(this, arguments));
	  }
	
	  _createClass(DragHandle, [{
	    key: 'render',
	    value: function render() {
	      var cn = (0, _classnames2.default)(styles.dragHandle, this.props.hover && styles.hover);
	      return _react2.default.createElement(
	        'svg',
	        { className: cn, height: '24', width: '24', viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', {
	          d: 'M 8.9999995,8 C 10.1,8 11,7.1 11,6 11,4.9 10.1,4 8.9999995,4 c -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 15,14 c 1.1,0 2,-0.9 2,-2 0,-1.1 -0.9,-2 -2,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 8.9999995,14 C 10.1,14 11,13.1 11,12 c 0,-1.1 -0.9,-2 -2.0000005,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 15,20 c 1.1,0 2,-0.9 2,-2 0,-1.1 -0.9,-2 -2,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 8.9999995,20 C 10.1,20 11,19.1 11,18 c 0,-1.1 -0.9,-2 -2.0000005,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 15,8 c 1.1,0 2,-0.9 2,-2 0,-1.1 -0.9,-2 -2,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z m 0,0',
	          fill: '#000000' })
	      );
	    }
	  }]);
	
	  return DragHandle;
	}(_react.Component), _class.propTypes = {
	  hover: _react.PropTypes.bool
	}, _temp);
	
	var Open = exports.Open = function (_Component3) {
	  _inherits(Open, _Component3);
	
	  function Open() {
	    _classCallCheck(this, Open);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Open).apply(this, arguments));
	  }
	
	  _createClass(Open, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: '14', width: '17', viewBox: '0 0 18 18' },
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#232323', fill: 'none',
	          fillRule: 'evenodd', d: 'M 8 0.88 L 15 8 L 8 15.12' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#232323', fill: 'none',
	          fillRule: 'evenodd', d: 'M 0 8 L 14 8' })
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	var Rename = exports.Rename = function (_Component4) {
	  _inherits(Rename, _Component4);
	
	  function Rename() {
	    _classCallCheck(this, Rename);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Rename).apply(this, arguments));
	  }
	
	  _createClass(Rename, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: '16', width: '16', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 13 1 L 13 15' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 1 4 L 10 4 L 10 12 L 1 12 L 1 4 Z M 1 4' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 16 1 L 9.94 1' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 16 15 L 9.94 15' })
	      );
	    }
	  }]);
	
	  return Rename;
	}(_react.Component);
	
	var SetColor = exports.SetColor = function (_Component5) {
	  _inherits(SetColor, _Component5);
	
	  function SetColor() {
	    _classCallCheck(this, SetColor);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(SetColor).apply(this, arguments));
	  }
	
	  _createClass(SetColor, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: '17', width: '14', viewBox: '0 0 14 17' },
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'square', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 7 16 L 7 9 L 13 7.13 L 13 4.13' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 1 1 L 13 1 L 13 5 L 1 5 L 1 1 Z M 1 1' })
	      );
	    }
	  }]);
	
	  return SetColor;
	}(_react.Component);
	
	var Detach = exports.Detach = function (_Component6) {
	  _inherits(Detach, _Component6);
	
	  function Detach() {
	    _classCallCheck(this, Detach);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Detach).apply(this, arguments));
	  }
	
	  _createClass(Detach, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: '16', width: '16', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 7 15 L 4 10 L 7 6 L 4 1' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 12 15 L 9 10 L 12 6 L 9 1' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 0 8 L 6.05 8' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 10.14 8 L 16 8' })
	      );
	    }
	  }]);
	
	  return Detach;
	}(_react.Component);
	
	var Delete = exports.Delete = function (_Component7) {
	  _inherits(Delete, _Component7);
	
	  function Delete() {
	    _classCallCheck(this, Delete);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Delete).apply(this, arguments));
	  }
	
	  _createClass(Delete, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: '17', width: '14', viewBox: '0 0 14 17' },
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 1 4 L 13 4 L 13 7 L 1 7 L 1 4 Z M 1 4' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 2 7 L 2 16 L 12 16 L 12 7 L 2 7 Z M 2 7' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 5 4 L 5 1 L 9 1 L 9 4 L 5 4 Z M 5 4' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 9 9 L 9 14 L 9 9 Z M 9 9' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 5 9 L 5 14 L 5 9 Z M 5 9' })
	      );
	    }
	  }]);
	
	  return Delete;
	}(_react.Component);
	
	var AppendNew = exports.AppendNew = function (_Component8) {
	  _inherits(AppendNew, _Component8);
	
	  function AppendNew() {
	    _classCallCheck(this, AppendNew);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(AppendNew).apply(this, arguments));
	  }
	
	  _createClass(AppendNew, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { height: '16', width: '16', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 0 8 L 16 8' }),
	        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
	          fillRule: 'evenodd', d: 'M 8 0 L 8 16' })
	      );
	    }
	  }]);
	
	  return AppendNew;
	}(_react.Component);

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Common = __webpack_require__(11);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _projectsActions = __webpack_require__(22);
	
	var _userActions = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(479);
	
	var getState = function getState(state) {
	  return {
	    foreignUser: state.routing.foreignUser,
	    authorizedUser: state.user.authorizedUser,
	    shownUser: state.user.shownUser,
	    projects: state.projects.list
	  };
	};
	
	var StartNewProjectButton = (_dec = (0, _reduxSimple.connect)(getState, { addProject: _projectsActions.addProject, logInAndToIndex: _userActions.logInAndToIndex }), _dec(_class = function (_Component) {
	  _inherits(StartNewProjectButton, _Component);
	
	  function StartNewProjectButton() {
	    _classCallCheck(this, StartNewProjectButton);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StartNewProjectButton).apply(this, arguments));
	  }
	
	  _createClass(StartNewProjectButton, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var authorizedUser = this.props.authorizedUser;
	
	      if (!authorizedUser) this.props.logInAndToIndex();
	      this.props.addProject({ transition: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Common.Button,
	        { onClick: this.handleClick.bind(this) },
	        'Start new project'
	      );
	    }
	  }]);
	
	  return StartNewProjectButton;
	}(_react.Component)) || _class);
	exports.default = StartNewProjectButton;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(480);
	
	var Tab = function (_Component) {
	  _inherits(Tab, _Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Tab).apply(this, arguments));
	  }
	
	  _createClass(Tab, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)(styles.tab, this.props.selected && styles.selected);
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, onClick: this.props.onSelected },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react.Component);
	
	exports.default = Tab;
	
	
	Tab.propTypes = {
	  name: _react.PropTypes.string.isRequired,
	  selected: _react.PropTypes.bool,
	  onSelected: _react.PropTypes.func
	};

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(481);
	
	var Tooltip = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    _classCallCheck(this, Tooltip);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Tooltip).apply(this, arguments));
	  }
	
	  _createClass(Tooltip, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.tooltip },
	        _react2.default.createElement(
	          'span',
	          { className: styles.icon },
	          _react2.default.createElement(_Icons.TooltipIcon, null)
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: styles.iconHover },
	          _react2.default.createElement(_Icons.TooltipHoverIcon, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.content },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component);
	
	exports.default = Tooltip;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CSSCore = __webpack_require__(154);
	
	var _CSSCore2 = _interopRequireDefault(_CSSCore);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _Popups = __webpack_require__(216);
	
	var _EditorLinkPreview = __webpack_require__(563);
	
	var _EditorLinkPreview2 = _interopRequireDefault(_EditorLinkPreview);
	
	__webpack_require__(457);
	
	var _Common = __webpack_require__(11);
	
	var _Icons = __webpack_require__(17);
	
	var _editorHelpers = __webpack_require__(214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(483);
	
	var getState = function getState(state) {
	  return {
	    node: state.nodes.editorNode
	  };
	};
	
	var getOffsetFromElementWithClassName = function getOffsetFromElementWithClassName(element, className) {
	  var node = element;
	  var offset = {
	    left: 0,
	    top: 0
	  };
	  while (!_CSSCore2.default.hasClass(node, className) && node.nodeName !== 'BODY') {
	    offset.top += node.offsetTop;
	    offset.left += node.offsetLeft;
	    node = node.offsetParent;
	  }
	  return offset;
	};
	
	var NodePage = (_dec = (0, _reduxSimple.connect)(getState), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(NodePage, _Component);
	
	  function NodePage() {
	    _classCallCheck(this, NodePage);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NodePage).call(this));
	
	    _this.state = {
	      ready: false,
	      linkPreview: false,
	      linkEditorActive: false,
	      linkEditor: {
	        text: '',
	        url: 'http://'
	      }
	    };
	    _this.linkOffset = null;
	    _this.deleteLink = null;
	    _this.afterEditLink = null;
	    return _this;
	  }
	
	  _createClass(NodePage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.init(this.props);
	    }
	  }, {
	    key: 'clearLinkPreview',
	    value: function clearLinkPreview() {
	      this.setState({
	        linkPreview: false
	      });
	      this.linkOffset = null;
	      this.deleteLink = null;
	      this.afterEditLink = null;
	    }
	  }, {
	    key: 'linkPreview',
	    value: function linkPreview(e, info, methods) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      this.linkOffset = getOffsetFromElementWithClassName(e.target, styles.wrapper);
	      this.linkOffset = _extends({}, this.linkOffset, {
	        top: this.linkOffset.top + 32
	      });
	
	      this.deleteLink = function () {
	        methods.remove();
	      };
	      this.editLink = function () {
	        _this2.setState({
	          linkPreview: false
	        });
	        _this2.showLinkPopup(info);
	      };
	      this.afterEditLink = function (newInfo) {
	        methods.replace(newInfo);
	      };
	
	      this.setState({
	        linkPreview: info
	      });
	    }
	  }, {
	    key: 'makeLinkFromFirebase',
	    value: function makeLinkFromFirebase(info, methods) {
	      var _this3 = this;
	
	      var link = document.createElement('a');
	      link.setAttribute('href', info.href);
	      link.innerHTML = info.content;
	      link.addEventListener('click', function (e) {
	        return _this3.linkPreview(e, info, methods);
	      });
	      if (info.hasOwnProperty('target')) link.setAttribute('target', info.target);
	      return link;
	    }
	  }, {
	    key: 'init',
	    value: function init(props) {
	      var _this4 = this;
	
	      if (!props.node) return;
	      var _props$node = this.props.node;
	      var refLink = _props$node.refLink;
	      var caption = _props$node.caption;
	
	      var nodeCaption = caption + '\n\n\n\n\n\n\n\n';
	
	      var firepadRefPath = refLink + '/firepad';
	      this.firepadRef = (0, _firebase2.default)(firepadRefPath);
	      this.firePadElement = (0, _reactDom.findDOMNode)(this).getElementsByClassName(styles.firepad)[0];
	      this.codeMirror = window.CodeMirror( // eslint-disable-line
	      this.firePadElement, { lineWrapping: true });
	      this.firepad = window.Firepad.fromCodeMirror(this.firepadRef, this.codeMirror, {
	        richTextShortcuts: true,
	        richTextToolbar: false,
	        defaultText: nodeCaption
	      });
	
	      this.firepad.registerEntity('a', {
	        render: this.makeLinkFromFirebase.bind(this),
	        export: this.makeLinkFromFirebase.bind(this),
	        fromElement: _editorHelpers.makeFirebaseFromLink
	      });
	
	      this.codeMirror.getWrapperElement().addEventListener('copy', function (e) {
	        return (0, _editorHelpers.copy)(_this4.firepad, e);
	      });
	      this.codeMirror.getWrapperElement().addEventListener('cut', function (e) {
	        return (0, _editorHelpers.cut)(_this4.firepad, _this4.codeMirror, e);
	      });
	      this.codeMirror.getWrapperElement().addEventListener('paste', function (e) {
	        return (0, _editorHelpers.paste)(_this4.firepad, e);
	      });
	
	      this.firepad.on('ready', function () {
	        return _this4.setState({ ready: true });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.firepad) this.firepad.dispose();
	    }
	  }, {
	    key: 'handleFirepadClick',
	    value: function handleFirepadClick(ev) {
	      ev.stopPropagation();
	    }
	  }, {
	    key: 'handleControlsClick',
	    value: function handleControlsClick(ev) {
	      ev.stopPropagation();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var _this5 = this;
	
	      if (props.node && props.node.id !== _lodash2.default.get(this.props.node, 'id')) {
	        if (this.firepad) this.firepad.dispose();
	        this.setState({ ready: false });
	        (0, _reactDom.findDOMNode)(this).getElementsByClassName(styles.firepad)[0].innerHTML = '';
	        setTimeout(function () {
	          return _this5.init(props);
	        }, 100);
	      }
	    }
	  }, {
	    key: 'showLinkPopup',
	    value: function showLinkPopup(link) {
	      this.setState({
	        linkEditorActive: true,
	        linkEditor: {
	          text: link.content || this.codeMirror.getSelection(),
	          url: link.href || 'http://'
	        }
	      });
	    }
	  }, {
	    key: 'hideLinkPopup',
	    value: function hideLinkPopup() {
	      this.clearLinkPreview();
	      this.setState({
	        linkEditorActive: false,
	        linkEditor: {
	          text: '',
	          url: 'http://'
	        }
	      });
	    }
	  }, {
	    key: 'insertLink',
	    value: function insertLink(info) {
	      var data = {
	        href: info.link,
	        content: info.text,
	        target: '_blank'
	      };
	      if (this.afterEditLink) {
	        this.afterEditLink(data);
	        this.clearLinkPreview();
	      } else {
	        this.codeMirror.replaceSelection('');
	        if (this.firepad) {
	          this.firepad.insertEntity('a', data);
	        }
	      }
	      this.hideLinkPopup();
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton(icon, action) {
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _Common.ActionIcon,
	        { smallShadow: true, marginedBottom: true, onClick: function onClick() {
	            var _firepad;
	
	            return _this6.firepad && (_firepad = _this6.firepad)[action].apply(_firepad, args);
	          } },
	        icon
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.editor },
	        !this.state.ready && this.props.spinner,
	        _react2.default.createElement(
	          'div',
	          { className: styles.controls },
	          this.renderButton(_react2.default.createElement(_Icons.EditorBold, { onClick: this.handleControlsClick.bind(this), width: '18', height: '14' }), 'bold'),
	          this.renderButton(_react2.default.createElement(_Icons.EditorList, { onClick: this.handleControlsClick.bind(this), width: '16', height: '12' }), 'unorderedList'),
	          this.renderButton(_react2.default.createElement(_Icons.EditorNumberedList, { onClick: this.handleControlsClick.bind(this), width: '16', height: '14' }), 'orderedList'),
	          _react2.default.createElement(
	            _Common.ActionIcon,
	            { smallShadow: true, marginedBottom: true, onClick: this.showLinkPopup.bind(this) },
	            _react2.default.createElement(_Icons.EditorLink, { width: '14', height: '10' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.wrapper },
	          _react2.default.createElement('div', {
	            onClick: this.handleFirepadClick.bind(this),
	            className: (0, _classnames2.default)(styles.firepad, !this.state.ready && styles.firepadLoading)
	          }),
	          this.state.linkPreview && _react2.default.createElement(_EditorLinkPreview2.default, {
	            clearPreview: this.clearLinkPreview.bind(this),
	            offset: this.linkOffset,
	            deleteLink: this.deleteLink.bind(this),
	            edit: this.editLink.bind(this),
	            info: this.state.linkPreview
	          })
	        ),
	        _react2.default.createElement(
	          _Popups.PopupAnimator,
	          null,
	          this.state.linkEditorActive && _react2.default.createElement(
	            _Popups.Popup,
	            { autoSize: true },
	            _react2.default.createElement(
	              _Popups.PopupContent,
	              null,
	              _react2.default.createElement(_Popups.PopupEditorLink, {
	                defaultText: this.state.linkEditor.text,
	                defaultUrl: this.state.linkEditor.url,
	                submit: this.insertLink.bind(this),
	                cancel: this.hideLinkPopup.bind(this)
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NodePage;
	}(_react.Component), _class2.propTypes = {
	  node: _react.PropTypes.object,
	  spinner: _react.PropTypes.any.isRequired
	}, _temp)) || _class);
	exports.default = NodePage;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _Icons = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(484);
	
	var EditorLinkPreview = (_temp = _class = function (_Component) {
	  _inherits(EditorLinkPreview, _Component);
	
	  function EditorLinkPreview() {
	    _classCallCheck(this, EditorLinkPreview);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(EditorLinkPreview).apply(this, arguments));
	  }
	
	  _createClass(EditorLinkPreview, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var info = _props.info;
	      var offset = _props.offset;
	      var edit = _props.edit;
	      var deleteLink = _props.deleteLink;
	      var clearPreview = _props.clearPreview;
	
	      return _react2.default.createElement(
	        _reactOnclickout2.default,
	        { onClickOut: clearPreview },
	        _react2.default.createElement(
	          'div',
	          { className: styles.preview, style: offset },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Go to link:'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: info.href, target: '_blank' },
	            info.href
	          ),
	          _react2.default.createElement(_Icons.EditorEdit, { width: '18', height: '18', onClick: edit }),
	          _react2.default.createElement(_Icons.EditorDelete, { width: '18', height: '17', onClick: function onClick() {
	              deleteLink();clearPreview();
	            } })
	        )
	      );
	    }
	  }]);
	
	  return EditorLinkPreview;
	}(_react.Component), _class.propTypes = {
	  info: _react.PropTypes.object.isRequired,
	  offset: _react.PropTypes.object.isRequired,
	  edit: _react.PropTypes.func.isRequired,
	  deleteLink: _react.PropTypes.func.isRequired,
	  clearPreview: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = EditorLinkPreview;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _routing = __webpack_require__(44);
	
	var _routing2 = __webpack_require__(27);
	
	var _Editor = __webpack_require__(562);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _Viewer = __webpack_require__(565);
	
	var _Viewer2 = _interopRequireDefault(_Viewer);
	
	var _Spinner = __webpack_require__(137);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _TopBar = __webpack_require__(213);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	var _ActionIcon = __webpack_require__(210);
	
	var _ActionIcon2 = _interopRequireDefault(_ActionIcon);
	
	var _Icons = __webpack_require__(17);
	
	var _UserMenu = __webpack_require__(227);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _Auth = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(485);
	
	var getState = function getState(state) {
	  return {
	    routeType: state.routing.type,
	    foreignUser: state.routing.foreignUser,
	    authorizedUser: state.user.authorizedUser,
	    node: state.nodes.editorNode
	  };
	};
	
	var NodePage = (_dec = (0, _reduxSimple.connect)(getState, { goLeft: _routing.goLeft }), _dec(_class = function (_Component) {
	  _inherits(NodePage, _Component);
	
	  function NodePage() {
	    _classCallCheck(this, NodePage);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NodePage).apply(this, arguments));
	  }
	
	  _createClass(NodePage, [{
	    key: 'canEdit',
	    value: function canEdit() {
	      var _props = this.props;
	      var node = _props.node;
	      var authorizedUser = _props.authorizedUser;
	
	
	      if (!node || !authorizedUser) return false;
	
	      var owner = node.owner;
	      var userId = authorizedUser.id;
	
	
	      if (!owner || !userId) return false;
	
	      return owner === userId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var routeType = _props2.routeType;
	      var authorizedUser = _props2.authorizedUser;
	
	      var canEdit = this.canEdit();
	      var showControls = routeType === _routing2.JALAN_NODE;
	
	      var spinner = routeType === _routing2.JALAN_NODE ? _react2.default.createElement(_Spinner2.default, { routeSpinner: true }) : _react2.default.createElement(_Spinner2.default, { halfRouteSpinner: true });
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.nodePage },
	        _react2.default.createElement(
	          _TopBar2.default,
	          { left: true, hidden: !showControls },
	          _react2.default.createElement(
	            _ActionIcon2.default,
	            { onClick: this.props.goLeft },
	            _react2.default.createElement(_Icons.ArrowBack, { width: '15', height: '14' })
	          )
	        ),
	        _react2.default.createElement(
	          _TopBar2.default,
	          { right: true, hidden: !showControls },
	          !!authorizedUser ? _react2.default.createElement(
	            _ActionIcon2.default,
	            { smallShadow: true },
	            _react2.default.createElement(_UserMenu2.default, { compact: true })
	          ) : _react2.default.createElement(_Auth.LoginSmall, null)
	        ),
	        canEdit ? _react2.default.createElement(_Editor2.default, { spinner: spinner }) : _react2.default.createElement(_Viewer2.default, { spinner: spinner })
	      );
	    }
	  }]);
	
	  return NodePage;
	}(_react.Component)) || _class);
	exports.default = NodePage;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Common = __webpack_require__(11);
	
	var _routing = __webpack_require__(44);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _editorHelpers = __webpack_require__(214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(486);
	
	var getState = function getState(state) {
	  return {
	    node: state.nodes.editorNode,
	    project: state.projects.project,
	    shownUser: state.user.shownUser
	  };
	};
	
	var NodePage = (_dec = (0, _reduxSimple.connect)(getState, { viewProject: _routing.viewProject }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(NodePage, _Component);
	
	  function NodePage() {
	    _classCallCheck(this, NodePage);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NodePage).call(this));
	
	    _this.state = {
	      ready: false,
	      content: null
	    };
	    return _this;
	  }
	
	  _createClass(NodePage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.init(this.props);
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent(data) {
	      this.setState({ ready: true, content: data });
	    }
	  }, {
	    key: 'init',
	    value: function init(props) {
	      var _this2 = this;
	
	      if (!props.node) return;
	      var refLink = props.node.refLink;
	
	      var firepadRefPath = refLink + '/firepad';
	
	      this.firepadRef = (0, _firebase2.default)(firepadRefPath);
	
	      this.firepad = new window.Firepad.Headless(this.firepadRef);
	      this.firepad.entityManager_.register('a', {
	        render: _editorHelpers.makeLinkFromFirebase,
	        export: _editorHelpers.makeLinkFromFirebase,
	        fromElement: _editorHelpers.makeFirebaseFromLink
	      });
	
	      this.firepad.getHtml(function (data) {
	        _this2.setContent(data);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.firepad) this.firepad.dispose();
	    }
	  }, {
	    key: 'getEmptyNodeContent',
	    value: function getEmptyNodeContent() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var node = _props.node;
	      var project = _props.project;
	      var shownUser = _props.shownUser;
	
	
	      var nodeCaption = node.caption;
	      var projectTitle = project.name;
	      var goToProjects = function goToProjects() {
	        _this3.props.viewProject(shownUser.id, project.id);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.viewer) },
	        _react2.default.createElement(
	          'div',
	          null,
	          nodeCaption
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          { className: (0, _classnames2.default)(styles.emptyContentCaption) },
	          'This is just a piece of "',
	          projectTitle,
	          '" project and',
	          _react2.default.createElement('br', null),
	          'has no content yet.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _Common.Button,
	          { onClick: goToProjects },
	          'Go to the project'
	        )
	      );
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var _this4 = this;
	
	      if (props.node && props.node.id !== _lodash2.default.get(this.props.node, 'id')) {
	        this.setState({ ready: false });
	        setTimeout(function () {
	          return _this4.init(props);
	        }, 100);
	      } else if (props.node && props.node.timestamp !== _lodash2.default.get(this.props.node, 'timestamp')) {
	        this.firepad.getHtml(function (data) {
	          _this4.setContent(data);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.ready) {
	        return _react2.default.createElement(
	          'div',
	          { className: styles.firepad },
	          this.props.spinner
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.firepad },
	        this.state.content !== '' ? _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.viewer), dangerouslySetInnerHTML: { __html: this.state.content } }) : this.getEmptyNodeContent()
	      );
	    }
	  }]);
	
	  return NodePage;
	}(_react.Component), _class2.propTypes = {
	  node: _react.PropTypes.object,
	  spinner: _react.PropTypes.any.isRequired
	}, _temp)) || _class);
	exports.default = NodePage;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Common = __webpack_require__(11);
	
	var _Markup = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(487);
	
	var EditorLink = function (_Component) {
	  _inherits(EditorLink, _Component);
	
	  function EditorLink(props) {
	    _classCallCheck(this, EditorLink);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorLink).call(this, props));
	
	    _this.state = {
	      link: props.defaultUrl || '',
	      text: props.defaultText || ''
	    };
	    return _this;
	  }
	
	  _createClass(EditorLink, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.link },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          _react2.default.createElement(
	            _Markup.HeadingMedium,
	            { noMargins: true },
	            'Add link'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.field },
	          _react2.default.createElement(
	            'div',
	            { className: styles.label },
	            'Link to:'
	          ),
	          _react2.default.createElement('input', { className: styles.input, value: this.state.link,
	            onChange: function onChange(e) {
	              return _this2.setState({ link: e.target.value });
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.field },
	          _react2.default.createElement(
	            'div',
	            { className: styles.label },
	            'Display text:'
	          ),
	          _react2.default.createElement('input', { className: styles.input, value: this.state.text,
	            onChange: function onChange(e) {
	              return _this2.setState({ text: e.target.value });
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.controls },
	          _react2.default.createElement(
	            'div',
	            { className: styles.cancel },
	            _react2.default.createElement(
	              _Common.Button,
	              { onClick: this.props.cancel, light: true },
	              'Cancel'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.delete },
	            _react2.default.createElement(
	              _Common.Button,
	              { onClick: function onClick() {
	                  return _this2.props.submit({ link: _this2.state.link, text: _this2.state.text });
	                }, light: true },
	              'Ok'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditorLink;
	}(_react.Component);
	
	exports.default = EditorLink;
	
	
	EditorLink.propTypes = {
	  defaultText: _react.PropTypes.string,
	  defaultUrl: _react.PropTypes.string,
	  submit: _react.PropTypes.func.isRequired,
	  cancel: _react.PropTypes.func.isRequired
	};

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EditorLink = __webpack_require__(566);
	
	var _EditorLink2 = _interopRequireDefault(_EditorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _EditorLink2.default;
	/* injects from baggage-loader */

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(488);
	
	var getStylesFromProps = function getStylesFromProps(_ref) {
	  var _ref$customWidth = _ref.customWidth;
	  var customWidth = _ref$customWidth === undefined ? null : _ref$customWidth;
	  return {
	    width: customWidth
	  };
	};
	
	var Popup = function (_Component) {
	  _inherits(Popup, _Component);
	
	  function Popup() {
	    _classCallCheck(this, Popup);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Popup).apply(this, arguments));
	  }
	
	  _createClass(Popup, [{
	    key: 'close',
	    value: function close() {
	      if (this.props.onClose) this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var containerClassName = (0, _classnames2.default)(styles.container, this.props.autoSize && styles.autoSize);
	      return _react2.default.createElement(
	        'div',
	        { className: styles.popup },
	        _react2.default.createElement('div', { className: styles.fade }),
	        _react2.default.createElement(
	          _reactOnclickout2.default,
	          { onClickOut: this.close.bind(this) },
	          _react2.default.createElement(
	            'div',
	            { className: styles.containerWrapper },
	            _react2.default.createElement(
	              'div',
	              { style: getStylesFromProps(this.props), className: containerClassName },
	              this.props.children
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Popup;
	}(_react.Component);
	
	exports.default = Popup;
	
	
	Popup.propTypes = {
	  children: _react.PropTypes.any,
	  customWidth: _react.PropTypes.number,
	  onClose: _react.PropTypes.func
	};

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(167);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(489);
	
	var PopupAnimator = (_temp = _class = function (_Component) {
	  _inherits(PopupAnimator, _Component);
	
	  function PopupAnimator() {
	    _classCallCheck(this, PopupAnimator);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(PopupAnimator).apply(this, arguments));
	  }
	
	  _createClass(PopupAnimator, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          component: 'div',
	          transitionName: {
	            enter: styles.enter,
	            enterActive: styles.enterActive,
	            leave: styles.leave,
	            leaveActive: styles.leaveActive
	          },
	          transitionEnterTimeout: 240,
	          transitionLeaveTimeout: 180
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PopupAnimator;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any
	}, _temp);
	exports.default = PopupAnimator;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(490);
	
	var getStylesFromProps = function getStylesFromProps(_ref) {
	  var _ref$customPaddingTop = _ref.customPaddingTop;
	  var customPaddingTop = _ref$customPaddingTop === undefined ? null : _ref$customPaddingTop;
	  return {
	    paddingTop: customPaddingTop
	  };
	};
	
	var PopupContent = function (_Component) {
	  _inherits(PopupContent, _Component);
	
	  function PopupContent() {
	    _classCallCheck(this, PopupContent);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(PopupContent).apply(this, arguments));
	  }
	
	  _createClass(PopupContent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: getStylesFromProps(this.props), className: styles.content },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PopupContent;
	}(_react.Component);
	
	exports.default = PopupContent;
	
	
	PopupContent.propTypes = {
	  children: _react.PropTypes.any
	};

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(491);
	
	var PopupHeader = function (_Component) {
	  _inherits(PopupHeader, _Component);
	
	  function PopupHeader() {
	    _classCallCheck(this, PopupHeader);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(PopupHeader).apply(this, arguments));
	  }
	
	  _createClass(PopupHeader, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)(styles.header, this.props.transparent && styles.transparent);
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PopupHeader;
	}(_react.Component);
	
	exports.default = PopupHeader;
	
	
	PopupHeader.propTypes = {
	  children: _react.PropTypes.any,
	  transparent: _react.PropTypes.bool
	};

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(492);
	
	var PopupHeaderText = function (_Component) {
	  _inherits(PopupHeaderText, _Component);
	
	  function PopupHeaderText() {
	    _classCallCheck(this, PopupHeaderText);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(PopupHeaderText).apply(this, arguments));
	  }
	
	  _createClass(PopupHeaderText, [{
	    key: 'render',
	    value: function render() {
	      var classNames = (0, _classnames2.default)(styles.text, this.props.delimiter && styles.delimiter, this.props.faded && styles.faded);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props, { className: classNames }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return PopupHeaderText;
	}(_react.Component);
	
	exports.default = PopupHeaderText;
	
	
	PopupHeaderText.propTypes = {
	  children: _react.PropTypes.any,
	  delimiter: _react.PropTypes.bool,
	  faded: _react.PropTypes.bool
	};

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Common = __webpack_require__(11);
	
	var _projectsActions = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(493);
	
	var getState = function getState(state) {
	  return {
	    project: state.projects.project
	  };
	};
	
	var ProjectConfirmDeleteNode = (_dec = (0, _reduxSimple.connect)(getState, { removeNode: _projectsActions.removeNode }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectConfirmDeleteNode, _Component);
	
	  function ProjectConfirmDeleteNode() {
	    _classCallCheck(this, ProjectConfirmDeleteNode);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectConfirmDeleteNode).apply(this, arguments));
	  }
	
	  _createClass(ProjectConfirmDeleteNode, [{
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.props.onSubmitted();
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var nodeId = this.props.nodeId;
	
	      this.props.removeNode(nodeId);
	      this.props.onSubmitted();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.projectConfirmDeleteNode },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          'Delete node and content?'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.controls },
	          _react2.default.createElement(
	            'div',
	            { className: styles.cancel },
	            _react2.default.createElement(
	              _Common.Button,
	              { onClick: this.handleCancel.bind(this), light: true },
	              'Cancel'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.remove },
	            _react2.default.createElement(
	              _Common.Button,
	              { onClick: this.handleDelete.bind(this), light: true },
	              'Delete'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectConfirmDeleteNode;
	}(_react.Component), _class2.propTypes = {
	  onSubmitted: _react.PropTypes.func.isRequired,
	  nodeId: _react.PropTypes.string.isRequired
	}, _temp)) || _class);
	exports.default = ProjectConfirmDeleteNode;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProjectConfirmDeleteNode = __webpack_require__(573);
	
	var _ProjectConfirmDeleteNode2 = _interopRequireDefault(_ProjectConfirmDeleteNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectConfirmDeleteNode2.default;
	/* injects from baggage-loader */

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Common = __webpack_require__(11);
	
	var _projectsActions = __webpack_require__(22);
	
	var _routing = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(494);
	
	var getState = function getState(state) {
	  return {
	    project: state.projects.project
	  };
	};
	
	var ProjectDelete = (_dec = (0, _reduxSimple.connect)(getState, { projectDelete: _projectsActions.projectDelete, openIndex: _routing.openIndex }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectDelete, _Component);
	
	  function ProjectDelete() {
	    _classCallCheck(this, ProjectDelete);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectDelete).apply(this, arguments));
	  }
	
	  _createClass(ProjectDelete, [{
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.props.onSubmitted();
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      this.props.onSubmitted();
	      this.props.projectDelete(this.props.project);
	      this.props.openIndex();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.projectDelete },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          'Delete project?'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.controls },
	          _react2.default.createElement(
	            'div',
	            { className: styles.cancel },
	            _react2.default.createElement(
	              _Common.Button,
	              { onClick: this.handleCancel.bind(this), light: true },
	              'Cancel'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.delete },
	            _react2.default.createElement(
	              _Common.Button,
	              { onClick: this.handleDelete.bind(this), light: true },
	              'Delete'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectDelete;
	}(_react.Component), _class2.propTypes = {
	  onSubmitted: _react.PropTypes.func.isRequired,
	  projectDelete: _react.PropTypes.func.isRequired,
	  project: _react.PropTypes.object.isRequired,
	  openIndex: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ProjectDelete;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProjectDelete = __webpack_require__(575);
	
	var _ProjectDelete2 = _interopRequireDefault(_ProjectDelete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectDelete2.default;
	/* injects from baggage-loader */

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _projectsActions = __webpack_require__(22);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _Markup = __webpack_require__(82);
	
	var _Common = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(495);
	
	var getState = function getState(state) {
	  return {
	    project: state.projects.project,
	
	    shareLoaded: state.projects.shareLoaded,
	    shareLoading: state.projects.shareLoading,
	    sharePopupOpened: state.projects.sharePopupOpened,
	
	    shareLink: state.projects.shareLink
	  };
	};
	
	var ProjectShare = (_dec = (0, _reduxSimple.connect)(getState, { shareProject: _projectsActions.shareProject, shareProjectShowFBPopup: _projectsActions.shareProjectShowFBPopup }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectShare, _Component);
	
	  function ProjectShare() {
	    _classCallCheck(this, ProjectShare);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectShare).apply(this, arguments));
	  }
	
	  _createClass(ProjectShare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = (0, _reactDom.findDOMNode)(this.refs.linkInput);
	      (0, _raf2.default)(function () {
	        return inputNode.select();
	      });
	    }
	  }, {
	    key: 'getFBShareLink',
	    value: function getFBShareLink() {
	      var project = this.props.project;
	
	
	      this.props.shareProject(project);
	    }
	  }, {
	    key: 'showFBPopup',
	    value: function showFBPopup() {
	      var shareLink = this.props.shareLink;
	
	
	      this.props.shareProjectShowFBPopup(shareLink);
	    }
	  }, {
	    key: 'getFacebookButton',
	    value: function getFacebookButton() {
	      var _props = this.props;
	      var shareLoaded = _props.shareLoaded;
	      var shareLoading = _props.shareLoading;
	      var sharePopupOpened = _props.sharePopupOpened;
	
	
	      if (!shareLoaded || sharePopupOpened) {
	        return _react2.default.createElement(
	          _Common.Button,
	          { loading: shareLoading, onClick: this.getFBShareLink.bind(this), facebook: true, small: true },
	          'Facebook'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Common.Button,
	        { onClick: this.showFBPopup.bind(this), facebook: true, small: true },
	        'Share'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var project = _props2.project;
	      var shareLoading = _props2.shareLoading;
	      var shareLoaded = _props2.shareLoaded;
	      var sharePopupOpened = _props2.sharePopupOpened;
	
	      var projectShareLink = 'https://meta.pro/project/' + project.id;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.projectShare },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          _react2.default.createElement(
	            _Markup.HeadingMedium,
	            { noMargins: true },
	            'Share project'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.link },
	          _react2.default.createElement(
	            'div',
	            { className: styles.label },
	            'Link:'
	          ),
	          _react2.default.createElement('input', { ref: 'linkInput', readOnly: true, className: styles.input, value: projectShareLink })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.social },
	          _react2.default.createElement(
	            'div',
	            { className: styles.label },
	            'Social:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.buttons },
	            this.getFacebookButton(),
	            shareLoading && _react2.default.createElement(
	              'div',
	              { className: styles.caption },
	              'Generating image...'
	            ),
	            shareLoaded && !sharePopupOpened && _react2.default.createElement(
	              'div',
	              { className: styles.caption },
	              'Done!'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectShare;
	}(_react.Component), _class2.propTypes = {
	  onSubmitted: _react.PropTypes.func.isRequired,
	  project: _react.PropTypes.object.isRequired,
	
	  shareLoaded: _react.PropTypes.bool,
	  shareLoading: _react.PropTypes.bool,
	  sharePopupOpened: _react.PropTypes.bool,
	
	  shareLink: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = ProjectShare;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProjectShare = __webpack_require__(577);
	
	var _ProjectShare2 = _interopRequireDefault(_ProjectShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectShare2.default;
	/* injects from baggage-loader */

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Markup = __webpack_require__(82);
	
	var _Common = __webpack_require__(11);
	
	var _projectsActions = __webpack_require__(22);
	
	var _projectPermissions = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(496);
	
	var getState = function getState(state) {
	  return {
	    project: state.projects.project,
	    authorizedUser: state.user.authorizedUser
	  };
	};
	
	var ProjectVisibility = (_dec = (0, _reduxSimple.connect)(getState, { setPermission: _projectsActions.setPermission }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectVisibility, _Component);
	
	  function ProjectVisibility(props) {
	    _classCallCheck(this, ProjectVisibility);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectVisibility).call(this, props));
	
	    _this.state = {
	      permission: (0, _projectPermissions.getPermission)(props.project, props.authorizedUser.publicProjects)
	    };
	    return _this;
	  }
	
	  _createClass(ProjectVisibility, [{
	    key: 'handleSelected',
	    value: function handleSelected(val) {
	      this.setState({ permission: val });
	    }
	  }, {
	    key: 'handleAccept',
	    value: function handleAccept() {
	      var _parsePermission = (0, _projectPermissions.parsePermission)(this.state.permission);
	
	      var isPublic = _parsePermission.isPublic;
	      var isListed = _parsePermission.isListed;
	
	      this.props.setPermission(this.props.authorizedUser.id, this.props.project.id, isPublic, isListed);
	      this.props.onSubmitted();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.projectVisibility },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          _react2.default.createElement(
	            _Markup.HeadingMedium,
	            { noMargins: true },
	            'Set project visibility'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.options },
	          _react2.default.createElement(
	            _Common.CheckBox.Group,
	            { onSelect: this.handleSelected.bind(this), defaultSelected: this.state.permission },
	            _react2.default.createElement(
	              _Common.CheckBox.Item,
	              { id: _projectPermissions.PERMISSIONS.PUBLIC },
	              _react2.default.createElement(_Common.CheckBox.Icon, null),
	              _react2.default.createElement(
	                _Common.CheckBox.Label,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Public'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _Markup.Faded,
	                  null,
	                  'Anyone can see it.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Common.CheckBox.Item,
	              { id: _projectPermissions.PERMISSIONS.UNLISTED },
	              _react2.default.createElement(_Common.CheckBox.Icon, null),
	              _react2.default.createElement(
	                _Common.CheckBox.Label,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Unlisted'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _Markup.Faded,
	                  null,
	                  'Only those with the link can see it.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Common.CheckBox.Item,
	              { id: _projectPermissions.PERMISSIONS.PRIVATE },
	              _react2.default.createElement(_Common.CheckBox.Icon, null),
	              _react2.default.createElement(
	                _Common.CheckBox.Label,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Private'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _Markup.Faded,
	                  null,
	                  'Only you can see it.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.accept },
	            _react2.default.createElement(
	              _Common.Button,
	              { light: true, onClick: this.handleAccept.bind(this) },
	              'ACCEPT'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectVisibility;
	}(_react.Component), _class2.propTypes = {
	  onSubmitted: _react.PropTypes.func.isRequired,
	  project: _react.PropTypes.object.isRequired,
	  authorizedUser: _react.PropTypes.object,
	  setPermission: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = ProjectVisibility;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProjectVisibility = __webpack_require__(579);
	
	var _ProjectVisibility2 = _interopRequireDefault(_ProjectVisibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectVisibility2.default;
	/* injects from baggage-loader */

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Markup = __webpack_require__(82);
	
	var _Common = __webpack_require__(11);
	
	var _projectsActions = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(497);
	
	var getState = function getState(state) {
	  return {
	    project: state.projects.project,
	    authorizedUser: state.user.authorizedUser
	  };
	};
	
	var ProjectVisibility = (_dec = (0, _reduxSimple.connect)(getState, { setPermission: _projectsActions.setPermission }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectVisibility, _Component);
	
	  function ProjectVisibility() {
	    _classCallCheck(this, ProjectVisibility);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectVisibility).apply(this, arguments));
	  }
	
	  _createClass(ProjectVisibility, [{
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.props.onSubmitted();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      this.props.setPermission(this.props.authorizedUser.id, this.props.project.id, true, false);
	      this.props.onSubmitted();
	      this.props.onChecked();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.projectVisibility },
	        _react2.default.createElement(
	          'div',
	          { className: styles.title },
	          _react2.default.createElement(
	            _Markup.HeadingMedium,
	            { noMargins: true },
	            'Change project’s visibility?'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.text },
	          'This project’s visibility is set to “Private”. Let Meta change the visibility to “Unlisted” so it can be visible to anyone who has the link.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.controls },
	          _react2.default.createElement(
	            _Common.Button,
	            { onClick: this.handleCancel.bind(this), light: true },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            _Common.Button,
	            { onClick: this.handleChange.bind(this), light: true },
	            'Change'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectVisibility;
	}(_react.Component), _class2.propTypes = {
	  onSubmitted: _react.PropTypes.func.isRequired,
	  project: _react.PropTypes.object.isRequired,
	  authorizedUser: _react.PropTypes.object,
	  setPermission: _react.PropTypes.func,
	  onChecked: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = ProjectVisibility;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProjectVisibilityCheckBeforeShare = __webpack_require__(581);
	
	var _ProjectVisibilityCheckBeforeShare2 = _interopRequireDefault(_ProjectVisibilityCheckBeforeShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectVisibilityCheckBeforeShare2.default;
	/* injects from baggage-loader */

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Common = __webpack_require__(11);
	
	var _Icons = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(498);
	
	var WelcomePopup = function (_Component) {
	  _inherits(WelcomePopup, _Component);
	
	  function WelcomePopup() {
	    _classCallCheck(this, WelcomePopup);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(WelcomePopup).apply(this, arguments));
	  }
	
	  _createClass(WelcomePopup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var onStay = _props.onStay;
	      var onGoToProjects = _props.onGoToProjects;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.welcome },
	        _react2.default.createElement(_Icons.Logo, { className: styles.logo }),
	        _react2.default.createElement(
	          _Common.Markup.HeadingLarge,
	          null,
	          'Welcome to Meta Projects!'
	        ),
	        _react2.default.createElement(
	          _Common.Markup.HeadingMedium,
	          null,
	          'Meta Projects is a tool that helps you collect abstract things and thoughts into a tangible project.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.action },
	          _react2.default.createElement(
	            _Common.Button,
	            { onClick: onStay },
	            'Stay on this page'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.action },
	          _react2.default.createElement(
	            _Common.Button,
	            { onClick: onGoToProjects },
	            'Go to your projects'
	          )
	        )
	      );
	    }
	  }]);
	
	  return WelcomePopup;
	}(_react.Component);
	
	exports.default = WelcomePopup;
	
	
	WelcomePopup.propTypes = {
	  onStay: _react.PropTypes.func.isRequired,
	  onGoToProjects: _react.PropTypes.func.isRequired
	};

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Welcome = __webpack_require__(583);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Welcome2.default;
	/* injects from baggage-loader */

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	/* injects from baggage-loader */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Icons = __webpack_require__(17);
	
	var _Common = __webpack_require__(11);
	
	var _projectsActions = __webpack_require__(22);
	
	var _ga = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getState = function getState(state) {
	  return {
	    userId: state.user.authorizedUser.id
	  };
	};
	
	var ProjectAdd = (_dec = (0, _reduxSimple.connect)(getState, { addProject: _projectsActions.addProject }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectAdd, _Component);
	
	  function ProjectAdd() {
	    _classCallCheck(this, ProjectAdd);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectAdd).apply(this, arguments));
	  }
	
	  _createClass(ProjectAdd, [{
	    key: 'add',
	    value: function add() {
	      var userId = this.props.userId;
	
	
	      (0, _ga.projectAddEvent)(userId);
	      this.props.addProject({ transition: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Common.ActionIcon,
	        { onClick: this.add.bind(this) },
	        _react2.default.createElement(_Icons.Plus, { width: '16', height: '16' })
	      );
	    }
	  }]);
	
	  return ProjectAdd;
	}(_react.Component), _class2.propTypes = {
	  addProject: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ProjectAdd;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	/* injects from baggage-loader */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _ProjectMenuView = __webpack_require__(587);
	
	var _ProjectMenuView2 = _interopRequireDefault(_ProjectMenuView);
	
	var _popupActions = __webpack_require__(101);
	
	var _popupTypes = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getState = function getState() {
	  return {};
	};
	
	var ProjectMenu = (_dec = (0, _reduxSimple.connect)(getState, { popupShow: _popupActions.popupShow }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectMenu, _Component);
	
	  function ProjectMenu() {
	    _classCallCheck(this, ProjectMenu);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectMenu).apply(this, arguments));
	  }
	
	  _createClass(ProjectMenu, [{
	    key: 'handleRename',
	    value: function handleRename() {
	      this.props.rename();
	      this.props.onClose();
	    }
	  }, {
	    key: 'handleShare',
	    value: function handleShare() {
	      this.props.popupShow(_popupTypes.PROJECT_SHARE);
	      this.props.onClose();
	    }
	  }, {
	    key: 'handleVisibilityCheckBeforeShare',
	    value: function handleVisibilityCheckBeforeShare() {
	      this.props.popupShow(_popupTypes.PROJECT_SHARE_VISIBILITY_CHECK, this.handleShare.bind(this));
	      this.props.onClose();
	    }
	  }, {
	    key: 'handleVisibility',
	    value: function handleVisibility() {
	      this.props.popupShow(_popupTypes.PROJECT_VISIBILITY);
	      this.props.onClose();
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      this.props.popupShow(_popupTypes.PROJECT_DELETE);
	      this.props.onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ProjectMenuView2.default, {
	        onRename: this.handleRename.bind(this),
	        onShare: this.handleShare.bind(this),
	        onVisibility: this.handleVisibility.bind(this),
	        onDelete: this.handleDelete.bind(this),
	        onShareVisibilityCheck: this.handleVisibilityCheckBeforeShare.bind(this)
	      });
	    }
	  }]);
	
	  return ProjectMenu;
	}(_react.Component), _class2.propTypes = {
	  popupShow: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  rename: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ProjectMenu;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	/* injects from baggage-loader */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _ReactIcons = __webpack_require__(136);
	
	var _Icons = __webpack_require__(17);
	
	var _Common = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getState = function getState(state) {
	  return {
	    project: state.projects.project
	  };
	};
	
	var ProjectMenuView = (_dec = (0, _reduxSimple.connect)(getState), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProjectMenuView, _Component);
	
	  function ProjectMenuView() {
	    _classCallCheck(this, ProjectMenuView);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectMenuView).apply(this, arguments));
	  }
	
	  _createClass(ProjectMenuView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var onRename = _props.onRename;
	      var onShare = _props.onShare;
	      var onVisibility = _props.onVisibility;
	      var onDelete = _props.onDelete;
	      var onShareVisibilityCheck = _props.onShareVisibilityCheck;
	      var project = _props.project;
	
	
	      return _react2.default.createElement(
	        _Common.Menu,
	        null,
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { thin: true, onClick: onRename },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_ReactIcons.Rename, null)
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Rename'
	          )
	        ),
	        project.public ? _react2.default.createElement(
	          _Common.Menu.Item,
	          { thin: true, onClick: onShare },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_Icons.Share, { width: '14' })
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Share'
	          )
	        ) : _react2.default.createElement(
	          _Common.Menu.Item,
	          { thin: true, onClick: onShareVisibilityCheck },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_Icons.Share, { width: '14' })
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Share'
	          )
	        ),
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { thin: true, onClick: onVisibility },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_Icons.Visibility, { width: '14' })
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Set visibility'
	          )
	        ),
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { thin: true, onClick: onDelete },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_ReactIcons.Delete, null)
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Delete'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectMenuView;
	}(_react.Component), _class2.propTypes = {
	  onRename: _react.PropTypes.func.isRequired,
	  onShare: _react.PropTypes.func.isRequired,
	  onVisibility: _react.PropTypes.func.isRequired,
	  onDelete: _react.PropTypes.func.isRequired,
	  onShareVisibilityCheck: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ProjectMenuView;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	/* injects from baggage-loader */
	
	/*
	
	    Given project, returns a project, rendered in <svg>
	
	    Computes the nodes bounding boxes and uses <StaticProjectView> for rendering
	
	*/
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StaticProjectView = __webpack_require__(611);
	
	var _StaticProjectView2 = _interopRequireDefault(_StaticProjectView);
	
	var _getProjectDimentions2 = __webpack_require__(226);
	
	var _getProjectDimentions3 = _interopRequireDefault(_getProjectDimentions2);
	
	var _getNodesRects = __webpack_require__(225);
	
	var _getNodesRects2 = _interopRequireDefault(_getNodesRects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectRenderer = (_temp = _class = function (_Component) {
	  _inherits(ProjectRenderer, _Component);
	
	  function ProjectRenderer() {
	    _classCallCheck(this, ProjectRenderer);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectRenderer).apply(this, arguments));
	  }
	
	  _createClass(ProjectRenderer, [{
	    key: 'render',
	    value: function render() {
	      var project = this.props.project;
	      var graph = project.graph;
	      var nodesData = project.nodesData;
	
	      // get the svg width & height
	
	      var _getProjectDimentions = (0, _getProjectDimentions3.default)(project);
	
	      var width = _getProjectDimentions.width;
	      var height = _getProjectDimentions.height;
	      var minByX = _getProjectDimentions.minByX;
	      var minByY = _getProjectDimentions.minByY;
	
	      var nodesRects = (0, _getNodesRects2.default)(project);
	
	      var translateX = -minByX.x + minByX.width / 2;
	      var translateY = -minByY.y + minByY.height / 2;
	
	      return _react2.default.createElement(_StaticProjectView2.default, {
	        graph: graph, nodesData: nodesData, nodesRects: nodesRects,
	
	        viewX: translateX, viewY: translateY,
	        viewWidth: width, viewHeight: height
	      });
	    }
	  }]);
	
	  return ProjectRenderer;
	}(_react.Component), _class.propTypes = {
	  project: _react.PropTypes.object.isRequired
	}, _temp);
	exports.default = ProjectRenderer;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProjectRenderer = __webpack_require__(588);
	
	var _ProjectRenderer2 = _interopRequireDefault(_ProjectRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectRenderer2.default;
	/* injects from baggage-loader */

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(939);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _jsBase = __webpack_require__(825);
	
	var _ProjectRenderer = __webpack_require__(589);
	
	var _ProjectRenderer2 = _interopRequireDefault(_ProjectRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	var getProjectBase64SrcImage = function getProjectBase64SrcImage(project) {
	  var svgString = _server2.default.renderToStaticMarkup(_react2.default.createElement(_ProjectRenderer2.default, { project: project }));
	
	  var addedXMLNamespace = svgString.replace(/<svg /, '<svg xmlns="http://www.w3.org/2000/svg" ');
	  var base64Encoded = _jsBase.Base64.encode(addedXMLNamespace);
	  var src = 'data:image/svg+xml;base64,' + base64Encoded;
	
	  return src;
	};
	
	exports.default = getProjectBase64SrcImage;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _promise = __webpack_require__(387);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ProjectShareRenderer = __webpack_require__(218);
	
	var _ProjectShareRenderer2 = _interopRequireDefault(_ProjectShareRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	var getProjectShareImage = function getProjectShareImage(_ref) {
	  var project = _ref.project;
	  var authorName = _ref.authorName;
	  var projectTitle = _ref.projectTitle;
	  var _ref$width = _ref.width;
	  var width = _ref$width === undefined ? 1200 : _ref$width;
	  var _ref$height = _ref.height;
	  var height = _ref$height === undefined ? 630 : _ref$height;
	
	  var $canvasContainer = document.createElement('div');
	
	  return new _promise2.default(function (resolve) {
	    (0, _reactDom.render)(_react2.default.createElement(_ProjectShareRenderer2.default, {
	      project: project,
	      authorName: authorName,
	      projectTitle: projectTitle,
	      width: width,
	      height: height
	    }), $canvasContainer, function () {
	      var $canvas = $canvasContainer.querySelector('canvas');
	      var imageData = $canvas.toDataURL('image/png');
	      (0, _reactDom.unmountComponentAtNode)($canvasContainer);
	
	      resolve(imageData);
	    });
	  });
	};
	
	exports.default = getProjectShareImage;

/***/ },
/* 592 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	var logo = ['data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA', '/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzUlEQVRo3mNgGAWjYBSMglEwkgHjQFp', '+T4v7P7qY0rWvJLmJBcVA7uL/pDpC6WsvVQPhvxcDUW5g3AYJfBaKLbSxRrGQ8chRusYq01DPAyz0tOz', '/IY7/DP8REXY/czQGhlES+t/A8J+BoRe/6lNEliKMDAyMW+lTRLMMZOgpChlgCn4ioghFKulo44G/nAz/', 'bYwwy/N3lxkYBH8OXAzcD+AmSh3rZ3YGmfWjmZi0GGBsYGD8f5AdfzV+c7QYpW1rlFAM3L9JXJZh/', 'fuPQebld5Icwu1UhFV8g94+rOJuAhdIb8zpaKTjlAuTXAhnS3z+y9C+6ftoEhr1wKgH6FkPJNwW', '/p+IJrn2yAsUPjOa/OdEVkQpdlsYXoLdZVVl4JM/hmhZKNYxMDChNiG+2fWhlIBcTgz/', 'KfLAYAWBaeswxL6uUmIcGV3KiYsIRJDj//9J+xkZB60HSAELVN/CPcK/6M1/BoY/ROvVFVz', '/n8Efu9w910GQBxinpzHAOvPI6XfI98iIAZNfK+', 'JNuizISYA77B5KUWZHJUfweCswvIyjTV7BGwP9Fzbg1Xz5fSDjQMfQ6MgcNvARLbl8H', 'q7DKsSAga5nRsEoGAWjYBQMbgAAp3F2HkPexT4AAAAASUVORK5CYII='].join('');
	
	exports.default = logo;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icons = __webpack_require__(17);
	
	var _shallowequal = __webpack_require__(100);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(500);
	
	/* eslint max-len: 0 */
	
	var BORDER_WIDTH = 40;
	
	var shallowEqualCustomizer = function shallowEqualCustomizer(value) {
	  if (typeof value === 'function') return true;
	};
	
	var EdgeView = function (_Component) {
	  _inherits(EdgeView, _Component);
	
	  function EdgeView() {
	    _classCallCheck(this, EdgeView);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(EdgeView).apply(this, arguments));
	  }
	
	  _createClass(EdgeView, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowequal2.default)(nextProps, this.props, shallowEqualCustomizer); // checks only for shallow equality of props
	    }
	  }, {
	    key: 'getMovedCoords',
	    value: function getMovedCoords() {
	      var _props = this.props;
	      var startX = _props.startX;
	      var startY = _props.startY;
	      var startDirX = _props.startDirX;
	      var startDirY = _props.startDirY;
	      var endX = _props.endX;
	      var endY = _props.endY;
	      var endDirX = _props.endDirX;
	      var endDirY = _props.endDirY;
	
	      var _getViewportCoords = this.getViewportCoords();
	
	      var left = _getViewportCoords.left;
	      var top = _getViewportCoords.top;
	
	
	      var movedStartX = startX - left;
	      var movedStartY = startY - top;
	      var movedEndX = endX - left;
	      var movedEndY = endY - top;
	
	      var movedStartDirX = startDirX - left;
	      var movedStartDirY = startDirY - top;
	      var movedEndDirX = endDirX - left;
	      var movedEndDirY = endDirY - top;
	
	      return {
	        movedStartX: movedStartX, movedStartY: movedStartY,
	        movedEndX: movedEndX, movedEndY: movedEndY,
	        movedStartDirX: movedStartDirX, movedStartDirY: movedStartDirY,
	        movedEndDirX: movedEndDirX, movedEndDirY: movedEndDirY
	      };
	    }
	  }, {
	    key: 'getViewportCoords',
	    value: function getViewportCoords() {
	      var _Math, _Math2, _Math3, _Math4;
	
	      var _props2 = this.props;
	      var startX = _props2.startX;
	      var startY = _props2.startY;
	      var startDirX = _props2.startDirX;
	      var startDirY = _props2.startDirY;
	      var endX = _props2.endX;
	      var endY = _props2.endY;
	      var endDirX = _props2.endDirX;
	      var endDirY = _props2.endDirY;
	
	
	      var XPoints = [startX, startDirX, endDirX, endX];
	      var YPoints = [startY, startDirY, endDirY, endY];
	
	      var left = Math.round((_Math = Math).min.apply(_Math, XPoints) - BORDER_WIDTH) + 0.5;
	      var right = Math.round((_Math2 = Math).max.apply(_Math2, XPoints) + BORDER_WIDTH) + 0.5;
	
	      var top = Math.round((_Math3 = Math).min.apply(_Math3, YPoints) - BORDER_WIDTH) + 0.5;
	      var bottom = Math.round((_Math4 = Math).max.apply(_Math4, YPoints) + BORDER_WIDTH) + 0.5;
	
	      var width = right - left;
	      var height = bottom - top;
	
	      var centerX = width / 2 + left;
	      var centerY = height / 2 + top;
	
	      return {
	        width: width, height: height,
	        top: top, bottom: bottom, left: left, right: right,
	        centerX: centerX, centerY: centerY
	      };
	    }
	  }, {
	    key: 'handleRemoveClick',
	    value: function handleRemoveClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      this.props.onRemove();
	    }
	  }, {
	    key: 'getHoverArea',
	    value: function getHoverArea() {
	      var disableModifications = this.props.disableModifications;
	
	      if (disableModifications) return null;
	
	      var _getMovedCoords = this.getMovedCoords();
	
	      var movedStartX = _getMovedCoords.movedStartX;
	      var movedStartY = _getMovedCoords.movedStartY;
	      var movedEndX = _getMovedCoords.movedEndX;
	      var movedEndY = _getMovedCoords.movedEndY;
	      var movedStartDirX = _getMovedCoords.movedStartDirX;
	      var movedStartDirY = _getMovedCoords.movedStartDirY;
	      var movedEndDirX = _getMovedCoords.movedEndDirX;
	      var movedEndDirY = _getMovedCoords.movedEndDirY;
	
	
	      return _react2.default.createElement('path', {
	        className: styles.pathHoverArea,
	        d: 'M ' + movedStartX + ' ' + movedStartY + ' C ' + movedStartDirX + ' ' + movedStartDirY + ' ' + movedEndDirX + ' ' + movedEndDirY + ' ' + movedEndX + ' ' + movedEndY,
	        strokeWidth: BORDER_WIDTH,
	        stroke: 'none',
	        fill: 'none'
	      });
	    }
	  }, {
	    key: 'getPathAttributes',
	    value: function getPathAttributes() {
	      var _props3 = this.props;
	      var color = _props3.color;
	      var dashed = _props3.dashed;
	
	
	      var style = {
	        strokeWidth: '1.0',
	        stroke: color,
	        fill: 'none',
	        strokeDasharray: '16, 0'
	      };
	
	      if (dashed) {
	        style = _extends({}, style, { strokeDasharray: '10, 6' });
	      }
	
	      return style;
	    }
	  }, {
	    key: 'getPathStyle',
	    value: function getPathStyle() {
	      var dashed = this.props.dashed;
	
	
	      if (!dashed) {
	        return { strokeDashoffset: '10' };
	      }
	      return { strokeDashoffset: '6' };
	    }
	  }, {
	    key: 'getEdgePath',
	    value: function getEdgePath() {
	      var _getMovedCoords2 = this.getMovedCoords();
	
	      var movedStartX = _getMovedCoords2.movedStartX;
	      var movedStartY = _getMovedCoords2.movedStartY;
	      var movedEndX = _getMovedCoords2.movedEndX;
	      var movedEndY = _getMovedCoords2.movedEndY;
	      var movedStartDirX = _getMovedCoords2.movedStartDirX;
	      var movedStartDirY = _getMovedCoords2.movedStartDirY;
	      var movedEndDirX = _getMovedCoords2.movedEndDirX;
	      var movedEndDirY = _getMovedCoords2.movedEndDirY;
	
	
	      return _react2.default.createElement('path', _extends({
	        className: styles.path,
	        d: 'M ' + movedStartX + ' ' + movedStartY + ' C ' + movedStartDirX + ' ' + movedStartDirY + ' ' + movedEndDirX + ' ' + movedEndDirY + ' ' + movedEndX + ' ' + movedEndY
	      }, this.getPathAttributes(), {
	        style: this.getPathStyle()
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props;
	      var highlight = _props4.highlight;
	      var disableModifications = _props4.disableModifications;
	
	      var _getViewportCoords2 = this.getViewportCoords();
	
	      var width = _getViewportCoords2.width;
	      var height = _getViewportCoords2.height;
	      var left = _getViewportCoords2.left;
	      var top = _getViewportCoords2.top;
	      var centerX = _getViewportCoords2.centerX;
	      var centerY = _getViewportCoords2.centerY;
	
	
	      var classname = (0, _classnames2.default)(styles.edgeView, highlight && styles.highlighted);
	
	      var showControls = !disableModifications;
	
	      var result = _react2.default.createElement(
	        'div',
	        {
	          className: classname
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            className: styles.svgContainer,
	            width: width,
	            height: height,
	            style: {
	              position: 'absolute',
	              left: left + 'px',
	              top: top + 'px'
	            }
	          },
	          this.getEdgePath(),
	          this.getHoverArea()
	        ),
	        showControls && _react2.default.createElement(
	          'div',
	          {
	            onClick: this.handleRemoveClick.bind(this),
	            className: styles.removeContainer,
	            style: { left: centerX + 'px', top: centerY + 'px' }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: styles.remove },
	            _react2.default.createElement(_Icons.Scissors, { className: styles.icon })
	          )
	        )
	      );
	
	      return result;
	    }
	  }]);
	
	  return EdgeView;
	}(_react.Component);
	
	exports.default = EdgeView;
	
	
	EdgeView.propTypes = {
	  startX: _react.PropTypes.number.isRequired,
	  startY: _react.PropTypes.number.isRequired,
	  endX: _react.PropTypes.number.isRequired,
	  endY: _react.PropTypes.number.isRequired,
	
	  color: _react.PropTypes.string.isRequired,
	  dashed: _react.PropTypes.bool,
	
	  startDirX: _react.PropTypes.number.isRequired,
	  startDirY: _react.PropTypes.number.isRequired,
	  endDirX: _react.PropTypes.number.isRequired,
	  endDirY: _react.PropTypes.number.isRequired,
	  id: _react.PropTypes.any.isRequired,
	
	  onRemove: _react.PropTypes.func.isRequired,
	
	  disableModifications: _react.PropTypes.bool
	};

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EdgeView = __webpack_require__(593);
	
	var _EdgeView2 = _interopRequireDefault(_EdgeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _EdgeView2.default;
	/* injects from baggage-loader */

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projectDragItemTypes = __webpack_require__(138);
	
	var _projectDragItemTypes2 = _interopRequireDefault(_projectDragItemTypes);
	
	var _reactDnd = __webpack_require__(121);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _reactDndHtml5Backend = __webpack_require__(175);
	
	var _shallowequal = __webpack_require__(100);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NodeViewContent = __webpack_require__(596);
	
	var _NodeViewContent2 = _interopRequireDefault(_NodeViewContent);
	
	var _NodeViewMenu = __webpack_require__(597);
	
	var _NodeViewMenu2 = _interopRequireDefault(_NodeViewMenu);
	
	var _color = __webpack_require__(234);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _hotkeys = __webpack_require__(598);
	
	var _reactHotkeys = __webpack_require__(956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(501);
	
	var shallowEqualCustomizer = function shallowEqualCustomizer(value) {
	  if (typeof value === 'function') return true;
	};
	
	var isBright = function isBright(color) {
	  return (0, _color2.default)(color).light();
	};
	
	var nodeSource = {
	  beginDrag: function beginDrag(props) {
	    var id = props.id;
	
	    props.onBeginDrag(id);
	    return { id: id };
	  },
	  endDrag: function endDrag(props, monitor, component) {
	    props.onEndDrag(component.props.id);
	
	    if (!monitor.didDrop()) {
	      var _component$props = component.props;
	      var x = _component$props.x;
	      var y = _component$props.y; // get original props!
	
	      component.props.onPositionUpdate({ x: x, y: y });
	      return true;
	    }
	
	    var result = monitor.getDropResult();
	    if (result.type === _projectDragItemTypes2.default.NODE) {
	      component.props.onEdgeConnectionRequest(result.id);
	      return true;
	    }
	
	    return true;
	  }
	};
	
	function collectSource(connect, monitor) {
	  return {
	    connectDragSource: connect.dragSource(),
	    connectDragPreview: connect.dragPreview(),
	    isDragging: monitor.isDragging(),
	    draggedNode: monitor.getItem()
	  };
	}
	var nodeTarget = {
	  hover: function hover(props) {
	    return { id: props.id };
	  },
	  canDrop: function canDrop(props, monitor) {
	    var item = monitor.getItem();
	    return item.id !== props.id && props.canBeDropTarget;
	  },
	  drop: function drop(props) {
	    return { type: _projectDragItemTypes2.default.NODE, id: props.id };
	  }
	};
	
	function collectTarget(connect, monitor) {
	  return {
	    connectDropTarget: connect.dropTarget(),
	    isNodeOver: monitor.isOver()
	  };
	}
	
	var NodeView = (_dec = (0, _reactDnd.DragSource)(_projectDragItemTypes2.default.NODE, nodeSource, collectSource), _dec2 = (0, _reactDnd.DropTarget)(_projectDragItemTypes2.default.NODE, nodeTarget, collectTarget), _dec(_class = _dec2(_class = function (_Component) {
	  _inherits(NodeView, _Component);
	
	  function NodeView(props) {
	    _classCallCheck(this, NodeView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NodeView).call(this, props));
	
	    _this.state = {
	      noPointerEvents: false,
	      mouseInside: false,
	      menuOpen: false,
	      editingCaption: false,
	      colorPickerOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(NodeView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)(), { captureDraggingState: true }); // remove preview
	
	      if (this.props.editOnMount) {
	        this.startEditingContent();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // checks only for shallow equality of props and state
	      return !(0, _shallowequal2.default)(nextProps, this.props, shallowEqualCustomizer) || !(0, _shallowequal2.default)(nextState, this.state);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var _this2 = this;
	
	      var _props = this.props;
	      var wasDragging = _props.isDragging;
	      var wasNodeOver = _props.isNodeOver;
	      var isDragging = nextProps.isDragging;
	      var isNodeOver = nextProps.isNodeOver;
	
	
	      if (!wasDragging && isDragging) {
	        (0, _raf2.default)(function () {
	          return _this2.setState({ noPointerEvents: true });
	        }); // enable dropping the node on another
	      }
	
	      if (!isDragging && this.state.noPointerEvents) {
	        this.setState({ noPointerEvents: false });
	      }
	
	      if (!isDragging && wasDragging) {
	        (0, _raf2.default)(function () {
	          return _this2.handleMouseEnter();
	        });
	        setTimeout(function () {
	          if (_this2.state.mouseInside) _this2.handleMouseLeave();
	        }, 800);
	      }
	
	      if (isDragging) {
	        this.closeMenu();
	      }
	
	      if (!wasNodeOver && isNodeOver) {
	        this.props.onNodeOver();
	      }
	      if (wasNodeOver && !isNodeOver) {
	        this.props.onNodeOverStop();
	      }
	    }
	  }, {
	    key: 'getHotKeyHandlers',
	    value: function getHotKeyHandlers() {
	      var _this3 = this,
	          _ref;
	
	      return _ref = {}, _defineProperty(_ref, _hotkeys.APPEND_RIGHT_CONNECTED, function (ev) {
	        ev.preventDefault();
	        _this3.props.onAppendRightConnected();
	      }), _defineProperty(_ref, _hotkeys.APPEND_RIGHT, function (ev) {
	        ev.preventDefault();
	        _this3.props.onAppendRight();
	      }), _defineProperty(_ref, _hotkeys.APPEND_BOTTOM_CONNECTED, function (ev) {
	        ev.preventDefault();
	        _this3.props.onAppendBottomConnected();
	      }), _ref;
	    }
	  }, {
	    key: 'openMenu',
	    value: function openMenu() {
	      var _this4 = this;
	
	      (0, _raf2.default)(function () {
	        return _this4.setState({ colorPickerOpen: false, menuOpen: true });
	      });
	    }
	  }, {
	    key: 'closeMenu',
	    value: function closeMenu() {
	      this.setState({ menuOpen: false });
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter() {
	      if (this.props.isDragging || this.state.mouseInside) return; // prevent lags
	
	      this.setState({ mouseInside: true });
	      if (this.props.onHover) this.props.onHover();
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave() {
	      this.setState({ mouseInside: false });
	      if (this.props.onHoverStop) this.props.onHoverStop();
	    }
	  }, {
	    key: 'handleClickOut',
	    value: function handleClickOut() {
	      if ((this.state.mouseInside || this.state.menuOpen || this.state.colorPickerOpen) && !this.isDraggingSelf()) {
	        this.closeMenu();
	        this.setState({ mouseInside: false, colorPickerOpen: false });
	      }
	    }
	  }, {
	    key: 'handleCaptionEditStart',
	    value: function handleCaptionEditStart() {
	      this.setState({ editingCaption: true });
	    }
	  }, {
	    key: 'handleCaptionEdit',
	    value: function handleCaptionEdit(newCaption) {
	      this.props.onCaptionUpdated(newCaption);
	      this.setState({ editingCaption: false });
	      this.handleMouseLeave();
	    }
	  }, {
	    key: 'startEditingContent',
	    value: function startEditingContent() {
	      if (this.refs.nodeContent) {
	        this.refs.nodeContent.startEdit();
	        this.setState({ editingCaption: true });
	      }
	    }
	  }, {
	    key: 'handleMenuRenameClick',
	    value: function handleMenuRenameClick() {
	      this.startEditingContent();
	      this.closeMenu();
	    }
	  }, {
	    key: 'handleMenuColorClick',
	    value: function handleMenuColorClick() {
	      // this.closeMenu();
	      this.setState({ colorPickerOpen: true });
	    }
	  }, {
	    key: 'handleMenuRemoveClick',
	    value: function handleMenuRemoveClick() {
	      this.props.onRemove();
	      this.closeMenu();
	    }
	  }, {
	    key: 'handleMenuOpenClick',
	    value: function handleMenuOpenClick() {
	      this.props.onPreview();
	      this.closeMenu();
	    }
	  }, {
	    key: 'handleColorPick',
	    value: function handleColorPick(color) {
	      this.props.onColorUpdate(color);
	      this.handleClickOut();
	    }
	  }, {
	    key: 'handleMenuDetachClick',
	    value: function handleMenuDetachClick() {
	      this.props.onDetach();
	      this.closeMenu();
	    }
	  }, {
	    key: 'handleMenuAppendNewClick',
	    value: function handleMenuAppendNewClick() {
	      this.props.onAppendNew();
	      this.closeMenu();
	    }
	  }, {
	    key: 'isDraggingSelf',
	    value: function isDraggingSelf() {
	      var _props2 = this.props;
	      var id = _props2.id;
	      var isDragging = _props2.isDragging;
	      var draggedNode = _props2.draggedNode;
	
	      if (!draggedNode || !isDragging) return false;
	
	      return isDragging && draggedNode && draggedNode.id === id;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(ev) {
	      var _props3 = this.props;
	      var isPreviewing = _props3.isPreviewing;
	      var onPreview = _props3.onPreview;
	      var disableModifications = _props3.disableModifications;
	
	
	      if (this.state.editingCaption) {
	        ev.preventDefault();
	        return;
	      }
	
	      if (isPreviewing && !disableModifications) {
	        ev.stopPropagation();
	        this.startEditingContent();
	      } else {
	        ev.stopPropagation();
	        onPreview();
	      }
	    }
	  }, {
	    key: 'handleBoundingRectUpdate',
	    value: function handleBoundingRectUpdate(rect) {
	      this.props.onBoundingRectUpdated(rect);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props;
	      var id = _props4.id;
	      var x = _props4.x;
	      var y = _props4.y;
	      var caption = _props4.caption;
	      var color = _props4.color;
	      var isDragging = _props4.isDragging;
	      var isNodeOver = _props4.isNodeOver;
	      var connectDropTarget = _props4.connectDropTarget;
	      var connectDragSource = _props4.connectDragSource;
	      var canBeDropTarget = _props4.canBeDropTarget;
	      var disableModifications = _props4.disableModifications;
	      var _state = this.state;
	      var mouseInside = _state.mouseInside;
	      var menuOpen = _state.menuOpen;
	      var editingCaption = _state.editingCaption;
	      var colorPickerOpen = _state.colorPickerOpen;
	      var noPointerEvents = _state.noPointerEvents;
	
	      var draggingSelf = this.isDraggingSelf();
	
	      // const light = isBright(color) || (mouseInside && !editingCaption) || menuOpen || colorPickerOpen;
	
	      var stylesProps = {
	        nodeOver: isNodeOver && !draggingSelf,
	        canBeDropTarget: canBeDropTarget,
	        expanded: !disableModifications && (mouseInside || menuOpen || colorPickerOpen || isDragging),
	        menuOpen: menuOpen, colorPickerOpen: colorPickerOpen,
	        dragging: isDragging,
	        editingCaption: editingCaption,
	        /* highlightColor: (mouseInside || menuOpen || colorPickerOpen || isDragging) && !editingCaption, */
	        highlightColor: false,
	        light: isBright(color)
	      };
	
	      var dataProps = {
	        id: id, caption: caption, color: color
	      };
	
	      var eventProps = {
	        onBoundingRectUpdated: this.handleBoundingRectUpdate.bind(this),
	
	        onMenuOpen: this.openMenu.bind(this),
	        onMouseEnter: this.handleMouseEnter.bind(this),
	        onMouseLeave: this.handleMouseLeave.bind(this),
	        onClick: this.handleClick.bind(this),
	
	        onCaptionEditStart: this.handleCaptionEditStart.bind(this),
	        onCaptionEdit: this.handleCaptionEdit.bind(this),
	
	        onBeginDragSubtree: this.props.onBeginDragSubtree,
	        onEndDragSubtree: this.props.onEndDragSubtree,
	
	        connectDragSource: connectDragSource,
	        disableModifications: disableModifications
	      };
	
	      var containerClassName = (0, _classnames2.default)(styles.container, isDragging && styles.dragging, noPointerEvents && styles.noPointerEvents, (menuOpen || mouseInside) && styles.lifted);
	
	      var Content = _react2.default.createElement(
	        'div',
	        { className: styles.node },
	        _react2.default.createElement(_NodeViewContent2.default, _extends({
	          ref: 'nodeContent'
	        }, dataProps, stylesProps, eventProps)),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(styles.dropdownMenu, this.props.menuOpen && styles.menuOpen) },
	          _react2.default.createElement(
	            'div',
	            { className: styles.menuContent },
	            _react2.default.createElement(_NodeViewMenu2.default, {
	              nodeId: id,
	
	              onClose: this.closeMenu.bind(this),
	              isOpen: menuOpen,
	              isColorPickerOpen: colorPickerOpen,
	
	              onColorPick: this.handleColorPick.bind(this),
	              onMenuOpenClick: this.handleMenuOpenClick.bind(this),
	              onMenuRenameClick: this.handleMenuRenameClick.bind(this),
	              onMenuColorClick: this.handleMenuColorClick.bind(this),
	              onMenuRemoveClick: this.handleMenuRemoveClick.bind(this),
	              onMenuDetachClick: this.handleMenuDetachClick.bind(this),
	              onMenuAppendNewClick: this.handleMenuAppendNewClick.bind(this)
	            })
	          )
	        )
	      );
	
	      var result = _react2.default.createElement(
	        _reactOnclickout2.default,
	        { onClickOut: this.handleClickOut.bind(this) },
	        _react2.default.createElement(
	          'div',
	          {
	            style: { transform: 'translate(-50%, -50%) translate(' + x + 'px, ' + y + 'px)' },
	            className: containerClassName
	          },
	          _react2.default.createElement(
	            _reactHotkeys.HotKeys,
	            { keyMap: _hotkeys.KEY_MAP, handlers: this.getHotKeyHandlers() },
	            this.props.disableModifications ? Content : connectDropTarget(Content)
	          )
	        )
	      );
	
	      return result;
	    }
	  }]);
	
	  return NodeView;
	}(_react.Component)) || _class) || _class);
	exports.default = NodeView;
	
	
	NodeView.propTypes = {
	  x: _react.PropTypes.number.isRequired,
	  y: _react.PropTypes.number.isRequired,
	  caption: _react.PropTypes.string.isRequired,
	  color: _react.PropTypes.string.isRequired,
	
	  isNodeBeingDragged: _react.PropTypes.bool,
	  isDragging: _react.PropTypes.bool,
	  connectDragSource: _react.PropTypes.func,
	  connectDragPreview: _react.PropTypes.func,
	
	  onNodeOver: _react.PropTypes.func.isRequired,
	  onNodeOverStop: _react.PropTypes.func.isRequired,
	
	  id: _react.PropTypes.string.isRequired,
	
	  onPositionUpdate: _react.PropTypes.func.isRequired,
	  onCaptionUpdated: _react.PropTypes.func.isRequired,
	  onBoundingRectUpdated: _react.PropTypes.func.isRequired,
	
	  onHover: _react.PropTypes.func.isRequired,
	  onHoverStop: _react.PropTypes.func.isRequired,
	  onRemove: _react.PropTypes.func.isRequired,
	  onPreview: _react.PropTypes.func.isRequired,
	  onDetach: _react.PropTypes.func.isRequired,
	  onAppendNew: _react.PropTypes.func.isRequired,
	  onAppendRightConnected: _react.PropTypes.func.isRequired,
	  onAppendRight: _react.PropTypes.func.isRequired,
	  onAppendBottomConnected: _react.PropTypes.func.isRequired,
	
	  onColorUpdate: _react.PropTypes.func.isRequired,
	
	  onEdgeConnectionRequest: _react.PropTypes.func.isRequired,
	  canBeDropTarget: _react.PropTypes.bool,
	
	  editOnMount: _react.PropTypes.bool
	};

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactIcons = __webpack_require__(136);
	
	var _Common = __webpack_require__(11);
	
	var _Icons = __webpack_require__(17);
	
	var _projectDragItemTypes = __webpack_require__(138);
	
	var _projectDragItemTypes2 = _interopRequireDefault(_projectDragItemTypes);
	
	var _reactDnd = __webpack_require__(121);
	
	var _reactDndHtml5Backend = __webpack_require__(175);
	
	var _shallowequal = __webpack_require__(100);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(502);
	
	var shallowEqualCustomizer = function shallowEqualCustomizer(value) {
	  if (typeof value === 'function') return true;
	};
	
	var nodeSource = {
	  beginDrag: function beginDrag(props) {
	    var id = props.id;
	
	    props.onBeginDragSubtree(id);
	    return { id: id };
	  },
	  endDrag: function endDrag(props, monitor) {
	    var _monitor$getDifferenc = monitor.getDifferenceFromInitialOffset();
	
	    var dx = _monitor$getDifferenc.x;
	    var dy = _monitor$getDifferenc.y;
	
	
	    props.onEndDragSubtree({ dx: dx, dy: dy });
	
	    return true;
	  }
	};
	
	function collectSource(connect, monitor) {
	  return {
	    connectDragSource: connect.dragSource(),
	    connectDragPreview: connect.dragPreview(),
	    isDragging: monitor.isDragging(),
	    draggedNode: monitor.getItem()
	  };
	}
	
	var NodeDragHandle = (_dec = (0, _reactDnd.DragSource)(_projectDragItemTypes2.default.NODE_HANDLE, nodeSource, collectSource), _dec(_class = function (_Component) {
	  _inherits(NodeDragHandle, _Component);
	
	  function NodeDragHandle() {
	    _classCallCheck(this, NodeDragHandle);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NodeDragHandle).apply(this, arguments));
	  }
	
	  _createClass(NodeDragHandle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)(), { captureDraggingState: true }); // remove preview
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var connectDragSource = this.props.connectDragSource;
	
	
	      return connectDragSource(_react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.dragHandle, styles.control) },
	        _react2.default.createElement(
	          'i',
	          { className: styles.controlIcon },
	          _react2.default.createElement(_ReactIcons.DragHandle, { hover: this.props.isDragging })
	        )
	      ));
	    }
	  }]);
	
	  return NodeDragHandle;
	}(_react.Component)) || _class);
	
	var NodeViewContent = function (_Component2) {
	  _inherits(NodeViewContent, _Component2);
	
	  function NodeViewContent() {
	    _classCallCheck(this, NodeViewContent);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NodeViewContent).apply(this, arguments));
	  }
	
	  _createClass(NodeViewContent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _raf2.default)(this.sendBoundingRectUpdates.bind(this));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      // checks only for shallow equality of props and state
	      return !(0, _shallowequal2.default)(nextProps, this.props, shallowEqualCustomizer);
	    }
	  }, {
	    key: 'getNodeCaptionBoundingRect',
	    value: function getNodeCaptionBoundingRect() {
	      var captionNode = this.refs.captionNode;
	
	      if (!captionNode) return { width: 0, height: 0 };
	
	      return {
	        width: captionNode.offsetWidth + 16 * 2,
	        height: captionNode.offsetHeight
	      };
	    }
	  }, {
	    key: 'startEdit',
	    value: function startEdit() {
	      this.refs.captionTextArea.startEdit();
	    }
	  }, {
	    key: 'sendBoundingRectUpdates',
	    value: function sendBoundingRectUpdates() {
	      if (!this.props.onBoundingRectUpdated) return;
	
	      var rect = this.getNodeCaptionBoundingRect();
	      var width = rect.width;
	      var height = rect.height;
	
	
	      this.props.onBoundingRectUpdated({ width: width, height: height });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      if (nextProps.caption !== this.props.caption) {
	        this.sendBoundingRectUpdates();
	      }
	    }
	  }, {
	    key: 'handleCaptionEditChange',
	    value: function handleCaptionEditChange() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        return _this3.sendBoundingRectUpdates();
	      }, 0);
	    }
	  }, {
	    key: 'handleMenuClick',
	    value: function handleMenuClick(ev) {
	      ev.stopPropagation();
	      this.props.onMenuOpen();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var caption = _props.caption;
	      var color = _props.color;
	      var nodeOver = _props.nodeOver;
	      var canBeDropTarget = _props.canBeDropTarget;
	      var expanded = _props.expanded;
	      var menuOpen = _props.menuOpen;
	      var dragging = _props.dragging;
	      var editingCaption = _props.editingCaption;
	      var highlightColor = _props.highlightColor;
	      var light = _props.light;
	      var connectDragSource = _props.connectDragSource;
	      var disableModifications = _props.disableModifications;
	
	
	      var classname = (0, _classnames2.default)(styles.nodeView, disableModifications && styles.disableModifications, nodeOver && styles.nodeOver, expanded && styles.expanded, menuOpen && styles.menuOpen, dragging && styles.dragging, editingCaption && styles.editingCaption, highlightColor && styles.highlightColor);
	
	      var Content = _react2.default.createElement(
	        'div',
	        {
	          className: classname,
	          style: { backgroundColor: color, color: light ? 'black' : 'white' },
	          onMouseEnter: this.props.onMouseEnter,
	          onMouseMove: this.props.onMouseEnter,
	          onMouseLeave: this.props.onMouseLeave
	        },
	        _react2.default.createElement(NodeDragHandle, this.props),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'captionNode',
	            className: styles.caption,
	            onClick: this.props.onClick
	          },
	          _react2.default.createElement(_Common.EditableTextArea, {
	            ref: 'captionTextArea',
	            disabled: disableModifications,
	            dark: !light, maxWidth: 300, text: caption,
	            editing: editingCaption,
	            onEditSubmit: this.props.onCaptionEdit,
	            onEditStart: this.props.onCaptionEditStart,
	            onEditChange: this.handleCaptionEditChange.bind(this)
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.control },
	          _react2.default.createElement(
	            'i',
	            { onClick: this.handleMenuClick.bind(this), className: styles.controlIcon },
	            _react2.default.createElement(_ReactIcons.Hamburger, null)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: styles.overlay,
	            style: { borderColor: color }
	          },
	          canBeDropTarget ? _react2.default.createElement(_Icons.Clip, { className: styles.clipIcon }) : _react2.default.createElement(_Icons.ClipCrossed, { className: styles.clipIcon })
	        )
	      );
	
	      return disableModifications ? Content : connectDragSource(Content);
	    }
	  }]);
	
	  return NodeViewContent;
	}(_react.Component);
	
	exports.default = NodeViewContent;
	
	
	NodeViewContent.propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  color: _react.PropTypes.string.isRequired,
	  caption: _react.PropTypes.string.isRequired,
	
	  editingCaption: _react.PropTypes.bool,
	
	  onMenuOpen: _react.PropTypes.func.isRequired,
	  onBoundingRectUpdated: _react.PropTypes.func.isRequired,
	
	  onCaptionEditStart: _react.PropTypes.func.isRequired,
	  onCaptionEdit: _react.PropTypes.func.isRequired,
	
	  onMouseEnter: _react.PropTypes.func.isRequired,
	  onMouseLeave: _react.PropTypes.func.isRequired,
	  onClick: _react.PropTypes.func.isRequired,
	
	  connectDragSource: _react.PropTypes.func.isRequired,
	  disableModifications: _react.PropTypes.bool
	};

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactIcons = __webpack_require__(136);
	
	var _Common = __webpack_require__(11);
	
	var _Icons = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* injects from baggage-loader */
	
	var NodeViewMenu = function (_Component) {
	  _inherits(NodeViewMenu, _Component);
	
	  function NodeViewMenu() {
	    _classCallCheck(this, NodeViewMenu);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NodeViewMenu).apply(this, arguments));
	  }
	
	  _createClass(NodeViewMenu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var isOpen = _props.isOpen;
	      var isColorPickerOpen = _props.isColorPickerOpen;
	
	
	      if (isColorPickerOpen) {
	        return _react2.default.createElement(
	          _Common.Menu,
	          {
	            close: this.props.onClose,
	            isOpen: isOpen,
	            backdrop: true, openable: true
	          },
	          _react2.default.createElement(_Common.ColorPicker, { onPick: this.props.onColorPick })
	        );
	      }
	
	      return _react2.default.createElement(
	        _Common.Menu,
	        {
	          close: this.props.onClose,
	          isOpen: isOpen,
	          backdrop: true, openable: true
	        },
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { onClick: this.props.onMenuOpenClick },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_ReactIcons.Open, null)
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Open'
	          )
	        ),
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { onClick: this.props.onMenuRenameClick },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_ReactIcons.Rename, null)
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Rename'
	          )
	        ),
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { onClick: this.props.onMenuColorClick },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_ReactIcons.SetColor, null)
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Set color'
	          )
	        ),
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { onClick: this.props.onMenuDetachClick },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_Icons.Scissors, { width: '14', height: '14' })
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Detach'
	          )
	        ),
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { onClick: this.props.onMenuRemoveClick },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_ReactIcons.Delete, null)
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Delete'
	          )
	        ),
	        _react2.default.createElement(
	          _Common.Menu.Item,
	          { onClick: this.props.onMenuAppendNewClick },
	          _react2.default.createElement(
	            _Common.Menu.ItemIcon,
	            null,
	            _react2.default.createElement(_ReactIcons.AppendNew, null)
	          ),
	          _react2.default.createElement(
	            _Common.Menu.ItemLabel,
	            null,
	            'Append new'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NodeViewMenu;
	}(_react.Component);
	
	exports.default = NodeViewMenu;
	
	
	NodeViewMenu.propTypes = {
	  onClose: _react.PropTypes.func.isRequired,
	  isOpen: _react.PropTypes.bool,
	  isColorPickerOpen: _react.PropTypes.bool,
	
	  onMenuOpenClick: _react.PropTypes.func.isRequired,
	  onMenuRenameClick: _react.PropTypes.func.isRequired,
	  onMenuColorClick: _react.PropTypes.func.isRequired,
	  onMenuRemoveClick: _react.PropTypes.func.isRequired,
	  onMenuDetachClick: _react.PropTypes.func.isRequired,
	  onMenuAppendNewClick: _react.PropTypes.func.isRequired,
	
	  onColorPick: _react.PropTypes.func.isRequired
	};

/***/ },
/* 598 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _KEY_MAP;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* injects from baggage-loader */
	
	var APPEND_RIGHT_CONNECTED = exports.APPEND_RIGHT_CONNECTED = 'APPEND_RIGHT_CONNECTED';
	var APPEND_RIGHT = exports.APPEND_RIGHT = 'APPEND_RIGHT';
	var APPEND_BOTTOM_CONNECTED = exports.APPEND_BOTTOM_CONNECTED = 'APPEND_BOTTOM_CONNECTED';
	
	var KEY_MAP = exports.KEY_MAP = (_KEY_MAP = {}, _defineProperty(_KEY_MAP, APPEND_RIGHT, 'shift+tab'), _defineProperty(_KEY_MAP, APPEND_RIGHT_CONNECTED, 'tab'), _defineProperty(_KEY_MAP, APPEND_BOTTOM_CONNECTED, ['ctrl+enter', 'command+enter']), _KEY_MAP);

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NodeView = __webpack_require__(595);
	
	var _NodeView2 = _interopRequireDefault(_NodeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NodeView2.default;
	/* injects from baggage-loader */

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.renderEdges = exports.renderEdge = exports.renderNode = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(121);
	
	var _reactDom = __webpack_require__(29);
	
	var _xtend = __webpack_require__(206);
	
	var _xtend2 = _interopRequireDefault(_xtend);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _pureGraph = __webpack_require__(34);
	
	var _utils = __webpack_require__(68);
	
	var _functional = __webpack_require__(83);
	
	var _sceneUtils = __webpack_require__(606);
	
	var _projectDragItemTypes = __webpack_require__(138);
	
	var _projectDragItemTypes2 = _interopRequireDefault(_projectDragItemTypes);
	
	var _NodeView = __webpack_require__(599);
	
	var _NodeView2 = _interopRequireDefault(_NodeView);
	
	var _EdgeView = __webpack_require__(594);
	
	var _EdgeView2 = _interopRequireDefault(_EdgeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(503);
	
	var APPEND_RIGHT_PADDING = 112;
	var APPEND_BOTTOM_PADDING = 96;
	
	var getDroppableNodes = function getDroppableNodes(nodeId, graphData) {
	  var nodes = (0, _pureGraph.getNodes)(graphData);
	  var isDetached = (0, _pureGraph.getEdgesIncidentToNode)(nodeId, graphData).length === 0;
	  if (isDetached) return nodes;
	
	  return nodes.filter(function (node) {
	    if (node === nodeId) return false;
	
	    var isNodeDetached = (0, _pureGraph.getEdgesIncidentToNode)(node, graphData).length === 0;
	    if (isNodeDetached) return true;
	
	    var graphToCheck = (0, _functional.compose)((0, _pureGraph.addEdge)((0, _utils.guid)(), nodeId, node), (0, _pureGraph.removeEdgesToNode)(nodeId))(graphData);
	
	    return !(0, _pureGraph.hasCyclesInConnectedComponent)(nodeId, graphToCheck);
	  });
	};
	
	var renderNode = exports.renderNode = function renderNode(_ref) {
	  var id = _ref.id;
	  var _ref$data = _ref.data;
	  var x = _ref$data.x;
	  var y = _ref$data.y;
	  var caption = _ref$data.caption;
	  var color = _ref$data.color;
	  var isNodeBeingDragged = _ref.isNodeBeingDragged;
	  var isPreviewing = _ref.isPreviewing;
	  var onPositionUpdate = _ref.onPositionUpdate;
	  var onCaptionUpdated = _ref.onCaptionUpdated;
	  var onRemove = _ref.onRemove;
	  var onBoundingRectUpdate = _ref.onBoundingRectUpdate;
	  var onHover = _ref.onHover;
	  var onHoverStop = _ref.onHoverStop;
	  var onEdgeConnectionRequest = _ref.onEdgeConnectionRequest;
	  var onPreview = _ref.onPreview;
	  var onColorUpdate = _ref.onColorUpdate;
	  var onDetach = _ref.onDetach;
	  var onAppendNew = _ref.onAppendNew;
	  var onAppendRight = _ref.onAppendRight;
	  var onAppendRightConnected = _ref.onAppendRightConnected;
	  var onAppendBottomConnected = _ref.onAppendBottomConnected;
	  var onBeginDrag = _ref.onBeginDrag;
	  var onBeginDragSubtree = _ref.onBeginDragSubtree;
	  var onEndDrag = _ref.onEndDrag;
	  var onEndDragSubtree = _ref.onEndDragSubtree;
	  var canBeDropTarget = _ref.canBeDropTarget;
	  var onNodeOver = _ref.onNodeOver;
	  var onNodeOverStop = _ref.onNodeOverStop;
	  var disableModifications = _ref.disableModifications;
	  var editOnMount = _ref.editOnMount;
	  return _react2.default.createElement(_NodeView2.default, {
	    key: id,
	    onPreview: onPreview, isPreviewing: isPreviewing,
	    id: id, x: x, y: y, caption: caption, color: color,
	    isNodeBeingDragged: isNodeBeingDragged,
	    onBoundingRectUpdated: onBoundingRectUpdate,
	    onCaptionUpdated: onCaptionUpdated,
	    onPositionUpdate: onPositionUpdate,
	    onRemove: onRemove,
	    onDetach: onDetach,
	    onAppendNew: onAppendNew,
	    onAppendRightConnected: onAppendRightConnected,
	    onAppendRight: onAppendRight,
	    onAppendBottomConnected: onAppendBottomConnected,
	
	    onColorUpdate: onColorUpdate,
	    onHover: onHover, onHoverStop: onHoverStop,
	    onEdgeConnectionRequest: onEdgeConnectionRequest,
	    onBeginDrag: onBeginDrag,
	    onBeginDragSubtree: onBeginDragSubtree,
	    onEndDrag: onEndDrag,
	    onEndDragSubtree: onEndDragSubtree,
	    canBeDropTarget: canBeDropTarget,
	
	    onNodeOver: onNodeOver,
	    onNodeOverStop: onNodeOverStop,
	
	    disableModifications: disableModifications,
	
	    editOnMount: editOnMount
	  });
	};
	
	var renderEdge = exports.renderEdge = function renderEdge(_ref2) {
	  var id = _ref2.id;
	  var color = _ref2.color;
	  var highlight = _ref2.highlight;
	  var startX = _ref2.startX;
	  var startY = _ref2.startY;
	  var startDirX = _ref2.startDirX;
	  var startDirY = _ref2.startDirY;
	  var endX = _ref2.endX;
	  var endY = _ref2.endY;
	  var endDirX = _ref2.endDirX;
	  var endDirY = _ref2.endDirY;
	  var onRemove = _ref2.onRemove;
	  var disableModifications = _ref2.disableModifications;
	  var dashed = _ref2.dashed;
	  return _react2.default.createElement(_EdgeView2.default, {
	    key: id, id: id, color: color, highlight: highlight, dashed: dashed,
	    startX: startX, startY: startY,
	    startDirX: startDirX, startDirY: startDirY,
	    endX: endX, endY: endY,
	    endDirX: endDirX, endDirY: endDirY,
	
	    onRemove: onRemove,
	    disableModifications: disableModifications
	  });
	};
	
	var renderEdges = exports.renderEdges = function renderEdges(_ref3) {
	  var graphData = _ref3.graphData;
	  var nodesData = _ref3.nodesData;
	  var nodeRects = _ref3.nodeRects;
	  var draggedNodeOverOther = _ref3.draggedNodeOverOther;
	  var draggedNodeId = _ref3.draggedNodeId;
	  var canDrop = _ref3.canDrop;
	  var disableModifications = _ref3.disableModifications;
	  var onRemoveHandler = _ref3.onRemoveHandler;
	  return (0, _sceneUtils.getEdgesCoordinates)(nodeRects, graphData, nodesData).map(function (edgeData) {
	    var edge = (0, _pureGraph.getEdgeWithId)(edgeData.id, graphData);
	    var toNodeId = edge.to;
	
	
	    var dashed = draggedNodeOverOther && draggedNodeId === toNodeId && canDrop;
	
	    var color = nodesData[toNodeId].color;
	
	    // const highlight = (hoveredNodeId === toNodeId);
	
	    var onRemove = function onRemove() {
	      return onRemoveHandler(edgeData.id);
	    };
	
	    return renderEdge((0, _xtend2.default)(edgeData, { color: color, highlight: false, onRemove: onRemove, disableModifications: disableModifications, dashed: dashed }));
	  });
	};
	
	var ProjectScene = (_dec = (0, _reactDnd.DragLayer)(function (monitor) {
	  return {
	    dragItem: monitor.getItem(),
	    itemType: monitor.getItemType(),
	    currentOffsetDifference: monitor.getDifferenceFromInitialOffset(),
	    isDragging: monitor.isDragging()
	  };
	}), _dec(_class = function (_Component) {
	  _inherits(ProjectScene, _Component);
	
	  function ProjectScene(props) {
	    _classCallCheck(this, ProjectScene);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectScene).call(this, props));
	
	    _this.state = {
	      nodeRects: {},
	
	      hoveredNodeId: null,
	      hoveredNode: false,
	
	      droppableNodes: [],
	      draggedNodeOverOther: false,
	      canDrop: false,
	
	      isDraggingNode: false,
	      draggingNodeId: null,
	      draggingSubTree: false,
	      draggingNodeData: { x: 0, y: 0 }
	    };
	    return _this;
	  }
	
	  _createClass(ProjectScene, [{
	    key: 'isDraggingNode',
	    value: function isDraggingNode() {
	      var _props = this.props;
	      var isDragging = _props.isDragging;
	      var itemType = _props.itemType;
	      var dragItem = _props.dragItem;
	      var currentOffsetDifference = _props.currentOffsetDifference;
	
	      return isDragging && dragItem && currentOffsetDifference && itemType === _projectDragItemTypes2.default.NODE;
	    }
	  }, {
	    key: 'isDraggingSubTree',
	    value: function isDraggingSubTree() {
	      // TODO REMAKE
	      var _props2 = this.props;
	      var itemType = _props2.itemType;
	      var dragItem = _props2.dragItem;
	      var currentOffsetDifference = _props2.currentOffsetDifference;
	      var draggingSubTree = this.state.draggingSubTree;
	
	
	      return draggingSubTree && dragItem && currentOffsetDifference && itemType === _projectDragItemTypes2.default.NODE_HANDLE;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // prevent drag
	      var node = (0, _reactDom.findDOMNode)(this);
	      node.addEventListener('mousedown', function (e) {
	        e.stopPropagation();
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleNodeBoundingRectUpdate = function () {};
	    }
	  }, {
	    key: 'handleNodeHover',
	    value: function handleNodeHover() {
	      // this.setState({ hoveredNodeId: id, hoveredNode: true });
	    }
	  }, {
	    key: 'handleNodeHoverStop',
	    value: function handleNodeHoverStop() {
	      // this.setState({ hoveredNodeId: null, hoveredNode: false });
	    }
	  }, {
	    key: 'handleNodeBoundingRectUpdate',
	    value: function handleNodeBoundingRectUpdate(id, rect) {
	      var newRect = _defineProperty({}, id, rect);
	      var newRects = (0, _xtend2.default)(this.state.nodeRects, newRect);
	
	      this.setState({ nodeRects: newRects });
	    }
	  }, {
	    key: 'updateNodeData',
	    value: function updateNodeData(id, data) {
	      var nodeData = this.props.nodesData[id];
	      var newNodeData = _extends({}, nodeData, data);
	
	      this.props.onNodeDataUpdate(id, newNodeData);
	    }
	  }, {
	    key: 'updateNodesData',
	    value: function updateNodesData(nodesIds, newNodesData) {
	      this.props.onNodesDataUpdate(nodesIds, newNodesData);
	    }
	  }, {
	    key: 'handleNodeCaptionUpdate',
	    value: function handleNodeCaptionUpdate(id, caption) {
	      this.updateNodeData(id, { caption: caption });
	    }
	  }, {
	    key: 'handleNodePositionUpdate',
	    value: function handleNodePositionUpdate(id, _ref4) {
	      var x = _ref4.x;
	      var y = _ref4.y;
	
	      this.updateNodeData(id, { x: x, y: y });
	    }
	  }, {
	    key: 'handleNodeColorUpdate',
	    value: function handleNodeColorUpdate(id, color) {
	      this.updateNodeData(id, { color: color });
	    }
	  }, {
	    key: 'handleNodeRemove',
	    value: function handleNodeRemove(id) {
	      this.props.onNodeRemove(id);
	    }
	  }, {
	    key: 'handleNodeDetach',
	    value: function handleNodeDetach(id) {
	      this.props.onNodeDetach(id);
	    }
	  }, {
	    key: 'handleNodeAppendNew',
	    value: function handleNodeAppendNew(id) {
	      this.props.onNodeAppendNew(id);
	    }
	  }, {
	    key: 'getAppendedRightNodePos',
	    value: function getAppendedRightNodePos(id) {
	      var nodesData = this.props.nodesData;
	      var nodeRects = this.state.nodeRects;
	      var _nodesData$id = nodesData[id];
	      var nodeX = _nodesData$id.x;
	      var nodeY = _nodesData$id.y;
	      var nodeWidth = nodeRects[id].width;
	
	
	      var x = nodeX + nodeWidth / 2 + APPEND_RIGHT_PADDING;
	      var y = nodeY;
	
	      return { x: x, y: y };
	    }
	  }, {
	    key: 'getAppendedBottomNodePos',
	    value: function getAppendedBottomNodePos(id) {
	      var nodesData = this.props.nodesData;
	      var nodeRects = this.state.nodeRects;
	      var _nodesData$id2 = nodesData[id];
	      var nodeX = _nodesData$id2.x;
	      var nodeY = _nodesData$id2.y;
	      var nodeHeight = nodeRects[id].height;
	
	
	      var x = nodeX;
	      var y = nodeY + nodeHeight / 2 + APPEND_BOTTOM_PADDING;
	
	      return { x: x, y: y };
	    }
	  }, {
	    key: 'handleNodeAppendRightConnected',
	    value: function handleNodeAppendRightConnected(id) {
	      var _getAppendedRightNode = this.getAppendedRightNodePos(id);
	
	      var x = _getAppendedRightNode.x;
	      var y = _getAppendedRightNode.y;
	
	
	      this.props.onNodeAppendRightConnected(id, { x: x, y: y });
	    }
	  }, {
	    key: 'handleNodeAppendRight',
	    value: function handleNodeAppendRight(id) {
	      var _getAppendedRightNode2 = this.getAppendedRightNodePos(id);
	
	      var x = _getAppendedRightNode2.x;
	      var y = _getAppendedRightNode2.y;
	
	
	      this.props.onNodeAppendRight(id, { x: x, y: y });
	    }
	  }, {
	    key: 'handleNodeAppendBottomConnected',
	    value: function handleNodeAppendBottomConnected(id) {
	      var _getAppendedBottomNod = this.getAppendedBottomNodePos(id);
	
	      var x = _getAppendedBottomNod.x;
	      var y = _getAppendedBottomNod.y;
	
	
	      this.props.onNodeAppendBottomConnected(id, { x: x, y: y });
	    }
	  }, {
	    key: 'handleEdgeConnectionRequest',
	    value: function handleEdgeConnectionRequest(fromId, toId) {
	      this.props.onEdgeConnectionRequest(fromId, toId);
	    }
	  }, {
	    key: 'handleEdgeRemove',
	    value: function handleEdgeRemove(edgeId) {
	      this.props.onEdgeRemove(edgeId);
	    }
	  }, {
	    key: 'handleNodePreview',
	    value: function handleNodePreview(nodeId) {
	      var _props3 = this.props;
	      var canPreviewNode = _props3.canPreviewNode;
	      var onNodePreview = _props3.onNodePreview;
	
	      if (!canPreviewNode) return;
	
	      onNodePreview(nodeId);
	    }
	  }, {
	    key: 'handleNodeBeginDrag',
	    value: function handleNodeBeginDrag(nodeId) {
	      var _this2 = this;
	
	      var graphData = this.props.graphData;
	
	
	      (0, _raf2.default)(function () {
	        var droppableNodes = getDroppableNodes(nodeId, graphData);
	        _this2.setState({ droppableNodes: droppableNodes });
	      });
	    }
	  }, {
	    key: 'handleNodeEndDrag',
	    value: function handleNodeEndDrag() {
	      this.setState({ droppableNodes: [] });
	    }
	  }, {
	    key: 'handleNodeBeginDragSubTree',
	    value: function handleNodeBeginDragSubTree() {
	      this.setState({
	        droppableNodes: [],
	        draggingSubTree: true
	      });
	    }
	  }, {
	    key: 'handleNodeEndDragSubTree',
	    value: function handleNodeEndDragSubTree(id, _ref5) {
	      var dx = _ref5.dx;
	      var dy = _ref5.dy;
	
	      this.setState({
	        droppableNodes: [],
	        draggingSubTree: false
	      });
	
	      var _props4 = this.props;
	      var graphData = _props4.graphData;
	      var nodesData = _props4.nodesData;
	
	
	      var draggedNodes = (0, _pureGraph.getNodesOfSubgraphFrom)(this.getDraggedNodeId(), graphData);
	
	      var draggedNodesIds = (0, _pureGraph.getNodesOfSubgraphFrom)(id, graphData);
	      var draggedNodesData = draggedNodesIds.map(function (nodeId) {
	        return _extends({ id: nodeId }, nodesData[nodeId]);
	      });
	      var shiftedNodesData = this.getShiftedNodesData(draggedNodesData, { dx: dx, dy: dy });
	
	      this.updateNodesData(draggedNodes, shiftedNodesData);
	    }
	  }, {
	    key: 'handleNodeOver',
	    value: function handleNodeOver(id) {
	      var _this3 = this;
	
	      (0, _raf2.default)(function () {
	        var droppableNodes = _this3.state.droppableNodes;
	
	
	        _this3.setState({
	          draggedNodeOverOther: true,
	          canDrop: droppableNodes.indexOf(id) > -1
	        });
	      });
	    }
	  }, {
	    key: 'handleNodeOverStop',
	    value: function handleNodeOverStop() {
	      this.setState({
	        draggedNodeOverOther: false,
	        canDrop: false
	      });
	    }
	  }, {
	    key: 'getDraggedNodeId',
	    value: function getDraggedNodeId() {
	      if (!this.props.dragItem) return null;
	      var id = this.props.dragItem.id;
	
	
	      return id;
	    }
	  }, {
	    key: 'getDraggedNodesIds',
	    value: function getDraggedNodesIds() {
	      var graphData = this.props.graphData;
	
	
	      if (this.isDraggingSubTree()) {
	        return [].concat(_toConsumableArray((0, _pureGraph.getNodesOfSubgraphFrom)(this.getDraggedNodeId(), graphData)), [this.getDraggedNodeId()]);
	      }
	
	      if (this.isDraggingNode()) {
	        return [this.getDraggedNodeId()];
	      }
	
	      return [];
	    }
	  }, {
	    key: 'getShiftedNodesData',
	    value: function getShiftedNodesData(modifiedNodesData, _ref6) {
	      var dx = _ref6.dx;
	      var dy = _ref6.dy;
	      var nodesData = this.props.nodesData;
	
	
	      var shiftedData = modifiedNodesData.map(function (data) {
	        return _extends({}, data, {
	          x: data.x + dx,
	          y: data.y + dy
	        });
	      }).reduce(function (res, nodeData) {
	        return _extends({}, res, _defineProperty({}, nodeData.id, nodeData));
	      }, {});
	
	      return _extends({}, nodesData, shiftedData);
	    }
	  }, {
	    key: 'getNodesData',
	    value: function getNodesData() {
	      var nodesData = this.props.nodesData;
	
	
	      var draggedNodesIds = this.getDraggedNodesIds();
	      if (draggedNodesIds.length === 0) return nodesData;
	
	      // handle dragging nodes case
	      var currentOffsetDifference = this.props.currentOffsetDifference;
	      var dx = currentOffsetDifference.x;
	      var dy = currentOffsetDifference.y;
	
	
	      var draggedNodesData = draggedNodesIds.map(function (id) {
	        return _extends({ id: id }, nodesData[id]);
	      });
	      return this.getShiftedNodesData(draggedNodesData, { dx: dx, dy: dy });
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes(_ref7) {
	      var _this4 = this;
	
	      var graphData = _ref7.graphData;
	      var nodesData = _ref7.nodesData;
	      var previewingNode = _ref7.previewingNode;
	      var previewingNodeId = _ref7.previewingNodeId;
	      var disableModifications = _ref7.disableModifications;
	      var droppableNodes = _ref7.droppableNodes;
	      var editNodesOnMount = _ref7.editNodesOnMount;
	
	      var nodeIds = (0, _pureGraph.getNodes)(graphData);
	      var renderedNodes = nodeIds.map(function (id) {
	        return { id: id, data: nodesData[id] };
	      }).filter(function (_ref8) {
	        var data = _ref8.data;
	        return !!data;
	      }).map(function (_ref9) {
	        var id = _ref9.id;
	        var data = _ref9.data;
	        return renderNode({
	          id: id, data: data,
	
	          isNodeBeingDragged: _this4.isDraggingNode(),
	          onCaptionUpdated: _this4.handleNodeCaptionUpdate.bind(_this4, id),
	          onBoundingRectUpdate: _this4.handleNodeBoundingRectUpdate.bind(_this4, id),
	          onRemove: _this4.handleNodeRemove.bind(_this4, id),
	          onPositionUpdate: _this4.handleNodePositionUpdate.bind(_this4, id),
	          onColorUpdate: _this4.handleNodeColorUpdate.bind(_this4, id),
	          onDetach: _this4.handleNodeDetach.bind(_this4, id),
	          onAppendNew: _this4.handleNodeAppendNew.bind(_this4, id),
	          onAppendRight: _this4.handleNodeAppendRight.bind(_this4, id),
	          onAppendRightConnected: _this4.handleNodeAppendRightConnected.bind(_this4, id),
	          onAppendBottomConnected: _this4.handleNodeAppendBottomConnected.bind(_this4, id),
	          onHover: _this4.handleNodeHover.bind(_this4, id),
	          onHoverStop: _this4.handleNodeHoverStop.bind(_this4, id),
	          onEdgeConnectionRequest: function onEdgeConnectionRequest(from) {
	            return _this4.handleEdgeConnectionRequest(from, id);
	          },
	          onPreview: _this4.handleNodePreview.bind(_this4, id),
	          isPreviewing: previewingNode && previewingNodeId === id,
	
	          onBeginDrag: _this4.handleNodeBeginDrag.bind(_this4, id),
	          onEndDrag: _this4.handleNodeEndDrag.bind(_this4, id),
	
	          onBeginDragSubtree: _this4.handleNodeBeginDragSubTree.bind(_this4, id),
	          onEndDragSubtree: _this4.handleNodeEndDragSubTree.bind(_this4, id),
	
	          canBeDropTarget: droppableNodes.indexOf(id) > -1,
	
	          onNodeOver: _this4.handleNodeOver.bind(_this4, id),
	          onNodeOverStop: _this4.handleNodeOverStop.bind(_this4, id),
	
	          disableModifications: disableModifications, editOnMount: editNodesOnMount
	        });
	      });
	
	      return renderedNodes;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props;
	      var graphData = _props5.graphData;
	      var previewingNode = _props5.previewingNode;
	      var previewingNodeId = _props5.previewingNodeId;
	      var disableModifications = _props5.disableModifications;
	      var editNodesOnMount = _props5.editNodesOnMount;
	      var _state = this.state;
	      var nodeRects = _state.nodeRects;
	      var hoveredNodeId = _state.hoveredNodeId;
	      var draggedNodeOverOther = _state.draggedNodeOverOther;
	      var droppableNodes = _state.droppableNodes;
	      var canDrop = _state.canDrop;
	
	
	      var usedNodesData = this.getNodesData();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderEdges({
	          nodeRects: nodeRects, graphData: graphData, nodesData: usedNodesData, hoveredNodeId: hoveredNodeId, disableModifications: disableModifications,
	          draggedNodeOverOther: draggedNodeOverOther, canDrop: canDrop,
	          draggedNodeId: this.getDraggedNodeId(),
	          onRemoveHandler: this.handleEdgeRemove.bind(this)
	        }),
	        this.renderNodes({
	          graphData: graphData, nodesData: usedNodesData,
	          previewingNode: previewingNode, previewingNodeId: previewingNodeId,
	          disableModifications: disableModifications, droppableNodes: droppableNodes, editNodesOnMount: editNodesOnMount
	        })
	      );
	    }
	  }]);
	
	  return ProjectScene;
	}(_react.Component)) || _class);
	exports.default = ProjectScene;
	
	
	ProjectScene.propTypes = {
	  graphData: _react.PropTypes.object.isRequired,
	  nodesData: _react.PropTypes.object.isRequired,
	
	  onNodeDataUpdate: _react.PropTypes.func.isRequired,
	  onNodesDataUpdate: _react.PropTypes.func.isRequired,
	  onNodeRemove: _react.PropTypes.func.isRequired,
	  onNodePreview: _react.PropTypes.func.isRequired,
	  onNodeDetach: _react.PropTypes.func.isRequired,
	  onNodeAppendNew: _react.PropTypes.func.isRequired,
	  onNodeAppendRightConnected: _react.PropTypes.func.isRequired,
	  onNodeAppendRight: _react.PropTypes.func.isRequired,
	  onNodeAppendBottomConnected: _react.PropTypes.func.isRequired,
	
	  onEdgeConnectionRequest: _react.PropTypes.func.isRequired,
	  onEdgeRemove: _react.PropTypes.func.isRequired,
	
	  canPreviewNode: _react.PropTypes.bool,
	  previewingNode: _react.PropTypes.bool,
	  previewingNodeId: _react.PropTypes.string,
	
	  disableModifications: _react.PropTypes.bool,
	  editNodesOnMount: _react.PropTypes.bool
	};

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(121);
	
	var _reactDndHtml5Backend = __webpack_require__(175);
	
	var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _Common = __webpack_require__(11);
	
	var _shallowequal = __webpack_require__(100);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _Viewport = __webpack_require__(604);
	
	var _ProjectScene = __webpack_require__(600);
	
	var _ProjectScene2 = _interopRequireDefault(_ProjectScene);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(504);
	
	var ProjectView = (_dec = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default), _dec(_class = (0, _Viewport.windowDimensions)(_class = function (_Component) {
	  _inherits(ProjectView, _Component);
	
	  function ProjectView(props, context) {
	    _classCallCheck(this, ProjectView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectView).call(this, props, context));
	
	    if (props.previewingNode && props.previewingNodeId && props.data && props.data.nodesData) {
	      var _props$data$nodesData = props.data.nodesData[props.previewingNodeId];
	      var x = _props$data$nodesData.x;
	      var y = _props$data$nodesData.y;
	
	      _this.state = { viewportX: x, viewportY: y };
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (props.previewingProject || props.viewingProject) {
	      var x = props.initSceneX || 0;
	      var y = props.initSceneY || 0;
	      _this.state = { viewportX: x, viewportY: y };
	      return _possibleConstructorReturn(_this);
	    }
	
	    _this.state = {
	      viewportX: props.initSceneX || 0,
	      viewportY: props.initSceneY || 0
	    };
	    return _this;
	  }
	
	  _createClass(ProjectView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ showing: true });
	    }
	  }, {
	    key: 'handleEdgeConnectionRequest',
	    value: function handleEdgeConnectionRequest(fromId, toId) {
	      this.props.onEdgeConnectionRequest(fromId, toId);
	    }
	  }, {
	    key: 'handleEdgeRemove',
	    value: function handleEdgeRemove(edgeId) {
	      this.props.onEdgeRemove(edgeId);
	    }
	  }, {
	    key: 'handleNodeRemove',
	    value: function handleNodeRemove(id) {
	      this.props.onNodeRemove(id);
	    }
	  }, {
	    key: 'handleNodeDataUpdate',
	    value: function handleNodeDataUpdate(id, data) {
	      // TODO DE_BIND
	      this.props.onNodeUpdate(id, data);
	    }
	  }, {
	    key: 'handleNodesDataUpdate',
	    value: function handleNodesDataUpdate(nodesIds, nodesData) {
	      this.props.onNodesUpdate(nodesIds, nodesData);
	    }
	  }, {
	    key: 'handleNodeDetach',
	    value: function handleNodeDetach(id) {
	      this.props.onNodeDetach(id);
	    }
	  }, {
	    key: 'handleNodeAppendNew',
	    value: function handleNodeAppendNew(id) {
	      this.props.onNodeAppendNew(id);
	    }
	  }, {
	    key: 'handleNodeAppendRightConnected',
	    value: function handleNodeAppendRightConnected(id, _ref) {
	      var x = _ref.x;
	      var y = _ref.y;
	
	      this.props.onNodeAppendRightConnected(id, { x: x, y: y });
	    }
	  }, {
	    key: 'handleNodeAppendBottomConnected',
	    value: function handleNodeAppendBottomConnected(id, _ref2) {
	      var x = _ref2.x;
	      var y = _ref2.y;
	
	      this.props.onNodeAppendBottomConnected(id, { x: x, y: y });
	    }
	  }, {
	    key: 'handleNodeAppendRight',
	    value: function handleNodeAppendRight(id, _ref3) {
	      var x = _ref3.x;
	      var y = _ref3.y;
	
	      this.props.onNodeAppendRight(id, { x: x, y: y });
	    }
	  }, {
	    key: 'getViewportPosition',
	    value: function getViewportPosition() {
	      return this.refs.viewport.getPosition();
	    }
	  }, {
	    key: 'handleNodePreview',
	    value: function handleNodePreview(nodeId) {
	      var _this2 = this;
	
	      var nodesData = this.props.data.nodesData;
	      var _nodesData$nodeId = nodesData[nodeId];
	      var nodeX = _nodesData$nodeId.x;
	      var nodeY = _nodesData$nodeId.y;
	
	      this.props.onNodePreview(nodeId);
	      this.props.onViewportPositionChange({ x: nodeX, y: nodeY });
	      (0, _raf2.default)(function () {
	        return _this2.setState({ viewportX: nodeX, viewportY: nodeY });
	      });
	    }
	  }, {
	    key: 'handlePositionChange',
	    value: function handlePositionChange(_ref4) {
	      var x = _ref4.x;
	      var y = _ref4.y;
	
	      this.setState({ viewportX: x, viewportY: y });
	      this.props.onViewportPositionChange({ x: x, y: y });
	    }
	  }, {
	    key: 'handleViewportPositionChange',
	    value: function handleViewportPositionChange(pos) {
	      this.handlePositionChange(pos);
	    }
	  }, {
	    key: 'handleViewportDragStart',
	    value: function handleViewportDragStart() {
	      this.props.onViewportDragStart();
	    }
	  }, {
	    key: 'handleViewportDragStop',
	    value: function handleViewportDragStop() {
	      this.props.onViewportDragStop();
	    }
	  }, {
	    key: 'getScenePosition',
	    value: function getScenePosition() {
	      // shift the scene if previewing
	      var _props = this.props;
	      var previewingProject = _props.previewingProject;
	      var viewingUser = _props.viewingUser;
	      var previewingNode = _props.previewingNode;
	      var previewingNodeId = _props.previewingNodeId;
	      var viewingNode = _props.viewingNode;
	      var windowWidth = _props.windowWidth;
	      var nodesData = _props.data.nodesData;
	      var _state = this.state;
	      var viewportX = _state.viewportX;
	      var viewportY = _state.viewportY;
	
	
	      if (previewingNode && previewingNodeId || viewingNode) {
	        var _nodesData$previewing = nodesData[previewingNodeId];
	        var nodeX = _nodesData$previewing.x;
	        var nodeY = _nodesData$previewing.y;
	
	        return { x: Math.round(nodeX + windowWidth / 4), y: nodeY };
	      }
	
	      if (previewingProject || viewingUser) {
	        var x = this.props.initSceneX || 0;
	        var y = this.props.initSceneY || 0;
	
	        return { x: x - windowWidth / 4, y: y };
	      }
	
	      return { x: viewportX, y: viewportY };
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty() {
	      var nodesData = this.props.data.nodesData;
	
	      if ((0, _shallowequal2.default)(nodesData, {})) return true;
	      if (!nodesData) return true;
	      return false;
	    }
	  }, {
	    key: 'getEmptyView',
	    value: function getEmptyView() {
	      var RemoveLink = _react2.default.createElement(
	        _Common.PseudoLink,
	        {
	          onClick: this.props.onProjectDelete,
	          danger: true
	        },
	        'remove the project'
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: styles.emptyView },
	        _react2.default.createElement(
	          'div',
	          { className: styles.caption },
	          'You\'ve just deleted the last record in your project. Don\'t leave it like that.',
	          _react2.default.createElement('br', null),
	          'Click the button below to add something again or ',
	          RemoveLink,
	          '.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var data = _props2.data;
	      var viewingProject = _props2.viewingProject;
	      var previewingNode = _props2.previewingNode;
	      var previewingNodeId = _props2.previewingNodeId;
	      var previewingProject = _props2.previewingProject;
	      var windowWidth = _props2.windowWidth;
	      var windowHeight = _props2.windowHeight;
	      var canPreviewNode = _props2.canPreviewNode;
	      var disableModifications = _props2.disableModifications;
	      var editNodesOnMount = _props2.editNodesOnMount;
	
	
	      if (this.isEmpty()) return this.getEmptyView();
	
	      var graph = data.graph;
	      var nodesData = data.nodesData;
	
	
	      var classname = (0, _classnames2.default)(styles.projectView, previewingNode && styles.previewingNode, previewingProject && styles.noPointerEvents);
	
	      var _getScenePosition = this.getScenePosition();
	
	      var x = _getScenePosition.x;
	      var y = _getScenePosition.y;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: classname },
	        _react2.default.createElement(
	          'div',
	          {
	            style: { width: windowWidth, height: windowHeight },
	            className: styles.viewport
	          },
	          _react2.default.createElement(
	            _Viewport.DraggableViewport,
	            {
	              ref: 'viewport',
	              softWhenNotDragging: true,
	              initSceneX: x, initSceneY: y,
	              sendPositionChange: viewingProject,
	              onDragStart: this.handleViewportDragStart.bind(this),
	              onDragStop: this.handleViewportDragStop.bind(this),
	              onPositionChange: this.handleViewportPositionChange.bind(this)
	            },
	            _react2.default.createElement(_ProjectScene2.default, {
	              canPreviewNode: canPreviewNode,
	              previewingNode: previewingNode,
	              previewingNodeId: previewingNodeId,
	              onNodeDataUpdate: this.handleNodeDataUpdate.bind(this),
	              onNodesDataUpdate: this.handleNodesDataUpdate.bind(this),
	              onNodeRemove: this.handleNodeRemove.bind(this),
	              onEdgeRemove: this.handleEdgeRemove.bind(this),
	              onNodePreview: this.handleNodePreview.bind(this),
	              onNodeDetach: this.handleNodeDetach.bind(this),
	              onNodeAppendNew: this.handleNodeAppendNew.bind(this),
	              onNodeAppendRightConnected: this.handleNodeAppendRightConnected.bind(this),
	              onNodeAppendBottomConnected: this.handleNodeAppendBottomConnected.bind(this),
	              onNodeAppendRight: this.handleNodeAppendRight.bind(this),
	              onEdgeConnectionRequest: this.handleEdgeConnectionRequest.bind(this),
	              graphData: graph,
	              nodesData: nodesData,
	              disableModifications: disableModifications,
	              editNodesOnMount: editNodesOnMount
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectView;
	}(_react.Component)) || _class) || _class);
	exports.default = ProjectView;
	
	
	ProjectView.propTypes = {
	  data: _react.PropTypes.object,
	
	  onNodeUpdate: _react.PropTypes.func.isRequired,
	  onNodesUpdate: _react.PropTypes.func.isRequired,
	  onNodeRemove: _react.PropTypes.func.isRequired,
	  onNodeDetach: _react.PropTypes.func.isRequired,
	  onNodeAppendNew: _react.PropTypes.func.isRequired,
	  onNodeAppendRight: _react.PropTypes.func.isRequired,
	  onNodeAppendRightConnected: _react.PropTypes.func.isRequired,
	  onNodeAppendBottomConnected: _react.PropTypes.func.isRequired,
	
	  onEdgeRemove: _react.PropTypes.func.isRequired,
	  onEdgeConnectionRequest: _react.PropTypes.func.isRequired,
	
	  onProjectDelete: _react.PropTypes.func.isRequired,
	
	  connectDropTarget: _react.PropTypes.func,
	  isNodeOver: _react.PropTypes.bool,
	
	  onViewportPositionChange: _react.PropTypes.func.isRequired,
	  initSceneX: _react.PropTypes.number.isRequired,
	  initSceneY: _react.PropTypes.number.isRequired,
	
	  previewingProject: _react.PropTypes.bool,
	  viewingUser: _react.PropTypes.bool,
	  viewingNode: _react.PropTypes.bool,
	
	  canPreviewNode: _react.PropTypes.bool,
	  previewingNode: _react.PropTypes.bool,
	  previewingNodeId: _react.PropTypes.string,
	
	  disableModifications: _react.PropTypes.bool,
	  editNodesOnMount: _react.PropTypes.bool,
	
	  onViewportDragStart: _react.PropTypes.func.isRequired,
	  onViewportDragStop: _react.PropTypes.func.isRequired,
	
	  windowWidth: _react.PropTypes.number
	};

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClickdrag = __webpack_require__(916);
	
	var _reactClickdrag2 = _interopRequireDefault(_reactClickdrag);
	
	var _reactDom = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(505);
	
	var DragArea = function (_Component) {
	  _inherits(DragArea, _Component);
	
	  function DragArea(props) {
	    _classCallCheck(this, DragArea);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DragArea).call(this, props));
	
	    _this.state = {
	      x: props.initX || 0,
	      y: props.initY || 0,
	      lastX: props.initX || 0,
	      lastY: props.initY || 0
	    };
	    return _this;
	  }
	
	  _createClass(DragArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.preventDefault) {
	        var node = (0, _reactDom.findDOMNode)(this);
	        node.addEventListener('mousedown', function (e) {
	          e.preventDefault();
	        });
	
	        /*
	        node.addEventListener('click', e => {
	          const { moveDeltaX, moveDeltaY } = this.props.dataDrag;
	          console.log({...this.props.dataDrag});
	           if ((moveDeltaY !== 0) || (moveDeltaX !== 0)) {
	            e.stopPropagation();
	          }
	        });
	        */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var dataDragChanged = nextProps.dataDrag !== this.props.dataDrag;
	      var willMove = nextProps.dataDrag.isMoving;
	      var moving = this.props.dataDrag.isMoving;
	      var mouseDown = this.props.dataDrag.isMouseDown;
	
	      if (dataDragChanged) {
	        if (!this.props.dataDrag.isMoving && nextProps.dataDrag.isMoving) {
	          this.notifyDragStart();
	        }
	        if (this.props.dataDrag.isMouseDown && !nextProps.dataDrag.isMouseDown) {
	          this.notifyDragStop();
	        }
	
	        var _state = this.state;
	        var x = _state.x;
	        var y = _state.y;
	        var lastX = _state.lastX;
	        var lastY = _state.lastY;
	
	
	        if (willMove) {
	          var dx = nextProps.dataDrag.moveDeltaX;
	          var dy = nextProps.dataDrag.moveDeltaY;
	
	          var _getShiftedCoordinate = this.getShiftedCoordinates({ lastX: lastX, lastY: lastY, dx: dx, dy: dy });
	
	          var newX = _getShiftedCoordinate.newX;
	          var newY = _getShiftedCoordinate.newY;
	
	
	          this.setState({ x: newX, y: newY });
	          this.props.onDrag({ x: newX, y: newY });
	        } else {
	          this.setState({ lastX: x, lastY: y });
	        }
	      } else {
	        var initX = nextProps.initX;
	        var initY = nextProps.initY;
	        var _props = this.props;
	        var oldInitX = _props.initX;
	        var oldInitY = _props.initY;
	
	
	        if (initX !== oldInitX || initY !== oldInitY) {
	          // if init coords have changed
	          this.setState({
	            x: initX, y: initY,
	            lastX: initX, lastY: initY
	          });
	          this.props.onDrag({ x: initX, y: initY });
	        }
	      }
	
	      if (mouseDown && !moving) {
	        this.setLastCoords(nextProps.lastX, nextProps.lastY);
	      }
	    }
	  }, {
	    key: 'getShiftedCoordinates',
	    value: function getShiftedCoordinates(_ref) {
	      var lastX = _ref.lastX;
	      var lastY = _ref.lastY;
	      var dx = _ref.dx;
	      var dy = _ref.dy;
	      var reversed = this.props.reversed;
	
	
	      var newX = undefined;
	      var newY = undefined;
	
	      if (!reversed) {
	        newX = lastX + dx;
	        newY = lastY + dy;
	      } else {
	        newX = lastX - dx;
	        newY = lastY - dy;
	      }
	
	      return { newX: newX, newY: newY };
	    }
	  }, {
	    key: 'setLastCoords',
	    value: function setLastCoords(lastX, lastY) {
	      if (!this.props.traceLast) return;
	      this.setState({ lastX: lastX, lastY: lastY });
	    }
	  }, {
	    key: 'notifyDragStart',
	    value: function notifyDragStart() {
	      if (this.props.onDragStart) this.props.onDragStart();
	    }
	  }, {
	    key: 'notifyDragStop',
	    value: function notifyDragStop() {
	      if (this.props.onDragStop) this.props.onDragStop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.dragArea },
	        this.props.children
	      );
	    }
	  }]);
	
	  return DragArea;
	}(_react.Component);
	
	var dragConfig = {
	  onDragStart: function onDragStart() {
	    if (document) {
	      document.body.style.cursor = 'move';
	    }
	  },
	  onDragStop: function onDragStop() {
	    if (document) {
	      document.body.style.cursor = '';
	    }
	  }
	};
	
	exports.default = (0, _reactClickdrag2.default)(DragArea, dragConfig);
	
	
	DragArea.propTypes = {
	  initX: _react.PropTypes.number.isRequired,
	  initY: _react.PropTypes.number.isRequired,
	  onDrag: _react.PropTypes.func.isRequired,
	  onDragStart: _react.PropTypes.func,
	  onDragStop: _react.PropTypes.func,
	
	  children: _react.PropTypes.any.isRequired,
	  dataDrag: _react.PropTypes.object,
	  preventDefault: _react.PropTypes.bool,
	  traceLast: _react.PropTypes.bool
	};

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Viewport = __webpack_require__(220);
	
	var _Viewport2 = _interopRequireDefault(_Viewport);
	
	var _DragArea = __webpack_require__(602);
	
	var _DragArea2 = _interopRequireDefault(_DragArea);
	
	var _reactMotion = __webpack_require__(971);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* injects from baggage-loader */
	
	var SPRING_CONFIG = [800, 80];
	var SPRING_SOFT_CONFIG = [120, 20];
	
	var DraggableViewport = function (_Component) {
	  _inherits(DraggableViewport, _Component);
	
	  function DraggableViewport(props) {
	    _classCallCheck(this, DraggableViewport);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DraggableViewport).call(this, props));
	
	    _this.state = {
	      dragging: false,
	      x: props.initSceneX || 0,
	      y: props.initSceneY || 0
	    };
	
	    return _this;
	  }
	
	  _createClass(DraggableViewport, [{
	    key: 'handleDragStart',
	    value: function handleDragStart() {
	      this.setState({ dragging: true });
	      this.props.onDragStart();
	    }
	  }, {
	    key: 'handleDrag',
	    value: function handleDrag(_ref) {
	      var x = _ref.x;
	      var y = _ref.y;
	
	      this.setState({ x: x, y: y });
	    }
	  }, {
	    key: 'onPositionChange',
	    value: function onPositionChange(pos) {
	      if (this.props.sendPositionChange && this.props.onPositionChange) this.props.onPositionChange(pos);
	    }
	  }, {
	    key: 'handleDragStop',
	    value: function handleDragStop() {
	      var _state = this.state;
	      var x = _state.x;
	      var y = _state.y;
	
	      this.setState({ dragging: false });
	      this.onPositionChange({ x: x, y: y });
	      this.props.onDragStop();
	    }
	  }, {
	    key: 'getPosition',
	    value: function getPosition() {
	      var _state2 = this.state;
	      var x = _state2.x;
	      var y = _state2.y;
	
	      return { x: x, y: y };
	    }
	  }, {
	    key: 'getSpringConfig',
	    value: function getSpringConfig() {
	      if (this.state.dragging) {
	        return SPRING_CONFIG;
	      }
	      return SPRING_SOFT_CONFIG;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state3 = this.state;
	      var x = _state3.x;
	      var y = _state3.y;
	      var _props = this.props;
	      var initSceneX = _props.initSceneX;
	      var initSceneY = _props.initSceneY;
	
	
	      var springConfig = this.getSpringConfig();
	
	      return _react2.default.createElement(
	        _DragArea2.default,
	        {
	          initX: initSceneX,
	          initY: initSceneY,
	          onDrag: this.handleDrag.bind(this),
	          onDragStop: this.handleDragStop.bind(this),
	          onDragStart: this.handleDragStart.bind(this),
	          preventDefault: true,
	          reversed: true
	        },
	        _react2.default.createElement(
	          _reactMotion.Motion,
	          { defaultStyle: { x: initSceneX, y: initSceneY },
	            style: { x: (0, _reactMotion.spring)(x, springConfig), y: (0, _reactMotion.spring)(y, springConfig) } },
	          function (value) {
	            return _react2.default.createElement(
	              _Viewport2.default,
	              { x: Math.round(value.x), y: Math.round(value.y) /* truncate coords for svg rendering */ },
	              _this2.props.children
	            );
	          }
	        )
	      );
	    }
	  }]);
	
	  return DraggableViewport;
	}(_react.Component);
	
	exports.default = DraggableViewport;
	
	
	DraggableViewport.propTypes = {
	  initSceneX: _react.PropTypes.number.isRequired,
	  initSceneY: _react.PropTypes.number.isRequired,
	  children: _react.PropTypes.any.isRequired,
	  soft: _react.PropTypes.bool,
	  sendPositionChange: _react.PropTypes.bool,
	
	  onPositionChange: _react.PropTypes.func,
	
	  onDragStart: _react.PropTypes.func.isRequired,
	  onDragStop: _react.PropTypes.func.isRequired
	};

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.windowDimensions = exports.DraggableViewport = undefined;
	
	var _Viewport = __webpack_require__(220);
	
	var _Viewport2 = _interopRequireDefault(_Viewport);
	
	var _DraggableViewport = __webpack_require__(603);
	
	var _DraggableViewport2 = _interopRequireDefault(_DraggableViewport);
	
	var _windowDimensions = __webpack_require__(605);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Viewport2.default;
	/* injects from baggage-loader */
	
	exports.DraggableViewport = _DraggableViewport2.default;
	exports.windowDimensions = _windowDimensions2.default;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = windowDimensions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _raf = __webpack_require__(42);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* injects from baggage-loader */
	
	function windowDimensions(DecoratedComponent) {
	  return function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(_class).call(this, props, context));
	
	      _this.state = {
	        windowWidth: window.innerWidth,
	        windowHeight: window.innerHeight
	      };
	
	      _this.rafResize = function () {
	        return (0, _raf2.default)(_this.handleResize.bind(_this));
	      };
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this.rafResize);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.rafResize);
	      }
	    }, {
	      key: 'handleResize',
	      value: function handleResize() {
	        this.setState({
	          windowWidth: window.innerWidth,
	          windowHeight: window.innerHeight
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(DecoratedComponent, _extends({
	          windowWidth: this.windowWidth,
	          windowHeight: this.windowHeight
	        }, this.state, this.props));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component);
	}

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEdgesCoordinates = exports.getEdgeCoordinates = exports.getRectMidPoints = undefined;
	
	var _pureGraph = __webpack_require__(34);
	
	var _is = __webpack_require__(157);
	
	var _is2 = _interopRequireDefault(_is);
	
	var _utils = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// get rectangle midpoints, with normal vectors
	var getRectMidPoints = exports.getRectMidPoints = function getRectMidPoints(x, y, w, h) {
	  return [{ x: x - w / 2, y: y, nx: -1, ny: +0 }, { x: x, y: y + h / 2, nx: +0, ny: +1 }, { x: x + w / 2, y: y, nx: +1, ny: +0 }, { x: x, y: y - h / 2, nx: +0, ny: -1 }];
	};
	/* injects from baggage-loader */
	
	var getEdgeCoordinates = exports.getEdgeCoordinates = function getEdgeCoordinates(_ref) {
	  var edge = _ref.edge;
	  var nodeFrom = _ref.nodeFrom;
	  var nodeTo = _ref.nodeTo;
	  var rectFrom = _ref.rectFrom;
	  var rectTo = _ref.rectTo;
	  var fromX = nodeFrom.x;
	  var fromY = nodeFrom.y;
	  var toX = nodeTo.x;
	  var toY = nodeTo.y;
	  var fromWidth = rectFrom.width;
	  var fromHeight = rectFrom.height;
	  var toWidth = rectTo.width;
	  var toHeight = rectTo.height;
	
	  // get midpoints
	
	  var fromMidPoints = getRectMidPoints(fromX, fromY, fromWidth, fromHeight);
	  var toMidPoints = getRectMidPoints(toX, toY, toWidth, toHeight);
	
	  // get closest pair of midpoints
	  var closestPair = (0, _utils.getClosestPair)(fromMidPoints, toMidPoints);
	
	  var p1 = closestPair.p1;
	  var _closestPair$p = closestPair.p1;
	  var startX = _closestPair$p.x;
	  var startY = _closestPair$p.y;
	  var p2 = closestPair.p2;
	  var _closestPair$p2 = closestPair.p2;
	  var endX = _closestPair$p2.x;
	  var endY = _closestPair$p2.y;
	
	  // calculate direction vectors (for bezier curves)
	
	  var weightedWidth = Math.abs(endX - startX) * 0.5;
	  var weightedHeight = Math.abs(endY - startY) * 0.5;
	
	  var startDirX = startX + p1.nx * weightedWidth;
	  var startDirY = startY + p1.ny * weightedHeight;
	
	  var endDirX = endX + p2.nx * weightedWidth;
	  var endDirY = endY + p2.ny * weightedHeight;
	
	  return { startX: startX, startY: startY, startDirX: startDirX, startDirY: startDirY, endDirX: endDirX, endDirY: endDirY, endX: endX, endY: endY, id: edge.id };
	};
	
	var getEdgesCoordinates = exports.getEdgesCoordinates = function getEdgesCoordinates(nodeRects, graphData, nodesData) {
	  return (0, _pureGraph.getEdges)(graphData).map(function (edge) {
	    var fromId = edge.from;
	    var toId = edge.to;
	
	
	    var rectFrom = nodeRects[fromId];
	    var rectTo = nodeRects[toId];
	
	    var nodeFrom = nodesData[fromId];
	    var nodeTo = nodesData[toId];
	
	    return { edge: edge, rectFrom: rectFrom, rectTo: rectTo, nodeFrom: nodeFrom, nodeTo: nodeTo };
	  }).filter(function (_ref2) {
	    var rectFrom = _ref2.rectFrom;
	    var rectTo = _ref2.rectTo;
	    return _is2.default.defined(rectFrom) && _is2.default.defined(rectTo);
	  }).map(function (_ref3) {
	    var edge = _ref3.edge;
	    var nodeFrom = _ref3.nodeFrom;
	    var nodeTo = _ref3.nodeTo;
	    var rectFrom = _ref3.rectFrom;
	    var rectTo = _ref3.rectTo;
	    return getEdgeCoordinates({
	      edge: edge,
	      nodeFrom: nodeFrom,
	      nodeTo: nodeTo,
	      rectFrom: rectFrom,
	      rectTo: rectTo
	    });
	  });
	};

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _component = __webpack_require__(123);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ProjectsListItem = __webpack_require__(221);
	
	var _ProjectsListItem2 = _interopRequireDefault(_ProjectsListItem);
	
	var _Spinner = __webpack_require__(137);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(507);
	
	var ProjectList = (_temp = _class = function (_Component) {
	  _inherits(ProjectList, _Component);
	
	  function ProjectList() {
	    _classCallCheck(this, ProjectList);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectList).apply(this, arguments));
	  }
	
	  _createClass(ProjectList, [{
	    key: 'render',
	    value: function render() {
	      var projects = this.props.projects;
	
	
	      if (!projects) {
	        return _react2.default.createElement(_Spinner2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _lodash2.default.map(this.props.projects, function (project) {
	          return _react2.default.createElement(
	            'div',
	            { key: project.id },
	            _react2.default.createElement(_ProjectsListItem2.default, { project: project })
	          );
	        })
	      );
	    }
	  }]);
	
	  return ProjectList;
	}(_component2.default), _class.propTypes = {
	  projects: _react.PropTypes.array
	}, _temp);
	exports.default = ProjectList;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* injects from baggage-loader */
	
	var EDGE_WIDTH = 1;
	
	var StaticEdgeView = function (_Component) {
	  _inherits(StaticEdgeView, _Component);
	
	  function StaticEdgeView() {
	    _classCallCheck(this, StaticEdgeView);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StaticEdgeView).apply(this, arguments));
	  }
	
	  _createClass(StaticEdgeView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var startX = _props.startX;
	      var startY = _props.startY;
	      var endX = _props.endX;
	      var endY = _props.endY;
	      var startDirX = _props.startDirX;
	      var startDirY = _props.startDirY;
	      var endDirX = _props.endDirX;
	      var endDirY = _props.endDirY;
	      var color = _props.color;
	
	
	      return _react2.default.createElement('path', {
	        d: 'M ' + startX + ' ' + startY + ' C ' + startDirX + ' ' + startDirY + ' ' + endDirX + ' ' + endDirY + ' ' + endX + ' ' + endY,
	        strokeWidth: EDGE_WIDTH,
	        stroke: color,
	        fill: 'none'
	      });
	    }
	  }]);
	
	  return StaticEdgeView;
	}(_react.Component);
	
	exports.default = StaticEdgeView;
	
	
	StaticEdgeView.propTypes = {
	  startX: _react.PropTypes.number.isRequired,
	  startY: _react.PropTypes.number.isRequired,
	  endX: _react.PropTypes.number.isRequired,
	  endY: _react.PropTypes.number.isRequired,
	
	  startDirX: _react.PropTypes.number.isRequired,
	  startDirY: _react.PropTypes.number.isRequired,
	  endDirX: _react.PropTypes.number.isRequired,
	  endDirY: _react.PropTypes.number.isRequired,
	  color: _react.PropTypes.string.isRequired
	};

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MultilineText = __webpack_require__(612);
	
	var _MultilineText2 = _interopRequireDefault(_MultilineText);
	
	var _color = __webpack_require__(234);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _constants = __webpack_require__(223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* injects from baggage-loader */
	
	var isBright = function isBright(color) {
	  return (0, _color2.default)(color).light();
	};
	
	var StaticNodeView = function (_Component) {
	  _inherits(StaticNodeView, _Component);
	
	  function StaticNodeView() {
	    _classCallCheck(this, StaticNodeView);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StaticNodeView).apply(this, arguments));
	  }
	
	  _createClass(StaticNodeView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var id = _props.id;
	      var color = _props.color;
	      var width = _props.width;
	      var height = _props.height;
	      var caption = _props.caption;
	
	
	      var rectWidth = width;
	      var rectHeight = height;
	
	      var halfRectWidth = rectWidth / 2;
	      var halfRectHeight = rectHeight / 2;
	
	      var isLight = isBright(color);
	
	      return _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + -halfRectWidth + ', ' + -halfRectHeight + ')' },
	        _react2.default.createElement('rect', {
	          key: 'node-' + id,
	          width: rectWidth, height: rectHeight,
	          x: 0, y: 0,
	          rx: _constants.NODE_BORDER_RADIUS,
	          ry: _constants.NODE_BORDER_RADIUS,
	
	          fill: color
	        }),
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(' + _constants.NODE_PADDING_HORIZONTAL + ', 8)' },
	          _react2.default.createElement(_MultilineText2.default, {
	            text: caption,
	            maxWidth: _constants.NODE_MAX_WIDTH,
	            color: isLight ? 'black' : 'white'
	          })
	        )
	      );
	    }
	  }]);
	
	  return StaticNodeView;
	}(_react.Component);
	
	exports.default = StaticNodeView;
	
	
	StaticNodeView.propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  color: _react.PropTypes.string.isRequired,
	  caption: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired
	};

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	/*
	
	    Given project data & nodes rects, returns a rendered graph
	
	*/
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureGraph = __webpack_require__(34);
	
	var _StaticNodeView = __webpack_require__(609);
	
	var _StaticNodeView2 = _interopRequireDefault(_StaticNodeView);
	
	var _StaticEdgeView = __webpack_require__(608);
	
	var _StaticEdgeView2 = _interopRequireDefault(_StaticEdgeView);
	
	var _computational = __webpack_require__(613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// rendering nodes
	
	var renderNode = function renderNode(_ref) {
	  var id = _ref.id;
	  var x = _ref.x;
	  var y = _ref.y;
	  var width = _ref.width;
	  var height = _ref.height;
	  var color = _ref.color;
	  var caption = _ref.caption;
	
	  var tx = Math.round(x);
	  var ty = Math.round(y);
	
	  return _react2.default.createElement(
	    'g',
	    { key: id, transform: 'translate(' + tx + ', ' + ty + ')' },
	    _react2.default.createElement(_StaticNodeView2.default, {
	      id: id, width: width, height: height, color: color, caption: caption
	    })
	  );
	};
	
	var renderNodes = function renderNodes(nodes, rects) {
	  return nodes.map(function (node) {
	    var id = node.id;
	    var data = node.data;
	    var _rects$id = rects[id];
	    var width = _rects$id.width;
	    var height = _rects$id.height;
	
	
	    return renderNode(_extends({}, data, { id: id, width: width, height: height }));
	  });
	};
	
	// rendering edges
	
	var renderEdge = function renderEdge(_ref2) {
	  var id = _ref2.id;
	  var color = _ref2.color;
	  var startX = _ref2.startX;
	  var startY = _ref2.startY;
	  var endX = _ref2.endX;
	  var endY = _ref2.endY;
	  var startDirX = _ref2.startDirX;
	  var startDirY = _ref2.startDirY;
	  var endDirX = _ref2.endDirX;
	  var endDirY = _ref2.endDirY;
	
	  return _react2.default.createElement(_StaticEdgeView2.default, _extends({
	    key: id,
	    color: color
	  }, { startX: startX, startY: startY, endX: endX, endY: endY, startDirX: startDirX, startDirY: startDirY, endDirX: endDirX, endDirY: endDirY }));
	};
	
	var renderEdges = function renderEdges(edges, nodesData, nodesRects) {
	  return edges.map(function (edge) {
	    var id = edge.id;
	    var from = edge.from;
	    var to = edge.to;
	    var _nodesData$from = nodesData[from];
	    var fromX = _nodesData$from.x;
	    var fromY = _nodesData$from.y;
	    var _nodesData$to = nodesData[to];
	    var toX = _nodesData$to.x;
	    var toY = _nodesData$to.y;
	    var _nodesRects$from = nodesRects[from];
	    var fromWidth = _nodesRects$from.width;
	    var fromHeight = _nodesRects$from.height;
	    var _nodesRects$to = nodesRects[to];
	    var toWidth = _nodesRects$to.width;
	    var toHeight = _nodesRects$to.height;
	
	    var _getEdgeCoordinates = (0, _computational.getEdgeCoordinates)({ fromX: fromX, fromY: fromY, toX: toX, toY: toY, fromWidth: fromWidth, fromHeight: fromHeight, toWidth: toWidth, toHeight: toHeight });
	
	    var startX = _getEdgeCoordinates.startX;
	    var startY = _getEdgeCoordinates.startY;
	    var endX = _getEdgeCoordinates.endX;
	    var endY = _getEdgeCoordinates.endY;
	    var startDirX = _getEdgeCoordinates.startDirX;
	    var startDirY = _getEdgeCoordinates.startDirY;
	    var endDirX = _getEdgeCoordinates.endDirX;
	    var endDirY = _getEdgeCoordinates.endDirY;
	    var edgeColor = nodesData[to].color;
	
	
	    return renderEdge({
	      id: id, color: edgeColor,
	      startX: startX, startY: startY,
	      endX: endX, endY: endY,
	      startDirX: startDirX, startDirY: startDirY,
	      endDirX: endDirX, endDirY: endDirY
	    });
	  });
	};
	
	var StaticProjectView = (_temp = _class = function (_Component) {
	  _inherits(StaticProjectView, _Component);
	
	  function StaticProjectView() {
	    _classCallCheck(this, StaticProjectView);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StaticProjectView).apply(this, arguments));
	  }
	
	  _createClass(StaticProjectView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var graph = _props.graph;
	      var nodesData = _props.nodesData;
	      var nodesRects = _props.nodesRects;
	      var viewWidth = _props.viewWidth;
	      var viewHeight = _props.viewHeight;
	      var viewX = _props.viewX;
	      var viewY = _props.viewY;
	
	
	      var nodes = (0, _pureGraph.getNodes)(graph);
	      var mappedNodesData = nodes.map(function (id) {
	        return { id: id, data: nodesData[id] };
	      });
	
	      var edges = (0, _pureGraph.getEdges)(graph);
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: viewWidth,
	          height: viewHeight
	        },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(' + viewX + ', ' + viewY + ')' },
	          renderEdges(edges, nodesData, nodesRects),
	          renderNodes(mappedNodesData, nodesRects)
	        )
	      );
	    }
	  }]);
	
	  return StaticProjectView;
	}(_react.Component), _class.propTypes = {
	  graph: _react.PropTypes.object.isRequired,
	  nodesData: _react.PropTypes.object.isRequired,
	  nodesRects: _react.PropTypes.object.isRequired,
	
	  viewWidth: _react.PropTypes.number.isRequired,
	  viewHeight: _react.PropTypes.number.isRequired,
	  viewX: _react.PropTypes.number.isRequired,
	  viewY: _react.PropTypes.number.isRequired
	}, _temp);
	exports.default = StaticProjectView;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StaticProjectView = __webpack_require__(610);
	
	var _StaticProjectView2 = _interopRequireDefault(_StaticProjectView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticProjectView2.default;
	/* injects from baggage-loader */

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	/* injects from baggage-loader */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _measureText2 = __webpack_require__(140);
	
	var _measureText3 = _interopRequireDefault(_measureText2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultilineText = (_temp = _class = function (_Component) {
	  _inherits(MultilineText, _Component);
	
	  function MultilineText() {
	    _classCallCheck(this, MultilineText);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(MultilineText).apply(this, arguments));
	  }
	
	  _createClass(MultilineText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var text = _props.text;
	      var color = _props.color;
	      var maxWidth = _props.maxWidth;
	      var fontFamily = _props.fontFamily;
	      var fontSize = _props.fontSize;
	      var lineHeight = _props.lineHeight;
	
	      var _measureText = (0, _measureText3.default)({ text: text, maxWidth: maxWidth, fontFamily: fontFamily, fontSize: fontSize, lineHeight: lineHeight });
	
	      var lines = _measureText.lines;
	
	
	      return _react2.default.createElement(
	        'text',
	        { y: 0, fontFamily: fontFamily, fontSize: fontSize },
	        lines.map(function (line, index) {
	          return _react2.default.createElement(
	            'tspan',
	            {
	              fill: color, key: index, x: 0,
	              dy: index > 0 ? lineHeight : fontSize - 0.5
	            },
	            line.text
	          );
	        })
	      );
	    }
	  }]);
	
	  return MultilineText;
	}(_react.Component), _class.propTypes = {
	  text: _react.PropTypes.string.isRequired,
	
	  color: _react.PropTypes.string,
	  maxWidth: _react.PropTypes.number,
	  fontFamily: _react.PropTypes.string,
	  fontSize: _react.PropTypes.number,
	  lineHeight: _react.PropTypes.number
	}, _class.defaultProps = {
	  color: 'black',
	  maxWidth: +Infinity,
	  fontFamily: 'sans-serif',
	  fontSize: 14,
	  lineHeight: 14 * 1.3
	}, _temp);
	exports.default = MultilineText;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEdgesCoordinates = exports.getEdgeCoordinates = exports.getRectMidPoints = undefined;
	
	var _pureGraph = __webpack_require__(34);
	
	var _is = __webpack_require__(157);
	
	var _is2 = _interopRequireDefault(_is);
	
	var _utils = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// get rectangle midpoints, with normal vectors
	var getRectMidPoints = exports.getRectMidPoints = function getRectMidPoints(x, y, w, h) {
	  return [{ x: x - w / 2, y: y, nx: -1, ny: +0 }, { x: x, y: y + h / 2, nx: +0, ny: +1 }, { x: x + w / 2, y: y, nx: +1, ny: +0 }, { x: x, y: y - h / 2, nx: +0, ny: -1 }];
	};
	
	/*
	     returns the bezier curve edge coordinates
	*/
	
	/* injects from baggage-loader */
	
	var getEdgeCoordinates = exports.getEdgeCoordinates = function getEdgeCoordinates(_ref) {
	  var fromX = _ref.fromX;
	  var fromY = _ref.fromY;
	  var toX = _ref.toX;
	  var toY = _ref.toY;
	  var fromWidth = _ref.fromWidth;
	  var fromHeight = _ref.fromHeight;
	  var toWidth = _ref.toWidth;
	  var toHeight = _ref.toHeight;
	
	  // get midpoints
	  var fromMidPoints = getRectMidPoints(fromX, fromY, fromWidth, fromHeight);
	  var toMidPoints = getRectMidPoints(toX, toY, toWidth, toHeight);
	
	  // get closest pair of midpoints
	  var closestPair = (0, _utils.getClosestPair)(fromMidPoints, toMidPoints);
	
	  var p1 = closestPair.p1;
	  var _closestPair$p = closestPair.p1;
	  var startX = _closestPair$p.x;
	  var startY = _closestPair$p.y;
	  var p2 = closestPair.p2;
	  var _closestPair$p2 = closestPair.p2;
	  var endX = _closestPair$p2.x;
	  var endY = _closestPair$p2.y;
	
	  // calculate direction vectors (for bezier curves)
	
	  var weightedWidth = Math.abs(endX - startX) * 0.5;
	  var weightedHeight = Math.abs(endY - startY) * 0.5;
	
	  var startDirX = startX + p1.nx * weightedWidth;
	  var startDirY = startY + p1.ny * weightedHeight;
	
	  var endDirX = endX + p2.nx * weightedWidth;
	  var endDirY = endY + p2.ny * weightedHeight;
	
	  return { startX: startX, startY: startY, startDirX: startDirX, startDirY: startDirY, endDirX: endDirX, endDirY: endDirY, endX: endX, endY: endY };
	};
	
	var getEdgesCoordinates = exports.getEdgesCoordinates = function getEdgesCoordinates(nodeRects, graphData, nodesData) {
	  return (0, _pureGraph.getEdges)(graphData).map(function (edge) {
	    var fromId = edge.from;
	    var toId = edge.to;
	
	
	    var rectFrom = nodeRects[fromId];
	    var rectTo = nodeRects[toId];
	
	    var nodeFrom = nodesData[fromId];
	    var nodeTo = nodesData[toId];
	
	    return { edge: edge, rectFrom: rectFrom, rectTo: rectTo, nodeFrom: nodeFrom, nodeTo: nodeTo };
	  }).filter(function (_ref2) {
	    var rectFrom = _ref2.rectFrom;
	    var rectTo = _ref2.rectTo;
	    return _is2.default.defined(rectFrom) && _is2.default.defined(rectTo);
	  }).map(function (_ref3) {
	    var edge = _ref3.edge;
	    var nodeFrom = _ref3.nodeFrom;
	    var nodeTo = _ref3.nodeTo;
	    var rectFrom = _ref3.rectFrom;
	    var rectTo = _ref3.rectTo;
	    return getEdgeCoordinates({
	      edge: edge,
	      nodeFrom: nodeFrom,
	      nodeTo: nodeTo,
	      rectFrom: rectFrom,
	      rectTo: rectTo
	    });
	  });
	};

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectShareRenderer = __webpack_require__(219);
	
	var _projectStubbedData = __webpack_require__(628);
	
	var _projectStubbedData2 = _interopRequireDefault(_projectStubbedData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* injects from baggage-loader */
	
	// import { Base64 } from 'js-base64';
	
	var STUB_PROJECT = (0, _projectStubbedData2.default)();
	
	var authorName = 'Justin Biebah';
	var projectTitle = 'Мой очень классный проект';
	
	/*
	const imageBase64 = getProjectShareImage({
	  project: STUB_PROJECT,
	  authorName, projectTitle,
	  width: 1200,
	  height: 630
	});
	*/
	
	var width = 1200;
	var height = 630;
	
	var TestPage = function (_Component) {
	  _inherits(TestPage, _Component);
	
	  function TestPage() {
	    _classCallCheck(this, TestPage);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(TestPage).apply(this, arguments));
	  }
	
	  _createClass(TestPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ProjectShareRenderer.ProjectShareRenderer, {
	          project: STUB_PROJECT,
	          authorName: authorName,
	          projectTitle: projectTitle,
	          width: width,
	          height: height
	        })
	      );
	    }
	  }]);
	
	  return TestPage;
	}(_react.Component);
	
	exports.default = TestPage;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _Common = __webpack_require__(11);
	
	var _User = __webpack_require__(67);
	
	var _UserMenuFull = __webpack_require__(617);
	
	var _UserMenuFull2 = _interopRequireDefault(_UserMenuFull);
	
	var _UserMenuCompact = __webpack_require__(616);
	
	var _UserMenuCompact2 = _interopRequireDefault(_UserMenuCompact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(510);
	
	var getState = function getState(state) {
	  return {
	    authorizedUser: state.user.authorizedUser,
	    foreignUser: state.routing.foreignUser
	  };
	};
	
	var UserMenu = (_dec = (0, _reduxSimple.connect)(getState), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(UserMenu, _Component);
	
	  function UserMenu() {
	    _classCallCheck(this, UserMenu);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(UserMenu).call(this));
	
	    _this.state = {
	      menuOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(UserMenu, [{
	    key: 'openMenu',
	    value: function openMenu(e) {
	      if (e) {
	        e.stopPropagation();
	      }
	      this.setState({ menuOpen: true });
	    }
	  }, {
	    key: 'closeMenu',
	    value: function closeMenu(e) {
	      if (e) {
	        e.stopPropagation();
	      }
	      this.setState({ menuOpen: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var authorizedUser = _props.authorizedUser;
	      var foreignUser = _props.foreignUser;
	      var compact = _props.compact;
	
	      var className = (0, _classnames2.default)(styles.userMenuWrapper);
	
	      if (!authorizedUser) return null;
	
	      return _react2.default.createElement(
	        _Common.ActionIcon,
	        { right: true, smallShadow: true },
	        _react2.default.createElement(
	          'div',
	          { className: className },
	          _react2.default.createElement(
	            _User.UserPic,
	            { my: true, url: authorizedUser.avatarUrl, onClick: this.openMenu.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: styles.userMenuContainer },
	              compact ? _react2.default.createElement(_UserMenuCompact2.default, {
	                open: this.state.menuOpen,
	
	                foreignUser: foreignUser,
	                authorizedUser: authorizedUser,
	                onClose: this.closeMenu.bind(this)
	              }) : _react2.default.createElement(_UserMenuFull2.default, {
	                open: this.state.menuOpen,
	
	                foreignUser: foreignUser,
	                authorizedUser: authorizedUser,
	                onClose: this.closeMenu.bind(this)
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserMenu;
	}(_react.Component), _class2.propTypes = {
	  authorizedUser: _react.PropTypes.object,
	  foreignUser: _react.PropTypes.string,
	  compact: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = UserMenu;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(167);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactOnclickout = __webpack_require__(56);
	
	var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);
	
	var _Auth = __webpack_require__(66);
	
	var _Icons = __webpack_require__(17);
	
	var _Common = __webpack_require__(11);
	
	var _User = __webpack_require__(67);
	
	var _routing = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(511);
	
	var UserMenuFull = (_temp = _class = function (_Component) {
	  _inherits(UserMenuFull, _Component);
	
	  function UserMenuFull() {
	    _classCallCheck(this, UserMenuFull);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserMenuFull).apply(this, arguments));
	  }
	
	  _createClass(UserMenuFull, [{
	    key: 'getUserContent',
	    value: function getUserContent() {
	      var authorizedUser = this.props.authorizedUser;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(styles.userContent, this.props.withMyPageLink && styles.myPageLink) },
	        _react2.default.createElement(
	          'div',
	          { className: styles.iconContainer },
	          _react2.default.createElement(_User.UserPic, { my: true, url: authorizedUser.avatarUrl })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: styles.name },
	          authorizedUser.displayName
	        )
	      );
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var _props = this.props;
	      var foreignUser = _props.foreignUser;
	      var open = _props.open;
	
	
	      if (!open) return null;
	
	      var containerClassName = (0, _classnames2.default)(styles.userMenuCompact, open && styles.open);
	      return _react2.default.createElement(
	        'div',
	        { className: containerClassName },
	        _react2.default.createElement(
	          'div',
	          { className: styles.content },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(styles.item),
	              onClick: this.props.onClose
	            },
	            foreignUser ? _react2.default.createElement(
	              _Common.Link,
	              { jalan: { type: _routing.JALAN_INDEX }, noUnderline: true },
	              this.getUserContent()
	            ) : this.getUserContent()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(styles.item, styles.logout) },
	            _react2.default.createElement(
	              _Auth.Logout,
	              null,
	              _react2.default.createElement(
	                _Common.Menu.Item,
	                null,
	                _react2.default.createElement(
	                  _Common.Menu.ItemIcon,
	                  null,
	                  _react2.default.createElement(_Icons.Exit, { width: '18', height: '18' })
	                ),
	                _react2.default.createElement(
	                  _Common.Menu.ItemLabel,
	                  null,
	                  'Log out'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactOnclickout2.default,
	        { onClickOut: this.props.onClose },
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: {
	              enter: styles.enter,
	              enterActive: styles.enterActive,
	              leave: styles.leave,
	              leaveActive: styles.leaveActive
	            },
	            transitionEnterTimeout: 300,
	            transitionLeaveTimeout: 400
	          },
	          this.getContent()
	        )
	      );
	    }
	  }]);
	
	  return UserMenuFull;
	}(_react.Component), _class.propTypes = {
	  authorizedUser: _react.PropTypes.object,
	  foreignUser: _react.PropTypes.string,
	
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool
	}, _temp);
	exports.default = UserMenuFull;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(167);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Auth = __webpack_require__(66);
	
	var _Icons = __webpack_require__(17);
	
	var _Common = __webpack_require__(11);
	
	var _User = __webpack_require__(67);
	
	var _routing = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(512);
	
	var UserMenuFull = (_temp = _class = function (_Component) {
	  _inherits(UserMenuFull, _Component);
	
	  function UserMenuFull() {
	    _classCallCheck(this, UserMenuFull);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserMenuFull).apply(this, arguments));
	  }
	
	  _createClass(UserMenuFull, [{
	    key: 'getContent',
	    value: function getContent() {
	      var _props = this.props;
	      var authorizedUser = _props.authorizedUser;
	      var foreignUser = _props.foreignUser;
	      var open = _props.open;
	
	
	      if (!open || !authorizedUser) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: styles.userMenuFull },
	        _react2.default.createElement(
	          _Common.Menu,
	          { close: this.props.onClose },
	          _react2.default.createElement(
	            _Common.Menu.Item,
	            { onClick: this.props.onClose },
	            foreignUser ? _react2.default.createElement(
	              _Common.Link,
	              { jalan: { type: _routing.JALAN_INDEX }, noUnderline: true },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(styles.user, this.props.withMyPageLink && styles.myPageLink) },
	                _react2.default.createElement(_User.UserPic, { my: true, url: authorizedUser.avatarUrl }),
	                _react2.default.createElement(
	                  'div',
	                  { className: styles.name },
	                  authorizedUser.displayName
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(styles.user, this.props.withMyPageLink && styles.myPageLink) },
	              _react2.default.createElement(_User.UserPic, { my: true, url: authorizedUser.avatarUrl }),
	              _react2.default.createElement(
	                'div',
	                { className: styles.name },
	                authorizedUser.displayName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Auth.Logout,
	            null,
	            _react2.default.createElement(
	              _Common.Menu.Item,
	              null,
	              _react2.default.createElement(
	                _Common.Menu.ItemIcon,
	                null,
	                _react2.default.createElement(_Icons.Exit, { width: '18', height: '18' })
	              ),
	              _react2.default.createElement(
	                _Common.Menu.ItemLabel,
	                null,
	                'Log out'
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          component: 'div',
	          transitionName: {
	            enter: styles.enter,
	            enterActive: styles.enterActive,
	            leave: styles.leave,
	            leaveActive: styles.leaveActive
	          },
	          transitionEnterTimeout: 240,
	          transitionLeaveTimeout: 180
	        },
	        this.getContent()
	      );
	    }
	  }]);
	
	  return UserMenuFull;
	}(_react.Component), _class.propTypes = {
	  authorizedUser: _react.PropTypes.object,
	  foreignUser: _react.PropTypes.string,
	
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool
	}, _temp);
	exports.default = UserMenuFull;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(514);
	
	var UserPageWrapper = (_temp = _class = function (_Component) {
	  _inherits(UserPageWrapper, _Component);
	
	  function UserPageWrapper() {
	    _classCallCheck(this, UserPageWrapper);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserPageWrapper).apply(this, arguments));
	  }
	
	  _createClass(UserPageWrapper, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.wrapper },
	        this.props.children
	      );
	    }
	  }]);
	
	  return UserPageWrapper;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any
	}, _temp);
	exports.default = UserPageWrapper;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* injects from baggage-loader */
	var styles = __webpack_require__(515);
	
	var UserPic = (_temp = _class = function (_Component) {
	  _inherits(UserPic, _Component);
	
	  function UserPic() {
	    _classCallCheck(this, UserPic);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserPic).apply(this, arguments));
	  }
	
	  _createClass(UserPic, [{
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)(styles.userPic, this.props.my && styles.my);
	      return _react2.default.createElement(
	        'div',
	        { className: className, onClick: this.props.onClick,
	          style: { backgroundImage: 'url(' + this.props.url + ')' } },
	        this.props.children
	      );
	    }
	  }]);
	
	  return UserPic;
	}(_react.Component), _class.propTypes = {
	  url: _react.PropTypes.string,
	  my: _react.PropTypes.bool
	}, _temp);
	exports.default = UserPic;

/***/ },
/* 620 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* injects from baggage-loader */
	
	var KEY_ESC = exports.KEY_ESC = 27;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(622);
	
	__webpack_require__(645);
	
	__webpack_require__(458);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createBrowserHistory = __webpack_require__(810);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _asap = __webpack_require__(135);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _reactDom = __webpack_require__(29);
	
	var _reduxSimple = __webpack_require__(10);
	
	var _gremlins = __webpack_require__(805);
	
	var _gremlins2 = _interopRequireDefault(_gremlins);
	
	var _reactClicker = __webpack_require__(642);
	
	var _index = __webpack_require__(639);
	
	var _App = __webpack_require__(209);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	var history = (0, _createBrowserHistory2.default)();
	var store = (0, _index.configureStore)(history);
	
	(0, _asap2.default)(function () {
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reduxSimple.Provider,
	    { store: store },
	    _react2.default.createElement(_App2.default, null)
	  ), document.getElementById('mount'));
	});
	
	if (false) {
	  window.store = store;
	}
	
	window.gremlins = function () {
	  var nb = arguments.length <= 0 || arguments[0] === undefined ? 10000 : arguments[0];
	
	  _gremlins2.default.createHorde().gremlin((0, _reactClicker.reactClicker)()).unleash({ nb: nb });
	};

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* injects from baggage-loader */
	
	if (window) {
	  window._rollbarConfig = __webpack_require__(644);
	  __webpack_require__(537);
	}

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pureGraph = __webpack_require__(34);
	
	var _functional = __webpack_require__(83);
	
	// import {randomElement} from 'utils/utils';
	
	/* injects from baggage-loader */
	
	var getDefaultProject = function getDefaultProject() {
	  return {
	    name: 'Hi there',
	
	    nodesData: {
	      first: { x: -20, y: -170, color: '#D0F192', caption: 'Sample node' },
	      second: { x: 20, y: 0, color: '#6D826C', caption: 'Another sample node' }
	    },
	
	    graph: (0, _functional.compose)((0, _pureGraph.addEdge)('first-second', 'first', 'second'), (0, _pureGraph.addNode)('first'), (0, _pureGraph.addNode)('second'))(_pureGraph.EMPTY_GRAPH)
	  };
	};
	
	exports.default = getDefaultProject;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(450);
	
	var _user = __webpack_require__(631);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _popup = __webpack_require__(626);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _projects = __webpack_require__(629);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _nodes = __webpack_require__(625);
	
	var _nodes2 = _interopRequireDefault(_nodes);
	
	var _routing = __webpack_require__(630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	exports.default = (0, _redux.combineReducers)({
	  routing: _routing.routing,
	  user: _user2.default,
	  popup: _popup2.default,
	  projects: _projects2.default,
	  nodes: _nodes2.default
	});

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	exports.default = nodes;
	
	var _actionTypes = __webpack_require__(23);
	
	var initialState = {
	  editorNode: null
	};
	
	function nodes() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.SET_EDITOR_NODE:
	      return _extends({}, state, {
	        editorNode: action.value
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	exports.default = popup;
	
	var _lodash = __webpack_require__(28);
	
	var _actionTypes = __webpack_require__(23);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  popups: [] // order is important, due to z-index of popups
	  // stored as { type: String, data: * }
	};
	
	function popup() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.POPUP_SHOW:
	      return _extends({}, state, {
	        popups: [].concat(_toConsumableArray(state.popups), [{ type: action.popupType, data: action.popupData }])
	      });
	
	    case _actionTypes.POPUP_CLOSE:
	      return _extends({}, state, {
	        popups: state.popups.filter(function (t) {
	          return t !== action.popupType;
	        })
	      });
	
	    case _actionTypes.POPUP_CLOSE_LAST:
	      return _extends({}, state, {
	        popups: (0, _lodash.dropRight)(state.popups)
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pureGraph = __webpack_require__(34);
	
	var _functional = __webpack_require__(83);
	
	var _utils = __webpack_require__(68);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* injects from baggage-loader */
	
	var names = ['The Family Dog', 'How to Get Windows 10', 'Дорийский контрапункт контрастных фактур: основные моменты', 'A Robotic Dog’s Mortality', 'Welcome!', 'Some Random Funny Project Name'];
	
	var ID_0 = '-KC-0';
	var ID_1 = '-KC-1';
	
	var getStubData = function getStubData() {
	  var _nodesData;
	
	  return {
	    name: (0, _utils.randomElement)(names),
	
	    nodesData: (_nodesData = {}, _defineProperty(_nodesData, ID_0, { x: -100, y: -25, color: '#D0F192', caption: 'Very beginning' }), _defineProperty(_nodesData, ID_1, { x: 100, y: 25, color: '#6D826C', caption: 'And then…' }), _nodesData),
	
	    graph: (0, _functional.compose)((0, _pureGraph.addEdge)(ID_0 + '-' + ID_1, ID_0, ID_1), (0, _pureGraph.addNode)(ID_1), (0, _pureGraph.addNode)(ID_0))(_pureGraph.EMPTY_GRAPH)
	  };
	};
	
	exports.default = getStubData;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pureGraph = __webpack_require__(34);
	
	var _functional = __webpack_require__(83);
	
	var _utils = __webpack_require__(68);
	
	var names = ['The Family Dog', 'How to Get Windows 10', 'Дорийский контрапункт контрастных фактур: основные моменты', 'A Robotic Dog’s Mortality', 'Welcome!', 'Some Random Funny Project Name'];
	/* injects from baggage-loader */
	
	var getStubData = function getStubData() {
	  return {
	    // name: randomElement(names) + randomElement(names) + randomElement(names) + randomElement(names),
	    name: (0, _utils.randomElement)(names),
	
	    nodesData: {
	      pragmatic: { x: 110, y: -120, color: '#D0F192', caption: 'Pragmatic thinking' },
	      focus: { x: 400, y: -80, color: '#6D826C', caption: 'Manage Focus' },
	      learn: { x: -160, y: -50, color: '#6D826C', caption: 'Learn deliberately' },
	      debug: { x: 150, y: 0, color: '#6D826C', caption: 'Debug your mind' },
	      'gain-exp': { x: -400, y: 50, color: '#2A363B', caption: 'Gain experience' },
	      'right-mind': { x: -200, y: 120, color: '#2A363B', caption: 'Get in your right mind' },
	      cognitive: {
	        x: 120, y: 250, color: '#2A363B', caption: 'Cognitive biases, Cognitive biases, Cognitive biases,\n        biases Cognitive biases, Cognitive biases, Cognitive biases, biases'
	      },
	      hardware: { x: 360, y: 200, color: '#2A363B', caption: 'Hardware bugs' },
	      person: { x: 500, y: 150, color: '#2A363B', caption: 'Personality tendencies' }
	    },
	
	    graph: (0, _functional.compose)((0, _pureGraph.addEdge)('0', 'pragmatic', 'focus'), (0, _pureGraph.addEdge)('1', 'pragmatic', 'learn'), (0, _pureGraph.addEdge)('2', 'pragmatic', 'debug'), (0, _pureGraph.addEdge)('3', 'learn', 'gain-exp'), (0, _pureGraph.addEdge)('4', 'learn', 'right-mind'), (0, _pureGraph.addEdge)('5', 'debug', 'cognitive'), (0, _pureGraph.addEdge)('6', 'debug', 'hardware'), (0, _pureGraph.addEdge)('7', 'debug', 'person'), (0, _pureGraph.addNode)('pragmatic'), (0, _pureGraph.addNode)('focus'), (0, _pureGraph.addNode)('learn'), (0, _pureGraph.addNode)('debug'), (0, _pureGraph.addNode)('gain-exp'), (0, _pureGraph.addNode)('right-mind'), (0, _pureGraph.addNode)('cognitive'), (0, _pureGraph.addNode)('hardware'), (0, _pureGraph.addNode)('person'))(_pureGraph.EMPTY_GRAPH)
	  };
	};
	
	exports.default = getStubData;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	exports.default = projects;
	
	var _actionTypes = __webpack_require__(23);
	
	var initialState = {
	  list: null,
	  project: null,
	
	  shareLoaded: false,
	  shareLoading: false,
	
	  shareLink: null,
	  sharePopupOpened: false
	};
	
	function projects() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	
	  switch (action.type) {
	    case _actionTypes.SET_PROJECTS_LIST:
	      return _extends({}, state, {
	        list: action.value
	      });
	
	    case _actionTypes.SET_PROJECT:
	      return _extends({}, state, {
	        project: action.value
	      });
	
	    case _actionTypes.SHARE_PROJECT:
	      return _extends({}, state, {
	
	        shareLoaded: false,
	        shareLoading: true,
	        shareLink: null,
	
	        sharePopupOpened: false
	      });
	
	    case _actionTypes.SHARE_PROJECT_GOT_FB_LINK:
	      return _extends({}, state, {
	
	        shareLoaded: true,
	        shareLoading: false,
	        shareLink: action.link
	      });
	
	    case _actionTypes.SHARE_PROJECT_SUCCESS:
	      return _extends({}, state, {
	
	        shareLoaded: true,
	        shareLoading: false
	      });
	
	    case _actionTypes.SHARE_PROJECT_POPUP_OPENED:
	      return _extends({}, state, {
	        sharePopupOpened: true
	      });
	
	    case _actionTypes.SHARE_PROJECT_FAILURE:
	      return _extends({}, state, {
	        shareLoading: false,
	        shareLoaded: false,
	        shareLink: action.link
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	exports.routing = routing;
	
	var _actionTypes = __webpack_require__(23);
	
	var INITIAL_STATE = {};
	
	function routing() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
	  var action = arguments[1];
	
	  if (_actionTypes.ROUTING_ACTIONS_KEYS.indexOf(action.type) !== -1) {
	    var type = action.type;
	    var meta = action.meta;
	    var _action$params = action.params;
	    var params = _action$params === undefined ? {} : _action$params;
	
	    var foreignUser = params.userId;
	    return _extends({}, state, { foreignUser: foreignUser, type: type, params: params, meta: meta });
	  }
	  return state;
	}

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	exports.default = user;
	
	var _actionTypes = __webpack_require__(23);
	
	var initialState = {
	  loggingIn: false,
	  shownUser: null,
	  authorizedUser: null,
	  isAuthorizing: false,
	  firstLogin: false,
	  welcomePopupShown: false
	};
	
	function user() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.LOG_IN:
	      return _extends({}, state, {
	        loggingIn: true
	      });
	
	    case _actionTypes.LOGGED_IN:
	      return _extends({}, state, {
	        loggingIn: false
	      });
	
	    case _actionTypes.LOG_OUT:
	      return state;
	
	    case _actionTypes.SET_SHOWN_USER:
	      return _extends({}, state, {
	        shownUser: action.value
	      });
	
	    case _actionTypes.SET_AUTHORIZING:
	      return _extends({}, state, {
	        isAuthorizing: action.value
	      });
	
	    case _actionTypes.SET_AUTHORIZED_USER:
	      return _extends({}, state, {
	        authorizedUser: action.value
	      });
	
	    case _actionTypes.USER_SET_FIRST_LOGIN:
	      return _extends({}, state, {
	        firstLogin: action.value
	      });
	
	    case _actionTypes.USER_SET_WELCOME_POPUP_SHOWN:
	      return _extends({}, state, {
	        welcomePopupShown: action.value
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = watchAuth;
	
	var _reduxSaga = __webpack_require__(25);
	
	var _kebakaran = __webpack_require__(90);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _userActions = __webpack_require__(49);
	
	var _routing = __webpack_require__(44);
	
	var _actionTypes = __webpack_require__(23);
	
	var _projectsActions = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [watchLogin, watchLoginAndToIndex, watchLogout, checkUser, getAuthorizedUser, watchAuth].map(regeneratorRuntime.mark);
	/* injects from baggage-loader */
	
	/* eslint-disable max-len */
	/* eslint no-console: 0 */
	
	var debug = __webpack_require__(40)('metapro:sagas:user');
	
	function watchLogin() {
	  return regeneratorRuntime.wrap(function watchLogin$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.LOG_IN);
	
	        case 3:
	          _context.prev = 3;
	          _context.next = 6;
	          return _firebase.auth.signInAnonymously();
	
	        case 6:
	          _context.next = 11;
	          break;
	
	        case 8:
	          _context.prev = 8;
	          _context.t0 = _context['catch'](3);
	
	          console.warn('Auth failed: ', _context.t0);
	
	        case 11:
	          _context.next = 0;
	          break;
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[3, 8]]);
	}
	
	function watchLoginAndToIndex() {
	  return regeneratorRuntime.wrap(function watchLoginAndToIndex$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (false) {
	            _context2.next = 11;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.LOG_IN_AND_TO_INDEX);
	
	        case 3:
	          _context2.next = 5;
	          return (0, _reduxSaga.put)((0, _userActions.logIn)());
	
	        case 5:
	          _context2.next = 7;
	          return (0, _reduxSaga.take)(_actionTypes.LOGGED_IN);
	
	        case 7:
	          _context2.next = 9;
	          return (0, _reduxSaga.put)((0, _routing.openIndex)());
	
	        case 9:
	          _context2.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function watchLogout() {
	  return regeneratorRuntime.wrap(function watchLogout$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (false) {
	            _context3.next = 6;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _reduxSaga.take)(_actionTypes.LOG_OUT);
	
	        case 3:
	          (0, _firebase2.default)().unauth();
	          _context3.next = 0;
	          break;
	
	        case 6:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function checkUser(id, user) {
	  var _sagaCbLoose, listener, callback, userRef, userExists;
	
	  return regeneratorRuntime.wrap(function checkUser$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _sagaCbLoose = (0, _kebakaran.sagaCbLoose)();
	          listener = _sagaCbLoose.listener;
	          callback = _sagaCbLoose.callback;
	          userRef = (0, _firebase2.default)('users/' + id);
	
	          userRef.once('value', listener);
	          _context4.next = 7;
	          return (0, _reduxSaga.cps)(callback);
	
	        case 7:
	          userExists = _context4.sent;
	
	          if (userExists.exists()) {
	            _context4.next = 13;
	            break;
	          }
	
	          _context4.next = 11;
	          return (0, _reduxSaga.put)((0, _userActions.setFirstLogin)(true));
	
	        case 11:
	          _context4.next = 13;
	          return (0, _reduxSaga.put)((0, _projectsActions.addDefaultProject)());
	
	        case 13:
	          userRef.update(user);
	
	        case 14:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function getAuthorizedUser(userId) {
	  var userStream, _sagaCbLoose2,
	  // check for `users/` existence
	  listener, callback, userRef, usersData, user;
	
	  return regeneratorRuntime.wrap(function getAuthorizedUser$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          debug('start getAuthorizedUser(%s)', userId);
	
	          userStream = (0, _kebakaran.stream)((0, _firebase2.default)('users/' + userId));
	          _context5.prev = 2;
	          _sagaCbLoose2 = (0, _kebakaran.sagaCbLoose)();
	          listener = _sagaCbLoose2.listener;
	          callback = _sagaCbLoose2.callback;
	          userRef = (0, _firebase2.default)('users/');
	
	          userRef.once('value', listener);
	          _context5.next = 10;
	          return (0, _reduxSaga.cps)(callback);
	
	        case 10:
	          usersData = _context5.sent;
	
	          if (usersData) {
	            _context5.next = 18;
	            break;
	          }
	
	          (0, _firebase2.default)('users/').set(true);
	          user = { id: userId };
	
	          (0, _firebase2.default)('users/' + userId).set(user);
	          _context5.next = 17;
	          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)({
	            id: userId
	          }));
	
	        case 17:
	          return _context5.abrupt('return');
	
	        case 18:
	          if (false) {
	            _context5.next = 27;
	            break;
	          }
	
	          _context5.next = 21;
	          return userStream.next();
	
	        case 21:
	          user = _context5.sent;
	
	          if (user !== null) {
	            user = _extends({}, user, { id: userId });
	          }
	          _context5.next = 25;
	          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)(_extends({}, user, {
	            id: userId
	          })));
	
	        case 25:
	          _context5.next = 18;
	          break;
	
	        case 27:
	          _context5.next = 32;
	          break;
	
	        case 29:
	          _context5.prev = 29;
	          _context5.t0 = _context5['catch'](2);
	
	          if (!(_context5.t0 instanceof _reduxSaga.SagaCancellationException)) {
	            console.warn('unknown Error', _context5.t0);
	          }
	
	        case 32:
	          _context5.prev = 32;
	
	          userStream.close();
	          return _context5.finish(32);
	
	        case 35:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[2, 29, 32, 35]]);
	}
	
	function watchAuth(getState) {
	  var _sagaCbLoose3, listener, callback, watcher, userData, _user;
	
	  return regeneratorRuntime.wrap(function watchAuth$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _reduxSaga.fork)(watchLogin);
	
	        case 2:
	          _context6.next = 4;
	          return (0, _reduxSaga.fork)(watchLogout);
	
	        case 4:
	          _context6.next = 6;
	          return (0, _reduxSaga.fork)(watchLoginAndToIndex);
	
	        case 6:
	          _sagaCbLoose3 = (0, _kebakaran.sagaCbLoose)();
	          listener = _sagaCbLoose3.listener;
	          callback = _sagaCbLoose3.callback;
	          watcher = null;
	
	          _firebase.auth.onAuthStateChanged(listener);
	
	        case 11:
	          if (false) {
	            _context6.next = 36;
	            break;
	          }
	
	          _context6.next = 14;
	          return (0, _reduxSaga.cps)(callback);
	
	        case 14:
	          userData = _context6.sent;
	
	          if (!userData) {
	            _context6.next = 28;
	            break;
	          }
	
	          _user = {
	            displayName: 'Anonymous',
	            avatarUrl: 'https://storage.googleapis.com/material-design/publish/material_v_10/assets/0B5-3BCtasWxEV2R6bkNDOUxFZ00/style_icons_product_human_best_do1.png'
	          };
	          _context6.next = 19;
	          return (0, _reduxSaga.fork)(checkUser, userData.uid, _user);
	
	        case 19:
	          _context6.next = 21;
	          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)(_extends({}, _user, {
	            id: userData.uid
	          })));
	
	        case 21:
	          _context6.next = 23;
	          return (0, _reduxSaga.fork)(getAuthorizedUser, userData.uid);
	
	        case 23:
	          watcher = _context6.sent;
	          _context6.next = 26;
	          return (0, _reduxSaga.put)((0, _userActions.loggedIn)());
	
	        case 26:
	          _context6.next = 34;
	          break;
	
	        case 28:
	          // logout
	          if (watcher) {
	            watcher.cancel();
	          }
	          _context6.next = 31;
	          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)(null));
	
	        case 31:
	          if (getState().routing.foreignUser) {
	            _context6.next = 34;
	            break;
	          }
	
	          _context6.next = 34;
	          return (0, _reduxSaga.put)((0, _routing.openIndex)());
	
	        case 34:
	          _context6.next = 11;
	          break;
	
	        case 36:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = root;
	
	var _reduxSaga = __webpack_require__(25);
	
	var _actionTypes = __webpack_require__(23);
	
	var _data = __webpack_require__(141);
	
	var _routing = __webpack_require__(27);
	
	var _auth = __webpack_require__(632);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _nodeDescription = __webpack_require__(635);
	
	var _user = __webpack_require__(638);
	
	var _project = __webpack_require__(636);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _actions = __webpack_require__(229);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _title = __webpack_require__(637);
	
	var _makeWatcher = __webpack_require__(634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [root].map(regeneratorRuntime.mark);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	/* injects from baggage-loader */
	
	var watchUser = (0, _makeWatcher.makeMonitor)({
	  task: _user.getUser,
	  event: (0, _reduxSaga.take)([].concat(_toConsumableArray(_actionTypes.ROUTING_ACTIONS_KEYS), [_actionTypes.SET_PROJECT])),
	  mapEvent: function mapEvent() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _ref$params = _ref.params;
	    var params = _ref$params === undefined ? {} : _ref$params;
	    var getState = arguments[1];
	
	    var _getState = getState();
	
	    var project = _getState.projects.project;
	
	
	    if (params.userId) {
	      return (0, _makeWatcher.start)(params.userId);
	    }
	
	    if (project && project.owner) {
	      return (0, _makeWatcher.start)(project.owner);
	    }
	
	    return (0, _makeWatcher.stop)();
	  }
	});
	
	var watchProjects = (0, _makeWatcher.makeMonitor)({
	  task: _user.getProjects,
	  event: (0, _reduxSaga.take)([].concat(_toConsumableArray(_actionTypes.ROUTING_ACTIONS_KEYS), [_actionTypes.SET_AUTHORIZED_USER])),
	  mapEvent: function mapEvent(_ref2, getState) {
	    var meta = _ref2.meta;
	
	    var _getState2 = getState();
	
	    var user = _getState2.user;
	    var routing = _getState2.routing;
	
	
	    var authorizedUser = user.authorizedUser;
	    var params = routing.params;
	    var type = routing.type;
	
	
	    if (authorizedUser && type === _routing.JALAN_INDEX || authorizedUser && authorizedUser.id === (params || {}).userId) {
	      return (0, _makeWatcher.start)(authorizedUser.id, 'permissions');
	    }
	
	    if (params && params.userId) return (0, _makeWatcher.start)(params.userId, 'public');
	
	    return (0, _makeWatcher.stop)();
	  }
	});
	
	var watchProject = (0, _makeWatcher.makeMonitor)({
	  task: _project2.default,
	  event: (0, _reduxSaga.take)(_actionTypes.ROUTING_ACTIONS_KEYS),
	  mapEvent: function mapEvent(_ref3) {
	    var params = _ref3.params;
	    var meta = _ref3.meta;
	
	    if (meta.data.indexOf(_data.PROJECT_DATA) !== -1) {
	      return (0, _makeWatcher.start)(params.projectId);
	    }
	    return (0, _makeWatcher.stop)();
	  }
	});
	
	var watchNode = (0, _makeWatcher.makeMonitor)({
	  task: _nodeDescription.getNodeDescription,
	  event: (0, _reduxSaga.take)(_actionTypes.ROUTING_ACTIONS_KEYS),
	  mapEvent: function mapEvent(_ref4) {
	    var params = _ref4.params;
	    var meta = _ref4.meta;
	
	    if (meta.data.indexOf(_data.NODE_DATA) !== -1) {
	      return (0, _makeWatcher.start)(params.projectId, params.nodeId);
	    }
	    return (0, _makeWatcher.stop)();
	  }
	});
	
	function root(getState) {
	  return regeneratorRuntime.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return [(0, _reduxSaga.call)(watchUser, getState), (0, _reduxSaga.call)(watchProject, getState), (0, _reduxSaga.call)(watchProjects, getState), (0, _reduxSaga.call)(watchNode, getState), (0, _reduxSaga.call)(_auth2.default, getState), (0, _reduxSaga.call)(_actions2.default, getState), (0, _reduxSaga.call)(_title.titleSaga, getState)];
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.start = start;
	exports.stop = stop;
	exports.makeMonitor = makeMonitor;
	
	var _invariant = __webpack_require__(4);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxSaga = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* injects from baggage-loader */
	
	var debug = __webpack_require__(40)('metapro:monitor');
	
	var START = Symbol();
	var STOP = Symbol();
	var ACTION = Symbol();
	var ARGS = Symbol();
	
	function start() {
	  var _ref;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return _ref = {}, _defineProperty(_ref, ACTION, START), _defineProperty(_ref, ARGS, args), _ref;
	}
	
	function stop() {
	  return _defineProperty({}, ACTION, STOP);
	}
	
	function makeMonitor(_ref3) {
	  var task = _ref3.task;
	  var event = _ref3.event;
	  var mapEvent = _ref3.mapEvent;
	
	  (0, _invariant2.default)(typeof task === 'function', 'makeMonitor task param must be a function');
	  (0, _invariant2.default)(typeof mapEvent === 'function', 'makeMonitor task param must be a function');
	
	  var name = task.name;
	
	  return regeneratorRuntime.mark(function monitor(getState) {
	    var process, processArgs, result, action;
	    return regeneratorRuntime.wrap(function monitor$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            debug('%s starts', name);
	
	            process = null;
	            processArgs = [];
	
	          case 3:
	            if (false) {
	              _context.next = 32;
	              break;
	            }
	
	            _context.next = 6;
	            return event;
	
	          case 6:
	            result = _context.sent;
	            action = mapEvent(result, getState);
	
	
	            (0, _invariant2.default)(action && action[ACTION], 'mapEvent must return start(...) or stop()');
	
	            if (!(action[ACTION] === START)) {
	              _context.next = 23;
	              break;
	            }
	
	            if (!process) {
	              _context.next = 17;
	              break;
	            }
	
	            if (_lodash2.default.isEqual(processArgs, action[ARGS])) {
	              _context.next = 17;
	              break;
	            }
	
	            debug('%s cancels task due to args change', name);
	            _context.next = 15;
	            return (0, _reduxSaga.cancel)(process);
	
	          case 15:
	            process = null;
	            processArgs = [];
	
	          case 17:
	            if (process) {
	              _context.next = 23;
	              break;
	            }
	
	            processArgs = action[ARGS];
	            debug.apply(undefined, ['%s forks with', name].concat(_toConsumableArray(processArgs)));
	            _context.next = 22;
	            return _reduxSaga.fork.apply(undefined, [task].concat(_toConsumableArray(processArgs)));
	
	          case 22:
	            process = _context.sent;
	
	          case 23:
	            if (!(action[ACTION] === STOP)) {
	              _context.next = 30;
	              break;
	            }
	
	            if (!process) {
	              _context.next = 30;
	              break;
	            }
	
	            debug('%s cancels task due to stop action', name);
	            _context.next = 28;
	            return (0, _reduxSaga.cancel)(process);
	
	          case 28:
	            process = null;
	            processArgs = [];
	
	          case 30:
	            _context.next = 3;
	            break;
	
	          case 32:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, monitor, this);
	  });
	}

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNodeDescription = getNodeDescription;
	exports.getForeignNodeDescription = getForeignNodeDescription;
	
	var _reduxSaga = __webpack_require__(25);
	
	var _kebakaran = __webpack_require__(90);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _nodesActions = __webpack_require__(538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [getCaption, getNodeDescription, getForeignNodeDescription].map(regeneratorRuntime.mark);
	/* injects from baggage-loader */
	
	/* eslint no-console: 0 */
	
	function getCaption(captionRef) {
	  var _sagaCb, listener, callback, caption;
	
	  return regeneratorRuntime.wrap(function getCaption$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _sagaCb = (0, _kebakaran.sagaCbLoose)();
	          listener = _sagaCb.listener;
	          callback = _sagaCb.callback;
	
	          captionRef.once('value', listener);
	          _context.next = 7;
	          return (0, _reduxSaga.cps)(callback);
	
	        case 7:
	          caption = _context.sent;
	          return _context.abrupt('return', caption.val());
	
	        case 11:
	          _context.prev = 11;
	          _context.t0 = _context['catch'](0);
	
	          if (_context.t0 instanceof _reduxSaga.SagaCancellationException) {
	            _context.next = 15;
	            break;
	          }
	
	          throw _context.t0;
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 11]]);
	}
	
	/*
	function* setNodeOwner(nodeRef, ownerId) {
	  try {
	    nodeRef.child('owner').set(ownerId);
	  } catch (err) {
	    if (!(err instanceof SagaCancellationException)) {
	      throw err;
	    }
	  }
	}
	*/
	
	function getNodeDescription(projectId, nodeId) {
	  var projectRefLink, captionRefLink, descriptionRefLink, projectOwnerRefLink, captionStream, projectOwnerStream, _caption, owner;
	
	  return regeneratorRuntime.wrap(function getNodeDescription$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          //if (!nodeId) {
	          //  yield put(setEditorNode(null));
	          //  return;
	          //}
	          projectRefLink = 'projects/' + projectId;
	          captionRefLink = projectRefLink + '/nodesData/' + nodeId + '/caption';
	          descriptionRefLink = projectRefLink + '/descriptions/' + nodeId;
	          projectOwnerRefLink = projectRefLink + '/owner';
	          captionStream = (0, _kebakaran.stream)((0, _firebase2.default)(captionRefLink));
	          projectOwnerStream = (0, _kebakaran.stream)((0, _firebase2.default)(projectOwnerRefLink));
	          _context2.prev = 6;
	          _context2.next = 9;
	          return captionStream.next();
	
	        case 9:
	          _caption = _context2.sent;
	          _context2.next = 12;
	          return projectOwnerStream.next();
	
	        case 12:
	          owner = _context2.sent;
	          _context2.next = 15;
	          return (0, _reduxSaga.put)((0, _nodesActions.setEditorNode)({
	            id: nodeId,
	            refLink: descriptionRefLink,
	            owner: owner,
	            caption: _caption
	          }));
	
	        case 15:
	          _context2.next = 21;
	          break;
	
	        case 17:
	          _context2.prev = 17;
	          _context2.t0 = _context2['catch'](6);
	
	          if (_context2.t0 instanceof _reduxSaga.SagaCancellationException) {
	            _context2.next = 21;
	            break;
	          }
	
	          throw _context2.t0;
	
	        case 21:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[6, 17]]);
	}
	
	function getForeignNodeDescription(projectId, nodeId) {
	  var caption, descriptionRefLink, descriptionHistoryRef, _sagaCb2, listener, callback;
	
	  return regeneratorRuntime.wrap(function getForeignNodeDescription$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (nodeId) {
	            _context3.next = 4;
	            break;
	          }
	
	          _context3.next = 3;
	          return (0, _reduxSaga.put)((0, _nodesActions.setEditorNode)(null));
	
	        case 3:
	          return _context3.abrupt('return');
	
	        case 4:
	          _context3.next = 6;
	          return (0, _reduxSaga.call)(getCaption, (0, _firebase2.default)('projects/' + projectId + '/nodesData/' + nodeId + '/caption'));
	
	        case 6:
	          caption = _context3.sent;
	          descriptionRefLink = 'projects/' + projectId + '/descriptions/' + nodeId;
	          descriptionHistoryRef = (0, _firebase2.default)(descriptionRefLink + '/history');
	          _sagaCb2 = (0, _kebakaran.sagaCbLoose)();
	          listener = _sagaCb2.listener;
	          callback = _sagaCb2.callback;
	
	          descriptionHistoryRef.on('value', listener);
	
	          _context3.prev = 13;
	
	        case 14:
	          if (false) {
	            _context3.next = 21;
	            break;
	          }
	
	          _context3.next = 17;
	          return (0, _reduxSaga.cps)(callback);
	
	        case 17:
	          _context3.next = 19;
	          return (0, _reduxSaga.put)((0, _nodesActions.setEditorNode)({
	            id: nodeId,
	            refLink: descriptionRefLink,
	            timestamp: new Date().getTime(),
	            caption: caption
	          }));
	
	        case 19:
	          _context3.next = 14;
	          break;
	
	        case 21:
	          _context3.next = 26;
	          break;
	
	        case 23:
	          _context3.prev = 23;
	          _context3.t0 = _context3['catch'](13);
	
	          if (!(_context3.t0 instanceof _reduxSaga.SagaCancellationException)) {
	            console.warn('unknown Error', _context3.t0);
	          }
	
	        case 26:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[13, 23]]);
	}

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	/* eslint no-console: 0 */
	
	exports.default = getProject;
	
	var _reduxSaga = __webpack_require__(25);
	
	var _kebakaran = __webpack_require__(90);
	
	var _pureGraph = __webpack_require__(34);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _projectsActions = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [getProject].map(regeneratorRuntime.mark);
	
	function getProject(projectId) {
	  var projectStream, project, _sagaCbLoose,
	
	  // check for projects/` existence
	  listener, callback, projectsRef, projectsData;
	
	  return regeneratorRuntime.wrap(function getProject$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (projectId) {
	            _context.next = 2;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 2:
	          projectStream = (0, _kebakaran.stream)((0, _kebakaran.struct)({
	            name: (0, _firebase2.default)('projects/' + projectId + '/name'),
	            graph: (0, _firebase2.default)('projects/' + projectId + '/graph'),
	            nodesData: (0, _firebase2.default)('projects/' + projectId + '/nodesData'),
	            public: (0, _firebase2.default)('projects/' + projectId + '/public'),
	            owner: (0, _firebase2.default)('projects/' + projectId + '/owner')
	          }));
	          _context.prev = 3;
	
	        case 4:
	          if (false) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 7;
	          return projectStream.next();
	
	        case 7:
	          project = _context.sent;
	          _sagaCbLoose = (0, _kebakaran.sagaCbLoose)();
	          listener = _sagaCbLoose.listener;
	          callback = _sagaCbLoose.callback;
	          projectsRef = (0, _firebase2.default)('projects/');
	
	          projectsRef.once('value', listener);
	          _context.next = 15;
	          return (0, _reduxSaga.cps)(callback);
	
	        case 15:
	          projectsData = _context.sent;
	
	
	          if (!projectsData) {
	            (0, _firebase2.default)('projects/').set(true);
	          }
	
	          if (project) {
	            _context.next = 20;
	            break;
	          }
	
	          _context.next = 20;
	          return (0, _reduxSaga.put)((0, _projectsActions.setProject)({}));
	
	        case 20:
	          _context.next = 22;
	          return (0, _reduxSaga.put)((0, _projectsActions.setProject)(_extends({}, project, {
	            id: projectId,
	            graph: (0, _pureGraph.convertFromIncidentForm)(project.graph) || _pureGraph.EMPTY_GRAPH
	          })));
	
	        case 22:
	          _context.next = 4;
	          break;
	
	        case 24:
	          _context.next = 29;
	          break;
	
	        case 26:
	          _context.prev = 26;
	          _context.t0 = _context['catch'](3);
	
	          if (!(_context.t0 instanceof _reduxSaga.SagaCancellationException)) {
	            console.warn('unknown Error', _context.t0);
	          }
	
	        case 29:
	          _context.prev = 29;
	
	          projectStream.close();
	          return _context.finish(29);
	
	        case 32:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[3, 26, 29, 32]]);
	}

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.titleSaga = titleSaga;
	
	var _reduxSaga = __webpack_require__(25);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _data = __webpack_require__(141);
	
	var _actionTypes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [titleSaga].map(regeneratorRuntime.mark);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	/* injects from baggage-loader */
	
	function setTitle(title) {
	  document.title = 'Metapro - ' + title;
	}
	
	function titleSaga(getState) {
	  var state, foreignUser, data, project, user, node;
	  return regeneratorRuntime.wrap(function titleSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (false) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _reduxSaga.take)([].concat(_toConsumableArray(_actionTypes.ROUTING_ACTIONS_KEYS), [_actionTypes.SET_AUTHORIZED_USER, _actionTypes.SET_SHOWN_USER, _actionTypes.SET_PROJECT, _actionTypes.SET_EDITOR_NODE]));
	
	        case 3:
	          state = getState();
	          foreignUser = state.routing.foreignUser;
	          data = state.routing.meta.data;
	          project = state.projects.project;
	          user = foreignUser ? state.user.showUser : state.user.authorizedUser;
	          node = state.nodes.editorNode;
	
	          if (!(_lodash2.default.isEqual(data, [_data.PROJECTS_DATA]) && user)) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _reduxSaga.call)(setTitle, user.displayName + ' projects');
	
	        case 12:
	          _context.next = 22;
	          break;
	
	        case 14:
	          if (!(_lodash2.default.isEqual(data, [_data.PROJECT_DATA]) && project)) {
	            _context.next = 19;
	            break;
	          }
	
	          _context.next = 17;
	          return (0, _reduxSaga.call)(setTitle, project.name);
	
	        case 17:
	          _context.next = 22;
	          break;
	
	        case 19:
	          if (!(_lodash2.default.isEqual(data, [_data.NODE_DATA]) && node)) {
	            _context.next = 22;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _reduxSaga.call)(setTitle, node.caption);
	
	        case 22:
	          _context.next = 0;
	          break;
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/* injects from baggage-loader */
	
	/* eslint no-console: 0 */
	
	exports.getUser = getUser;
	exports.getProjects = getProjects;
	
	var _invariant = __webpack_require__(4);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _reduxSaga = __webpack_require__(25);
	
	var _kebakaran = __webpack_require__(90);
	
	var _firebase = __webpack_require__(50);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _userActions = __webpack_require__(49);
	
	var _projectsActions = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [getUser, getProjects].map(regeneratorRuntime.mark);
	
	var debug = __webpack_require__(40)('metapro:sagas:user');
	
	function getUser(userId) {
	  var userStream, user;
	  return regeneratorRuntime.wrap(function getUser$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          debug('start getUser(%s)', userId);
	
	          userStream = (0, _kebakaran.stream)((0, _firebase2.default)('users/' + userId));
	          _context.prev = 2;
	
	        case 3:
	          if (false) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 6;
	          return userStream.next();
	
	        case 6:
	          user = _context.sent;
	
	          if (user !== null) {
	            user = _extends({}, user, { id: userId });
	          }
	          _context.next = 10;
	          return (0, _reduxSaga.put)((0, _userActions.setShownUser)(user));
	
	        case 10:
	          _context.next = 3;
	          break;
	
	        case 12:
	          _context.next = 17;
	          break;
	
	        case 14:
	          _context.prev = 14;
	          _context.t0 = _context['catch'](2);
	
	          if (!(_context.t0 instanceof _reduxSaga.SagaCancellationException)) {
	            console.warn('unknown Error', _context.t0);
	          }
	
	        case 17:
	          _context.prev = 17;
	
	          userStream.close();
	          return _context.finish(17);
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[2, 14, 17, 20]]);
	}
	
	function getProjects(userId, mode) {
	  var listRef, mapKey, projectsStream, projects;
	  return regeneratorRuntime.wrap(function getProjects$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          (0, _invariant2.default)(userId, 'getProjects requires userId');
	          (0, _invariant2.default)(mode === 'permissions' || mode === 'public', 'getProjects requires mode to be `permission` or `public`');
	
	          listRef = mode === 'permissions' ? (0, _firebase2.default)('userPermissions').orderByChild('user').equalTo(userId) : (0, _firebase2.default)('users/' + userId + '/publicProjects');
	          mapKey = mode === 'permissions' ? function (perm) {
	            return perm.val().project;
	          } : function (proj) {
	            return proj.key;
	          };
	          projectsStream = (0, _kebakaran.stream)((0, _kebakaran.list)(listRef, function (key) {
	            return (0, _kebakaran.struct)({
	              name: (0, _firebase2.default)('projects/' + key + '/name'),
	              owner: (0, _firebase2.default)('projects/' + key + '/owner'),
	              nodes: (0, _firebase2.default)('projects/' + key + '/graph/nodes'),
	              public: (0, _firebase2.default)('projects/' + key + '/public')
	            });
	          }, { mapKey: mapKey }));
	          _context2.prev = 5;
	          _context2.next = 8;
	          return (0, _reduxSaga.put)((0, _projectsActions.setProjectsList)([]));
	
	        case 8:
	          if (false) {
	            _context2.next = 16;
	            break;
	          }
	
	          _context2.next = 11;
	          return projectsStream.next();
	
	        case 11:
	          projects = _context2.sent;
	          _context2.next = 14;
	          return (0, _reduxSaga.put)((0, _projectsActions.setProjectsList)(projects || []));
	
	        case 14:
	          _context2.next = 8;
	          break;
	
	        case 16:
	          _context2.next = 21;
	          break;
	
	        case 18:
	          _context2.prev = 18;
	          _context2.t0 = _context2['catch'](5);
	
	          if (!(_context2.t0 instanceof _reduxSaga.SagaCancellationException)) {
	            console.warn('unknown Error', _context2.t0);
	          }
	
	        case 21:
	          _context2.prev = 21;
	
	          projectsStream.close();
	          return _context2.finish(21);
	
	        case 24:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[5, 18, 21, 24]]);
	}

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configureStore = configureStore;
	
	var _redux = __webpack_require__(450);
	
	var _reduxThunk = __webpack_require__(1065);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxSaga = __webpack_require__(25);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _jalan = __webpack_require__(273);
	
	var _index = __webpack_require__(624);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(633);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _logger = __webpack_require__(640);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _meta = __webpack_require__(641);
	
	var _ga = __webpack_require__(231);
	
	var _routing = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	function configureStore(history) {
	
	  history.listen(function (ev) {
	    if (ev.action !== 'PUSH') return;
	    (0, _ga.pageView)(ev.pathname);
	  });
	
	  var jalanSaga = (0, _jalan.createJalan)(history, [{ '/': _routing.JALAN_INDEX }, { '/user/{userId}': _routing.JALAN_USER_LIST }, { '/index-project/{userId}/{projectId}': _routing.JALAN_INDEX_PROJECT }, { '/project/{projectId}': _routing.JALAN_PROJECT }, { '/project-node/{projectId}/{nodeId}': _routing.JALAN_PROJECT_NODE }, { '/node/{projectId}/{nodeId}': _routing.JALAN_NODE },
	
	  /*
	    { '/user-list-project/{userId}/{projectId}': JALAN_USER_LIST_PROJECT },
	    { '/user-project/{userId}/{projectId}': JALAN_USER_PROJECT },
	    { '/user-project-node/{userId}/{projectId}/{nodeId}': JALAN_USER_PROJECT_NODE },
	    { '/user-node/{userId}/{projectId}/{nodeId}': JALAN_USER_NODE },
	  */
	
	  { '/test': _routing.JALAN_TEST }]);
	
	  var middlewares = [_meta.meta, (0, _reduxSaga2.default)(jalanSaga, _index4.default), _reduxThunk2.default];
	
	  try {
	    var debugConfig = localStorage.getItem('debug');
	    if (/.*logger.*/.test(debugConfig)) {
	      middlewares.push(_logger2.default);
	    }
	  } catch (err) {
	    // pass
	  }
	
	  var store = _redux.applyMiddleware.apply(undefined, middlewares)(_redux.createStore)(_index2.default);
	
	  return store;
	}
	// import { error } from './rollbar';
	
	// error('Hello World!', { actions: { type: 'POST', payload: { postId: 123 } } });

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	/* injects from baggage-loader */
	
	/* eslint no-console: 0 */
	
	
	var debug = __webpack_require__(40)('metapro:logger');
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      var type = action.type;
	
	      var rest = _objectWithoutProperties(action, ['type']);
	
	      if (type && type.substring(0, 2) !== '@@' && type.substring(0, 7) !== 'EFFECT_') {
	        if (console.group) {
	          console.group(type);
	          if (!_lodash2.default.isEmpty(rest)) {
	            console.info('payload', rest);
	          }
	        } else {
	          debug(type);
	        }
	      }
	      var result = next(action);
	      if (type && type.substring(0, 2) !== '@@' && type.substring(0, 7) !== 'EFFECT_') {
	        if (console.groupEnd) {
	          console.info('next state', store.getState());
	          console.groupEnd(type);
	        }
	      }
	      return result;
	    };
	  };
	};

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.meta = undefined;
	
	var _metaMiddleware;
	
	var _jalan = __webpack_require__(273);
	
	var _routing = __webpack_require__(27);
	
	var _data = __webpack_require__(141);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* injects from baggage-loader */
	
	var meta = exports.meta = (0, _jalan.metaMiddleware)((_metaMiddleware = {}, _defineProperty(_metaMiddleware, _routing.JALAN_USER_LIST, { data: [_data.PROJECTS_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_INDEX, { data: [_data.PROJECTS_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_INDEX_PROJECT, { data: [_data.PROJECTS_DATA, _data.PROJECT_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_PROJECT, { data: [_data.PROJECTS_DATA, _data.PROJECT_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_PROJECT_NODE, { data: [_data.PROJECT_DATA, _data.NODE_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_NODE, { data: [_data.NODE_DATA, _data.PROJECT_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_TEST, { data: [_data.PROJECT_DATA] }), _metaMiddleware));

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reactClicker = reactClicker;
	
	var _reactAddonsTestUtils = __webpack_require__(897);
	
	var _reactAddonsTestUtils2 = _interopRequireDefault(_reactAddonsTestUtils);
	
	var _configurable = __webpack_require__(806);
	
	var _configurable2 = _interopRequireDefault(_configurable);
	
	var _chance = __webpack_require__(807);
	
	var _chance2 = _interopRequireDefault(_chance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reactClicker() {
	
	  var document = window.document;
	  var body = document.body;
	
	  var defaultClickTypes = ['click', 'click', 'click', 'click', 'click', 'click', 'doubleClick', 'doubleClick', 'mouseDown', 'mouseUp', 'mouseEnter', 'mouseEnter', 'mouseEnter', 'mouseMove', 'mouseLeave'];
	
	  /**
	   * @mixin
	   */
	  var config = {
	    clickTypes: defaultClickTypes,
	    positionSelector: defaultPositionSelector,
	    showAction: defaultShowAction,
	    canClick: defaultCanClick,
	    maxNbTries: 10,
	    logger: {},
	    randomizer: new _chance2.default()
	  };
	
	  function defaultPositionSelector() {
	    return [config.randomizer.natural({ max: document.documentElement.clientWidth - 1 }), config.randomizer.natural({ max: document.documentElement.clientHeight - 1 })];
	  }
	
	  function defaultShowAction(x, y) {
	    var clickSignal = document.createElement('div');
	    clickSignal.style.border = '3px solid red';
	    clickSignal.style['border-radius'] = '50%';
	    clickSignal.style.width = '40px';
	    clickSignal.style.height = '40px';
	    clickSignal.style['box-sizing'] = 'border-box';
	    clickSignal.style.position = 'absolute';
	    clickSignal.style.webkitTransition = 'opacity 1s ease-out';
	    clickSignal.style.mozTransition = 'opacity 1s ease-out';
	    clickSignal.style.transition = 'opacity 1s ease-out';
	    clickSignal.style.left = x - 20 + 'px';
	    clickSignal.style.top = y - 20 + 'px';
	    var element = body.appendChild(clickSignal);
	    setTimeout(function () {
	      body.removeChild(element);
	    }, 1000);
	    setTimeout(function () {
	      element.style.opacity = 0;
	    }, 50);
	  }
	
	  function defaultCanClick() {
	    return true;
	  }
	
	  /**
	   * @mixes config
	   */
	  function clickerGremlin() {
	    var position = undefined;
	    var posX = undefined;
	    var posY = undefined;
	    var targetElement = undefined;
	    var nbTries = 0;
	    do {
	      position = config.positionSelector();
	      posX = position[0];
	      posY = position[1];
	      targetElement = document.elementFromPoint(posX, posY);
	      nbTries++;
	      if (nbTries > config.maxNbTries) return false;
	    } while (!targetElement || !config.canClick(targetElement));
	
	    var clickType = config.randomizer.pick(config.clickTypes);
	
	    _reactAddonsTestUtils2.default.Simulate[clickType](targetElement);
	
	    if (typeof config.showAction === 'function') {
	      config.showAction(posX, posY);
	    }
	
	    if (typeof config.logger.log === 'function') {
	      config.logger.log('gremlin', 'clicker   ', clickType, 'at', posX, posY);
	    }
	  }
	
	  (0, _configurable2.default)(clickerGremlin, config);
	
	  return clickerGremlin;
	}
	/* injects from baggage-loader */
	
	/* eslint no-use-before-define: 0 */
	/* eslint prefer-template: 0 */

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uploadProjectImage = uploadProjectImage;
	
	var _promise = __webpack_require__(387);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	__webpack_require__(820);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* injects from baggage-loader */
	
	/* eslint no-unused-vars: 0*/
	
	
	var BUCKET_PATH = 'naissur-hello-bucket/projects-share-images'; // polyfilling Promise
	
	var getProjectUrl = function getProjectUrl(projectKey) {
	  return 'https://s3.amazonaws.com/' + BUCKET_PATH + '/' + projectKey;
	};
	
	function uploadProjectImage(_ref) {
	  var projectId = _ref.projectId;
	  var base64Data = _ref.base64Data;
	
	  var strippedImageData = base64Data.split('base64,')[1];
	  var buf = new Buffer(strippedImageData, 'base64');
	
	  var prefix = new Date().getTime().toString() + Math.random().toString();
	  var projectKey = prefix + '-' + projectId + '.png'; // add prefix to avoid facebook caching
	
	  var projectUrl = getProjectUrl(projectKey);
	
	  return fetch(projectUrl, {
	    headers: {
	      'Content-Type': 'image/png',
	      'Content-Encoding': 'base64',
	      'x-amz-acl': 'public-read'
	    },
	    method: 'put',
	    body: buf
	  }).then(function () {
	    return projectUrl;
	  });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(232).Buffer))

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* injects from baggage-loader */
	
	module.exports = {
	  accessToken: '17861c08d87a4c389ddd50ad236771a1',
	  captureUncaught: true,
	  payload: {
	    environment: ("production")
	  }
	};

/***/ }
]);


// WEBPACK FOOTER //
// app.672c2451045ee7e26aed.js